//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import AxiosClient from './axiosClient';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class CalendarClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAvailability(year: number | undefined, month: number | undefined, token: string | undefined, cancelToken?: CancelToken): Promise<DateAvailabilityResult[]> {
        let url_ = this.baseUrl + "/api/public/appointment-calendar/availability?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailability(_response));
        });
    }

    protected processGetAvailability(response: AxiosResponse): Promise<DateAvailabilityResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DateAvailabilityResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DateAvailabilityResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateAvailabilityResult[]>(null as any);
    }

    getOpenings(year: number | undefined, month: number | undefined, day: number | undefined, token: string | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult[]> {
        let url_ = this.baseUrl + "/api/public/appointment-calendar/openings?";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (day === null)
            throw new globalThis.Error("The parameter 'day' cannot be null.");
        else if (day !== undefined)
            url_ += "day=" + encodeURIComponent("" + day) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOpenings(_response));
        });
    }

    protected processGetOpenings(response: AxiosResponse): Promise<ScheduleOpeningResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScheduleOpeningResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult[]>(null as any);
    }

    selectTime(model: SelectTimeRequestModel, cancelToken?: CancelToken): Promise<SelectTimeResponseModel> {
        let url_ = this.baseUrl + "/api/public/appointment-calendar/select-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSelectTime(_response));
        });
    }

    protected processSelectTime(response: AxiosResponse): Promise<SelectTimeResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SelectTimeResponseModel.fromJS(resultData200);
            return Promise.resolve<SelectTimeResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectTimeResponseModel>(null as any);
    }

    cancelPendingAppointment(appointmentId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/public/appointment-calendar/{appointmentId}/cancel";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelPendingAppointment(_response));
        });
    }

    protected processCancelPendingAppointment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    confirmAppointment(model: ConfirmAppointmentRequestModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/public/appointment-calendar/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfirmAppointment(_response));
        });
    }

    protected processConfirmAppointment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ApiVersionClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getVersion( cancelToken?: CancelToken): Promise<ApiVersionResponse> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVersion(_response));
        });
    }

    protected processGetVersion(response: AxiosResponse): Promise<ApiVersionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiVersionResponse.fromJS(resultData200);
            return Promise.resolve<ApiVersionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiVersionResponse>(null as any);
    }
}

export class ConfigClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getReCaptchaSiteKey( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/config/recaptcha/sitekey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReCaptchaSiteKey(_response));
        });
    }

    protected processGetReCaptchaSiteKey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getBranding( cancelToken?: CancelToken): Promise<BrandingResponse> {
        let url_ = this.baseUrl + "/api/config/branding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBranding(_response));
        });
    }

    protected processGetBranding(response: AxiosResponse): Promise<BrandingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BrandingResponse.fromJS(resultData200);
            return Promise.resolve<BrandingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandingResponse>(null as any);
    }

    getAnalyticsBeforePaymentScript( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/config/analytics/beforePaymentScript";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAnalyticsBeforePaymentScript(_response));
        });
    }

    protected processGetAnalyticsBeforePaymentScript(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getSupportedLanguages( cancelToken?: CancelToken): Promise<SupportedLanguagesResponse> {
        let url_ = this.baseUrl + "/api/config/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSupportedLanguages(_response));
        });
    }

    protected processGetSupportedLanguages(response: AxiosResponse): Promise<SupportedLanguagesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SupportedLanguagesResponse.fromJS(resultData200);
            return Promise.resolve<SupportedLanguagesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupportedLanguagesResponse>(null as any);
    }
}

export class PatientAnalyticsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    trackEvents(request: TrackAppEventsBatchRequest, cancelToken?: CancelToken): Promise<TrackAppEventsBatchResponse> {
        let url_ = this.baseUrl + "/api/patient/analytics/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTrackEvents(_response));
        });
    }

    protected processTrackEvents(response: AxiosResponse): Promise<TrackAppEventsBatchResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrackAppEventsBatchResponse.fromJS(resultData200);
            return Promise.resolve<TrackAppEventsBatchResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackAppEventsBatchResponse>(null as any);
    }
}

export class PatientAppointmentsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAppointments( cancelToken?: CancelToken): Promise<PublicPatientAppointmentModel[]> {
        let url_ = this.baseUrl + "/api/appointments/schedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAppointments(_response));
        });
    }

    protected processGetAppointments(response: AxiosResponse): Promise<PublicPatientAppointmentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicPatientAppointmentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublicPatientAppointmentModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPatientAppointmentModel[]>(null as any);
    }

    getPatientAppointments(patientLoginId: string, cancelToken?: CancelToken): Promise<PublicPatientAppointmentModel2[]> {
        let url_ = this.baseUrl + "/api/patientSite/appointments/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientAppointments(_response));
        });
    }

    protected processGetPatientAppointments(response: AxiosResponse): Promise<PublicPatientAppointmentModel2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicPatientAppointmentModel2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublicPatientAppointmentModel2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPatientAppointmentModel2[]>(null as any);
    }

    createEssentialsAppointmentAndPaymentLink(patientLoginId: string, cancelToken?: CancelToken): Promise<CreateAppointmentAndPaymentLinkResponse2> {
        let url_ = this.baseUrl + "/api/patientAppointments/createEssentialsAppointmentAndPaymentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientLoginId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEssentialsAppointmentAndPaymentLink(_response));
        });
    }

    protected processCreateEssentialsAppointmentAndPaymentLink(response: AxiosResponse): Promise<CreateAppointmentAndPaymentLinkResponse2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAppointmentAndPaymentLinkResponse2.fromJS(resultData200);
            return Promise.resolve<CreateAppointmentAndPaymentLinkResponse2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAppointmentAndPaymentLinkResponse2>(null as any);
    }

    createAppointmentAndPaymentLink(request: AppointmentAndPaymentLinkRequest, cancelToken?: CancelToken): Promise<CreateAppointmentAndPaymentLinkResponse2> {
        let url_ = this.baseUrl + "/api/patientAppointments/createAppointmentAndPaymentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAppointmentAndPaymentLink(_response));
        });
    }

    protected processCreateAppointmentAndPaymentLink(response: AxiosResponse): Promise<CreateAppointmentAndPaymentLinkResponse2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAppointmentAndPaymentLinkResponse2.fromJS(resultData200);
            return Promise.resolve<CreateAppointmentAndPaymentLinkResponse2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAppointmentAndPaymentLinkResponse2>(null as any);
    }

    appointmentPaymentFromToken(token: string | null | undefined, cancelToken?: CancelToken): Promise<AppointmentPaymentFromTokenResponse> {
        let url_ = this.baseUrl + "/api/patientAppointments/appointmentPaymentFromToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAppointmentPaymentFromToken(_response));
        });
    }

    protected processAppointmentPaymentFromToken(response: AxiosResponse): Promise<AppointmentPaymentFromTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppointmentPaymentFromTokenResponse.fromJS(resultData200);
            return Promise.resolve<AppointmentPaymentFromTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentPaymentFromTokenResponse>(null as any);
    }

    appointmentPurchased(request: AppointmentPurchasedConfirmRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/patientAppointments/appointmentPurchased";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAppointmentPurchased(_response));
        });
    }

    protected processAppointmentPurchased(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PatientChatClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getChat( cancelToken?: CancelToken): Promise<PublicSitePatientConversationModel> {
        let url_ = this.baseUrl + "/api/patient/chat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChat(_response));
        });
    }

    protected processGetChat(response: AxiosResponse): Promise<PublicSitePatientConversationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicSitePatientConversationModel.fromJS(resultData200);
            return Promise.resolve<PublicSitePatientConversationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSitePatientConversationModel>(null as any);
    }

    sendMessage(model: PublicSiteSendChatMessageRequest, cancelToken?: CancelToken): Promise<PublicSitePatientMessageModel> {
        let url_ = this.baseUrl + "/api/patient/chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<PublicSitePatientMessageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicSitePatientMessageModel.fromJS(resultData200);
            return Promise.resolve<PublicSitePatientMessageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSitePatientMessageModel>(null as any);
    }

    getUnreadMessagesCount( cancelToken?: CancelToken): Promise<UnreadMessagesResponse> {
        let url_ = this.baseUrl + "/api/patient/chat/unread";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnreadMessagesCount(_response));
        });
    }

    protected processGetUnreadMessagesCount(response: AxiosResponse): Promise<UnreadMessagesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnreadMessagesResponse.fromJS(resultData200);
            return Promise.resolve<UnreadMessagesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnreadMessagesResponse>(null as any);
    }
}

export class PatientInformationClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMe( cancelToken?: CancelToken): Promise<PatientInformationResponse> {
        let url_ = this.baseUrl + "/api/patient/information/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMe(_response));
        });
    }

    protected processGetMe(response: AxiosResponse): Promise<PatientInformationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientInformationResponse.fromJS(resultData200);
            return Promise.resolve<PatientInformationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientInformationResponse>(null as any);
    }

    getContactInfo( cancelToken?: CancelToken): Promise<ContactInfo> {
        let url_ = this.baseUrl + "/api/patient/information/contact";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContactInfo(_response));
        });
    }

    protected processGetContactInfo(response: AxiosResponse): Promise<ContactInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContactInfo.fromJS(resultData200);
            return Promise.resolve<ContactInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactInfo>(null as any);
    }
}

export class PatientInteractionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientInteractionInvitationPendings( cancelToken?: CancelToken): Promise<GetPublicInteractionRequestsInPendingStatusItem[]> {
        let url_ = this.baseUrl + "/api/patient/interactions/pendingInvitations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientInteractionInvitationPendings(_response));
        });
    }

    protected processGetPatientInteractionInvitationPendings(response: AxiosResponse): Promise<GetPublicInteractionRequestsInPendingStatusItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPublicInteractionRequestsInPendingStatusItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetPublicInteractionRequestsInPendingStatusItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPublicInteractionRequestsInPendingStatusItem[]>(null as any);
    }
}

export class PatientNotificationsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    register(req: RegisterDeviceRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patient/notifications/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegister(_response));
        });
    }

    protected processRegister(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unregister(req: RegisterDeviceRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patient/notifications/unregister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnregister(_response));
        });
    }

    protected processUnregister(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PatientNymbleClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    enrollWithNymble( cancelToken?: CancelToken): Promise<NymbleEnrollmentResponse> {
        let url_ = this.baseUrl + "/api/patient/nymble/enroll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnrollWithNymble(_response));
        });
    }

    protected processEnrollWithNymble(response: AxiosResponse): Promise<NymbleEnrollmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NymbleEnrollmentResponse.fromJS(resultData200);
            return Promise.resolve<NymbleEnrollmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NymbleEnrollmentResponse>(null as any);
    }

    sendMessage(request: NymbleSendMessageRequest, cancelToken?: CancelToken): Promise<NymbleMessageResponse> {
        let url_ = this.baseUrl + "/api/patient/nymble/message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<NymbleMessageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NymbleMessageResponse.fromJS(resultData200);
            return Promise.resolve<NymbleMessageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NymbleMessageResponse>(null as any);
    }

    getChatHistory( cancelToken?: CancelToken): Promise<NymbleChatMessage[]> {
        let url_ = this.baseUrl + "/api/patient/nymble/history";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChatHistory(_response));
        });
    }

    protected processGetChatHistory(response: AxiosResponse): Promise<NymbleChatMessage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NymbleChatMessage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<NymbleChatMessage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NymbleChatMessage[]>(null as any);
    }

    deleteUser( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patient/nymble/unenroll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteUser(_response));
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    handleWebhook(token: string | undefined, payload: NymbleWebhookPayload, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patient/nymble/webhook?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHandleWebhook(_response));
        });
    }

    protected processHandleWebhook(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PatientPaymentLinksClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientAvailableProductsForPurchase(productKind: ProductKind, cancelToken?: CancelToken): Promise<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto> {
        let url_ = this.baseUrl + "/api/patient/patientPaymentLinks/getPatientAvailableProductsForPurchaseAsync/{productKind}";
        if (productKind === undefined || productKind === null)
            throw new globalThis.Error("The parameter 'productKind' must be defined.");
        url_ = url_.replace("{productKind}", encodeURIComponent("" + productKind));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientAvailableProductsForPurchase(_response));
        });
    }

    protected processGetPatientAvailableProductsForPurchase(response: AxiosResponse): Promise<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto>(null as any);
    }

    createAppointmentAndPaymentLink(productId: string, cancelToken?: CancelToken): Promise<CreateAppointmentAndPaymentLinkResponse> {
        let url_ = this.baseUrl + "/api/patient/patientPaymentLinks/createAppointmentPaymentLinkAsync/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAppointmentAndPaymentLink(_response));
        });
    }

    protected processCreateAppointmentAndPaymentLink(response: AxiosResponse): Promise<CreateAppointmentAndPaymentLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAppointmentAndPaymentLinkResponse.fromJS(resultData200);
            return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(null as any);
    }

    createEssentialsAppointmentAndPaymentLink( cancelToken?: CancelToken): Promise<CreateAppointmentAndPaymentLinkResponse> {
        let url_ = this.baseUrl + "/api/patient/patientPaymentLinks/createEssentialsAppointmentPaymentLinkAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEssentialsAppointmentAndPaymentLink(_response));
        });
    }

    protected processCreateEssentialsAppointmentAndPaymentLink(response: AxiosResponse): Promise<CreateAppointmentAndPaymentLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateAppointmentAndPaymentLinkResponse.fromJS(resultData200);
            return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateAppointmentAndPaymentLinkResponse>(null as any);
    }

    appointmentPurchased(request: AppointmentPurchasedRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/patient/patientPaymentLinks/appointmentPurchased";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAppointmentPurchased(_response));
        });
    }

    protected processAppointmentPurchased(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PatientReceiptsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getReceipts( cancelToken?: CancelToken): Promise<PublicPatientReceiptModel[]> {
        let url_ = this.baseUrl + "/api/patient/receipts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReceipts(_response));
        });
    }

    protected processGetReceipts(response: AxiosResponse): Promise<PublicPatientReceiptModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicPatientReceiptModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublicPatientReceiptModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPatientReceiptModel[]>(null as any);
    }

    downloadReceipt(patientInteractionId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patient/receipts/{patientInteractionId}";
        if (patientInteractionId === undefined || patientInteractionId === null)
            throw new globalThis.Error("The parameter 'patientInteractionId' must be defined.");
        url_ = url_.replace("{patientInteractionId}", encodeURIComponent("" + patientInteractionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadReceipt(_response));
        });
    }

    protected processDownloadReceipt(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPatientReceipts(patientLoginId: string, cancelToken?: CancelToken): Promise<PublicPatientReceiptModel2[]> {
        let url_ = this.baseUrl + "/api/patientSite/receipts/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientReceipts(_response));
        });
    }

    protected processGetPatientReceipts(response: AxiosResponse): Promise<PublicPatientReceiptModel2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicPatientReceiptModel2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PublicPatientReceiptModel2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPatientReceiptModel2[]>(null as any);
    }

    downloadReceipt2(patientLoginId: string, patientInteractionId: number, model: DownloadReceiptRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/receipts/{patientLoginId}/{patientInteractionId}/download";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        if (patientInteractionId === undefined || patientInteractionId === null)
            throw new globalThis.Error("The parameter 'patientInteractionId' must be defined.");
        url_ = url_.replace("{patientInteractionId}", encodeURIComponent("" + patientInteractionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadReceipt2(_response));
        });
    }

    protected processDownloadReceipt2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PatientResourcesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientResources( cancelToken?: CancelToken): Promise<GetPatientResourcesResponse[]> {
        let url_ = this.baseUrl + "/api/patient/resources/availableResources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientResources(_response));
        });
    }

    protected processGetPatientResources(response: AxiosResponse): Promise<GetPatientResourcesResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPatientResourcesResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetPatientResourcesResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientResourcesResponse[]>(null as any);
    }

    getVideoResourceSasUrl(resourceId: number, cancelToken?: CancelToken): Promise<GetVideoResourceSasUrlResponse> {
        let url_ = this.baseUrl + "/api/patient/resources/sas/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVideoResourceSasUrl(_response));
        });
    }

    protected processGetVideoResourceSasUrl(response: AxiosResponse): Promise<GetVideoResourceSasUrlResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVideoResourceSasUrlResponse.fromJS(resultData200);
            return Promise.resolve<GetVideoResourceSasUrlResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVideoResourceSasUrlResponse>(null as any);
    }

    downloadResource(resourceId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patient/resources/downloadResource/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadResource(_response));
        });
    }

    protected processDownloadResource(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PatientSiteAuthenticationClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    login(request: LoginModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    confirmAccount(request: ConfirmAccountRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfirmAccount(_response));
        });
    }

    protected processConfirmAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetPassword(request: ResetPasswordRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/resetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    forgotPassword(request: ForgotPasswordRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PublicAppointmentPaymentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(token: string | null | undefined, language: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/public/appointment-payment?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    post(token: string | null | undefined, language: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/public/appointment-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (token !== null && token !== undefined)
            content_.append("token", token.toString());
        if (language !== null && language !== undefined)
            content_.append("language", language.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPost(_response));
        });
    }

    protected processPost(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PublicEnrollmentFormClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    postInitialEnrollment(request: EnrollmentInitialRequest, cancelToken?: CancelToken): Promise<EnrollmentInitialResponse> {
        let url_ = this.baseUrl + "/api/public/enrollment/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostInitialEnrollment(_response));
        });
    }

    protected processPostInitialEnrollment(response: AxiosResponse): Promise<EnrollmentInitialResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnrollmentInitialResponse.fromJS(resultData200);
            return Promise.resolve<EnrollmentInitialResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentInitialResponse>(null as any);
    }

    postPaymentComplete(request: PaymentCompleteRequest, cancelToken?: CancelToken): Promise<PaymentCompleteResponse> {
        let url_ = this.baseUrl + "/api/public/enrollment/payment-complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostPaymentComplete(_response));
        });
    }

    protected processPostPaymentComplete(response: AxiosResponse): Promise<PaymentCompleteResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentCompleteResponse.fromJS(resultData200);
            return Promise.resolve<PaymentCompleteResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentCompleteResponse>(null as any);
    }
}

export class PublicQuestionnaireEngineClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    postGenericInteraction(publicRequest: PostGenericInteractionPublicRequest, cancelToken?: CancelToken): Promise<PostEnrollmentInteractionResponse> {
        let url_ = this.baseUrl + "/api/public/publicQuestionnaireEngine/postGenericInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publicRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostGenericInteraction(_response));
        });
    }

    protected processPostGenericInteraction(response: AxiosResponse): Promise<PostEnrollmentInteractionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostEnrollmentInteractionResponse.fromJS(resultData200);
            return Promise.resolve<PostEnrollmentInteractionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostEnrollmentInteractionResponse>(null as any);
    }

    getGenericInteraction(requestKey: string | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel> {
        let url_ = this.baseUrl + "/api/public/publicQuestionnaireEngine/getGenericInteraction?";
        if (requestKey === null)
            throw new globalThis.Error("The parameter 'requestKey' cannot be null.");
        else if (requestKey !== undefined)
            url_ += "RequestKey=" + encodeURIComponent("" + requestKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGenericInteraction(_response));
        });
    }

    protected processGetGenericInteraction(response: AxiosResponse): Promise<InteractionRenderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel>(null as any);
    }

    postEnrollmentInteraction(request: PostEnrollmentInteractionRequest, cancelToken?: CancelToken): Promise<PostEnrollmentInteractionResponse> {
        let url_ = this.baseUrl + "/api/public/publicQuestionnaireEngine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostEnrollmentInteraction(_response));
        });
    }

    protected processPostEnrollmentInteraction(response: AxiosResponse): Promise<PostEnrollmentInteractionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostEnrollmentInteractionResponse.fromJS(resultData200);
            return Promise.resolve<PostEnrollmentInteractionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostEnrollmentInteractionResponse>(null as any);
    }

    getEnrollmentInteraction(languageCode: string | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel> {
        let url_ = this.baseUrl + "/api/public/publicQuestionnaireEngine?";
        if (languageCode === null)
            throw new globalThis.Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentInteraction(_response));
        });
    }

    protected processGetEnrollmentInteraction(response: AxiosResponse): Promise<InteractionRenderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel>(null as any);
    }
}

export class PublicTasksClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getJoin(callbackTaskId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/public/tasks/{callbackTaskId}/join";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJoin(_response));
        });
    }

    protected processGetJoin(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getJoin2(callbackTaskId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/public-tasks/{callbackTaskId}/join";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJoin2(_response));
        });
    }

    protected processGetJoin2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PatientSiteClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getByUserName(username: string | null | undefined, cancelToken?: CancelToken): Promise<PatientLoginDto> {
        let url_ = this.baseUrl + "/api/patientSite/GetByUserName?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetByUserName(_response));
        });
    }

    protected processGetByUserName(response: AxiosResponse): Promise<PatientLoginDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientLoginDto.fromJS(resultData200);
            return Promise.resolve<PatientLoginDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientLoginDto>(null as any);
    }

    getPasswordHash(email: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/patientSite/PasswordHash?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPasswordHash(_response));
        });
    }

    protected processGetPasswordHash(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    setPasswordHash(email: string | null | undefined, pass: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/patientSite/PasswordHash?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (pass !== undefined && pass !== null)
            url_ += "pass=" + encodeURIComponent("" + pass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetPasswordHash(_response));
        });
    }

    protected processSetPasswordHash(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doActivateAccount(token: string | null | undefined, hashedPassword: string | null | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/patientSite/activateAccount?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (hashedPassword !== undefined && hashedPassword !== null)
            url_ += "hashedPassword=" + encodeURIComponent("" + hashedPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoActivateAccount(_response));
        });
    }

    protected processDoActivateAccount(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    doSendForgetPasswordEmail(email: string | null | undefined, token: string | null | undefined, cancelToken?: CancelToken): Promise<ServiceOutcome> {
        let url_ = this.baseUrl + "/api/patientSite/sendForgetPasswordEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSendForgetPasswordEmail(_response));
        });
    }

    protected processDoSendForgetPasswordEmail(response: AxiosResponse): Promise<ServiceOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceOutcome.fromJS(resultData200);
            return Promise.resolve<ServiceOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOutcome>(null as any);
    }

    getPatientPublicInteractionRequests(patientLoginId: string | undefined, cancelToken?: CancelToken): Promise<GetPublicInteractionRequestsInPendingStatusItem2[]> {
        let url_ = this.baseUrl + "/api/patientSite/patientPublicInteractionRequests?";
        if (patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' cannot be null.");
        else if (patientLoginId !== undefined)
            url_ += "patientLoginId=" + encodeURIComponent("" + patientLoginId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientPublicInteractionRequests(_response));
        });
    }

    protected processGetPatientPublicInteractionRequests(response: AxiosResponse): Promise<GetPublicInteractionRequestsInPendingStatusItem2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPublicInteractionRequestsInPendingStatusItem2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetPublicInteractionRequestsInPendingStatusItem2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPublicInteractionRequestsInPendingStatusItem2[]>(null as any);
    }

    getPatientResources(patientId: string, cancelToken?: CancelToken): Promise<GetPatientResourcesResponse2[]> {
        let url_ = this.baseUrl + "/api/patientSite/{patientId}/patientResources";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientResources(_response));
        });
    }

    protected processGetPatientResources(response: AxiosResponse): Promise<GetPatientResourcesResponse2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPatientResourcesResponse2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GetPatientResourcesResponse2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientResourcesResponse2[]>(null as any);
    }

    getVideoResourceSASUrl(patientLoginId: string, documentId: number, cancelToken?: CancelToken): Promise<GetVideoResourceSasUrlResponse2> {
        let url_ = this.baseUrl + "/api/patientSite/{patientLoginId}/patientResources/{documentId}/sas";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVideoResourceSASUrl(_response));
        });
    }

    protected processGetVideoResourceSASUrl(response: AxiosResponse): Promise<GetVideoResourceSasUrlResponse2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetVideoResourceSasUrlResponse2.fromJS(resultData200);
            return Promise.resolve<GetVideoResourceSasUrlResponse2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVideoResourceSasUrlResponse2>(null as any);
    }

    getPatientResourceDetails(patientId: string, documentId: number, cancelToken?: CancelToken): Promise<GetPatientResourceDetailsResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientId}/patientResources/{documentId}/details";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientResourceDetails(_response));
        });
    }

    protected processGetPatientResourceDetails(response: AxiosResponse): Promise<GetPatientResourceDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPatientResourceDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetPatientResourceDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPatientResourceDetailsResponse>(null as any);
    }

    getPreferredLanguage(patientLoginId: string, cancelToken?: CancelToken): Promise<PreferredLanguageResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientLoginId}/preferredLanguage";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPreferredLanguage(_response));
        });
    }

    protected processGetPreferredLanguage(response: AxiosResponse): Promise<PreferredLanguageResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PreferredLanguageResponse.fromJS(resultData200);
            return Promise.resolve<PreferredLanguageResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreferredLanguageResponse>(null as any);
    }

    getProgramDetails(patientLoginId: string, cancelToken?: CancelToken): Promise<ProgramDetailsResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientLoginId}/programDetails";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProgramDetails(_response));
        });
    }

    protected processGetProgramDetails(response: AxiosResponse): Promise<ProgramDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgramDetailsResponse.fromJS(resultData200);
            return Promise.resolve<ProgramDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramDetailsResponse>(null as any);
    }

    downloadPatientResource(patientId: string, documentId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/{patientId}/patientResources/{documentId}/download";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDownloadPatientResource(_response));
        });
    }

    protected processDownloadPatientResource(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ReportsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientsWithoutFaxedAe(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/patients/adverse-events/fax-pending";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientsWithoutFaxedAe(_response));
        });
    }

    protected processGetPatientsWithoutFaxedAe(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getPatientsWithAe(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/patients/adverse-events";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientsWithAe(_response));
        });
    }

    protected processGetPatientsWithAe(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getPatientsWithAeContainingCcglow(studyId: string, containsCcglow: boolean | undefined, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/patients/adverse-events/cc-glow?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (containsCcglow === null)
            throw new globalThis.Error("The parameter 'containsCcglow' cannot be null.");
        else if (containsCcglow !== undefined)
            url_ += "containsCcglow=" + encodeURIComponent("" + containsCcglow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientsWithAeContainingCcglow(_response));
        });
    }

    protected processGetPatientsWithAeContainingCcglow(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getCcglowSummary(studyId: string, cancelToken?: CancelToken): Promise<AeCcglowSummary> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/adverse-events/study/ccglow";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCcglowSummary(_response));
        });
    }

    protected processGetCcglowSummary(response: AxiosResponse): Promise<AeCcglowSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AeCcglowSummary.fromJS(resultData200);
            return Promise.resolve<AeCcglowSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AeCcglowSummary>(null as any);
    }

    getAeSummary(studyId: string, cancelToken?: CancelToken): Promise<AeSummary> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/adverse-events/study";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAeSummary(_response));
        });
    }

    protected processGetAeSummary(response: AxiosResponse): Promise<AeSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AeSummary.fromJS(resultData200);
            return Promise.resolve<AeSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AeSummary>(null as any);
    }

    getMonthlyReport(studyId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/monthly?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMonthlyReport(_response));
        });
    }

    protected processGetMonthlyReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPhysicianReport(studyId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/physicians";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPhysicianReport(_response));
        });
    }

    protected processGetPhysicianReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSourceDataValidationReport(studyId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/source-data-validation?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSourceDataValidationReport(_response));
        });
    }

    protected processGetSourceDataValidationReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getReconciliationReport(studyId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/reconciliation?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReconciliationReport(_response));
        });
    }

    protected processGetReconciliationReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getStoppedTakingSummary(studyId: string, cancelToken?: CancelToken): Promise<StoppedTakingSummary> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/stopped-taking";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStoppedTakingSummary(_response));
        });
    }

    protected processGetStoppedTakingSummary(response: AxiosResponse): Promise<StoppedTakingSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StoppedTakingSummary.fromJS(resultData200);
            return Promise.resolve<StoppedTakingSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StoppedTakingSummary>(null as any);
    }

    getStoppedTakingPatients(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/lumedi-connect-reports/studies/{studyId}/stopped-taking/patients";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStoppedTakingPatients(_response));
        });
    }

    protected processGetStoppedTakingPatients(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }
}

export class PatientDeviceClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    registerDevice(patientLoginId: string, req: RegisterDeviceRequest2, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/devices/{patientLoginId}/register";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterDevice(_response));
        });
    }

    protected processRegisterDevice(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unregisterDevice(patientId: string, req: RegisterDeviceRequest2, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/devices/{patientId}/unregister";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnregisterDevice(_response));
        });
    }

    protected processUnregisterDevice(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PatientProductsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPatientAvailableProductsForPurchase(patientLoginId: string, productKind: ProductKind2, cancelToken?: CancelToken): Promise<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2> {
        let url_ = this.baseUrl + "/api/patientSite/products/getPatientAvailableProductsForPurchase/{patientLoginId}/{productKind}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        if (productKind === undefined || productKind === null)
            throw new globalThis.Error("The parameter 'productKind' must be defined.");
        url_ = url_.replace("{productKind}", encodeURIComponent("" + productKind));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPatientAvailableProductsForPurchase(_response));
        });
    }

    protected processGetPatientAvailableProductsForPurchase(response: AxiosResponse): Promise<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2>(null as any);
    }
}

export class PatientSiteAnalyticsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    trackEvents(patientLoginId: string, request: TrackAppEventsBatchRequest2, cancelToken?: CancelToken): Promise<TrackAppEventsBatchResponse2> {
        let url_ = this.baseUrl + "/api/patientSite/analytics/{patientLoginId}/events";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTrackEvents(_response));
        });
    }

    protected processTrackEvents(response: AxiosResponse): Promise<TrackAppEventsBatchResponse2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrackAppEventsBatchResponse2.fromJS(resultData200);
            return Promise.resolve<TrackAppEventsBatchResponse2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackAppEventsBatchResponse2>(null as any);
    }
}

export class PatientSiteChatClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getChat(patientLoginId: string, cancelToken?: CancelToken): Promise<PublicSitePatientConversationModel2> {
        let url_ = this.baseUrl + "/api/patientSite/chat/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChat(_response));
        });
    }

    protected processGetChat(response: AxiosResponse): Promise<PublicSitePatientConversationModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicSitePatientConversationModel2.fromJS(resultData200);
            return Promise.resolve<PublicSitePatientConversationModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSitePatientConversationModel2>(null as any);
    }

    sendMessage(patientLoginId: string, model: SendChatMessageRequest, cancelToken?: CancelToken): Promise<PublicSitePatientMessageModel2> {
        let url_ = this.baseUrl + "/api/patientSite/chat/{patientLoginId}";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<PublicSitePatientMessageModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicSitePatientMessageModel2.fromJS(resultData200);
            return Promise.resolve<PublicSitePatientMessageModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicSitePatientMessageModel2>(null as any);
    }

    getUnreadMessagesCount(patientLoginId: string, cancelToken?: CancelToken): Promise<UnreadMessagesResponse2> {
        let url_ = this.baseUrl + "/api/patientSite/chat/{patientLoginId}/unread";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUnreadMessagesCount(_response));
        });
    }

    protected processGetUnreadMessagesCount(response: AxiosResponse): Promise<UnreadMessagesResponse2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnreadMessagesResponse2.fromJS(resultData200);
            return Promise.resolve<UnreadMessagesResponse2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnreadMessagesResponse2>(null as any);
    }
}

export class PatientSiteNymbleClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    enrollWithNymble(patientLoginId: string, nymbleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/enroll";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nymbleId);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processEnrollWithNymble(_response));
        });
    }

    protected processEnrollWithNymble(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unenrollWithNymble(patientLoginId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/unenroll";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnenrollWithNymble(_response));
        });
    }

    protected processUnenrollWithNymble(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getNymbleId(patientLoginId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/nymbleId";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNymbleId(_response));
        });
    }

    protected processGetNymbleId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getNymbleEnrollData(patientLoginId: string, cancelToken?: CancelToken): Promise<GetNymbleEnrollData> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{patientLoginId}/nymble-enroll-data";
        if (patientLoginId === undefined || patientLoginId === null)
            throw new globalThis.Error("The parameter 'patientLoginId' must be defined.");
        url_ = url_.replace("{patientLoginId}", encodeURIComponent("" + patientLoginId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetNymbleEnrollData(_response));
        });
    }

    protected processGetNymbleEnrollData(response: AxiosResponse): Promise<GetNymbleEnrollData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetNymbleEnrollData.fromJS(resultData200);
            return Promise.resolve<GetNymbleEnrollData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetNymbleEnrollData>(null as any);
    }

    sendNymbleMessageNotification(nymbleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/patientSite/nymble/{nymbleId}/nymble-send-notification";
        if (nymbleId === undefined || nymbleId === null)
            throw new globalThis.Error("The parameter 'nymbleId' must be defined.");
        url_ = url_.replace("{nymbleId}", encodeURIComponent("" + nymbleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendNymbleMessageNotification(_response));
        });
    }

    protected processSendNymbleMessageNotification(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StudyParticipantsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStudyPspSystemPatient(studyId: string, cancelToken?: CancelToken): Promise<GetSystemPatientModel> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/system-patient";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyPspSystemPatient(_response));
        });
    }

    protected processGetStudyPspSystemPatient(response: AxiosResponse): Promise<GetSystemPatientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSystemPatientModel.fromJS(resultData200);
            return Promise.resolve<GetSystemPatientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSystemPatientModel>(null as any);
    }

    updateStudyPspSystemPatient(studyId: string, model: UpdateStudyPspSystemPatientModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/system-patient";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyPspSystemPatient(_response));
        });
    }

    protected processUpdateStudyPspSystemPatient(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getParticipants(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryResult[]> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetParticipants(_response));
        });
    }

    protected processGetParticipants(response: AxiosResponse): Promise<PatientSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PatientSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryResult[]>(null as any);
    }

    getSummary(studyId: string, cancelToken?: CancelToken): Promise<ParticipantsSummaryResult> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/statuses/summary";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSummary(_response));
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<ParticipantsSummaryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ParticipantsSummaryResult.fromJS(resultData200);
            return Promise.resolve<ParticipantsSummaryResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ParticipantsSummaryResult>(null as any);
    }

    getParticipantsForStatus(studyId: string, cancelToken?: CancelToken): Promise<PatientSummaryStatusResult[]> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/statuses";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetParticipantsForStatus(_response));
        });
    }

    protected processGetParticipantsForStatus(response: AxiosResponse): Promise<PatientSummaryStatusResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSummaryStatusResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PatientSummaryStatusResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientSummaryStatusResult[]>(null as any);
    }

    getEnrollmentCount(studyId: string, start: Date | null | undefined, end: Date | null | undefined, cancelToken?: CancelToken): Promise<EnrollmentCountModel> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/count?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentCount(_response));
        });
    }

    protected processGetEnrollmentCount(response: AxiosResponse): Promise<EnrollmentCountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnrollmentCountModel.fromJS(resultData200);
            return Promise.resolve<EnrollmentCountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrollmentCountModel>(null as any);
    }
}

export class MetricsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getQueueMetrics( cancelToken?: CancelToken): Promise<QueueMetricsModel> {
        let url_ = this.baseUrl + "/api/metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueueMetrics(_response));
        });
    }

    protected processGetQueueMetrics(response: AxiosResponse): Promise<QueueMetricsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueueMetricsModel.fromJS(resultData200);
            return Promise.resolve<QueueMetricsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueMetricsModel>(null as any);
    }

    getQueueMetrics2( cancelToken?: CancelToken): Promise<QueueMetricsModel2> {
        let url_ = this.baseUrl + "/api/v1/metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueueMetrics2(_response));
        });
    }

    protected processGetQueueMetrics2(response: AxiosResponse): Promise<QueueMetricsModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueueMetricsModel2.fromJS(resultData200);
            return Promise.resolve<QueueMetricsModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueMetricsModel2>(null as any);
    }

    getInboundCallMetrics( cancelToken?: CancelToken): Promise<CallMetricsModel> {
        let url_ = this.baseUrl + "/api/v1/metrics/calls";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInboundCallMetrics(_response));
        });
    }

    protected processGetInboundCallMetrics(response: AxiosResponse): Promise<CallMetricsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallMetricsModel.fromJS(resultData200);
            return Promise.resolve<CallMetricsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallMetricsModel>(null as any);
    }
}

export class InteractionAuditsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAuditableUsers(studyId: string, cancelToken?: CancelToken): Promise<AccountSummaryResult[]> {
        let url_ = this.baseUrl + "/api/interaction-audits/studies/{studyId}/accounts";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAuditableUsers(_response));
        });
    }

    protected processGetAuditableUsers(response: AxiosResponse): Promise<AccountSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AccountSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountSummaryResult[]>(null as any);
    }

    getAccountInteractions(studyId: string, accountId: string | null | undefined, cancelToken?: CancelToken): Promise<PatientInteractionSummaryResult[]> {
        let url_ = this.baseUrl + "/api/interaction-audits/studies/{studyId}/interactions?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (accountId !== undefined && accountId !== null)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccountInteractions(_response));
        });
    }

    protected processGetAccountInteractions(response: AxiosResponse): Promise<PatientInteractionSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientInteractionSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PatientInteractionSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientInteractionSummaryResult[]>(null as any);
    }
}

export class AsteriskClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSummary(studyId: string, cancelToken?: CancelToken): Promise<AsteriskSummaryModel> {
        let url_ = this.baseUrl + "/api/asterisk/studies/{studyId}/summary";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSummary(_response));
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<AsteriskSummaryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AsteriskSummaryModel.fromJS(resultData200);
            return Promise.resolve<AsteriskSummaryModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskSummaryModel>(null as any);
    }

    getSnapshot( cancelToken?: CancelToken): Promise<ChannelsStateSnapshot> {
        let url_ = this.baseUrl + "/api/v1/asterisk/snapshot";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSnapshot(_response));
        });
    }

    protected processGetSnapshot(response: AxiosResponse): Promise<ChannelsStateSnapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChannelsStateSnapshot.fromJS(resultData200);
            return Promise.resolve<ChannelsStateSnapshot>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChannelsStateSnapshot>(null as any);
    }

    getQueuesSnapshot( cancelToken?: CancelToken): Promise<QueueSummariesSnapshot> {
        let url_ = this.baseUrl + "/api/v1/asterisk/queues/snapshot";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueuesSnapshot(_response));
        });
    }

    protected processGetQueuesSnapshot(response: AxiosResponse): Promise<QueueSummariesSnapshot> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueueSummariesSnapshot.fromJS(resultData200);
            return Promise.resolve<QueueSummariesSnapshot>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueSummariesSnapshot>(null as any);
    }

    getQueues( cancelToken?: CancelToken): Promise<AsteriskQueueResult[]> {
        let url_ = this.baseUrl + "/api/v1/asterisk/queues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueues(_response));
        });
    }

    protected processGetQueues(response: AxiosResponse): Promise<AsteriskQueueResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AsteriskQueueResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AsteriskQueueResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskQueueResult[]>(null as any);
    }
}

export class QuestionnaireEngineClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProvinceState(countryCode: string | null | undefined, cancelToken?: CancelToken): Promise<ProvinceState[]> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/ProvinceState?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProvinceState(_response));
        });
    }

    protected processGetProvinceState(response: AxiosResponse): Promise<ProvinceState[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceState.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProvinceState[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProvinceState[]>(null as any);
    }

    getPharmacies(request: GetPharmaciesRequest, cancelToken?: CancelToken): Promise<PharmacyModel[]> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/Pharmacies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPharmacies(_response));
        });
    }

    protected processGetPharmacies(response: AxiosResponse): Promise<PharmacyModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PharmacyModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PharmacyModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PharmacyModel[]>(null as any);
    }

    getPhysician(request: GetPhysicianRequest, cancelToken?: CancelToken): Promise<PhysicianModel[]> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/Physician";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPhysician(_response));
        });
    }

    protected processGetPhysician(response: AxiosResponse): Promise<PhysicianModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhysicianModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PhysicianModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhysicianModel[]>(null as any);
    }

    getEnrollmentInteractionPublic(languageCode: string | null | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel2> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/enrollmentInteractionPublic?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEnrollmentInteractionPublic(_response));
        });
    }

    protected processGetEnrollmentInteractionPublic(response: AxiosResponse): Promise<InteractionRenderModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel2.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel2>(null as any);
    }

    postEnrollmentInteractionPublic(request: PostEnrollmentInteractionRequest2, cancelToken?: CancelToken): Promise<PostEnrollmentInteractionResponse2> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/enrollmentInteractionPublic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostEnrollmentInteractionPublic(_response));
        });
    }

    protected processPostEnrollmentInteractionPublic(response: AxiosResponse): Promise<PostEnrollmentInteractionResponse2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostEnrollmentInteractionResponse2.fromJS(resultData200);
            return Promise.resolve<PostEnrollmentInteractionResponse2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostEnrollmentInteractionResponse2>(null as any);
    }

    getGenericInteractionPublic(requestKey: string | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel2> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/PublicGenericInteraction?";
        if (requestKey === null)
            throw new globalThis.Error("The parameter 'requestKey' cannot be null.");
        else if (requestKey !== undefined)
            url_ += "requestKey=" + encodeURIComponent("" + requestKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetGenericInteractionPublic(_response));
        });
    }

    protected processGetGenericInteractionPublic(response: AxiosResponse): Promise<InteractionRenderModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel2.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel2>(null as any);
    }

    postGenericInteractionPublic(request: PostGenericInteractionPublicRequest2, cancelToken?: CancelToken): Promise<PostEnrollmentInteractionResponse2> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/PublicGenericInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostGenericInteractionPublic(_response));
        });
    }

    protected processPostGenericInteractionPublic(response: AxiosResponse): Promise<PostEnrollmentInteractionResponse2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PostEnrollmentInteractionResponse2.fromJS(resultData200);
            return Promise.resolve<PostEnrollmentInteractionResponse2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostEnrollmentInteractionResponse2>(null as any);
    }

    getInteraction(interactionId: number | undefined, languageCode: string | null | undefined, patientId: string | undefined, editingInteractionId: number | null | undefined, webinarId: string | null | undefined, cancelToken?: CancelToken): Promise<InteractionRenderModel2> {
        let url_ = this.baseUrl + "/api/questionnaireEngine?";
        if (interactionId === null)
            throw new globalThis.Error("The parameter 'interactionId' cannot be null.");
        else if (interactionId !== undefined)
            url_ += "interactionId=" + encodeURIComponent("" + interactionId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (patientId === null)
            throw new globalThis.Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (editingInteractionId !== undefined && editingInteractionId !== null)
            url_ += "editingInteractionId=" + encodeURIComponent("" + editingInteractionId) + "&";
        if (webinarId !== undefined && webinarId !== null)
            url_ += "webinarId=" + encodeURIComponent("" + webinarId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInteraction(_response));
        });
    }

    protected processGetInteraction(response: AxiosResponse): Promise<InteractionRenderModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionRenderModel2.fromJS(resultData200);
            return Promise.resolve<InteractionRenderModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionRenderModel2>(null as any);
    }

    postInteraction(response: InteractionResponseModel2, cancelToken?: CancelToken): Promise<InteractionModel> {
        let url_ = this.baseUrl + "/api/questionnaireEngine/interaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostInteraction(_response));
        });
    }

    protected processPostInteraction(response: AxiosResponse): Promise<InteractionModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InteractionModel.fromJS(resultData200);
            return Promise.resolve<InteractionModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InteractionModel>(null as any);
    }
}

export class MWMAccountClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    doAccountDeactivate(accountId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/accountDeactivate?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoAccountDeactivate(_response));
        });
    }

    protected processDoAccountDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doResendVerificationEmail(accountId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/resendVerificationEmail/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoResendVerificationEmail(_response));
        });
    }

    protected processDoResendVerificationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAccounts( cancelToken?: CancelToken): Promise<AccountDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccounts(_response));
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<AccountDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AccountDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountDto[]>(null as any);
    }

    getCultures( cancelToken?: CancelToken): Promise<AccountCultureResponseDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/cultures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCultures(_response));
        });
    }

    protected processGetCultures(response: AxiosResponse): Promise<AccountCultureResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountCultureResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AccountCultureResponseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountCultureResponseDto[]>(null as any);
    }

    doSetCulture(request: AccountCultureSetRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/cultures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSetCulture(_response));
        });
    }

    protected processDoSetCulture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doCreateAccount(adminRegisterRequestModel: AdminRegisterRequestModel, cancelToken?: CancelToken): Promise<AdminRegisterResponseModel> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(adminRegisterRequestModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCreateAccount(_response));
        });
    }

    protected processDoCreateAccount(response: AxiosResponse): Promise<AdminRegisterResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdminRegisterResponseModel.fromJS(resultData200);
            return Promise.resolve<AdminRegisterResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminRegisterResponseModel>(null as any);
    }

    getCurrentUserRole( cancelToken?: CancelToken): Promise<CurrentUserRole> {
        let url_ = this.baseUrl + "/api/mwm/MWMAccount/currentRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentUserRole(_response));
        });
    }

    protected processGetCurrentUserRole(response: AxiosResponse): Promise<CurrentUserRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentUserRole.fromJS(resultData200);
            return Promise.resolve<CurrentUserRole>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUserRole>(null as any);
    }
}

export class MWMAgentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCurrentAgent( cancelToken?: CancelToken): Promise<SimpleAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/currentAgent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentAgent(_response));
        });
    }

    protected processGetCurrentAgent(response: AxiosResponse): Promise<SimpleAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimpleAgentDto.fromJS(resultData200);
            return Promise.resolve<SimpleAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleAgentDto>(null as any);
    }

    saveCurrentAgent(simpleAgentDto: SimpleAgentDto, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/currentAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(simpleAgentDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveCurrentAgent(_response));
        });
    }

    protected processSaveCurrentAgent(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    getCurrentAgentAgentRole( cancelToken?: CancelToken): Promise<AgentRole> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/currentAgentRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentAgentAgentRole(_response));
        });
    }

    protected processGetCurrentAgentAgentRole(response: AxiosResponse): Promise<AgentRole> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<AgentRole>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRole>(null as any);
    }

    getProfilePicture( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/profilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProfilePicture(_response));
        });
    }

    protected processGetProfilePicture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doDownloadFile(key: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/file/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDownloadFile(_response));
        });
    }

    protected processDoDownloadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doUploadFile(formFile: FileParameter | null | undefined, fileType: AgentFileType | undefined, agentId: string | undefined, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        if (fileType === null || fileType === undefined)
            throw new globalThis.Error("The parameter 'fileType' cannot be null.");
        else
            content_.append("FileType", fileType.toString());
        if (agentId === null || agentId === undefined)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else
            content_.append("AgentId", agentId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoUploadFile(_response));
        });
    }

    protected processDoUploadFile(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    getSingle(agentId: string, cancelToken?: CancelToken): Promise<FullAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/get/{agentId}";
        if (agentId === undefined || agentId === null)
            throw new globalThis.Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingle(_response));
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<FullAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FullAgentDto.fromJS(resultData200);
            return Promise.resolve<FullAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FullAgentDto>(null as any);
    }

    getAgentSearch(filters_agentRoles: AgentRole[] | null | undefined, filters_agentStatuses: AgentStatus[] | null | undefined, filters_availableForCareTeam: boolean | null | undefined, filters_alwaysIncludeAgentIds: string[] | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfSummaryAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/search?";
        if (filters_agentRoles !== undefined && filters_agentRoles !== null)
            filters_agentRoles && filters_agentRoles.forEach(item => { url_ += "Filters.agentRoles=" + encodeURIComponent("" + item) + "&"; });
        if (filters_agentStatuses !== undefined && filters_agentStatuses !== null)
            filters_agentStatuses && filters_agentStatuses.forEach(item => { url_ += "Filters.agentStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (filters_availableForCareTeam !== undefined && filters_availableForCareTeam !== null)
            url_ += "Filters.availableForCareTeam=" + encodeURIComponent("" + filters_availableForCareTeam) + "&";
        if (filters_alwaysIncludeAgentIds !== undefined && filters_alwaysIncludeAgentIds !== null)
            filters_alwaysIncludeAgentIds && filters_alwaysIncludeAgentIds.forEach(item => { url_ += "Filters.alwaysIncludeAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentSearch(_response));
        });
    }

    protected processGetAgentSearch(response: AxiosResponse): Promise<PaginatedResponseOfSummaryAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfSummaryAgentDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfSummaryAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfSummaryAgentDto>(null as any);
    }

    getList(filters: GetListRequest | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfFullAgentDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/list?";
        if (filters !== undefined && filters !== null)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PaginatedResponseOfFullAgentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfFullAgentDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfFullAgentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfFullAgentDto>(null as any);
    }

    save(agentSaveRequestServiceModel: FullAgentDto, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentSaveRequestServiceModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    saveAgentNotes(agentNoteDto: AgentNoteDto, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentNoteDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveAgentNotes(_response));
        });
    }

    protected processSaveAgentNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentNoteDto>(null as any);
    }

    getAgentNotes(agentId: string | null | undefined, reviewed: boolean | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentNotes?";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (reviewed !== undefined && reviewed !== null)
            url_ += "Reviewed=" + encodeURIComponent("" + reviewed) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentNotes(_response));
        });
    }

    protected processGetAgentNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentNoteDto>(null as any);
    }

    saveAgentAdminNotes(agentAdminNoteDto: AgentAdminNoteDto, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentAdminNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentAdminNoteDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveAgentAdminNotes(_response));
        });
    }

    protected processSaveAgentAdminNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentNoteDto>(null as any);
    }

    getAgentAdminNotes(agentId: string | null | undefined, reviewed: boolean | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentAdminNoteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/agentAdminNotes?";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (reviewed !== undefined && reviewed !== null)
            url_ += "Reviewed=" + encodeURIComponent("" + reviewed) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentAdminNotes(_response));
        });
    }

    protected processGetAgentAdminNotes(response: AxiosResponse): Promise<PaginatedResponseOfAgentAdminNoteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentAdminNoteDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentAdminNoteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentAdminNoteDto>(null as any);
    }

    doReviewAgentAdminNote(doReviewAgentAdminNote: DoReviewAgentAdminNoteModelRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/reviewNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doReviewAgentAdminNote);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoReviewAgentAdminNote(_response));
        });
    }

    protected processDoReviewAgentAdminNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doSetActiveDevice(activeDevice: DoSetActiveDeviceRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/activeDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activeDevice);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSetActiveDevice(_response));
        });
    }

    protected processDoSetActiveDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPendingDevices(agentId: string | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfDeviceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/pendingDevices?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPendingDevices(_response));
        });
    }

    protected processGetPendingDevices(response: AxiosResponse): Promise<PaginatedResponseOfDeviceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfDeviceDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfDeviceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfDeviceDto>(null as any);
    }

    doDetachDevice(agentId: string | undefined, deviceId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/detachDevice?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDetachDevice(_response));
        });
    }

    protected processDoDetachDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveChecks(agentDeviceCheckDto: AgentDeviceCheckDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/checks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentDeviceCheckDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveChecks(_response));
        });
    }

    protected processSaveChecks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getChecks(agentId: string | undefined, cancelToken?: CancelToken): Promise<AgentDeviceCheckDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/checks?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChecks(_response));
        });
    }

    protected processGetChecks(response: AxiosResponse): Promise<AgentDeviceCheckDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentDeviceCheckDto.fromJS(resultData200);
            return Promise.resolve<AgentDeviceCheckDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentDeviceCheckDto>(null as any);
    }

    doCreateAccount(agentRegisterRequestModel: AgentRegisterRequestModel, cancelToken?: CancelToken): Promise<AgentRegisterResponseModel> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/createAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentRegisterRequestModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCreateAccount(_response));
        });
    }

    protected processDoCreateAccount(response: AxiosResponse): Promise<AgentRegisterResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentRegisterResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentRegisterResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRegisterResponseModel>(null as any);
    }

    getAgentReport(agentId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMAgent/report?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentReport(_response));
        });
    }

    protected processGetAgentReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MWMDashboardClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAdminDashboardCounts( cancelToken?: CancelToken): Promise<DashboardResponseModel> {
        let url_ = this.baseUrl + "/api/mwm/MWMDashboard/adminCounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAdminDashboardCounts(_response));
        });
    }

    protected processGetAdminDashboardCounts(response: AxiosResponse): Promise<DashboardResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DashboardResponseModel.fromJS(resultData200);
            return Promise.resolve<DashboardResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardResponseModel>(null as any);
    }
}

export class MWMDeviceClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDevicesReport(agentId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/report?";
        if (agentId === null)
            throw new globalThis.Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDevicesReport(_response));
        });
    }

    protected processGetDevicesReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSingle(deviceId: string, cancelToken?: CancelToken): Promise<DeviceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/get/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSingle(_response));
        });
    }

    protected processGetSingle(response: AxiosResponse): Promise<DeviceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeviceDto.fromJS(resultData200);
            return Promise.resolve<DeviceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto>(null as any);
    }

    getList( cancelToken?: CancelToken): Promise<DeviceDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetList(_response));
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DeviceDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DeviceDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceDto[]>(null as any);
    }

    getListPending( cancelToken?: CancelToken): Promise<DeviceAgentDto[]> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/listPending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetListPending(_response));
        });
    }

    protected processGetListPending(response: AxiosResponse): Promise<DeviceAgentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceAgentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DeviceAgentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeviceAgentDto[]>(null as any);
    }

    save(device: DeviceDto, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(device);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSave(_response));
        });
    }

    protected processSave(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    doReactivateDevice(deviceId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/reactivateDevice?";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoReactivateDevice(_response));
        });
    }

    protected processDoReactivateDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doDeleteDevice(deviceId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMDevice/deleteDevice?";
        if (deviceId === null)
            throw new globalThis.Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDeleteDevice(_response));
        });
    }

    protected processDoDeleteDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MWMInvoiceClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInvoicePdf(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/invoicePdf/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoicePdf(_response));
        });
    }

    protected processGetInvoicePdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteInvoice(invoiceId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/delete/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteInvoice(_response));
        });
    }

    protected processDeleteInvoice(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getInvoicingStatus(filters_FromDateInclusive: Date | null | undefined, filters_ToDateInclusive: Date | null | undefined, filters_AgentId: string | null | undefined, filters_AgentRoles: AgentRole[] | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfInvoicingStatusDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/invoicesStatus?";
        if (filters_FromDateInclusive !== undefined && filters_FromDateInclusive !== null)
            url_ += "Filters.FromDateInclusive=" + encodeURIComponent(filters_FromDateInclusive ? "" + filters_FromDateInclusive.toISOString() : "") + "&";
        if (filters_ToDateInclusive !== undefined && filters_ToDateInclusive !== null)
            url_ += "Filters.ToDateInclusive=" + encodeURIComponent(filters_ToDateInclusive ? "" + filters_ToDateInclusive.toISOString() : "") + "&";
        if (filters_AgentId !== undefined && filters_AgentId !== null)
            url_ += "Filters.AgentId=" + encodeURIComponent("" + filters_AgentId) + "&";
        if (filters_AgentRoles !== undefined && filters_AgentRoles !== null)
            filters_AgentRoles && filters_AgentRoles.forEach(item => { url_ += "Filters.AgentRoles=" + encodeURIComponent("" + item) + "&"; });
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoicingStatus(_response));
        });
    }

    protected processGetInvoicingStatus(response: AxiosResponse): Promise<PaginatedResponseOfInvoicingStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfInvoicingStatusDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfInvoicingStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfInvoicingStatusDto>(null as any);
    }

    getInvoices(filters_InvoiceFlow: InvoiceFlow | undefined, filters_Year: number | null | undefined, filters_InvoiceStatus: InvoiceStatus | null | undefined, filters_ServicePeriod: Date | null | undefined, filters_AgentId: string | null | undefined, filters_InvoiceNumber: number | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/all?";
        if (filters_InvoiceFlow === null)
            throw new globalThis.Error("The parameter 'filters_InvoiceFlow' cannot be null.");
        else if (filters_InvoiceFlow !== undefined)
            url_ += "Filters.InvoiceFlow=" + encodeURIComponent("" + filters_InvoiceFlow) + "&";
        if (filters_Year !== undefined && filters_Year !== null)
            url_ += "Filters.Year=" + encodeURIComponent("" + filters_Year) + "&";
        if (filters_InvoiceStatus !== undefined && filters_InvoiceStatus !== null)
            url_ += "Filters.InvoiceStatus=" + encodeURIComponent("" + filters_InvoiceStatus) + "&";
        if (filters_ServicePeriod !== undefined && filters_ServicePeriod !== null)
            url_ += "Filters.ServicePeriod=" + encodeURIComponent(filters_ServicePeriod ? "" + filters_ServicePeriod.toISOString() : "") + "&";
        if (filters_AgentId !== undefined && filters_AgentId !== null)
            url_ += "Filters.AgentId=" + encodeURIComponent("" + filters_AgentId) + "&";
        if (filters_InvoiceNumber !== undefined && filters_InvoiceNumber !== null)
            url_ += "Filters.InvoiceNumber=" + encodeURIComponent("" + filters_InvoiceNumber) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoices(_response));
        });
    }

    protected processGetInvoices(response: AxiosResponse): Promise<PaginatedResponseOfInvoiceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfInvoiceDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfInvoiceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfInvoiceDto>(null as any);
    }

    getInvoice(invoiceId: string, cancelToken?: CancelToken): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInvoice(_response));
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<InvoiceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceDto.fromJS(resultData200);
            return Promise.resolve<InvoiceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    disputeInvoice(doDisputeRequest: DoDisputeRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/dispute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doDisputeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDisputeInvoice(_response));
        });
    }

    protected processDisputeInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    submitInvoiceForApproval(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/submitForApproval/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSubmitInvoiceForApproval(_response));
        });
    }

    protected processSubmitInvoiceForApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    adminApprove(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/adminApprove/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAdminApprove(_response));
        });
    }

    protected processAdminApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    agentApprove(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/agentApprove/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAgentApprove(_response));
        });
    }

    protected processAgentApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    completeInvoice(invoiceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/complete/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteInvoice(_response));
        });
    }

    protected processCompleteInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveInvoice(createInvoiceRequest: CreateInvoiceRequest, cancelToken?: CancelToken): Promise<string | null> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createInvoiceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveInvoice(_response));
        });
    }

    protected processSaveInvoice(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    updateInvoice(updateInvoiceRequest: UpdateInvoiceRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMInvoice/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInvoiceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateInvoice(_response));
        });
    }

    protected processUpdateInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MWMLoginClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    ping( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPing(_response));
        });
    }

    protected processPing(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doVerifyAccount(accountVerifyRequest: AccountVerifyRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/verifyAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountVerifyRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoVerifyAccount(_response));
        });
    }

    protected processDoVerifyAccount(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doForgotPasswordStart(forgotPasswordStartModel: DoForgotPasswordStartModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/forgotPasswordStart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordStartModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoForgotPasswordStart(_response));
        });
    }

    protected processDoForgotPasswordStart(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doForgotPasswordComplete(doCompleteForgotPasswordRequest: DoCompleteForgotPasswordRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/forgotPasswordComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doCompleteForgotPasswordRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoForgotPasswordComplete(_response));
        });
    }

    protected processDoForgotPasswordComplete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doAuthenticate(accountAuthenticateModel: AccountAuthenticateModel, cancelToken?: CancelToken): Promise<AccountAuthenticateModelResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMLogin/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountAuthenticateModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoAuthenticate(_response));
        });
    }

    protected processDoAuthenticate(response: AxiosResponse): Promise<AccountAuthenticateModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountAuthenticateModelResponse.fromJS(resultData200);
            return Promise.resolve<AccountAuthenticateModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountAuthenticateModelResponse>(null as any);
    }
}

export class MWMSettingsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllSettings( cancelToken?: CancelToken): Promise<MWMSettings> {
        let url_ = this.baseUrl + "/api/mwm/MWMSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllSettings(_response));
        });
    }

    protected processGetAllSettings(response: AxiosResponse): Promise<MWMSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MWMSettings.fromJS(resultData200);
            return Promise.resolve<MWMSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MWMSettings>(null as any);
    }

    setAllSettings(newSettings: MWMSettings, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newSettings);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetAllSettings(_response));
        });
    }

    protected processSetAllSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPublicSettings( cancelToken?: CancelToken): Promise<MWMPublicSettings> {
        let url_ = this.baseUrl + "/api/mwm/MWMSettings/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPublicSettings(_response));
        });
    }

    protected processGetPublicSettings(response: AxiosResponse): Promise<MWMPublicSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MWMPublicSettings.fromJS(resultData200);
            return Promise.resolve<MWMPublicSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MWMPublicSettings>(null as any);
    }
}

export class MWMTrainingClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    saveResource(resourceId: string | null | undefined, externalLink: string | null | undefined, blobId: string | null | undefined, formFile: FileParameter | null | undefined, resourceType: ResourceType | undefined, name: string | undefined, description: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resourceUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (resourceId !== null && resourceId !== undefined)
            content_.append("ResourceId", resourceId.toString());
        if (externalLink !== null && externalLink !== undefined)
            content_.append("ExternalLink", externalLink.toString());
        if (blobId !== null && blobId !== undefined)
            content_.append("BlobId", blobId.toString());
        if (formFile !== null && formFile !== undefined)
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        if (resourceType === null || resourceType === undefined)
            throw new globalThis.Error("The parameter 'resourceType' cannot be null.");
        else
            content_.append("ResourceType", resourceType.toString());
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveResource(_response));
        });
    }

    protected processSaveResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doDownloadResourceFile(blobId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resourceFileDownload/{blobId}";
        if (blobId === undefined || blobId === null)
            throw new globalThis.Error("The parameter 'blobId' must be defined.");
        url_ = url_.replace("{blobId}", encodeURIComponent("" + blobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDownloadResourceFile(_response));
        });
    }

    protected processDoDownloadResourceFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doDeleteResource(resourceId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resourceDelete/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoDeleteResource(_response));
        });
    }

    protected processDoDeleteResource(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doSortTasks(doSortTasksRequest: DoSortTasksRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/sort/tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doSortTasksRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSortTasks(_response));
        });
    }

    protected processDoSortTasks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doSortModules(doSortModulesRequest: DoSortModulesRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/sort/modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doSortModulesRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSortModules(_response));
        });
    }

    protected processDoSortModules(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doSortTopics(doSortTopicsRequest: DoSortTopicsRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/sort/topics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doSortTopicsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoSortTopics(_response));
        });
    }

    protected processDoSortTopics(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTopic(topicId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/delete/topic/{topicId}";
        if (topicId === undefined || topicId === null)
            throw new globalThis.Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTopic(_response));
        });
    }

    protected processDeleteTopic(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTask(taskId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/delete/task/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTask(_response));
        });
    }

    protected processDeleteTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteModule(moduleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/delete/module/{moduleId}";
        if (moduleId === undefined || moduleId === null)
            throw new globalThis.Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteModule(_response));
        });
    }

    protected processDeleteModule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doCompleteHelpRequest(helpRequestId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequest/{helpRequestId}";
        if (helpRequestId === undefined || helpRequestId === null)
            throw new globalThis.Error("The parameter 'helpRequestId' must be defined.");
        url_ = url_.replace("{helpRequestId}", encodeURIComponent("" + helpRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCompleteHelpRequest(_response));
        });
    }

    protected processDoCompleteHelpRequest(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveHelpRequest(helpRequestDto: HelpRequestDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(helpRequestDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveHelpRequest(_response));
        });
    }

    protected processSaveHelpRequest(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getHelpRequest(filters_Completed: boolean | null | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfHelpRequestSummaryDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequest?";
        if (filters_Completed !== undefined && filters_Completed !== null)
            url_ += "Filters.Completed=" + encodeURIComponent("" + filters_Completed) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHelpRequest(_response));
        });
    }

    protected processGetHelpRequest(response: AxiosResponse): Promise<PaginatedResponseOfHelpRequestSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfHelpRequestSummaryDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfHelpRequestSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfHelpRequestSummaryDto>(null as any);
    }

    saveModule(moduleDto: SaveModuleRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveModule(_response));
        });
    }

    protected processSaveModule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveTopic(topicDto: SaveTopicRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/topic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topicDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveTopic(_response));
        });
    }

    protected processSaveTopic(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    saveTask(formFile: FileParameter | null | undefined, saveTaskRequest_TaskId: string | null | undefined, saveTaskRequest_Name: string | null | undefined, saveTaskRequest_Detailes: string | null | undefined, saveTaskRequest_ExternalUrl: string | null | undefined, saveTaskRequest_Content: string | null | undefined, saveTaskRequest_Description: string | null | undefined, saveTaskRequest_TopicId: string | undefined, saveTaskRequest_TaskType: TaskType | undefined, saveTaskRequest_BlobId: string | null | undefined, saveTaskRequest_IsEmbedded: boolean | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("FormFile", formFile.data, formFile.fileName ? formFile.fileName : "FormFile");
        if (saveTaskRequest_TaskId !== null && saveTaskRequest_TaskId !== undefined)
            content_.append("SaveTaskRequest.TaskId", saveTaskRequest_TaskId.toString());
        if (saveTaskRequest_Name !== null && saveTaskRequest_Name !== undefined)
            content_.append("SaveTaskRequest.Name", saveTaskRequest_Name.toString());
        if (saveTaskRequest_Detailes !== null && saveTaskRequest_Detailes !== undefined)
            content_.append("SaveTaskRequest.Detailes", saveTaskRequest_Detailes.toString());
        if (saveTaskRequest_ExternalUrl !== null && saveTaskRequest_ExternalUrl !== undefined)
            content_.append("SaveTaskRequest.ExternalUrl", saveTaskRequest_ExternalUrl.toString());
        if (saveTaskRequest_Content !== null && saveTaskRequest_Content !== undefined)
            content_.append("SaveTaskRequest.Content", saveTaskRequest_Content.toString());
        if (saveTaskRequest_Description !== null && saveTaskRequest_Description !== undefined)
            content_.append("SaveTaskRequest.Description", saveTaskRequest_Description.toString());
        if (saveTaskRequest_TopicId === null || saveTaskRequest_TopicId === undefined)
            throw new globalThis.Error("The parameter 'saveTaskRequest_TopicId' cannot be null.");
        else
            content_.append("SaveTaskRequest.TopicId", saveTaskRequest_TopicId.toString());
        if (saveTaskRequest_TaskType === null || saveTaskRequest_TaskType === undefined)
            throw new globalThis.Error("The parameter 'saveTaskRequest_TaskType' cannot be null.");
        else
            content_.append("SaveTaskRequest.TaskType", saveTaskRequest_TaskType.toString());
        if (saveTaskRequest_BlobId !== null && saveTaskRequest_BlobId !== undefined)
            content_.append("SaveTaskRequest.BlobId", saveTaskRequest_BlobId.toString());
        if (saveTaskRequest_IsEmbedded !== null && saveTaskRequest_IsEmbedded !== undefined)
            content_.append("SaveTaskRequest.IsEmbedded", saveTaskRequest_IsEmbedded.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSaveTask(_response));
        });
    }

    protected processSaveTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    doCompleteTask(agentCompleteTaskRequest: AgentCompleteTaskRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/taskComplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agentCompleteTaskRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCompleteTask(_response));
        });
    }

    protected processDoCompleteTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getResources(filters_ResourceType: ResourceType | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfResourceDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/resources?";
        if (filters_ResourceType === null)
            throw new globalThis.Error("The parameter 'filters_ResourceType' cannot be null.");
        else if (filters_ResourceType !== undefined)
            url_ += "Filters.ResourceType=" + encodeURIComponent("" + filters_ResourceType) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetResources(_response));
        });
    }

    protected processGetResources(response: AxiosResponse): Promise<PaginatedResponseOfResourceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfResourceDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfResourceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfResourceDto>(null as any);
    }

    getHelpRequestCount( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/helpRequestCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHelpRequestCount(_response));
        });
    }

    protected processGetHelpRequestCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getStatus(agentId: string | null | undefined, cancelToken?: CancelToken): Promise<AgentTaskCompletionStatusSummary> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/status?";
        if (agentId !== undefined && agentId !== null)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStatus(_response));
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<AgentTaskCompletionStatusSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentTaskCompletionStatusSummary.fromJS(resultData200);
            return Promise.resolve<AgentTaskCompletionStatusSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentTaskCompletionStatusSummary>(null as any);
    }

    getModules(filters_AgentRole: AgentRole | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfReadModuleDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/modules?";
        if (filters_AgentRole === null)
            throw new globalThis.Error("The parameter 'filters_AgentRole' cannot be null.");
        else if (filters_AgentRole !== undefined)
            url_ += "Filters.AgentRole=" + encodeURIComponent("" + filters_AgentRole) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetModules(_response));
        });
    }

    protected processGetModules(response: AxiosResponse): Promise<PaginatedResponseOfReadModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfReadModuleDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfReadModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfReadModuleDto>(null as any);
    }

    getTopics(filters_ModuleId: string | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfReadTopicDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/topics?";
        if (filters_ModuleId === null)
            throw new globalThis.Error("The parameter 'filters_ModuleId' cannot be null.");
        else if (filters_ModuleId !== undefined)
            url_ += "Filters.ModuleId=" + encodeURIComponent("" + filters_ModuleId) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTopics(_response));
        });
    }

    protected processGetTopics(response: AxiosResponse): Promise<PaginatedResponseOfReadTopicDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfReadTopicDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfReadTopicDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfReadTopicDto>(null as any);
    }

    getTasks(filters_TopicId: string | undefined, returnCounters: boolean | undefined, skip: number | null | undefined, take: number | undefined, returnAll: boolean | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfReadTaskDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/tasks?";
        if (filters_TopicId === null)
            throw new globalThis.Error("The parameter 'filters_TopicId' cannot be null.");
        else if (filters_TopicId !== undefined)
            url_ += "Filters.TopicId=" + encodeURIComponent("" + filters_TopicId) + "&";
        if (returnCounters === null)
            throw new globalThis.Error("The parameter 'returnCounters' cannot be null.");
        else if (returnCounters !== undefined)
            url_ += "ReturnCounters=" + encodeURIComponent("" + returnCounters) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (returnAll === null)
            throw new globalThis.Error("The parameter 'returnAll' cannot be null.");
        else if (returnAll !== undefined)
            url_ += "ReturnAll=" + encodeURIComponent("" + returnAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTasks(_response));
        });
    }

    protected processGetTasks(response: AxiosResponse): Promise<PaginatedResponseOfReadTaskDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfReadTaskDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfReadTaskDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfReadTaskDto>(null as any);
    }

    getAgentTask(taskId: string | undefined, cancelToken?: CancelToken): Promise<AgentTaskViewCompleteDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/agent/getTask?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentTask(_response));
        });
    }

    protected processGetAgentTask(response: AxiosResponse): Promise<AgentTaskViewCompleteDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentTaskViewCompleteDto.fromJS(resultData200);
            return Promise.resolve<AgentTaskViewCompleteDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentTaskViewCompleteDto>(null as any);
    }

    getAgentModules(agentId: string | null | undefined, cancelToken?: CancelToken): Promise<PaginatedResponseOfAgentModuleDto> {
        let url_ = this.baseUrl + "/api/mwm/MWMTraining/agent/getModules?";
        if (agentId !== undefined && agentId !== null)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAgentModules(_response));
        });
    }

    protected processGetAgentModules(response: AxiosResponse): Promise<PaginatedResponseOfAgentModuleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaginatedResponseOfAgentModuleDto.fromJS(resultData200);
            return Promise.resolve<PaginatedResponseOfAgentModuleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaginatedResponseOfAgentModuleDto>(null as any);
    }
}

export class WrapUpClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    completePhoneWrapUp(phoneCallRecordId: string, model: CompletePhoneWrapUpModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/wrap-up/{phoneCallRecordId}/complete";
        if (phoneCallRecordId === undefined || phoneCallRecordId === null)
            throw new globalThis.Error("The parameter 'phoneCallRecordId' must be defined.");
        url_ = url_.replace("{phoneCallRecordId}", encodeURIComponent("" + phoneCallRecordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompletePhoneWrapUp(_response));
        });
    }

    protected processCompletePhoneWrapUp(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPendingWrapUps( cancelToken?: CancelToken): Promise<PhoneWrapUpPendingResult[]> {
        let url_ = this.baseUrl + "/api/wrap-up";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPendingWrapUps(_response));
        });
    }

    protected processGetPendingWrapUps(response: AxiosResponse): Promise<PhoneWrapUpPendingResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhoneWrapUpPendingResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PhoneWrapUpPendingResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PhoneWrapUpPendingResult[]>(null as any);
    }
}

export class UsersClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserContext( cancelToken?: CancelToken): Promise<UserContextResult> {
        let url_ = this.baseUrl + "/api/v1/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserContext(_response));
        });
    }

    protected processGetUserContext(response: AxiosResponse): Promise<UserContextResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserContextResult.fromJS(resultData200);
            return Promise.resolve<UserContextResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserContextResult>(null as any);
    }

    setUserIsEnabled(userId: string, model: SetUserIsEnabledModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/enabled";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserIsEnabled(_response));
        });
    }

    protected processSetUserIsEnabled(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserStatusesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUserStatus( cancelToken?: CancelToken): Promise<UserStatusResult> {
        let url_ = this.baseUrl + "/api/v1/user/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserStatus(_response));
        });
    }

    protected processGetUserStatus(response: AxiosResponse): Promise<UserStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatusResult.fromJS(resultData200);
            return Promise.resolve<UserStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusResult>(null as any);
    }

    setUserStatus(model: SetUserStatusModel, cancelToken?: CancelToken): Promise<UserStatusResult> {
        let url_ = this.baseUrl + "/api/v1/user/statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserStatus(_response));
        });
    }

    protected processSetUserStatus(response: AxiosResponse): Promise<UserStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatusResult.fromJS(resultData200);
            return Promise.resolve<UserStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusResult>(null as any);
    }

    extendExpiration(userStatusId: string, model: ExtendExpirationModel, cancelToken?: CancelToken): Promise<UserStatusResult> {
        let url_ = this.baseUrl + "/api/v1/user/statuses/{userStatusId}";
        if (userStatusId === undefined || userStatusId === null)
            throw new globalThis.Error("The parameter 'userStatusId' must be defined.");
        url_ = url_.replace("{userStatusId}", encodeURIComponent("" + userStatusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExtendExpiration(_response));
        });
    }

    protected processExtendExpiration(response: AxiosResponse): Promise<UserStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatusResult.fromJS(resultData200);
            return Promise.resolve<UserStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusResult>(null as any);
    }
}

export class UserStatusesHistoryClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    statusHistory(userId: string, cancelToken?: CancelToken): Promise<UserStatusHistoryResult[]> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/statuses";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStatusHistory(_response));
        });
    }

    protected processStatusHistory(response: AxiosResponse): Promise<UserStatusHistoryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserStatusHistoryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserStatusHistoryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatusHistoryResult[]>(null as any);
    }
}

export class UserRolesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setUserRoles(studyId: string, model: SetUserRolesModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/user/roles/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserRoles(_response));
        });
    }

    protected processSetUserRoles(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TasksClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCallbackTasks(isActive: boolean | null | undefined, cancelToken?: CancelToken): Promise<CallbackTaskResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks?";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallbackTasks(_response));
        });
    }

    protected processGetCallbackTasks(response: AxiosResponse): Promise<CallbackTaskResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackTaskResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CallbackTaskResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackTaskResult[]>(null as any);
    }

    createTask(model: CreateCallbackTaskModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTask(_response));
        });
    }

    protected processCreateTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCallDurationOptions(studyId: string | null | undefined, callType: CallType | null | undefined, excludeSystem: boolean | undefined, cancelToken?: CancelToken): Promise<StudyCallDurationOptionResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks/options?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (callType !== undefined && callType !== null)
            url_ += "callType=" + encodeURIComponent("" + callType) + "&";
        if (excludeSystem === null)
            throw new globalThis.Error("The parameter 'excludeSystem' cannot be null.");
        else if (excludeSystem !== undefined)
            url_ += "excludeSystem=" + encodeURIComponent("" + excludeSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallDurationOptions(_response));
        });
    }

    protected processGetCallDurationOptions(response: AxiosResponse): Promise<StudyCallDurationOptionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyCallDurationOptionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StudyCallDurationOptionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyCallDurationOptionResult[]>(null as any);
    }

    createCallAttempt(callbackTaskId: string, model: CreateCallbackAttemptModel, cancelToken?: CancelToken): Promise<CallbackTaskResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks/{callbackTaskId}/attempts";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateCallAttempt(_response));
        });
    }

    protected processCreateCallAttempt(response: AxiosResponse): Promise<CallbackTaskResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackTaskResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CallbackTaskResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackTaskResult[]>(null as any);
    }

    requeueTask(callbackTaskId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<CallbackTaskResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/callbacks/{callbackTaskId}/requeue";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRequeueTask(_response));
        });
    }

    protected processRequeueTask(response: AxiosResponse): Promise<CallbackTaskResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackTaskResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CallbackTaskResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackTaskResult[]>(null as any);
    }

    getJoin(callbackTaskId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/join";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJoin(_response));
        });
    }

    protected processGetJoin(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRedirect(callbackTaskId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/redirect";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRedirect(_response));
        });
    }

    protected processGetRedirect(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTaskStateHistory(taskItemId: string, cancelToken?: CancelToken): Promise<TaskStateResult[]> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/states";
        if (taskItemId === undefined || taskItemId === null)
            throw new globalThis.Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTaskStateHistory(_response));
        });
    }

    protected processGetTaskStateHistory(response: AxiosResponse): Promise<TaskStateResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskStateResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TaskStateResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskStateResult[]>(null as any);
    }

    getHasRating(callbackTaskId: string, cancelToken?: CancelToken): Promise<ValueTupleOfStringAndBoolean> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/hasRating";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHasRating(_response));
        });
    }

    protected processGetHasRating(response: AxiosResponse): Promise<ValueTupleOfStringAndBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueTupleOfStringAndBoolean.fromJS(resultData200);
            return Promise.resolve<ValueTupleOfStringAndBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueTupleOfStringAndBoolean>(null as any);
    }

    setRating(callbackTaskId: string, model: CallRatingModel, cancelToken?: CancelToken): Promise<number | null> {
        let url_ = this.baseUrl + "/api/v1/tasks/{callbackTaskId}/rating";
        if (callbackTaskId === undefined || callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' must be defined.");
        url_ = url_.replace("{callbackTaskId}", encodeURIComponent("" + callbackTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetRating(_response));
        });
    }

    protected processSetRating(response: AxiosResponse): Promise<number | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number | null>(null as any);
    }

    archiveTask(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/archive";
        if (taskItemId === undefined || taskItemId === null)
            throw new globalThis.Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchiveTask(_response));
        });
    }

    protected processArchiveTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    wrapUpArchive(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/wrap-up/archive";
        if (taskItemId === undefined || taskItemId === null)
            throw new globalThis.Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWrapUpArchive(_response));
        });
    }

    protected processWrapUpArchive(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cancelTask(taskItemId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/cancel";
        if (taskItemId === undefined || taskItemId === null)
            throw new globalThis.Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelTask(_response));
        });
    }

    protected processCancelTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    completeTask(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/complete";
        if (taskItemId === undefined || taskItemId === null)
            throw new globalThis.Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteTask(_response));
        });
    }

    protected processCompleteTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    handleTask(taskItemId: string, model: HandleTaskModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/handle";
        if (taskItemId === undefined || taskItemId === null)
            throw new globalThis.Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHandleTask(_response));
        });
    }

    protected processHandleTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unArchiveTask(taskItemId: string, model: UpdateTaskStateModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/{taskItemId}/unarchive";
        if (taskItemId === undefined || taskItemId === null)
            throw new globalThis.Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnArchiveTask(_response));
        });
    }

    protected processUnArchiveTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createAgentCallbackTask(model: AgentCreateCallbackTaskModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/agents/callbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAgentCallbackTask(_response));
        });
    }

    protected processCreateAgentCallbackTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createHcpCallbackTask(model: AgentCreateHcpCallbackTaskModel, cancelToken?: CancelToken): Promise<CreateHcpCallResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/agents/callbacks/hcp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateHcpCallbackTask(_response));
        });
    }

    protected processCreateHcpCallbackTask(response: AxiosResponse): Promise<CreateHcpCallResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateHcpCallResponse.fromJS(resultData200);
            return Promise.resolve<CreateHcpCallResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateHcpCallResponse>(null as any);
    }

    getAppointmentCountForUserStudy(studyId: string, userId: string, shiftStart: Date | undefined, shiftEnd: Date | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/tasks/studies/{studyId}/users/{userId}/apppointments?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (shiftStart === null)
            throw new globalThis.Error("The parameter 'shiftStart' cannot be null.");
        else if (shiftStart !== undefined)
            url_ += "shiftStart=" + encodeURIComponent(shiftStart ? "" + shiftStart.toISOString() : "") + "&";
        if (shiftEnd === null)
            throw new globalThis.Error("The parameter 'shiftEnd' cannot be null.");
        else if (shiftEnd !== undefined)
            url_ += "shiftEnd=" + encodeURIComponent(shiftEnd ? "" + shiftEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAppointmentCountForUserStudy(_response));
        });
    }

    protected processGetAppointmentCountForUserStudy(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getCallAttemptConfiguration(studyId: string | undefined, callType: CallType | undefined, agentType: AgentType | undefined, cancelToken?: CancelToken): Promise<CallAttemptConfigurationResult> {
        let url_ = this.baseUrl + "/api/v1/tasks/call-attempt-config?";
        if (studyId === null)
            throw new globalThis.Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (callType === null)
            throw new globalThis.Error("The parameter 'callType' cannot be null.");
        else if (callType !== undefined)
            url_ += "callType=" + encodeURIComponent("" + callType) + "&";
        if (agentType === null)
            throw new globalThis.Error("The parameter 'agentType' cannot be null.");
        else if (agentType !== undefined)
            url_ += "agentType=" + encodeURIComponent("" + agentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallAttemptConfiguration(_response));
        });
    }

    protected processGetCallAttemptConfiguration(response: AxiosResponse): Promise<CallAttemptConfigurationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallAttemptConfigurationResult.fromJS(resultData200);
            return Promise.resolve<CallAttemptConfigurationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallAttemptConfigurationResult>(null as any);
    }

    recreateVideoAppointmentLinks( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tasks/recreateVideoAppointmentLinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRecreateVideoAppointmentLinks(_response));
        });
    }

    protected processRecreateVideoAppointmentLinks(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StudiesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getStudiesForUser( cancelToken?: CancelToken): Promise<StudyResult[]> {
        let url_ = this.baseUrl + "/api/v1/studies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudiesForUser(_response));
        });
    }

    protected processGetStudiesForUser(response: AxiosResponse): Promise<StudyResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StudyResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyResult[]>(null as any);
    }

    updateStudyUser(userId: string, model: UpdateStudyUserModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/studies/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyUser(_response));
        });
    }

    protected processUpdateStudyUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getStudyEmailConfiguration(studyId: string, cancelToken?: CancelToken): Promise<StudyEmailConfigurationResult> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/emails/configuration";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyEmailConfiguration(_response));
        });
    }

    protected processGetStudyEmailConfiguration(response: AxiosResponse): Promise<StudyEmailConfigurationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudyEmailConfigurationResult.fromJS(resultData200);
            return Promise.resolve<StudyEmailConfigurationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyEmailConfigurationResult>(null as any);
    }

    updateStudyEmailConfiguration(studyId: string, model: UpdateStudyEmailConfigurationModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/emails/configuration";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStudyEmailConfiguration(_response));
        });
    }

    protected processUpdateStudyEmailConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StatusesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRootStatuses( cancelToken?: CancelToken): Promise<RootStatusResult[]> {
        let url_ = this.baseUrl + "/api/v1/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRootStatuses(_response));
        });
    }

    protected processGetRootStatuses(response: AxiosResponse): Promise<RootStatusResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RootStatusResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<RootStatusResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RootStatusResult[]>(null as any);
    }

    createSubStatus(statusId: string, model: NewStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}/sub-statuses";
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateSubStatus(_response));
        });
    }

    protected processCreateSubStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    updateStatus(statusId: string, model: UpdateStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}";
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStatus(_response));
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    deleteSubStatusStatus(statusId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}";
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteSubStatusStatus(_response));
        });
    }

    protected processDeleteSubStatusStatus(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateDurationStatus(statusId: string, model: UpdateDurationStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/duration/{statusId}";
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDurationStatus(_response));
        });
    }

    protected processUpdateDurationStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    createDurationSubStatus(statusId: string, model: NewDurationStatusViewModel, cancelToken?: CancelToken): Promise<StatusResult> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}/sub-statuses/duration";
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateDurationSubStatus(_response));
        });
    }

    protected processCreateDurationSubStatus(response: AxiosResponse): Promise<StatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusResult.fromJS(resultData200);
            return Promise.resolve<StatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusResult>(null as any);
    }

    updateStatusCulture(statusId: string, cultureCode: string, model: UpdateStatusCultureViewModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/statuses/{statusId}/cultures/{cultureCode}";
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        if (cultureCode === undefined || cultureCode === null)
            throw new globalThis.Error("The parameter 'cultureCode' must be defined.");
        url_ = url_.replace("{cultureCode}", encodeURIComponent("" + cultureCode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateStatusCulture(_response));
        });
    }

    protected processUpdateStatusCulture(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class RolesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllRoles( cancelToken?: CancelToken): Promise<CallbackRoleResult[]> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllRoles(_response));
        });
    }

    protected processGetAllRoles(response: AxiosResponse): Promise<CallbackRoleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackRoleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CallbackRoleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult[]>(null as any);
    }

    createRole(model: CreateRoleModel, cancelToken?: CancelToken): Promise<CallbackRoleResult> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateRole(_response));
        });
    }

    protected processCreateRole(response: AxiosResponse): Promise<CallbackRoleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallbackRoleResult.fromJS(resultData200);
            return Promise.resolve<CallbackRoleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult>(null as any);
    }

    getRoles(studyId: string, cancelToken?: CancelToken): Promise<CallbackRoleResult[]> {
        let url_ = this.baseUrl + "/api/v1/roles/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<CallbackRoleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackRoleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CallbackRoleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult[]>(null as any);
    }

    getRoleById(roleId: string, cancelToken?: CancelToken): Promise<CallbackRoleResult> {
        let url_ = this.baseUrl + "/api/v1/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRoleById(_response));
        });
    }

    protected processGetRoleById(response: AxiosResponse): Promise<CallbackRoleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallbackRoleResult.fromJS(resultData200);
            return Promise.resolve<CallbackRoleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult>(null as any);
    }

    updateRole(roleId: string, model: UpdateRoleModel, cancelToken?: CancelToken): Promise<CallbackRoleResult> {
        let url_ = this.baseUrl + "/api/v1/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateRole(_response));
        });
    }

    protected processUpdateRole(response: AxiosResponse): Promise<CallbackRoleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CallbackRoleResult.fromJS(resultData200);
            return Promise.resolve<CallbackRoleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallbackRoleResult>(null as any);
    }

    deleteRole(roleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteRole(_response));
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PhoneClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAsteriskUser( cancelToken?: CancelToken): Promise<GetSoftphoneUserResponse> {
        let url_ = this.baseUrl + "/api/Phone/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAsteriskUser(_response));
        });
    }

    protected processGetAsteriskUser(response: AxiosResponse): Promise<GetSoftphoneUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSoftphoneUserResponse.fromJS(resultData200);
            return Promise.resolve<GetSoftphoneUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSoftphoneUserResponse>(null as any);
    }
}

export class PermissionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPermissions( cancelToken?: CancelToken): Promise<PermissionResult[]> {
        let url_ = this.baseUrl + "/api/v1/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetPermissions(_response));
        });
    }

    protected processGetPermissions(response: AxiosResponse): Promise<PermissionResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PermissionResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionResult[]>(null as any);
    }
}

export class PatientsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get(studyId: string | undefined, uniqueId: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, status: string | null | undefined, siteId: string | null | undefined, cancelToken?: CancelToken): Promise<SearchedPatient[]> {
        let url_ = this.baseUrl + "/api/v1/patients?";
        if (studyId === null)
            throw new globalThis.Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (uniqueId !== undefined && uniqueId !== null)
            url_ += "uniqueId=" + encodeURIComponent("" + uniqueId) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<SearchedPatient[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchedPatient.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SearchedPatient[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchedPatient[]>(null as any);
    }
}

export class PatientUnsubscribeClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isPatientUnsubscribed(patientId: string, cancelToken?: CancelToken): Promise<IsPatientUnsubscribedModel> {
        let url_ = this.baseUrl + "/api/unsubscribe/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsPatientUnsubscribed(_response));
        });
    }

    protected processIsPatientUnsubscribed(response: AxiosResponse): Promise<IsPatientUnsubscribedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsPatientUnsubscribedModel.fromJS(resultData200);
            return Promise.resolve<IsPatientUnsubscribedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsPatientUnsubscribedModel>(null as any);
    }

    unsubscribe(patientId: string, cancelToken?: CancelToken): Promise<IsPatientUnsubscribedModel> {
        let url_ = this.baseUrl + "/api/unsubscribe/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new globalThis.Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnsubscribe(_response));
        });
    }

    protected processUnsubscribe(response: AxiosResponse): Promise<IsPatientUnsubscribedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsPatientUnsubscribedModel.fromJS(resultData200);
            return Promise.resolve<IsPatientUnsubscribedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsPatientUnsubscribedModel>(null as any);
    }
}

export class PatientFollowUpsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    isValidEmailFollowUp(model: ValidateFollowUpModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/validateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsValidEmailFollowUp(_response));
        });
    }

    protected processIsValidEmailFollowUp(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setFollowUpAnswers(followUpId: string, model: SaxendaAnswerModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{followUpId}/submitAnswers";
        if (followUpId === undefined || followUpId === null)
            throw new globalThis.Error("The parameter 'followUpId' must be defined.");
        url_ = url_.replace("{followUpId}", encodeURIComponent("" + followUpId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetFollowUpAnswers(_response));
        });
    }

    protected processSetFollowUpAnswers(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PatientFollowUpsManagementClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSchedules(studyId: string | null | undefined, cancelToken?: CancelToken): Promise<StudyFollowUpScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSchedules(_response));
        });
    }

    protected processGetSchedules(response: AxiosResponse): Promise<StudyFollowUpScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyFollowUpScheduleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StudyFollowUpScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyFollowUpScheduleResult[]>(null as any);
    }

    getCallSchedules(studyId: string, cancelToken?: CancelToken): Promise<StudyFollowUpCallScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/callSchedules";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallSchedules(_response));
        });
    }

    protected processGetCallSchedules(response: AxiosResponse): Promise<StudyFollowUpCallScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyFollowUpCallScheduleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StudyFollowUpCallScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyFollowUpCallScheduleResult[]>(null as any);
    }

    createCallSchedule(studyId: string, model: CallScheduleModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/callSchedules";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateCallSchedule(_response));
        });
    }

    protected processCreateCallSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateCallSchedule(callScheduleId: string, model: CallScheduleModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/callSchedules/{callScheduleId}";
        if (callScheduleId === undefined || callScheduleId === null)
            throw new globalThis.Error("The parameter 'callScheduleId' must be defined.");
        url_ = url_.replace("{callScheduleId}", encodeURIComponent("" + callScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCallSchedule(_response));
        });
    }

    protected processUpdateCallSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteCallSchedule(callScheduleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/callSchedules/{callScheduleId}";
        if (callScheduleId === undefined || callScheduleId === null)
            throw new globalThis.Error("The parameter 'callScheduleId' must be defined.");
        url_ = url_.replace("{callScheduleId}", encodeURIComponent("" + callScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteCallSchedule(_response));
        });
    }

    protected processDeleteCallSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEmailSchedules(studyId: string, cancelToken?: CancelToken): Promise<StudyFollowUpEmailScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/emailSchedules";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmailSchedules(_response));
        });
    }

    protected processGetEmailSchedules(response: AxiosResponse): Promise<StudyFollowUpEmailScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyFollowUpEmailScheduleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StudyFollowUpEmailScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyFollowUpEmailScheduleResult[]>(null as any);
    }

    createEmailSchedule(studyId: string, model: EmailScheduleModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/{studyId}/emailSchedules";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEmailSchedule(_response));
        });
    }

    protected processCreateEmailSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateEmailSchedule(emailScheduleId: string, model: EmailScheduleModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/emailSchedules/{emailScheduleId}";
        if (emailScheduleId === undefined || emailScheduleId === null)
            throw new globalThis.Error("The parameter 'emailScheduleId' must be defined.");
        url_ = url_.replace("{emailScheduleId}", encodeURIComponent("" + emailScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEmailSchedule(_response));
        });
    }

    protected processUpdateEmailSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteEmailSchedule(emailScheduleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/patientfollowups/emailSchedules/{emailScheduleId}";
        if (emailScheduleId === undefined || emailScheduleId === null)
            throw new globalThis.Error("The parameter 'emailScheduleId' must be defined.");
        url_ = url_.replace("{emailScheduleId}", encodeURIComponent("" + emailScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteEmailSchedule(_response));
        });
    }

    protected processDeleteEmailSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MissedAppointmentFollowupClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createEmailFollowup(model: MissedAppointmentEmailFollowupModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEmailFollowup(_response));
        });
    }

    protected processCreateEmailFollowup(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEmailFollowupSchedules(studyId: string, cancelToken?: CancelToken): Promise<MissedAppointmentEmailScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/{studyId}/emailFollowUpSchedules";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmailFollowupSchedules(_response));
        });
    }

    protected processGetEmailFollowupSchedules(response: AxiosResponse): Promise<MissedAppointmentEmailScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MissedAppointmentEmailScheduleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MissedAppointmentEmailScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissedAppointmentEmailScheduleResult[]>(null as any);
    }

    updateEmailFollowupSchedule(scheduleId: string, model: MissedAppointmentEmailFollowupModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/updateEmailFollowUpSchedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateEmailFollowupSchedule(_response));
        });
    }

    protected processUpdateEmailFollowupSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteFollowupSchedule(scheduleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/deleteEmailFollowUpSchedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new globalThis.Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteFollowupSchedule(_response));
        });
    }

    protected processDeleteFollowupSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getStudyCallAttemptConfigurations(studyId: string, cancelToken?: CancelToken): Promise<CallAttemptConfigurationResult[]> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/callbackConfigurations/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyCallAttemptConfigurations(_response));
        });
    }

    protected processGetStudyCallAttemptConfigurations(response: AxiosResponse): Promise<CallAttemptConfigurationResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallAttemptConfigurationResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CallAttemptConfigurationResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallAttemptConfigurationResult[]>(null as any);
    }

    createCallConfiguration(studyId: string, model: MissedAppointmentCallConfigurationModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/{studyId}/callBackConfiguration";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateCallConfiguration(_response));
        });
    }

    protected processCreateCallConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateCallConfiguration(configurationId: string, model: MissedAppointmentCallConfigurationModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/missedappointmentfollowupconfiguration/callbackConfiguration/{configurationId}";
        if (configurationId === undefined || configurationId === null)
            throw new globalThis.Error("The parameter 'configurationId' must be defined.");
        url_ = url_.replace("{configurationId}", encodeURIComponent("" + configurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCallConfiguration(_response));
        });
    }

    protected processUpdateCallConfiguration(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MessageThreadsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMessageThreadSummaries( cancelToken?: CancelToken): Promise<MessageThreadSummaryResult[]> {
        let url_ = this.baseUrl + "/message-threads";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMessageThreadSummaries(_response));
        });
    }

    protected processGetMessageThreadSummaries(response: AxiosResponse): Promise<MessageThreadSummaryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageThreadSummaryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MessageThreadSummaryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadSummaryResult[]>(null as any);
    }

    createThread(model: CreateMessageThreadRequestModel, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateThread(_response));
        });
    }

    protected processCreateThread(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    getThread(messageThreadId: string, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new globalThis.Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetThread(_response));
        });
    }

    protected processGetThread(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    readThread(messageThreadId: string, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}/read";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new globalThis.Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReadThread(_response));
        });
    }

    protected processReadThread(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    createComment(model: CreateCommentForMessageThreadRequestModel, cancelToken?: CancelToken): Promise<MessageThreadResult> {
        let url_ = this.baseUrl + "/message-threads/comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateComment(_response));
        });
    }

    protected processCreateComment(response: AxiosResponse): Promise<MessageThreadResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MessageThreadResult.fromJS(resultData200);
            return Promise.resolve<MessageThreadResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageThreadResult>(null as any);
    }

    completeThread(messageThreadId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}/complete";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new globalThis.Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteThread(_response));
        });
    }

    protected processCompleteThread(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uncompleteThread(messageThreadId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/message-threads/{messageThreadId}/uncomplete";
        if (messageThreadId === undefined || messageThreadId === null)
            throw new globalThis.Error("The parameter 'messageThreadId' must be defined.");
        url_ = url_.replace("{messageThreadId}", encodeURIComponent("" + messageThreadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUncompleteThread(_response));
        });
    }

    protected processUncompleteThread(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class InitialStateClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    loadEmails( cancelToken?: CancelToken): Promise<InitialStateEmailResult> {
        let url_ = this.baseUrl + "/api/InitialState/emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLoadEmails(_response));
        });
    }

    protected processLoadEmails(response: AxiosResponse): Promise<InitialStateEmailResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InitialStateEmailResult.fromJS(resultData200);
            return Promise.resolve<InitialStateEmailResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InitialStateEmailResult>(null as any);
    }

    loadAdministrativeData( cancelToken?: CancelToken): Promise<AdministrativeDataResult> {
        let url_ = this.baseUrl + "/api/InitialState/administrative-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLoadAdministrativeData(_response));
        });
    }

    protected processLoadAdministrativeData(response: AxiosResponse): Promise<AdministrativeDataResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdministrativeDataResult.fromJS(resultData200);
            return Promise.resolve<AdministrativeDataResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdministrativeDataResult>(null as any);
    }

    loadTaskData( cancelToken?: CancelToken): Promise<TaskDataResult> {
        let url_ = this.baseUrl + "/api/InitialState/task-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLoadTaskData(_response));
        });
    }

    protected processLoadTaskData(response: AxiosResponse): Promise<TaskDataResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TaskDataResult.fromJS(resultData200);
            return Promise.resolve<TaskDataResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskDataResult>(null as any);
    }
}

export class IncomingVideosClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getActiveVideos( cancelToken?: CancelToken): Promise<IncomingVideoResult[]> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetActiveVideos(_response));
        });
    }

    protected processGetActiveVideos(response: AxiosResponse): Promise<IncomingVideoResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomingVideoResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IncomingVideoResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncomingVideoResult[]>(null as any);
    }

    getInProgressVideos( cancelToken?: CancelToken): Promise<InProgressVideoCallResult[]> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/in-progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInProgressVideos(_response));
        });
    }

    protected processGetInProgressVideos(response: AxiosResponse): Promise<InProgressVideoCallResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InProgressVideoCallResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<InProgressVideoCallResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InProgressVideoCallResult[]>(null as any);
    }

    getVideo(incomingVideoId: string, cancelToken?: CancelToken): Promise<IncomingVideoResult> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new globalThis.Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVideo(_response));
        });
    }

    protected processGetVideo(response: AxiosResponse): Promise<IncomingVideoResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncomingVideoResult.fromJS(resultData200);
            return Promise.resolve<IncomingVideoResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncomingVideoResult>(null as any);
    }

    joinVideo(incomingVideoId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/join";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new globalThis.Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processJoinVideo(_response));
        });
    }

    protected processJoinVideo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTaskStateHistory(incomingVideoId: string, cancelToken?: CancelToken): Promise<IncomingVideoStateResult[]> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/states";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new globalThis.Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTaskStateHistory(_response));
        });
    }

    protected processGetTaskStateHistory(response: AxiosResponse): Promise<IncomingVideoStateResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IncomingVideoStateResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<IncomingVideoStateResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncomingVideoStateResult[]>(null as any);
    }

    complete(model: CompleteIncomingVideoModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processComplete(_response));
        });
    }

    protected processComplete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unArchiveTask(incomingVideoId: string, model: UpdateIncomingVideoStateModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/unarchive";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new globalThis.Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnArchiveTask(_response));
        });
    }

    protected processUnArchiveTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createIncomingVideo(language: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{language}";
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateIncomingVideo(_response));
        });
    }

    protected processCreateIncomingVideo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getHasRating(incomingVideoId: string, cancelToken?: CancelToken): Promise<ValueTupleOfStringAndBoolean> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/hasRating";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new globalThis.Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetHasRating(_response));
        });
    }

    protected processGetHasRating(response: AxiosResponse): Promise<ValueTupleOfStringAndBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValueTupleOfStringAndBoolean.fromJS(resultData200);
            return Promise.resolve<ValueTupleOfStringAndBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValueTupleOfStringAndBoolean>(null as any);
    }

    setRating(incomingVideoId: string, model: CallRatingModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/incomingvideos/{incomingVideoId}/rating";
        if (incomingVideoId === undefined || incomingVideoId === null)
            throw new globalThis.Error("The parameter 'incomingVideoId' must be defined.");
        url_ = url_.replace("{incomingVideoId}", encodeURIComponent("" + incomingVideoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetRating(_response));
        });
    }

    protected processSetRating(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EmailTemplatesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTemplates(studyId: string | null | undefined, cancelToken?: CancelToken): Promise<EmailTemplateResult[]> {
        let url_ = this.baseUrl + "/api/email-templates?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplates(_response));
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<EmailTemplateResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailTemplateResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailTemplateResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult[]>(null as any);
    }

    getTemplate(templateId: string, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplate(_response));
        });
    }

    protected processGetTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    deleteTemplate(templateId: string, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteTemplate(_response));
        });
    }

    protected processDeleteTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    updateTemplate(templateId: string, model: UpdateEmailTemplateModel, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTemplate(_response));
        });
    }

    protected processUpdateTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    createTemplate(studyId: string, model: CreateEmailTemplateModel, cancelToken?: CancelToken): Promise<EmailTemplateResult> {
        let url_ = this.baseUrl + "/api/email-templates/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTemplate(_response));
        });
    }

    protected processCreateTemplate(response: AxiosResponse): Promise<EmailTemplateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailTemplateResult.fromJS(resultData200);
            return Promise.resolve<EmailTemplateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailTemplateResult>(null as any);
    }

    updateContent(emailContentId: string, subject: string | null | undefined, body: string | null | undefined, files: any[] | null | undefined, deleteAttachmentIds: string[] | null | undefined, cancelToken?: CancelToken): Promise<EmailContentResult> {
        let url_ = this.baseUrl + "/api/email-templates/contents/{emailContentId}";
        if (emailContentId === undefined || emailContentId === null)
            throw new globalThis.Error("The parameter 'emailContentId' must be defined.");
        url_ = url_.replace("{emailContentId}", encodeURIComponent("" + emailContentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (subject !== null && subject !== undefined)
            content_.append("Subject", subject.toString());
        if (body !== null && body !== undefined)
            content_.append("Body", body.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.toString()));
        if (deleteAttachmentIds !== null && deleteAttachmentIds !== undefined)
            deleteAttachmentIds.forEach(item_ => content_.append("DeleteAttachmentIds", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateContent(_response));
        });
    }

    protected processUpdateContent(response: AxiosResponse): Promise<EmailContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailContentResult.fromJS(resultData200);
            return Promise.resolve<EmailContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailContentResult>(null as any);
    }

    createContent(emailTemplateId: string, model: CreateEmailContentModel, cancelToken?: CancelToken): Promise<EmailContentResult> {
        let url_ = this.baseUrl + "/api/email-templates/{emailTemplateId}/contents";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new globalThis.Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateContent(_response));
        });
    }

    protected processCreateContent(response: AxiosResponse): Promise<EmailContentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailContentResult.fromJS(resultData200);
            return Promise.resolve<EmailContentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailContentResult>(null as any);
    }
}

export class EmailClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getInfoEmails( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/InfoEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetInfoEmails(_response));
        });
    }

    protected processGetInfoEmails(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getProcessedInfoEmails( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/ProcessedInfoEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProcessedInfoEmails(_response));
        });
    }

    protected processGetProcessedInfoEmails(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getFaxReceipts( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/FaxReceipts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFaxReceipts(_response));
        });
    }

    protected processGetFaxReceipts(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getProcessedFaxReceipts( cancelToken?: CancelToken): Promise<EmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/ProcessedFaxReceipts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProcessedFaxReceipts(_response));
        });
    }

    protected processGetProcessedFaxReceipts(response: AxiosResponse): Promise<EmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailResult[]>(null as any);
    }

    getSentFaxes( cancelToken?: CancelToken): Promise<SentEmailResult[]> {
        let url_ = this.baseUrl + "/api/v1/emails/SentFaxes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSentFaxes(_response));
        });
    }

    protected processGetSentFaxes(response: AxiosResponse): Promise<SentEmailResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SentEmailResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SentEmailResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SentEmailResult[]>(null as any);
    }

    processEmail(model: ProcessEmailModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/emails/ProcessEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProcessEmail(_response));
        });
    }

    protected processProcessEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    unprocessEmail(model: ProcessEmailModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/emails/UnprocessEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnprocessEmail(_response));
        });
    }

    protected processUnprocessEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAttachment(emailAddress: string, messageID: string, fileName: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/emails/{emailAddress}/{messageID}/{fileName}";
        if (emailAddress === undefined || emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        if (messageID === undefined || messageID === null)
            throw new globalThis.Error("The parameter 'messageID' must be defined.");
        url_ = url_.replace("{messageID}", encodeURIComponent("" + messageID));
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAttachment(_response));
        });
    }

    protected processGetAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class EmailSendersClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getEmailSenders( cancelToken?: CancelToken): Promise<EmailSenderServiceResult[]> {
        let url_ = this.baseUrl + "/api/v1/emailSenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetEmailSenders(_response));
        });
    }

    protected processGetEmailSenders(response: AxiosResponse): Promise<EmailSenderServiceResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailSenderServiceResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmailSenderServiceResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailSenderServiceResult[]>(null as any);
    }
}

export class CulturesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCultures( cancelToken?: CancelToken): Promise<CultureResult[]> {
        let url_ = this.baseUrl + "/api/cultures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCultures(_response));
        });
    }

    protected processGetCultures(response: AxiosResponse): Promise<CultureResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CultureResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CultureResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CultureResult[]>(null as any);
    }
}

export class CallActionsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTransferSurvey( cancelToken?: CancelToken): Promise<SurveyUIModel[]> {
        let url_ = this.baseUrl + "/api/v1/callActions/surveys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTransferSurvey(_response));
        });
    }

    protected processGetTransferSurvey(response: AxiosResponse): Promise<SurveyUIModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyUIModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SurveyUIModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyUIModel[]>(null as any);
    }

    doCallTransferToAgent(agentUserId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToAgent?";
        if (agentUserId === null)
            throw new globalThis.Error("The parameter 'agentUserId' cannot be null.");
        else if (agentUserId !== undefined)
            url_ += "agentUserId=" + encodeURIComponent("" + agentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferToAgent(_response));
        });
    }

    protected processDoCallTransferToAgent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doCallTransferSurvey(surveyId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToSurvey?";
        if (surveyId === null)
            throw new globalThis.Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferSurvey(_response));
        });
    }

    protected processDoCallTransferSurvey(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doCallTransferCustomerCare( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToCustomerCare";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferCustomerCare(_response));
        });
    }

    protected processDoCallTransferCustomerCare(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doCallTransferExternalNumber(destination: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/transferToExternalNumber?";
        if (destination !== undefined && destination !== null)
            url_ += "destination=" + encodeURIComponent("" + destination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallTransferExternalNumber(_response));
        });
    }

    protected processDoCallTransferExternalNumber(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doCallMerge( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/merge";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallMerge(_response));
        });
    }

    protected processDoCallMerge(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doHangUp( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/hangup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoHangUp(_response));
        });
    }

    protected processDoHangUp(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doCallMergeAndQuit( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/mergeandquit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallMergeAndQuit(_response));
        });
    }

    protected processDoCallMergeAndQuit(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    doCallAbort( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/callActions/abort";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoCallAbort(_response));
        });
    }

    protected processDoCallAbort(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StudyUserScheduleClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    setStudyUserScheduleIsLockedFalse(studyUserScheduleId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule/unlock?";
        if (studyUserScheduleId === null)
            throw new globalThis.Error("The parameter 'studyUserScheduleId' cannot be null.");
        else if (studyUserScheduleId !== undefined)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetStudyUserScheduleIsLockedFalse(_response));
        });
    }

    protected processSetStudyUserScheduleIsLockedFalse(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setStudyUserScheduleIsLockedTrue(studyUserScheduleId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule/lock?";
        if (studyUserScheduleId === null)
            throw new globalThis.Error("The parameter 'studyUserScheduleId' cannot be null.");
        else if (studyUserScheduleId !== undefined)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetStudyUserScheduleIsLockedTrue(_response));
        });
    }

    protected processSetStudyUserScheduleIsLockedTrue(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSchedules(userId: string | null | undefined, studyId: string | null | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<UserScheduleResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSchedules(_response));
        });
    }

    protected processGetSchedules(response: AxiosResponse): Promise<UserScheduleResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserScheduleResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserScheduleResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserScheduleResult[]>(null as any);
    }

    createStudyUserSchedule(model: CreateStudyUserScheduleModel, cancelToken?: CancelToken): Promise<UserScheduleResult> {
        let url_ = this.baseUrl + "/api/v1/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateStudyUserSchedule(_response));
        });
    }

    protected processCreateStudyUserSchedule(response: AxiosResponse): Promise<UserScheduleResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserScheduleResult.fromJS(resultData200);
            return Promise.resolve<UserScheduleResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserScheduleResult>(null as any);
    }

    updateUserSchedule(model: UpdateUserScheduleRequestModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUserSchedule(_response));
        });
    }

    protected processUpdateUserSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getScheduleReport(studyId: string | null | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule/report?";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleReport(_response));
        });
    }

    protected processGetScheduleReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteStudyUserSchedule(studyUserScheduleId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyUserScheduleId}";
        if (studyUserScheduleId === undefined || studyUserScheduleId === null)
            throw new globalThis.Error("The parameter 'studyUserScheduleId' must be defined.");
        url_ = url_.replace("{studyUserScheduleId}", encodeURIComponent("" + studyUserScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteStudyUserSchedule(_response));
        });
    }

    protected processDeleteStudyUserSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getScheduleOpeningsForUser(userId: string | null, studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult2[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/{userId}/openings?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new globalThis.Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningsForUser(_response));
        });
    }

    protected processGetScheduleOpeningsForUser(response: AxiosResponse): Promise<ScheduleOpeningResult2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScheduleOpeningResult2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult2[]>(null as any);
    }

    getScheduleOpeningsForStudy(studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult2[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/openings?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new globalThis.Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningsForStudy(_response));
        });
    }

    protected processGetScheduleOpeningsForStudy(response: AxiosResponse): Promise<ScheduleOpeningResult2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScheduleOpeningResult2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult2[]>(null as any);
    }

    getScheduleOpeningSlotsForUser(userId: string | null, studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult2[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/{userId}/openings/slots?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new globalThis.Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningSlotsForUser(_response));
        });
    }

    protected processGetScheduleOpeningSlotsForUser(response: AxiosResponse): Promise<ScheduleOpeningResult2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScheduleOpeningResult2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult2[]>(null as any);
    }

    getScheduleOpeningSlotsForStudy(studyId: string, start: Date | undefined, end: Date | undefined, durationInMinutes: number | undefined, cancelToken?: CancelToken): Promise<ScheduleOpeningResult2[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/study/{studyId}/users/openings/slots?";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (durationInMinutes === null)
            throw new globalThis.Error("The parameter 'durationInMinutes' cannot be null.");
        else if (durationInMinutes !== undefined)
            url_ += "durationInMinutes=" + encodeURIComponent("" + durationInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleOpeningSlotsForStudy(_response));
        });
    }

    protected processGetScheduleOpeningSlotsForStudy(response: AxiosResponse): Promise<ScheduleOpeningResult2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleOpeningResult2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScheduleOpeningResult2[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduleOpeningResult2[]>(null as any);
    }

    getStudyUserHours(userId: string | null | undefined, studyId: string | null | undefined, from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<StudyUserHoursResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/studies/hours?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (studyId !== undefined && studyId !== null)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyUserHours(_response));
        });
    }

    protected processGetStudyUserHours(response: AxiosResponse): Promise<StudyUserHoursResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudyUserHoursResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<StudyUserHoursResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudyUserHoursResult[]>(null as any);
    }

    isUserScheduled(userId: string, studyUserScheduleId: string | null | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/schedule/{userId}/scheduleValidation?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (studyUserScheduleId !== undefined && studyUserScheduleId !== null)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsUserScheduled(_response));
        });
    }

    protected processIsUserScheduled(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    duplicateSchedule(studyId: string, model: DuplicateScheduleViewModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyId}/duplicateSchedule";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDuplicateSchedule(_response));
        });
    }

    protected processDuplicateSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    postSchedule(studyId: string, model: PostScheduleViewModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyId}/schedulePostDate";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostSchedule(_response));
        });
    }

    protected processPostSchedule(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    currentSchedulePostedDate(studyId: string, cancelToken?: CancelToken): Promise<Date | null> {
        let url_ = this.baseUrl + "/api/v1/schedule/{studyId}/currentSchedulePostDate";
        if (studyId === undefined || studyId === null)
            throw new globalThis.Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCurrentSchedulePostedDate(_response));
        });
    }

    protected processCurrentSchedulePostedDate(response: AxiosResponse): Promise<Date | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 ? new Date(resultData200.toString()) : null as any;
    
            return Promise.resolve<Date | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Date | null>(null as any);
    }

    getScheduleGrid(studyId: string | undefined, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<GridScheduleViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/schedule/scheduleGrid?";
        if (studyId === null)
            throw new globalThis.Error("The parameter 'studyId' cannot be null.");
        else if (studyId !== undefined)
            url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetScheduleGrid(_response));
        });
    }

    protected processGetScheduleGrid(response: AxiosResponse): Promise<GridScheduleViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GridScheduleViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<GridScheduleViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GridScheduleViewModel[]>(null as any);
    }

    userScheduleAppointmentCheck(studyUserScheduleId: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/schedule/userScheduleAppointmentCheck?";
        if (studyUserScheduleId === null)
            throw new globalThis.Error("The parameter 'studyUserScheduleId' cannot be null.");
        else if (studyUserScheduleId !== undefined)
            url_ += "studyUserScheduleId=" + encodeURIComponent("" + studyUserScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserScheduleAppointmentCheck(_response));
        });
    }

    protected processUserScheduleAppointmentCheck(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    doesDestinationWeekHaveAppointments(start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/schedule/doesDestinationWeekHaveAppointments?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDoesDestinationWeekHaveAppointments(_response));
        });
    }

    protected processDoesDestinationWeekHaveAppointments(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class AvailabilityClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAvailabilityForCurrentUser( cancelToken?: CancelToken): Promise<AvailabilityResult[]> {
        let url_ = this.baseUrl + "/api/v1/availability/users/currentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailabilityForCurrentUser(_response));
        });
    }

    protected processGetAvailabilityForCurrentUser(response: AxiosResponse): Promise<AvailabilityResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailabilityResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityResult[]>(null as any);
    }

    getAvailabilityForAllUsers(start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<AvailabilityResult[]> {
        let url_ = this.baseUrl + "/api/v1/availability/users/allUsers?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailabilityForAllUsers(_response));
        });
    }

    protected processGetAvailabilityForAllUsers(response: AxiosResponse): Promise<AvailabilityResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailabilityResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityResult[]>(null as any);
    }

    getAvailabilityForUser(userId: string, toDate: Date | null | undefined, fromDate: Date | null | undefined, cancelToken?: CancelToken): Promise<AvailabilityResult[]> {
        let url_ = this.baseUrl + "/api/v1/availability/users/{userId}?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailabilityForUser(_response));
        });
    }

    protected processGetAvailabilityForUser(response: AxiosResponse): Promise<AvailabilityResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailabilityResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailabilityResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityResult[]>(null as any);
    }

    createEntry(model: AvailabilityViewModel, cancelToken?: CancelToken): Promise<AvailabilityViewModel> {
        let url_ = this.baseUrl + "/api/v1/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateEntry(_response));
        });
    }

    protected processCreateEntry(response: AxiosResponse): Promise<AvailabilityViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AvailabilityViewModel.fromJS(resultData200);
            return Promise.resolve<AvailabilityViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailabilityViewModel>(null as any);
    }

    updateAvailability(model: AvailabilityViewModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAvailability(_response));
        });
    }

    protected processUpdateAvailability(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteAvailability(entryId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/availability/{entryId}";
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteAvailability(_response));
        });
    }

    protected processDeleteAvailability(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    isUserAvailable(userId: string, start: Date | undefined, end: Date | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/availability/{userId}/availabilityValidation?";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processIsUserAvailable(_response));
        });
    }

    protected processIsUserAvailable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    duplicateAvailability(model: DuplicateAvailabilityViewModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/availability/duplicateAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDuplicateAvailability(_response));
        });
    }

    protected processDuplicateAvailability(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CallHistoryClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCallHistory(to: Date | undefined, from: Date | undefined, cancelToken?: CancelToken): Promise<CallHistoryResult[]> {
        let url_ = this.baseUrl + "/api/call-history?";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCallHistory(_response));
        });
    }

    protected processGetCallHistory(response: AxiosResponse): Promise<CallHistoryResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallHistoryResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CallHistoryResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallHistoryResult[]>(null as any);
    }
}

export class QueuesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getQueues( cancelToken?: CancelToken): Promise<AsteriskQueueResult[]> {
        let url_ = this.baseUrl + "/api/queues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueues(_response));
        });
    }

    protected processGetQueues(response: AxiosResponse): Promise<AsteriskQueueResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AsteriskQueueResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AsteriskQueueResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AsteriskQueueResult[]>(null as any);
    }

    getQueuesAssignments( cancelToken?: CancelToken): Promise<UserQueuesResult[]> {
        let url_ = this.baseUrl + "/api/queues/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetQueuesAssignments(_response));
        });
    }

    protected processGetQueuesAssignments(response: AxiosResponse): Promise<UserQueuesResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserQueuesResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserQueuesResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserQueuesResult[]>(null as any);
    }

    setUserQueues(userId: string, model: SetUserQueuesModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/queues/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetUserQueues(_response));
        });
    }

    protected processSetUserQueues(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    joinQueue(model: JoinTempQueueModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/queues/join";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processJoinQueue(_response));
        });
    }

    protected processJoinQueue(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AppointmentClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAppointments(from: Date | undefined, to: Date | undefined, cancelToken?: CancelToken): Promise<AppointmentResult[]> {
        let url_ = this.baseUrl + "/api/appointments?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAppointments(_response));
        });
    }

    protected processGetAppointments(response: AxiosResponse): Promise<AppointmentResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AppointmentResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentResult[]>(null as any);
    }

    updateAppointment(model: UpdateAppointmentModel, cancelToken?: CancelToken): Promise<AppointmentOutcome> {
        let url_ = this.baseUrl + "/api/appointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAppointment(_response));
        });
    }

    protected processUpdateAppointment(response: AxiosResponse): Promise<AppointmentOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<AppointmentOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentOutcome>(null as any);
    }

    getUserPendingAppointments( cancelToken?: CancelToken): Promise<AppointmentResult[]> {
        let url_ = this.baseUrl + "/api/appointments/pending";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserPendingAppointments(_response));
        });
    }

    protected processGetUserPendingAppointments(response: AxiosResponse): Promise<AppointmentResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AppointmentResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentResult[]>(null as any);
    }

    createPendingAppointment(model: CreatePendingAppointmentModel, cancelToken?: CancelToken): Promise<PendingAppointmentCreatedModel> {
        let url_ = this.baseUrl + "/api/appointments/pending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreatePendingAppointment(_response));
        });
    }

    protected processCreatePendingAppointment(response: AxiosResponse): Promise<PendingAppointmentCreatedModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PendingAppointmentCreatedModel.fromJS(resultData200);
            return Promise.resolve<PendingAppointmentCreatedModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PendingAppointmentCreatedModel>(null as any);
    }

    updateAppointmentTime(model: UpdateAppointmentTimeModel, cancelToken?: CancelToken): Promise<AppointmentOutcome> {
        let url_ = this.baseUrl + "/api/appointments/time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAppointmentTime(_response));
        });
    }

    protected processUpdateAppointmentTime(response: AxiosResponse): Promise<AppointmentOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<AppointmentOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppointmentOutcome>(null as any);
    }

    cancelPendingAppointment(appointmentId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/appointments/pending/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelPendingAppointment(_response));
        });
    }

    protected processCancelPendingAppointment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    finalizeHcpManualBreakAppointment(model: FinalizeHcpBreakAppointmentModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/appointments/break";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFinalizeHcpManualBreakAppointment(_response));
        });
    }

    protected processFinalizeHcpManualBreakAppointment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteAppointment(appointmentId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/appointments/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteAppointment(_response));
        });
    }

    protected processDeleteAppointment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AgentsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAll( cancelToken?: CancelToken): Promise<UserResult[]> {
        let url_ = this.baseUrl + "/api/v1/agents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResult[]>(null as any);
    }

    getUser(userId: string, cancelToken?: CancelToken): Promise<UserResult> {
        let url_ = this.baseUrl + "/api/v1/agents/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUser(_response));
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResult.fromJS(resultData200);
            return Promise.resolve<UserResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResult>(null as any);
    }

    getAllUsersAllStudies( cancelToken?: CancelToken): Promise<UserResult[]> {
        let url_ = this.baseUrl + "/api/v1/agents/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllUsersAllStudies(_response));
        });
    }

    protected processGetAllUsersAllStudies(response: AxiosResponse): Promise<UserResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResult[]>(null as any);
    }
}

export class ScheduleCallbackClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createCallback(model: CreateCallbackViewModel, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/schedule-callback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateCallback(_response));
        });
    }

    protected processCreateCallback(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAvailableCallbackAppointments(userTimezone: string | null | undefined, cancelToken?: CancelToken): Promise<ProgramAppointmentAvailabilityReponse> {
        let url_ = this.baseUrl + "/api/v1/schedule-callback/available-appointments?";
        if (userTimezone !== undefined && userTimezone !== null)
            url_ += "userTimezone=" + encodeURIComponent("" + userTimezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailableCallbackAppointments(_response));
        });
    }

    protected processGetAvailableCallbackAppointments(response: AxiosResponse): Promise<ProgramAppointmentAvailabilityReponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProgramAppointmentAvailabilityReponse.fromJS(resultData200);
            return Promise.resolve<ProgramAppointmentAvailabilityReponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramAppointmentAvailabilityReponse>(null as any);
    }

    getAvailableTimezones( cancelToken?: CancelToken): Promise<AvailableTimezoneResult[]> {
        let url_ = this.baseUrl + "/api/v1/schedule-callback/available-timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAvailableTimezones(_response));
        });
    }

    protected processGetAvailableTimezones(response: AxiosResponse): Promise<AvailableTimezoneResult[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableTimezoneResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AvailableTimezoneResult[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AvailableTimezoneResult[]>(null as any);
    }

    getVideoCallUrl(programId: string | null | undefined, language: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/schedule-callback/video-call?";
        if (programId !== undefined && programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVideoCallUrl(_response));
        });
    }

    protected processGetVideoCallUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    cancelCallbackTask(callbackTaskId: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/schedule-callback/cancel?";
        if (callbackTaskId === null)
            throw new globalThis.Error("The parameter 'callbackTaskId' cannot be null.");
        else if (callbackTaskId !== undefined)
            url_ += "callbackTaskId=" + encodeURIComponent("" + callbackTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelCallbackTask(_response));
        });
    }

    protected processCancelCallbackTask(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DateAvailabilityResult implements IDateAvailabilityResult {
    date?: Date;
    hasAvailability?: boolean;

    constructor(data?: IDateAvailabilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.hasAvailability = _data["hasAvailability"];
        }
    }

    static fromJS(data: any): DateAvailabilityResult {
        data = typeof data === 'object' ? data : {};
        let result = new DateAvailabilityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["hasAvailability"] = this.hasAvailability;
        return data;
    }
}

export interface IDateAvailabilityResult {
    date?: Date;
    hasAvailability?: boolean;
}

export class ScheduleOpeningResult implements IScheduleOpeningResult {
    start?: Date;
    end?: Date;

    constructor(data?: IScheduleOpeningResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleOpeningResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleOpeningResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }
}

export interface IScheduleOpeningResult {
    start?: Date;
    end?: Date;
}

export class SelectTimeResponseModel implements ISelectTimeResponseModel {
    success?: boolean;
    pendingAppointment?: PendingAppointmentModel | undefined;

    constructor(data?: ISelectTimeResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.pendingAppointment = _data["pendingAppointment"] ? PendingAppointmentModel.fromJS(_data["pendingAppointment"]) : undefined as any;
        }
    }

    static fromJS(data: any): SelectTimeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelectTimeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["pendingAppointment"] = this.pendingAppointment ? this.pendingAppointment.toJSON() : undefined as any;
        return data;
    }
}

export interface ISelectTimeResponseModel {
    success?: boolean;
    pendingAppointment?: PendingAppointmentModel | undefined;
}

export class PendingAppointmentModel implements IPendingAppointmentModel {
    appointmentId?: string;
    start?: Date;
    end?: Date;
    expiresOn?: Date;

    constructor(data?: IPendingAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PendingAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IPendingAppointmentModel {
    appointmentId?: string;
    start?: Date;
    end?: Date;
    expiresOn?: Date;
}

export class SelectTimeRequestModel implements ISelectTimeRequestModel {
    date?: Date;
    callbackToken?: string;

    constructor(data?: ISelectTimeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.callbackToken = _data["callbackToken"];
        }
    }

    static fromJS(data: any): SelectTimeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelectTimeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["callbackToken"] = this.callbackToken;
        return data;
    }
}

export interface ISelectTimeRequestModel {
    date?: Date;
    callbackToken?: string;
}

export class ConfirmAppointmentRequestModel implements IConfirmAppointmentRequestModel {
    callbackToken?: string;
    appointmentId?: string;
    callType?: CallType;

    constructor(data?: IConfirmAppointmentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callbackToken = _data["callbackToken"];
            this.appointmentId = _data["appointmentId"];
            this.callType = _data["callType"];
        }
    }

    static fromJS(data: any): ConfirmAppointmentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAppointmentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callbackToken"] = this.callbackToken;
        data["appointmentId"] = this.appointmentId;
        data["callType"] = this.callType;
        return data;
    }
}

export interface IConfirmAppointmentRequestModel {
    callbackToken?: string;
    appointmentId?: string;
    callType?: CallType;
}

export enum CallType {
    Phone = 1,
    Video = 2,
}

export class ApiVersionResponse implements IApiVersionResponse {
    version?: number;

    constructor(data?: IApiVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ApiVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        return data;
    }
}

export interface IApiVersionResponse {
    version?: number;
}

export class BrandingResponse implements IBrandingResponse {
    brand?: string;

    constructor(data?: IBrandingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brand = _data["brand"];
        }
    }

    static fromJS(data: any): BrandingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BrandingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand;
        return data;
    }
}

export interface IBrandingResponse {
    brand?: string;
}

export class SupportedLanguagesResponse implements ISupportedLanguagesResponse {
    languages?: string[] | undefined;
    supportedCultures?: string[] | undefined;
    defaultCulture?: string | undefined;

    constructor(data?: ISupportedLanguagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["supportedCultures"])) {
                this.supportedCultures = [] as any;
                for (let item of _data["supportedCultures"])
                    this.supportedCultures!.push(item);
            }
            this.defaultCulture = _data["defaultCulture"];
        }
    }

    static fromJS(data: any): SupportedLanguagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupportedLanguagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        if (Array.isArray(this.supportedCultures)) {
            data["supportedCultures"] = [];
            for (let item of this.supportedCultures)
                data["supportedCultures"].push(item);
        }
        data["defaultCulture"] = this.defaultCulture;
        return data;
    }
}

export interface ISupportedLanguagesResponse {
    languages?: string[] | undefined;
    supportedCultures?: string[] | undefined;
    defaultCulture?: string | undefined;
}

export class TrackAppEventsBatchResponse implements ITrackAppEventsBatchResponse {
    acceptedCount?: number;
    rejectedCount?: number;
    rejectionReasons?: string[] | undefined;

    constructor(data?: ITrackAppEventsBatchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acceptedCount = _data["AcceptedCount"];
            this.rejectedCount = _data["RejectedCount"];
            if (Array.isArray(_data["RejectionReasons"])) {
                this.rejectionReasons = [] as any;
                for (let item of _data["RejectionReasons"])
                    this.rejectionReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): TrackAppEventsBatchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrackAppEventsBatchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AcceptedCount"] = this.acceptedCount;
        data["RejectedCount"] = this.rejectedCount;
        if (Array.isArray(this.rejectionReasons)) {
            data["RejectionReasons"] = [];
            for (let item of this.rejectionReasons)
                data["RejectionReasons"].push(item);
        }
        return data;
    }
}

export interface ITrackAppEventsBatchResponse {
    acceptedCount?: number;
    rejectedCount?: number;
    rejectionReasons?: string[] | undefined;
}

export class TrackAppEventsBatchRequest implements ITrackAppEventsBatchRequest {
    platform?: string | undefined;
    appVersion?: string | undefined;
    events?: TrackAppEventDto[] | undefined;

    constructor(data?: ITrackAppEventsBatchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["Platform"];
            this.appVersion = _data["AppVersion"];
            if (Array.isArray(_data["Events"])) {
                this.events = [] as any;
                for (let item of _data["Events"])
                    this.events!.push(TrackAppEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackAppEventsBatchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrackAppEventsBatchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Platform"] = this.platform;
        data["AppVersion"] = this.appVersion;
        if (Array.isArray(this.events)) {
            data["Events"] = [];
            for (let item of this.events)
                data["Events"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrackAppEventsBatchRequest {
    platform?: string | undefined;
    appVersion?: string | undefined;
    events?: TrackAppEventDto[] | undefined;
}

export class TrackAppEventDto implements ITrackAppEventDto {
    eventType?: string | undefined;
    occurredOn!: Date;
    sessionId?: string | undefined;
    pageName?: string | undefined;
    resourceId?: number | undefined;
    resourceName?: string | undefined;
    resourceContentType?: string | undefined;
    sessionDurationSeconds?: number | undefined;
    nymbleId?: string | undefined;
    extra?: { [key: string]: string; } | undefined;

    constructor(data?: ITrackAppEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["EventType"];
            this.occurredOn = _data["OccurredOn"] ? new Date(_data["OccurredOn"].toString()) : undefined as any;
            this.sessionId = _data["SessionId"];
            this.pageName = _data["PageName"];
            this.resourceId = _data["ResourceId"];
            this.resourceName = _data["ResourceName"];
            this.resourceContentType = _data["ResourceContentType"];
            this.sessionDurationSeconds = _data["SessionDurationSeconds"];
            this.nymbleId = _data["NymbleId"];
            if (_data["Extra"]) {
                this.extra = {} as any;
                for (let key in _data["Extra"]) {
                    if (_data["Extra"].hasOwnProperty(key))
                        (this.extra as any)![key] = _data["Extra"][key];
                }
            }
        }
    }

    static fromJS(data: any): TrackAppEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackAppEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EventType"] = this.eventType;
        data["OccurredOn"] = this.occurredOn ? this.occurredOn.toISOString() : undefined as any;
        data["SessionId"] = this.sessionId;
        data["PageName"] = this.pageName;
        data["ResourceId"] = this.resourceId;
        data["ResourceName"] = this.resourceName;
        data["ResourceContentType"] = this.resourceContentType;
        data["SessionDurationSeconds"] = this.sessionDurationSeconds;
        data["NymbleId"] = this.nymbleId;
        if (this.extra) {
            data["Extra"] = {};
            for (let key in this.extra) {
                if (this.extra.hasOwnProperty(key))
                    (data["Extra"] as any)[key] = (this.extra as any)[key];
            }
        }
        return data;
    }
}

export interface ITrackAppEventDto {
    eventType?: string | undefined;
    occurredOn: Date;
    sessionId?: string | undefined;
    pageName?: string | undefined;
    resourceId?: number | undefined;
    resourceName?: string | undefined;
    resourceContentType?: string | undefined;
    sessionDurationSeconds?: number | undefined;
    nymbleId?: string | undefined;
    extra?: { [key: string]: string; } | undefined;
}

export class PublicPatientAppointmentModel implements IPublicPatientAppointmentModel {
    id!: string;
    appointmentMethod?: CallType2;
    agentName?: string | undefined;
    appointmentType?: string | undefined;
    date!: Date;
    duration?: number;
    joinUrl?: string | undefined;
    appointmentStatus?: PublicAppointmentStatus;

    constructor(data?: IPublicPatientAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.appointmentMethod = _data["AppointmentMethod"];
            this.agentName = _data["AgentName"];
            this.appointmentType = _data["AppointmentType"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : undefined as any;
            this.duration = _data["Duration"];
            this.joinUrl = _data["JoinUrl"];
            this.appointmentStatus = _data["AppointmentStatus"];
        }
    }

    static fromJS(data: any): PublicPatientAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPatientAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AppointmentMethod"] = this.appointmentMethod;
        data["AgentName"] = this.agentName;
        data["AppointmentType"] = this.appointmentType;
        data["Date"] = this.date ? this.date.toISOString() : undefined as any;
        data["Duration"] = this.duration;
        data["JoinUrl"] = this.joinUrl;
        data["AppointmentStatus"] = this.appointmentStatus;
        return data;
    }
}

export interface IPublicPatientAppointmentModel {
    id: string;
    appointmentMethod?: CallType2;
    agentName?: string | undefined;
    appointmentType?: string | undefined;
    date: Date;
    duration?: number;
    joinUrl?: string | undefined;
    appointmentStatus?: PublicAppointmentStatus;
}

export enum CallType2 {
    Phone = 1,
    Video = 2,
}

export enum PublicAppointmentStatus {
    Unknown = 0,
    Upcoming = 1,
    Completed = 2,
    Archived = 3,
}

export class PublicSitePatientConversationModel implements IPublicSitePatientConversationModel {
    state?: ConversationState;
    lastReadOn?: Date | undefined;
    messages?: PublicSitePatientMessageModel[] | undefined;

    constructor(data?: IPublicSitePatientConversationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["State"];
            this.lastReadOn = _data["LastReadOn"] ? new Date(_data["LastReadOn"].toString()) : undefined as any;
            if (Array.isArray(_data["Messages"])) {
                this.messages = [] as any;
                for (let item of _data["Messages"])
                    this.messages!.push(PublicSitePatientMessageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicSitePatientConversationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSitePatientConversationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["State"] = this.state;
        data["LastReadOn"] = this.lastReadOn ? this.lastReadOn.toISOString() : undefined as any;
        if (Array.isArray(this.messages)) {
            data["Messages"] = [];
            for (let item of this.messages)
                data["Messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPublicSitePatientConversationModel {
    state?: ConversationState;
    lastReadOn?: Date | undefined;
    messages?: PublicSitePatientMessageModel[] | undefined;
}

export enum ConversationState {
    Unknown = 0,
    Resolved = 1,
    Unresolved = 2,
}

export class PublicSitePatientMessageModel implements IPublicSitePatientMessageModel {
    id!: string;
    sentOn!: Date;
    senderType?: ChatSender;
    senderName?: string | undefined;
    message?: string | undefined;

    constructor(data?: IPublicSitePatientMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.sentOn = _data["SentOn"] ? new Date(_data["SentOn"].toString()) : undefined as any;
            this.senderType = _data["SenderType"];
            this.senderName = _data["SenderName"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): PublicSitePatientMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSitePatientMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SentOn"] = this.sentOn ? this.sentOn.toISOString() : undefined as any;
        data["SenderType"] = this.senderType;
        data["SenderName"] = this.senderName;
        data["Message"] = this.message;
        return data;
    }
}

export interface IPublicSitePatientMessageModel {
    id: string;
    sentOn: Date;
    senderType?: ChatSender;
    senderName?: string | undefined;
    message?: string | undefined;
}

export enum ChatSender {
    Unknown = 0,
    Patient = 1,
    Agent = 2,
    System = 3,
}

export class UnreadMessagesResponse implements IUnreadMessagesResponse {
    unreadMessages?: number;

    constructor(data?: IUnreadMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadMessages = _data["UnreadMessages"];
        }
    }

    static fromJS(data: any): UnreadMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnreadMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnreadMessages"] = this.unreadMessages;
        return data;
    }
}

export interface IUnreadMessagesResponse {
    unreadMessages?: number;
}

export class PublicSiteSendChatMessageRequest implements IPublicSiteSendChatMessageRequest {
    message?: string;

    constructor(data?: IPublicSiteSendChatMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PublicSiteSendChatMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSiteSendChatMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IPublicSiteSendChatMessageRequest {
    message?: string;
}

export class PatientInformationResponse implements IPatientInformationResponse {
    name?: string;
    patientStatus?: PatientStatus;
    purchasedDate?: Date | undefined;
    programProductDisplayPrice?: number | undefined;
    preferredLanguageCode?: string | undefined;

    constructor(data?: IPatientInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.patientStatus = _data["patientStatus"];
            this.purchasedDate = _data["purchasedDate"] ? new Date(_data["purchasedDate"].toString()) : undefined as any;
            this.programProductDisplayPrice = _data["programProductDisplayPrice"];
            this.preferredLanguageCode = _data["preferredLanguageCode"];
        }
    }

    static fromJS(data: any): PatientInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["patientStatus"] = this.patientStatus;
        data["purchasedDate"] = this.purchasedDate ? this.purchasedDate.toISOString() : undefined as any;
        data["programProductDisplayPrice"] = this.programProductDisplayPrice;
        data["preferredLanguageCode"] = this.preferredLanguageCode;
        return data;
    }
}

export interface IPatientInformationResponse {
    name?: string;
    patientStatus?: PatientStatus;
    purchasedDate?: Date | undefined;
    programProductDisplayPrice?: number | undefined;
    preferredLanguageCode?: string | undefined;
}

export enum PatientStatus {
    PartialEnrolled = 0,
    Enrolled = 1,
    Inactive = 2,
    Ineligible = 4,
    NotInterested = 5,
    PermanentlyIncomplete = 6,
    TestData = 7,
    Waitlist = 8,
    Paused = 9,
    OngoingSupport = 10,
    HoldingTank = 11,
    PreEnrollment = 12,
    Completed = 13,
    Assessment = 14,
    Enrolled12 = 15,
    Essentials = 16,
    ProgramOverview = 17,
    Webinar = 18,
}

export class ContactInfo implements IContactInfo {
    infoEmail!: string;
    phoneNumber!: string;
    niceFormattedPhoneNumber!: string;
    formattedPhoneNumber!: string;
    phoneDays!: string;
    phoneHours!: string;
    mailAddress!: string;

    constructor(data?: IContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.infoEmail = _data["infoEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.niceFormattedPhoneNumber = _data["niceFormattedPhoneNumber"];
            this.formattedPhoneNumber = _data["formattedPhoneNumber"];
            this.phoneDays = _data["phoneDays"];
            this.phoneHours = _data["phoneHours"];
            this.mailAddress = _data["mailAddress"];
        }
    }

    static fromJS(data: any): ContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["infoEmail"] = this.infoEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["niceFormattedPhoneNumber"] = this.niceFormattedPhoneNumber;
        data["formattedPhoneNumber"] = this.formattedPhoneNumber;
        data["phoneDays"] = this.phoneDays;
        data["phoneHours"] = this.phoneHours;
        data["mailAddress"] = this.mailAddress;
        return data;
    }
}

export interface IContactInfo {
    infoEmail: string;
    phoneNumber: string;
    niceFormattedPhoneNumber: string;
    formattedPhoneNumber: string;
    phoneDays: string;
    phoneHours: string;
    mailAddress: string;
}

export class GetPublicInteractionRequestsInPendingStatusItem implements IGetPublicInteractionRequestsInPendingStatusItem {
    publicInteractionRequestId!: string;
    interactionName?: string | undefined;

    constructor(data?: IGetPublicInteractionRequestsInPendingStatusItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicInteractionRequestId = _data["PublicInteractionRequestId"];
            this.interactionName = _data["InteractionName"];
        }
    }

    static fromJS(data: any): GetPublicInteractionRequestsInPendingStatusItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicInteractionRequestsInPendingStatusItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PublicInteractionRequestId"] = this.publicInteractionRequestId;
        data["InteractionName"] = this.interactionName;
        return data;
    }
}

export interface IGetPublicInteractionRequestsInPendingStatusItem {
    publicInteractionRequestId: string;
    interactionName?: string | undefined;
}

export class RegisterDeviceRequest implements IRegisterDeviceRequest {
    deviceToken?: string;
    platform?: string;

    constructor(data?: IRegisterDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceToken = _data["deviceToken"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): RegisterDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceToken"] = this.deviceToken;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IRegisterDeviceRequest {
    deviceToken?: string;
    platform?: string;
}

export class NymbleEnrollmentResponse implements INymbleEnrollmentResponse {
    nymbleId?: string;

    constructor(data?: INymbleEnrollmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nymbleId = _data["nymbleId"];
        }
    }

    static fromJS(data: any): NymbleEnrollmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleEnrollmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nymbleId"] = this.nymbleId;
        return data;
    }
}

export interface INymbleEnrollmentResponse {
    nymbleId?: string;
}

export class NymbleMessageResponse implements INymbleMessageResponse {
    id?: string;
    timestamp?: number;
    blocks?: NymbleResponseBlock[];

    constructor(data?: INymbleMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"];
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(NymbleResponseBlock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NymbleMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INymbleMessageResponse {
    id?: string;
    timestamp?: number;
    blocks?: NymbleResponseBlock[];
}

export class NymbleResponseBlock implements INymbleResponseBlock {
    type?: string;
    value?: string;

    constructor(data?: INymbleResponseBlock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NymbleResponseBlock {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleResponseBlock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface INymbleResponseBlock {
    type?: string;
    value?: string;
}

export class NymbleSendMessageRequest implements INymbleSendMessageRequest {
    message?: string;

    constructor(data?: INymbleSendMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): NymbleSendMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleSendMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface INymbleSendMessageRequest {
    message?: string;
}

export class NymbleChatMessage implements INymbleChatMessage {
    role?: string;
    messageType?: string;
    message?: NymbleMessage;

    constructor(data?: INymbleChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.messageType = _data["messageType"];
            this.message = _data["message"] ? NymbleMessage.fromJS(_data["message"]) : undefined as any;
        }
    }

    static fromJS(data: any): NymbleChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["messageType"] = this.messageType;
        data["message"] = this.message ? this.message.toJSON() : undefined as any;
        return data;
    }
}

export interface INymbleChatMessage {
    role?: string;
    messageType?: string;
    message?: NymbleMessage;
}

export class NymbleMessage implements INymbleMessage {
    id?: string;
    timestamp?: number;
    value?: string | undefined;
    blocks?: NymbleResponseBlock[] | undefined;

    constructor(data?: INymbleMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timestamp = _data["timestamp"];
            this.value = _data["value"];
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [] as any;
                for (let item of _data["blocks"])
                    this.blocks!.push(NymbleResponseBlock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NymbleMessage {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timestamp"] = this.timestamp;
        data["value"] = this.value;
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INymbleMessage {
    id?: string;
    timestamp?: number;
    value?: string | undefined;
    blocks?: NymbleResponseBlock[] | undefined;
}

export class NymbleWebhookPayload implements INymbleWebhookPayload {
    notificationId?: string;
    user?: NymbleWebhookUser;
    content?: NymbleWebhookContent;
    metadata?: NymbleWebhookMetadata;

    constructor(data?: INymbleWebhookPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationId = _data["notificationId"];
            this.user = _data["user"] ? NymbleWebhookUser.fromJS(_data["user"]) : undefined as any;
            this.content = _data["content"] ? NymbleWebhookContent.fromJS(_data["content"]) : undefined as any;
            this.metadata = _data["metadata"] ? NymbleWebhookMetadata.fromJS(_data["metadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): NymbleWebhookPayload {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleWebhookPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationId"] = this.notificationId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["content"] = this.content ? this.content.toJSON() : undefined as any;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined as any;
        return data;
    }
}

export interface INymbleWebhookPayload {
    notificationId?: string;
    user?: NymbleWebhookUser;
    content?: NymbleWebhookContent;
    metadata?: NymbleWebhookMetadata;
}

export class NymbleWebhookUser implements INymbleWebhookUser {
    nymbleId?: string;

    constructor(data?: INymbleWebhookUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nymbleId = _data["nymbleId"];
        }
    }

    static fromJS(data: any): NymbleWebhookUser {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleWebhookUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nymbleId"] = this.nymbleId;
        return data;
    }
}

export interface INymbleWebhookUser {
    nymbleId?: string;
}

export class NymbleWebhookContent implements INymbleWebhookContent {
    text?: string;

    constructor(data?: INymbleWebhookContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): NymbleWebhookContent {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleWebhookContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface INymbleWebhookContent {
    text?: string;
}

export class NymbleWebhookMetadata implements INymbleWebhookMetadata {
    dispatchedAt?: Date;

    constructor(data?: INymbleWebhookMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispatchedAt = _data["dispatchedAt"] ? new Date(_data["dispatchedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NymbleWebhookMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new NymbleWebhookMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispatchedAt"] = this.dispatchedAt ? this.dispatchedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface INymbleWebhookMetadata {
    dispatchedAt?: Date;
}

export class PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto implements IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto {
    results?: PatientAvailableProductForPurchaseResponseDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PatientAvailableProductForPurchaseResponseDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto {
    results?: PatientAvailableProductForPurchaseResponseDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class PatientAvailableProductForPurchaseResponseDto implements IPatientAvailableProductForPurchaseResponseDto {
    productId!: string;
    name?: string | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;

    constructor(data?: IPatientAvailableProductForPurchaseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.name = _data["Name"];
            this.label = _data["Label"];
            this.displayPrice = _data["DisplayPrice"];
        }
    }

    static fromJS(data: any): PatientAvailableProductForPurchaseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAvailableProductForPurchaseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["Name"] = this.name;
        data["Label"] = this.label;
        data["DisplayPrice"] = this.displayPrice;
        return data;
    }
}

export interface IPatientAvailableProductForPurchaseResponseDto {
    productId: string;
    name?: string | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;
}

export enum ProductKind {
    Maintenance = 1,
    Program = 2,
    OneTimeAppointment = 3,
}

export class CreateAppointmentAndPaymentLinkResponse implements ICreateAppointmentAndPaymentLinkResponse {
    patientServicePurchaseId!: string;
    paymentAlternatives?: CreateAppointmentPaymentAlternativeResponse[] | undefined;

    constructor(data?: ICreateAppointmentAndPaymentLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientServicePurchaseId = _data["PatientServicePurchaseId"];
            if (Array.isArray(_data["PaymentAlternatives"])) {
                this.paymentAlternatives = [] as any;
                for (let item of _data["PaymentAlternatives"])
                    this.paymentAlternatives!.push(CreateAppointmentPaymentAlternativeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAppointmentAndPaymentLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentAndPaymentLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PatientServicePurchaseId"] = this.patientServicePurchaseId;
        if (Array.isArray(this.paymentAlternatives)) {
            data["PaymentAlternatives"] = [];
            for (let item of this.paymentAlternatives)
                data["PaymentAlternatives"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateAppointmentAndPaymentLinkResponse {
    patientServicePurchaseId: string;
    paymentAlternatives?: CreateAppointmentPaymentAlternativeResponse[] | undefined;
}

export class CreateAppointmentPaymentAlternativeResponse implements ICreateAppointmentPaymentAlternativeResponse {
    paymentLink?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICreateAppointmentPaymentAlternativeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentLink = _data["PaymentLink"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): CreateAppointmentPaymentAlternativeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentPaymentAlternativeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PaymentLink"] = this.paymentLink;
        data["Name"] = this.name;
        return data;
    }
}

export interface ICreateAppointmentPaymentAlternativeResponse {
    paymentLink?: string | undefined;
    name?: string | undefined;
}

export class AppointmentPurchasedRequest implements IAppointmentPurchasedRequest {
    productId?: string;
    patientServicePurchaseId?: string;

    constructor(data?: IAppointmentPurchasedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.patientServicePurchaseId = _data["patientServicePurchaseId"];
        }
    }

    static fromJS(data: any): AppointmentPurchasedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentPurchasedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["patientServicePurchaseId"] = this.patientServicePurchaseId;
        return data;
    }
}

export interface IAppointmentPurchasedRequest {
    productId?: string;
    patientServicePurchaseId?: string;
}

export class PublicPatientReceiptModel implements IPublicPatientReceiptModel {
    id?: number;
    interactionDate!: Date;
    serviceDate?: string | undefined;
    serviceType?: string | undefined;
    serviceCost?: string | undefined;
    agentName?: string | undefined;

    constructor(data?: IPublicPatientReceiptModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.interactionDate = _data["InteractionDate"] ? new Date(_data["InteractionDate"].toString()) : undefined as any;
            this.serviceDate = _data["ServiceDate"];
            this.serviceType = _data["ServiceType"];
            this.serviceCost = _data["ServiceCost"];
            this.agentName = _data["AgentName"];
        }
    }

    static fromJS(data: any): PublicPatientReceiptModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPatientReceiptModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["InteractionDate"] = this.interactionDate ? this.interactionDate.toISOString() : undefined as any;
        data["ServiceDate"] = this.serviceDate;
        data["ServiceType"] = this.serviceType;
        data["ServiceCost"] = this.serviceCost;
        data["AgentName"] = this.agentName;
        return data;
    }
}

export interface IPublicPatientReceiptModel {
    id?: number;
    interactionDate: Date;
    serviceDate?: string | undefined;
    serviceType?: string | undefined;
    serviceCost?: string | undefined;
    agentName?: string | undefined;
}

export class GetPatientResourcesResponse implements IGetPatientResourcesResponse {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    author?: string | undefined;
    resourceType?: PatientResourceType;

    constructor(data?: IGetPatientResourcesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["ResourceId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.author = _data["Author"];
            this.resourceType = _data["ResourceType"];
        }
    }

    static fromJS(data: any): GetPatientResourcesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientResourcesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ResourceId"] = this.resourceId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["Author"] = this.author;
        data["ResourceType"] = this.resourceType;
        return data;
    }
}

export interface IGetPatientResourcesResponse {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    author?: string | undefined;
    resourceType?: PatientResourceType;
}

export enum PatientResourceType {
    PdfDocument = 1,
    Video = 2,
    Other = 3,
}

export class GetVideoResourceSasUrlResponse implements IGetVideoResourceSasUrlResponse {
    sasUrl?: string | undefined;
    validUntil!: Date;

    constructor(data?: IGetVideoResourceSasUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sasUrl = _data["SasUrl"];
            this.validUntil = _data["ValidUntil"] ? new Date(_data["ValidUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetVideoResourceSasUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetVideoResourceSasUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SasUrl"] = this.sasUrl;
        data["ValidUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetVideoResourceSasUrlResponse {
    sasUrl?: string | undefined;
    validUntil: Date;
}

export class LoginModel implements ILoginModel {
    user?: string;
    pass?: string;
    recaptchaToken?: string;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
            this.pass = _data["pass"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["pass"] = this.pass;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface ILoginModel {
    user?: string;
    pass?: string;
    recaptchaToken?: string;
}

export class ConfirmAccountRequest implements IConfirmAccountRequest {
    email?: string;
    token?: string;
    newPass?: string;
    recaptchaToken?: string;

    constructor(data?: IConfirmAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.newPass = _data["newPass"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): ConfirmAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["newPass"] = this.newPass;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IConfirmAccountRequest {
    email?: string;
    token?: string;
    newPass?: string;
    recaptchaToken?: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    email?: string;
    pass?: string;
    token?: string;
    recaptchaToken?: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.pass = _data["pass"];
            this.token = _data["token"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["pass"] = this.pass;
        data["token"] = this.token;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IResetPasswordRequest {
    email?: string;
    pass?: string;
    token?: string;
    recaptchaToken?: string;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email?: string;
    recaptchaToken?: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email?: string;
    recaptchaToken?: string;
}

export class EnrollmentInitialResponse implements IEnrollmentInitialResponse {
    callbackToken?: string | undefined;
    redirectURL?: string | undefined;
    paymentLinks?: PatientCreateResponsePaymentLinks[] | undefined;
    patientId?: string | undefined;

    constructor(data?: IEnrollmentInitialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callbackToken = _data["callbackToken"];
            this.redirectURL = _data["redirectURL"];
            if (Array.isArray(_data["paymentLinks"])) {
                this.paymentLinks = [] as any;
                for (let item of _data["paymentLinks"])
                    this.paymentLinks!.push(PatientCreateResponsePaymentLinks.fromJS(item));
            }
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): EnrollmentInitialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentInitialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callbackToken"] = this.callbackToken;
        data["redirectURL"] = this.redirectURL;
        if (Array.isArray(this.paymentLinks)) {
            data["paymentLinks"] = [];
            for (let item of this.paymentLinks)
                data["paymentLinks"].push(item ? item.toJSON() : undefined as any);
        }
        data["patientId"] = this.patientId;
        return data;
    }
}

export interface IEnrollmentInitialResponse {
    callbackToken?: string | undefined;
    redirectURL?: string | undefined;
    paymentLinks?: PatientCreateResponsePaymentLinks[] | undefined;
    patientId?: string | undefined;
}

export class PatientCreateResponsePaymentLinks implements IPatientCreateResponsePaymentLinks {
    name?: string;
    cancelAfterMonths?: number;
    url?: string;
    description?: string;
    productType?: string;

    constructor(data?: IPatientCreateResponsePaymentLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cancelAfterMonths = _data["cancelAfterMonths"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.productType = _data["productType"];
        }
    }

    static fromJS(data: any): PatientCreateResponsePaymentLinks {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCreateResponsePaymentLinks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cancelAfterMonths"] = this.cancelAfterMonths;
        data["url"] = this.url;
        data["description"] = this.description;
        data["productType"] = this.productType;
        return data;
    }
}

export interface IPatientCreateResponsePaymentLinks {
    name?: string;
    cancelAfterMonths?: number;
    url?: string;
    description?: string;
    productType?: string;
}

export class EnrollmentInitialRequest implements IEnrollmentInitialRequest {
    firstName!: string;
    lastName!: string;
    email!: string;
    referralSource!: ReferralSource;
    eligible?: boolean | undefined;
    province?: Province | undefined;
    programConsent?: boolean | undefined;
    joinWaitlist?: boolean | undefined;
    waitlistPhoneNumber?: string | undefined;
    waitlistPreferredTimes?: CallTime[] | undefined;
    waitlistVoicemail?: boolean | undefined;
    waitlistConsent?: boolean | undefined;
    callbackToken?: string | undefined;
    healthAssessment?: boolean;
    recaptchaToken?: string;
    patientPartnerChannel?: PatientPartnerChannel;
    systemReferralSource?: SystemReferralSource | undefined;
    phoneNumber?: string | undefined;
    preferredLanguageCode?: string | undefined;

    constructor(data?: IEnrollmentInitialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.referralSource = _data["referralSource"];
            this.eligible = _data["eligible"];
            this.province = _data["province"];
            this.programConsent = _data["programConsent"];
            this.joinWaitlist = _data["joinWaitlist"];
            this.waitlistPhoneNumber = _data["waitlistPhoneNumber"];
            if (Array.isArray(_data["waitlistPreferredTimes"])) {
                this.waitlistPreferredTimes = [] as any;
                for (let item of _data["waitlistPreferredTimes"])
                    this.waitlistPreferredTimes!.push(item);
            }
            this.waitlistVoicemail = _data["waitlistVoicemail"];
            this.waitlistConsent = _data["waitlistConsent"];
            this.callbackToken = _data["callbackToken"];
            this.healthAssessment = _data["healthAssessment"];
            this.recaptchaToken = _data["recaptchaToken"];
            this.patientPartnerChannel = _data["patientPartnerChannel"];
            this.systemReferralSource = _data["systemReferralSource"];
            this.phoneNumber = _data["phoneNumber"];
            this.preferredLanguageCode = _data["preferredLanguageCode"];
        }
    }

    static fromJS(data: any): EnrollmentInitialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentInitialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["referralSource"] = this.referralSource;
        data["eligible"] = this.eligible;
        data["province"] = this.province;
        data["programConsent"] = this.programConsent;
        data["joinWaitlist"] = this.joinWaitlist;
        data["waitlistPhoneNumber"] = this.waitlistPhoneNumber;
        if (Array.isArray(this.waitlistPreferredTimes)) {
            data["waitlistPreferredTimes"] = [];
            for (let item of this.waitlistPreferredTimes)
                data["waitlistPreferredTimes"].push(item);
        }
        data["waitlistVoicemail"] = this.waitlistVoicemail;
        data["waitlistConsent"] = this.waitlistConsent;
        data["callbackToken"] = this.callbackToken;
        data["healthAssessment"] = this.healthAssessment;
        data["recaptchaToken"] = this.recaptchaToken;
        data["patientPartnerChannel"] = this.patientPartnerChannel;
        data["systemReferralSource"] = this.systemReferralSource;
        data["phoneNumber"] = this.phoneNumber;
        data["preferredLanguageCode"] = this.preferredLanguageCode;
        return data;
    }
}

export interface IEnrollmentInitialRequest {
    firstName: string;
    lastName: string;
    email: string;
    referralSource: ReferralSource;
    eligible?: boolean | undefined;
    province?: Province | undefined;
    programConsent?: boolean | undefined;
    joinWaitlist?: boolean | undefined;
    waitlistPhoneNumber?: string | undefined;
    waitlistPreferredTimes?: CallTime[] | undefined;
    waitlistVoicemail?: boolean | undefined;
    waitlistConsent?: boolean | undefined;
    callbackToken?: string | undefined;
    healthAssessment?: boolean;
    recaptchaToken?: string;
    patientPartnerChannel?: PatientPartnerChannel;
    systemReferralSource?: SystemReferralSource | undefined;
    phoneNumber?: string | undefined;
    preferredLanguageCode?: string | undefined;
}

export enum ReferralSource {
    NotSpecified = 0,
    FriendOrFamily = 1,
    OnlineSearch = 2,
    HealthcareProvider = 3,
    SocialMedia = 4,
}

export enum Province {
    AB = 1,
    BC = 2,
    MB = 3,
    NB = 4,
    NL = 5,
    NT = 6,
    NS = 7,
    NU = 8,
    ON = 9,
    PE = 10,
    QC = 11,
    SK = 12,
    YT = 13,
    BR = 101,
}

export enum CallTime {
    Morning = 1,
    Afternoon = 2,
    Evening = 3,
}

export enum PatientPartnerChannel {
    UNKNOWN = 0,
    MWM = 1,
    LAUNCHIT_HEALTH = 2,
}

export enum SystemReferralSource {
    MWM = 1,
    Zepbound = 2,
    Lilly = 3,
}

export class PaymentCompleteResponse implements IPaymentCompleteResponse {
    success?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IPaymentCompleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): PaymentCompleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCompleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IPaymentCompleteResponse {
    success?: boolean;
    errorMessage?: string | undefined;
}

export class PaymentCompleteRequest implements IPaymentCompleteRequest {
    token!: string;

    constructor(data?: IPaymentCompleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): PaymentCompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCompleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IPaymentCompleteRequest {
    token: string;
}

export class PostEnrollmentInteractionResponse implements IPostEnrollmentInteractionResponse {
    status?: PostEnrollmentInteractionStatus;
    patientIdentifier?: string | undefined;
    errorType?: string | undefined;
    errorDescription?: string | undefined;
    redirectToUrl?: string | undefined;
    isRegistration?: boolean | undefined;

    constructor(data?: IPostEnrollmentInteractionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.patientIdentifier = _data["PatientIdentifier"];
            this.errorType = _data["ErrorType"];
            this.errorDescription = _data["ErrorDescription"];
            this.redirectToUrl = _data["RedirectToUrl"];
            this.isRegistration = _data["IsRegistration"];
        }
    }

    static fromJS(data: any): PostEnrollmentInteractionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostEnrollmentInteractionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["PatientIdentifier"] = this.patientIdentifier;
        data["ErrorType"] = this.errorType;
        data["ErrorDescription"] = this.errorDescription;
        data["RedirectToUrl"] = this.redirectToUrl;
        data["IsRegistration"] = this.isRegistration;
        return data;
    }
}

export interface IPostEnrollmentInteractionResponse {
    status?: PostEnrollmentInteractionStatus;
    patientIdentifier?: string | undefined;
    errorType?: string | undefined;
    errorDescription?: string | undefined;
    redirectToUrl?: string | undefined;
    isRegistration?: boolean | undefined;
}

export enum PostEnrollmentInteractionStatus {
    Ok = 0,
    PaymentFail = 1,
    PaymentSuccess = 2,
    PatientFailed = 3,
    RouteToPayment = 4,
    RouteToScheduler = 5,
    PatientSuccess = 6,
}

export class PostGenericInteractionPublicRequest implements IPostGenericInteractionPublicRequest {
    requestKey!: string;
    interactionResponse?: InteractionResponseModel | undefined;

    constructor(data?: IPostGenericInteractionPublicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestKey = _data["RequestKey"];
            this.interactionResponse = _data["InteractionResponse"] ? InteractionResponseModel.fromJS(_data["InteractionResponse"]) : undefined as any;
        }
    }

    static fromJS(data: any): PostGenericInteractionPublicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostGenericInteractionPublicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RequestKey"] = this.requestKey;
        data["InteractionResponse"] = this.interactionResponse ? this.interactionResponse.toJSON() : undefined as any;
        return data;
    }
}

export interface IPostGenericInteractionPublicRequest {
    requestKey: string;
    interactionResponse?: InteractionResponseModel | undefined;
}

export class InteractionResponseModel implements IInteractionResponseModel {
    iPAddress?: string | undefined;
    saveAsDraft?: boolean;
    callBackToken?: string | undefined;
    responses?: InteractionResponseQuestion[] | undefined;
    notes?: string | undefined;

    constructor(data?: IInteractionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iPAddress = _data["IPAddress"];
            this.saveAsDraft = _data["SaveAsDraft"];
            this.callBackToken = _data["CallBackToken"];
            if (Array.isArray(_data["Responses"])) {
                this.responses = [] as any;
                for (let item of _data["Responses"])
                    this.responses!.push(InteractionResponseQuestion.fromJS(item));
            }
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): InteractionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IPAddress"] = this.iPAddress;
        data["SaveAsDraft"] = this.saveAsDraft;
        data["CallBackToken"] = this.callBackToken;
        if (Array.isArray(this.responses)) {
            data["Responses"] = [];
            for (let item of this.responses)
                data["Responses"].push(item ? item.toJSON() : undefined as any);
        }
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IInteractionResponseModel {
    iPAddress?: string | undefined;
    saveAsDraft?: boolean;
    callBackToken?: string | undefined;
    responses?: InteractionResponseQuestion[] | undefined;
    notes?: string | undefined;
}

export class InteractionResponseQuestion implements IInteractionResponseQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId?: number;

    constructor(data?: IInteractionResponseQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Answers"])) {
                this.answers = [] as any;
                for (let item of _data["Answers"])
                    this.answers!.push(QuestionAnswerModel.fromJS(item));
            }
            this.interactionQuestionId = _data["InteractionQuestionId"];
        }
    }

    static fromJS(data: any): InteractionResponseQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionResponseQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["Answers"] = [];
            for (let item of this.answers)
                data["Answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["InteractionQuestionId"] = this.interactionQuestionId;
        return data;
    }
}

export interface IInteractionResponseQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId?: number;
}

export class QuestionAnswerModel implements IQuestionAnswerModel {
    answerValues?: QuestionAnswerValue[] | undefined;

    constructor(data?: IQuestionAnswerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AnswerValues"])) {
                this.answerValues = [] as any;
                for (let item of _data["AnswerValues"])
                    this.answerValues!.push(QuestionAnswerValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionAnswerModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answerValues)) {
            data["AnswerValues"] = [];
            for (let item of this.answerValues)
                data["AnswerValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionAnswerModel {
    answerValues?: QuestionAnswerValue[] | undefined;
}

export class QuestionAnswerValue implements IQuestionAnswerValue {
    subCode?: string | undefined;
    value?: string | undefined;

    constructor(data?: IQuestionAnswerValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCode = _data["SubCode"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): QuestionAnswerValue {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SubCode"] = this.subCode;
        data["Value"] = this.value;
        return data;
    }
}

export interface IQuestionAnswerValue {
    subCode?: string | undefined;
    value?: string | undefined;
}

export class InteractionRenderModel implements IInteractionRenderModel {
    heartBeatSend?: boolean;
    heartBeatEndpoint?: string | undefined;
    interactionType?: InteractionType;
    callbackToken?: string | undefined;
    name?: string | undefined;
    questions?: InteractionQuestion[] | undefined;
    groups?: InteractionQuestionGroup[] | undefined;
    interactionNote?: InteractionNoteModel | undefined;
    rules?: { [key: string]: InteractionRulesGroup; } | undefined;
    executionOutcomeNotifications?: ExecutionOutcomeNotification[] | undefined;

    constructor(data?: IInteractionRenderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heartBeatSend = _data["HeartBeatSend"];
            this.heartBeatEndpoint = _data["HeartBeatEndpoint"];
            this.interactionType = _data["InteractionType"];
            this.callbackToken = _data["CallbackToken"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Questions"])) {
                this.questions = [] as any;
                for (let item of _data["Questions"])
                    this.questions!.push(InteractionQuestion.fromJS(item));
            }
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(InteractionQuestionGroup.fromJS(item));
            }
            this.interactionNote = _data["InteractionNote"] ? InteractionNoteModel.fromJS(_data["InteractionNote"]) : undefined as any;
            if (_data["Rules"]) {
                this.rules = {} as any;
                for (let key in _data["Rules"]) {
                    if (_data["Rules"].hasOwnProperty(key))
                        (this.rules as any)![key] = _data["Rules"][key] ? InteractionRulesGroup.fromJS(_data["Rules"][key]) : new InteractionRulesGroup();
                }
            }
            if (Array.isArray(_data["ExecutionOutcomeNotifications"])) {
                this.executionOutcomeNotifications = [] as any;
                for (let item of _data["ExecutionOutcomeNotifications"])
                    this.executionOutcomeNotifications!.push(ExecutionOutcomeNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionRenderModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRenderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HeartBeatSend"] = this.heartBeatSend;
        data["HeartBeatEndpoint"] = this.heartBeatEndpoint;
        data["InteractionType"] = this.interactionType;
        data["CallbackToken"] = this.callbackToken;
        data["Name"] = this.name;
        if (Array.isArray(this.questions)) {
            data["Questions"] = [];
            for (let item of this.questions)
                data["Questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item ? item.toJSON() : undefined as any);
        }
        data["InteractionNote"] = this.interactionNote ? this.interactionNote.toJSON() : undefined as any;
        if (this.rules) {
            data["Rules"] = {};
            for (let key in this.rules) {
                if (this.rules.hasOwnProperty(key))
                    (data["Rules"] as any)[key] = this.rules[key] ? this.rules[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.executionOutcomeNotifications)) {
            data["ExecutionOutcomeNotifications"] = [];
            for (let item of this.executionOutcomeNotifications)
                data["ExecutionOutcomeNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInteractionRenderModel {
    heartBeatSend?: boolean;
    heartBeatEndpoint?: string | undefined;
    interactionType?: InteractionType;
    callbackToken?: string | undefined;
    name?: string | undefined;
    questions?: InteractionQuestion[] | undefined;
    groups?: InteractionQuestionGroup[] | undefined;
    interactionNote?: InteractionNoteModel | undefined;
    rules?: { [key: string]: InteractionRulesGroup; } | undefined;
    executionOutcomeNotifications?: ExecutionOutcomeNotification[] | undefined;
}

export enum InteractionType {
    Registration = 1,
    System = 2,
    Standard = 3,
    Signed = 4,
    EmailParticipant = 5,
    FaxPhysician = 6,
    FaxAttachment = 7,
}

export class InteractionQuestion implements IInteractionQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId?: number;
    uniqueCode?: string | undefined;
    isRepeatable?: boolean;
    items?: InteractionQuestionItem[] | undefined;

    constructor(data?: IInteractionQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Answers"])) {
                this.answers = [] as any;
                for (let item of _data["Answers"])
                    this.answers!.push(QuestionAnswerModel.fromJS(item));
            }
            this.interactionQuestionId = _data["InteractionQuestionId"];
            this.uniqueCode = _data["UniqueCode"];
            this.isRepeatable = _data["IsRepeatable"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(InteractionQuestionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["Answers"] = [];
            for (let item of this.answers)
                data["Answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["InteractionQuestionId"] = this.interactionQuestionId;
        data["UniqueCode"] = this.uniqueCode;
        data["IsRepeatable"] = this.isRepeatable;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInteractionQuestion {
    answers?: QuestionAnswerModel[] | undefined;
    interactionQuestionId?: number;
    uniqueCode?: string | undefined;
    isRepeatable?: boolean;
    items?: InteractionQuestionItem[] | undefined;
}

export class InteractionQuestionItem implements IInteractionQuestionItem {
    questionId!: string;
    subCode?: string | undefined;
    position?: number;
    questionType?: QuestionType;
    required?: boolean;
    readOnly?: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    questionOptions?: QuestionOption[] | undefined;
    extendedOptions?: ExtendedOptionsObjectMigration | undefined;
    renderData?: string | undefined;

    constructor(data?: IInteractionQuestionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["QuestionId"];
            this.subCode = _data["SubCode"];
            this.position = _data["Position"];
            this.questionType = _data["QuestionType"];
            this.required = _data["Required"];
            this.readOnly = _data["ReadOnly"];
            this.label = _data["Label"];
            this.instruction = _data["Instruction"];
            this.validationMessage = _data["ValidationMessage"];
            if (Array.isArray(_data["QuestionOptions"])) {
                this.questionOptions = [] as any;
                for (let item of _data["QuestionOptions"])
                    this.questionOptions!.push(QuestionOption.fromJS(item));
            }
            this.extendedOptions = _data["ExtendedOptions"] ? ExtendedOptionsObjectMigration.fromJS(_data["ExtendedOptions"]) : undefined as any;
            this.renderData = _data["RenderData"];
        }
    }

    static fromJS(data: any): InteractionQuestionItem {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuestionId"] = this.questionId;
        data["SubCode"] = this.subCode;
        data["Position"] = this.position;
        data["QuestionType"] = this.questionType;
        data["Required"] = this.required;
        data["ReadOnly"] = this.readOnly;
        data["Label"] = this.label;
        data["Instruction"] = this.instruction;
        data["ValidationMessage"] = this.validationMessage;
        if (Array.isArray(this.questionOptions)) {
            data["QuestionOptions"] = [];
            for (let item of this.questionOptions)
                data["QuestionOptions"].push(item ? item.toJSON() : undefined as any);
        }
        data["ExtendedOptions"] = this.extendedOptions ? this.extendedOptions.toJSON() : undefined as any;
        data["RenderData"] = this.renderData;
        return data;
    }
}

export interface IInteractionQuestionItem {
    questionId: string;
    subCode?: string | undefined;
    position?: number;
    questionType?: QuestionType;
    required?: boolean;
    readOnly?: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    questionOptions?: QuestionOption[] | undefined;
    extendedOptions?: ExtendedOptionsObjectMigration | undefined;
    renderData?: string | undefined;
}

export enum QuestionType {
    Instruction = 0,
    Identifier = 1,
    Text = 2,
    Number = 3,
    Date = 4,
    Time = 5,
    SingleChoice = 6,
    MultipleChoice = 7,
    Matrix = 8,
    MultiLineText = 9,
    InteractionNote = 10,
    Attachment = 11,
    Score = 12,
    Checkbox = 13,
    InteractionSummary = 14,
    Name = 20,
    Language = 21,
    Email = 22,
    MailingAddress = 23,
    PhoneInformation = 24,
    Height = 25,
    Weight = 26,
    Gender = 27,
    DateOfBirth = 28,
    ContactConsent = 29,
    Physician = 30,
    Guardian = 31,
    EnrollmentDate = 32,
    PatientStatus = 33,
    Frequency = 34,
    DropDown = 35,
    Avatar = 36,
    Initials = 37,
    CareMember = 38,
    Signature = 39,
    ActigraphMinuteData = 40,
    EMA = 41,
    AdverseEffectEvent = 42,
    ConcomitantMedicationDetails = 43,
    PhysicianListPhysician = 44,
    SelectDocument = 45,
    SelectAttachment = 46,
    Hidden = 47,
    PatientEmail = 48,
    PatientPhone = 49,
    MedicalHistoryDetails = 53,
    NovoNordiskToolsAndConsent = 54,
    ConcomitantMedicationDetailsShort = 55,
    BodyMassIndex = 56,
    AdverseEventCCGlow = 57,
    AdverseEventLink = 58,
    Pharmacy = 1001,
    ObesityModules = 1002,
    LabWork = 1003,
    Medications = 1004,
    Prescriptions = 1005,
    AomReview = 1006,
    AomReviewMedication = 1007,
    WaistCircumference = 1008,
    SleepApneaReferral = 1009,
    UpdatePatientStatus = 1010,
    Webinar = 1011,
    WebinarAttendance = 1012,
    WebinarEmail = 1013,
}

export class QuestionOption implements IQuestionOption {
    code?: string | undefined;
    label?: string | undefined;
    score?: number;

    constructor(data?: IQuestionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.label = _data["Label"];
            this.score = _data["Score"];
        }
    }

    static fromJS(data: any): QuestionOption {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Label"] = this.label;
        data["Score"] = this.score;
        return data;
    }
}

export interface IQuestionOption {
    code?: string | undefined;
    label?: string | undefined;
    score?: number;
}

export class ExtendedOptionsObjectMigration implements IExtendedOptionsObjectMigration {
    optionGroups?: OptionGroupMigration[] | undefined;
    extendedQuestionOptions?: ExtendedQuestionOptionMigration[] | undefined;

    constructor(data?: IExtendedOptionsObjectMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["OptionGroups"])) {
                this.optionGroups = [] as any;
                for (let item of _data["OptionGroups"])
                    this.optionGroups!.push(OptionGroupMigration.fromJS(item));
            }
            if (Array.isArray(_data["ExtendedQuestionOptions"])) {
                this.extendedQuestionOptions = [] as any;
                for (let item of _data["ExtendedQuestionOptions"])
                    this.extendedQuestionOptions!.push(ExtendedQuestionOptionMigration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtendedOptionsObjectMigration {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedOptionsObjectMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.optionGroups)) {
            data["OptionGroups"] = [];
            for (let item of this.optionGroups)
                data["OptionGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.extendedQuestionOptions)) {
            data["ExtendedQuestionOptions"] = [];
            for (let item of this.extendedQuestionOptions)
                data["ExtendedQuestionOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExtendedOptionsObjectMigration {
    optionGroups?: OptionGroupMigration[] | undefined;
    extendedQuestionOptions?: ExtendedQuestionOptionMigration[] | undefined;
}

export class OptionGroupMigration implements IOptionGroupMigration {
    uniqueCode?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    options?: QuestionOptionMigration[] | undefined;
    value?: string | undefined;
    required?: boolean;
    validationMessages?: LabelTranslation[] | undefined;
    validationMessage?: string | undefined;
    label?: string | undefined;

    constructor(data?: IOptionGroupMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueCode = _data["UniqueCode"];
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(LabelTranslation.fromJS(item));
            }
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(QuestionOptionMigration.fromJS(item));
            }
            this.value = _data["Value"];
            this.required = _data["Required"];
            if (Array.isArray(_data["ValidationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["ValidationMessages"])
                    this.validationMessages!.push(LabelTranslation.fromJS(item));
            }
            this.validationMessage = _data["ValidationMessage"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): OptionGroupMigration {
        data = typeof data === 'object' ? data : {};
        let result = new OptionGroupMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UniqueCode"] = this.uniqueCode;
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item ? item.toJSON() : undefined as any);
        }
        data["Value"] = this.value;
        data["Required"] = this.required;
        if (Array.isArray(this.validationMessages)) {
            data["ValidationMessages"] = [];
            for (let item of this.validationMessages)
                data["ValidationMessages"].push(item ? item.toJSON() : undefined as any);
        }
        data["ValidationMessage"] = this.validationMessage;
        data["Label"] = this.label;
        return data;
    }
}

export interface IOptionGroupMigration {
    uniqueCode?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    options?: QuestionOptionMigration[] | undefined;
    value?: string | undefined;
    required?: boolean;
    validationMessages?: LabelTranslation[] | undefined;
    validationMessage?: string | undefined;
    label?: string | undefined;
}

export class LabelTranslation implements ILabelTranslation {
    language?: string | undefined;
    languageCode?: string | undefined;
    value?: string | undefined;
    isDefault?: boolean;

    constructor(data?: ILabelTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["Language"];
            this.languageCode = _data["LanguageCode"];
            this.value = _data["Value"];
            this.isDefault = _data["IsDefault"];
        }
    }

    static fromJS(data: any): LabelTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new LabelTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Language"] = this.language;
        data["LanguageCode"] = this.languageCode;
        data["Value"] = this.value;
        data["IsDefault"] = this.isDefault;
        return data;
    }
}

export interface ILabelTranslation {
    language?: string | undefined;
    languageCode?: string | undefined;
    value?: string | undefined;
    isDefault?: boolean;
}

export class QuestionOptionMigration implements IQuestionOptionMigration {
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    label?: string | undefined;
    score?: number;

    constructor(data?: IQuestionOptionMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(LabelTranslation.fromJS(item));
            }
            this.label = _data["Label"];
            this.score = _data["Score"];
        }
    }

    static fromJS(data: any): QuestionOptionMigration {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOptionMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : undefined as any);
        }
        data["Label"] = this.label;
        data["Score"] = this.score;
        return data;
    }
}

export interface IQuestionOptionMigration {
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    label?: string | undefined;
    score?: number;
}

export class ExtendedQuestionOptionMigration implements IExtendedQuestionOptionMigration {
    label?: string | undefined;
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    score?: number;
    scoreOptions?: Score[] | undefined;

    constructor(data?: IExtendedQuestionOptionMigration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["Label"];
            this.code = _data["Code"];
            if (Array.isArray(_data["Labels"])) {
                this.labels = [] as any;
                for (let item of _data["Labels"])
                    this.labels!.push(LabelTranslation.fromJS(item));
            }
            this.score = _data["Score"];
            if (Array.isArray(_data["ScoreOptions"])) {
                this.scoreOptions = [] as any;
                for (let item of _data["ScoreOptions"])
                    this.scoreOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtendedQuestionOptionMigration {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedQuestionOptionMigration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Label"] = this.label;
        data["Code"] = this.code;
        if (Array.isArray(this.labels)) {
            data["Labels"] = [];
            for (let item of this.labels)
                data["Labels"].push(item ? item.toJSON() : undefined as any);
        }
        data["Score"] = this.score;
        if (Array.isArray(this.scoreOptions)) {
            data["ScoreOptions"] = [];
            for (let item of this.scoreOptions)
                data["ScoreOptions"].push(item);
        }
        return data;
    }
}

export interface IExtendedQuestionOptionMigration {
    label?: string | undefined;
    code?: string | undefined;
    labels?: LabelTranslation[] | undefined;
    score?: number;
    scoreOptions?: Score[] | undefined;
}

export enum Score {
    Ignore = 0,
    Include = 1,
    Reverse = 2,
}

export class InteractionQuestionGroup implements IInteractionQuestionGroup {
    groupId?: number;
    label?: string | undefined;
    questionIds?: number[] | undefined;

    constructor(data?: IInteractionQuestionGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["GroupId"];
            this.label = _data["Label"];
            if (Array.isArray(_data["QuestionIds"])) {
                this.questionIds = [] as any;
                for (let item of _data["QuestionIds"])
                    this.questionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InteractionQuestionGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestionGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GroupId"] = this.groupId;
        data["Label"] = this.label;
        if (Array.isArray(this.questionIds)) {
            data["QuestionIds"] = [];
            for (let item of this.questionIds)
                data["QuestionIds"].push(item);
        }
        return data;
    }
}

export interface IInteractionQuestionGroup {
    groupId?: number;
    label?: string | undefined;
    questionIds?: number[] | undefined;
}

export class InteractionNoteModel implements IInteractionNoteModel {
    noteType?: InteractionNoteType;
    notes?: string | undefined;

    constructor(data?: IInteractionNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["NoteType"];
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): InteractionNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NoteType"] = this.noteType;
        data["Notes"] = this.notes;
        return data;
    }
}

export interface IInteractionNoteModel {
    noteType?: InteractionNoteType;
    notes?: string | undefined;
}

export enum InteractionNoteType {
    Optional = 1,
    Required = 2,
    Hidden = 3,
    HiddenForPatients = 4,
}

export class InteractionRulesGroup implements IInteractionRulesGroup {
    rules?: InteractionRule[] | undefined;
    comparisor?: InteractionRuleComparisor | undefined;
    groups?: InteractionRulesGroup[] | undefined;

    constructor(data?: IInteractionRulesGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Rules"])) {
                this.rules = [] as any;
                for (let item of _data["Rules"])
                    this.rules!.push(InteractionRule.fromJS(item));
            }
            this.comparisor = _data["Comparisor"];
            if (Array.isArray(_data["Groups"])) {
                this.groups = [] as any;
                for (let item of _data["Groups"])
                    this.groups!.push(InteractionRulesGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionRulesGroup {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRulesGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["Rules"] = [];
            for (let item of this.rules)
                data["Rules"].push(item ? item.toJSON() : undefined as any);
        }
        data["Comparisor"] = this.comparisor;
        if (Array.isArray(this.groups)) {
            data["Groups"] = [];
            for (let item of this.groups)
                data["Groups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInteractionRulesGroup {
    rules?: InteractionRule[] | undefined;
    comparisor?: InteractionRuleComparisor | undefined;
    groups?: InteractionRulesGroup[] | undefined;
}

export class InteractionRule implements IInteractionRule {
    ruleId?: string | undefined;
    dependOnQuestionId?: number;
    operator?: InteractionRuleOperator;
    evaluatedValue?: string | undefined;
    evaluationSubCode?: string | undefined;

    constructor(data?: IInteractionRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["RuleId"];
            this.dependOnQuestionId = _data["DependOnQuestionId"];
            this.operator = _data["Operator"];
            this.evaluatedValue = _data["EvaluatedValue"];
            this.evaluationSubCode = _data["EvaluationSubCode"];
        }
    }

    static fromJS(data: any): InteractionRule {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RuleId"] = this.ruleId;
        data["DependOnQuestionId"] = this.dependOnQuestionId;
        data["Operator"] = this.operator;
        data["EvaluatedValue"] = this.evaluatedValue;
        data["EvaluationSubCode"] = this.evaluationSubCode;
        return data;
    }
}

export interface IInteractionRule {
    ruleId?: string | undefined;
    dependOnQuestionId?: number;
    operator?: InteractionRuleOperator;
    evaluatedValue?: string | undefined;
    evaluationSubCode?: string | undefined;
}

export enum InteractionRuleOperator {
    IsBlank = 1,
    IsNotBlank = 2,
    StartsWith = 3,
    EndsWith = 4,
    Contains = 5,
    Equals = 6,
    GreaterThan = 7,
    LessThan = 8,
    DoesNotContain = 9,
    DoesNotEqual = 10,
}

export enum InteractionRuleComparisor {
    And = 0,
    Or = 1,
}

export class ExecutionOutcomeNotification implements IExecutionOutcomeNotification {
    type?: ExecutionOutcomeNotificationType;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: IExecutionOutcomeNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.title = _data["Title"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): ExecutionOutcomeNotification {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionOutcomeNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Title"] = this.title;
        data["Description"] = this.description;
        return data;
    }
}

export interface IExecutionOutcomeNotification {
    type?: ExecutionOutcomeNotificationType;
    title?: string | undefined;
    description?: string | undefined;
}

export enum ExecutionOutcomeNotificationType {
    Info = 0,
    Alert = 1,
    Warning = 2,
    Error = 3,
}

export class PostEnrollmentInteractionRequest implements IPostEnrollmentInteractionRequest {
    interactionResponse?: InteractionResponseModel | undefined;
    enrollmentPaymentInformation?: EnrollmentPaymentInformation | undefined;

    constructor(data?: IPostEnrollmentInteractionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionResponse = _data["InteractionResponse"] ? InteractionResponseModel.fromJS(_data["InteractionResponse"]) : undefined as any;
            this.enrollmentPaymentInformation = _data["EnrollmentPaymentInformation"] ? EnrollmentPaymentInformation.fromJS(_data["EnrollmentPaymentInformation"]) : undefined as any;
        }
    }

    static fromJS(data: any): PostEnrollmentInteractionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostEnrollmentInteractionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InteractionResponse"] = this.interactionResponse ? this.interactionResponse.toJSON() : undefined as any;
        data["EnrollmentPaymentInformation"] = this.enrollmentPaymentInformation ? this.enrollmentPaymentInformation.toJSON() : undefined as any;
        return data;
    }
}

export interface IPostEnrollmentInteractionRequest {
    interactionResponse?: InteractionResponseModel | undefined;
    enrollmentPaymentInformation?: EnrollmentPaymentInformation | undefined;
}

export class EnrollmentPaymentInformation implements IEnrollmentPaymentInformation {
    cardNumber?: string | undefined;
    cvv?: string | undefined;
    expiration?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IEnrollmentPaymentInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["CardNumber"];
            this.cvv = _data["Cvv"];
            this.expiration = _data["Expiration"];
            this.streetNumber = _data["StreetNumber"];
            this.streetName = _data["StreetName"];
            this.postalCode = _data["PostalCode"];
        }
    }

    static fromJS(data: any): EnrollmentPaymentInformation {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentPaymentInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CardNumber"] = this.cardNumber;
        data["Cvv"] = this.cvv;
        data["Expiration"] = this.expiration;
        data["StreetNumber"] = this.streetNumber;
        data["StreetName"] = this.streetName;
        data["PostalCode"] = this.postalCode;
        return data;
    }
}

export interface IEnrollmentPaymentInformation {
    cardNumber?: string | undefined;
    cvv?: string | undefined;
    expiration?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    postalCode?: string | undefined;
}

export class PatientLoginDto implements IPatientLoginDto {
    patientLoginId?: string;
    loginEmail?: string | undefined;
    patientName?: string | undefined;
    patientVisits?: PatientLoginVisitDto[] | undefined;
    emailConfirmed?: boolean;

    constructor(data?: IPatientLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLoginId = _data["patientLoginId"];
            this.loginEmail = _data["loginEmail"];
            this.patientName = _data["patientName"];
            if (Array.isArray(_data["patientVisits"])) {
                this.patientVisits = [] as any;
                for (let item of _data["patientVisits"])
                    this.patientVisits!.push(PatientLoginVisitDto.fromJS(item));
            }
            this.emailConfirmed = _data["emailConfirmed"];
        }
    }

    static fromJS(data: any): PatientLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientLoginId"] = this.patientLoginId;
        data["loginEmail"] = this.loginEmail;
        data["patientName"] = this.patientName;
        if (Array.isArray(this.patientVisits)) {
            data["patientVisits"] = [];
            for (let item of this.patientVisits)
                data["patientVisits"].push(item ? item.toJSON() : undefined as any);
        }
        data["emailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface IPatientLoginDto {
    patientLoginId?: string;
    loginEmail?: string | undefined;
    patientName?: string | undefined;
    patientVisits?: PatientLoginVisitDto[] | undefined;
    emailConfirmed?: boolean;
}

export class PatientLoginVisitDto implements IPatientLoginVisitDto {
    patientVisitID?: string;
    visitNumber?: number | undefined;
    completedOn?: Date;
    isCompleted?: boolean;
    weight?: number | undefined;
    confidenceScore?: number | undefined;

    constructor(data?: IPatientLoginVisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientVisitID = _data["patientVisitID"];
            this.visitNumber = _data["visitNumber"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            this.isCompleted = _data["isCompleted"];
            this.weight = _data["weight"];
            this.confidenceScore = _data["confidenceScore"];
        }
    }

    static fromJS(data: any): PatientLoginVisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientLoginVisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientVisitID"] = this.patientVisitID;
        data["visitNumber"] = this.visitNumber;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        data["isCompleted"] = this.isCompleted;
        data["weight"] = this.weight;
        data["confidenceScore"] = this.confidenceScore;
        return data;
    }
}

export interface IPatientLoginVisitDto {
    patientVisitID?: string;
    visitNumber?: number | undefined;
    completedOn?: Date;
    isCompleted?: boolean;
    weight?: number | undefined;
    confidenceScore?: number | undefined;
}

export class ServiceOutcome implements IServiceOutcome {
    isSuccessful?: boolean;

    constructor(data?: IServiceOutcome) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): ServiceOutcome {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOutcome();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IServiceOutcome {
    isSuccessful?: boolean;
}

export class GetPublicInteractionRequestsInPendingStatusItem2 implements IGetPublicInteractionRequestsInPendingStatusItem2 {
    publicInteractionRequestId?: string;
    interactionName?: string | undefined;

    constructor(data?: IGetPublicInteractionRequestsInPendingStatusItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicInteractionRequestId = _data["publicInteractionRequestId"];
            this.interactionName = _data["interactionName"];
        }
    }

    static fromJS(data: any): GetPublicInteractionRequestsInPendingStatusItem2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicInteractionRequestsInPendingStatusItem2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicInteractionRequestId"] = this.publicInteractionRequestId;
        data["interactionName"] = this.interactionName;
        return data;
    }
}

export interface IGetPublicInteractionRequestsInPendingStatusItem2 {
    publicInteractionRequestId?: string;
    interactionName?: string | undefined;
}

export class GetPatientResourcesResponse2 implements IGetPatientResourcesResponse2 {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    author?: string | undefined;
    resourceType?: PatientResourceType2;

    constructor(data?: IGetPatientResourcesResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.author = _data["author"];
            this.resourceType = _data["resourceType"];
        }
    }

    static fromJS(data: any): GetPatientResourcesResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientResourcesResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["author"] = this.author;
        data["resourceType"] = this.resourceType;
        return data;
    }
}

export interface IGetPatientResourcesResponse2 {
    resourceId?: number;
    name?: string | undefined;
    description?: string | undefined;
    author?: string | undefined;
    resourceType?: PatientResourceType2;
}

export enum PatientResourceType2 {
    PdfDocument = 1,
    Video = 2,
    Other = 3,
}

export class GetVideoResourceSasUrlResponse2 implements IGetVideoResourceSasUrlResponse2 {
    sasUrl?: string | undefined;
    validUntil?: Date;

    constructor(data?: IGetVideoResourceSasUrlResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sasUrl = _data["sasUrl"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetVideoResourceSasUrlResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetVideoResourceSasUrlResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sasUrl"] = this.sasUrl;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetVideoResourceSasUrlResponse2 {
    sasUrl?: string | undefined;
    validUntil?: Date;
}

export class GetPatientResourceDetailsResponse implements IGetPatientResourceDetailsResponse {
    resourceId?: number;
    filename?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IGetPatientResourceDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.filename = _data["filename"];
            this.description = _data["description"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): GetPatientResourceDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPatientResourceDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["filename"] = this.filename;
        data["description"] = this.description;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IGetPatientResourceDetailsResponse {
    resourceId?: number;
    filename?: string | undefined;
    description?: string | undefined;
    contentType?: string | undefined;
}

export class PreferredLanguageResponse implements IPreferredLanguageResponse {
    languageCode?: string | undefined;

    constructor(data?: IPreferredLanguageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageCode = _data["languageCode"];
        }
    }

    static fromJS(data: any): PreferredLanguageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreferredLanguageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageCode"] = this.languageCode;
        return data;
    }
}

export interface IPreferredLanguageResponse {
    languageCode?: string | undefined;
}

export class ProgramDetailsResponse implements IProgramDetailsResponse {
    status?: PatientStatus2;
    sinceDate?: Date | undefined;
    programProductDisplayPrice?: number | undefined;

    constructor(data?: IProgramDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.sinceDate = _data["sinceDate"] ? new Date(_data["sinceDate"].toString()) : undefined as any;
            this.programProductDisplayPrice = _data["programProductDisplayPrice"];
        }
    }

    static fromJS(data: any): ProgramDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["sinceDate"] = this.sinceDate ? this.sinceDate.toISOString() : undefined as any;
        data["programProductDisplayPrice"] = this.programProductDisplayPrice;
        return data;
    }
}

export interface IProgramDetailsResponse {
    status?: PatientStatus2;
    sinceDate?: Date | undefined;
    programProductDisplayPrice?: number | undefined;
}

export enum PatientStatus2 {
    PartialEnrolled = 0,
    Enrolled = 1,
    Inactive = 2,
    Ineligible = 4,
    NotInterested = 5,
    PermanentlyIncomplete = 6,
    TestData = 7,
    Waitlist = 8,
    Paused = 9,
    OngoingSupport = 10,
    HoldingTank = 11,
    PreEnrollment = 12,
    Completed = 13,
    Assessment = 14,
    Enrolled12 = 15,
    Essentials = 16,
    ProgramOverview = 17,
    Webinar = 18,
}

export class PatientSummaryResult implements IPatientSummaryResult {
    patientId?: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IPatientSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.uniqueId = _data["uniqueId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): PatientSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["uniqueId"] = this.uniqueId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IPatientSummaryResult {
    patientId?: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class AeCcglowSummary implements IAeCcglowSummary {
    aeWithoutCcglowCount?: number;
    aeContainingCcglowCount?: number;

    constructor(data?: IAeCcglowSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aeWithoutCcglowCount = _data["aeWithoutCcglowCount"];
            this.aeContainingCcglowCount = _data["aeContainingCcglowCount"];
        }
    }

    static fromJS(data: any): AeCcglowSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AeCcglowSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aeWithoutCcglowCount"] = this.aeWithoutCcglowCount;
        data["aeContainingCcglowCount"] = this.aeContainingCcglowCount;
        return data;
    }
}

export interface IAeCcglowSummary {
    aeWithoutCcglowCount?: number;
    aeContainingCcglowCount?: number;
}

export class AeSummary implements IAeSummary {
    filedCount?: number;
    faxedCount?: number;

    constructor(data?: IAeSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filedCount = _data["filedCount"];
            this.faxedCount = _data["faxedCount"];
        }
    }

    static fromJS(data: any): AeSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AeSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filedCount"] = this.filedCount;
        data["faxedCount"] = this.faxedCount;
        return data;
    }
}

export interface IAeSummary {
    filedCount?: number;
    faxedCount?: number;
}

export class StoppedTakingSummary implements IStoppedTakingSummary {
    week3StoppedTakingCount?: number;
    week2StoppedTakingCount?: number;
    distinctStoppedTaking?: number;
    completedStoppingCallInteractions?: number;

    constructor(data?: IStoppedTakingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.week3StoppedTakingCount = _data["week3StoppedTakingCount"];
            this.week2StoppedTakingCount = _data["week2StoppedTakingCount"];
            this.distinctStoppedTaking = _data["distinctStoppedTaking"];
            this.completedStoppingCallInteractions = _data["completedStoppingCallInteractions"];
        }
    }

    static fromJS(data: any): StoppedTakingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new StoppedTakingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["week3StoppedTakingCount"] = this.week3StoppedTakingCount;
        data["week2StoppedTakingCount"] = this.week2StoppedTakingCount;
        data["distinctStoppedTaking"] = this.distinctStoppedTaking;
        data["completedStoppingCallInteractions"] = this.completedStoppingCallInteractions;
        return data;
    }
}

export interface IStoppedTakingSummary {
    week3StoppedTakingCount?: number;
    week2StoppedTakingCount?: number;
    distinctStoppedTaking?: number;
    completedStoppingCallInteractions?: number;
}

export class PublicPatientAppointmentModel2 implements IPublicPatientAppointmentModel2 {
    id?: string;
    appointmentMethod?: CallType;
    agentName?: string | undefined;
    appointmentType?: string | undefined;
    date?: Date;
    duration?: number;
    joinUrl?: string | undefined;
    appointmentStatus?: PublicAppointmentStatus2;

    constructor(data?: IPublicPatientAppointmentModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appointmentMethod = _data["appointmentMethod"];
            this.agentName = _data["agentName"];
            this.appointmentType = _data["appointmentType"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.joinUrl = _data["joinUrl"];
            this.appointmentStatus = _data["appointmentStatus"];
        }
    }

    static fromJS(data: any): PublicPatientAppointmentModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPatientAppointmentModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appointmentMethod"] = this.appointmentMethod;
        data["agentName"] = this.agentName;
        data["appointmentType"] = this.appointmentType;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["joinUrl"] = this.joinUrl;
        data["appointmentStatus"] = this.appointmentStatus;
        return data;
    }
}

export interface IPublicPatientAppointmentModel2 {
    id?: string;
    appointmentMethod?: CallType;
    agentName?: string | undefined;
    appointmentType?: string | undefined;
    date?: Date;
    duration?: number;
    joinUrl?: string | undefined;
    appointmentStatus?: PublicAppointmentStatus2;
}

export enum PublicAppointmentStatus2 {
    Unknown = 0,
    Upcoming = 1,
    Completed = 2,
    Archived = 3,
}

export class RegisterDeviceRequest2 implements IRegisterDeviceRequest2 {
    deviceToken?: string | undefined;
    platform?: string | undefined;

    constructor(data?: IRegisterDeviceRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceToken = _data["deviceToken"];
            this.platform = _data["platform"];
        }
    }

    static fromJS(data: any): RegisterDeviceRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDeviceRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceToken"] = this.deviceToken;
        data["platform"] = this.platform;
        return data;
    }
}

export interface IRegisterDeviceRequest2 {
    deviceToken?: string | undefined;
    platform?: string | undefined;
}

export class PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2 implements IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2 {
    results?: PatientAvailableProductForPurchaseResponseDto2[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PatientAvailableProductForPurchaseResponseDto2.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfPatientAvailableProductForPurchaseResponseDto2 {
    results?: PatientAvailableProductForPurchaseResponseDto2[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class PatientAvailableProductForPurchaseResponseDto2 implements IPatientAvailableProductForPurchaseResponseDto2 {
    productId?: string;
    name?: string | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;

    constructor(data?: IPatientAvailableProductForPurchaseResponseDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.displayPrice = _data["displayPrice"];
        }
    }

    static fromJS(data: any): PatientAvailableProductForPurchaseResponseDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAvailableProductForPurchaseResponseDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["label"] = this.label;
        data["displayPrice"] = this.displayPrice;
        return data;
    }
}

export interface IPatientAvailableProductForPurchaseResponseDto2 {
    productId?: string;
    name?: string | undefined;
    label?: string | undefined;
    displayPrice?: number | undefined;
}

export enum ProductKind2 {
    Maintenance = 1,
    Program = 2,
    OneTimeAppointment = 3,
}

export class PublicPatientReceiptModel2 implements IPublicPatientReceiptModel2 {
    id?: number;
    interactionDate?: Date;
    serviceDate?: string | undefined;
    serviceType?: string | undefined;
    serviceCost?: string | undefined;
    agentName?: string | undefined;

    constructor(data?: IPublicPatientReceiptModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.interactionDate = _data["interactionDate"] ? new Date(_data["interactionDate"].toString()) : undefined as any;
            this.serviceDate = _data["serviceDate"];
            this.serviceType = _data["serviceType"];
            this.serviceCost = _data["serviceCost"];
            this.agentName = _data["agentName"];
        }
    }

    static fromJS(data: any): PublicPatientReceiptModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new PublicPatientReceiptModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["interactionDate"] = this.interactionDate ? this.interactionDate.toISOString() : undefined as any;
        data["serviceDate"] = this.serviceDate;
        data["serviceType"] = this.serviceType;
        data["serviceCost"] = this.serviceCost;
        data["agentName"] = this.agentName;
        return data;
    }
}

export interface IPublicPatientReceiptModel2 {
    id?: number;
    interactionDate?: Date;
    serviceDate?: string | undefined;
    serviceType?: string | undefined;
    serviceCost?: string | undefined;
    agentName?: string | undefined;
}

export class DownloadReceiptRequest implements IDownloadReceiptRequest {
    url?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IDownloadReceiptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): DownloadReceiptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadReceiptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IDownloadReceiptRequest {
    url?: string | undefined;
    ipAddress?: string | undefined;
}

export class TrackAppEventsBatchResponse2 implements ITrackAppEventsBatchResponse2 {
    acceptedCount?: number;
    rejectedCount?: number;
    rejectionReasons?: string[] | undefined;

    constructor(data?: ITrackAppEventsBatchResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acceptedCount = _data["acceptedCount"];
            this.rejectedCount = _data["rejectedCount"];
            if (Array.isArray(_data["rejectionReasons"])) {
                this.rejectionReasons = [] as any;
                for (let item of _data["rejectionReasons"])
                    this.rejectionReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): TrackAppEventsBatchResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new TrackAppEventsBatchResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptedCount"] = this.acceptedCount;
        data["rejectedCount"] = this.rejectedCount;
        if (Array.isArray(this.rejectionReasons)) {
            data["rejectionReasons"] = [];
            for (let item of this.rejectionReasons)
                data["rejectionReasons"].push(item);
        }
        return data;
    }
}

export interface ITrackAppEventsBatchResponse2 {
    acceptedCount?: number;
    rejectedCount?: number;
    rejectionReasons?: string[] | undefined;
}

export class TrackAppEventsBatchRequest2 implements ITrackAppEventsBatchRequest2 {
    platform?: string | undefined;
    appVersion?: string | undefined;
    events?: TrackAppEventDto2[] | undefined;

    constructor(data?: ITrackAppEventsBatchRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.appVersion = _data["appVersion"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(TrackAppEventDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackAppEventsBatchRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new TrackAppEventsBatchRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["appVersion"] = this.appVersion;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrackAppEventsBatchRequest2 {
    platform?: string | undefined;
    appVersion?: string | undefined;
    events?: TrackAppEventDto2[] | undefined;
}

export class TrackAppEventDto2 implements ITrackAppEventDto2 {
    eventType?: string | undefined;
    occurredOn?: Date;
    sessionId?: string | undefined;
    pageName?: string | undefined;
    resourceId?: number | undefined;
    resourceName?: string | undefined;
    resourceContentType?: string | undefined;
    sessionDurationSeconds?: number | undefined;
    nymbleId?: string | undefined;
    extra?: { [key: string]: string; } | undefined;

    constructor(data?: ITrackAppEventDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.occurredOn = _data["occurredOn"] ? new Date(_data["occurredOn"].toString()) : undefined as any;
            this.sessionId = _data["sessionId"];
            this.pageName = _data["pageName"];
            this.resourceId = _data["resourceId"];
            this.resourceName = _data["resourceName"];
            this.resourceContentType = _data["resourceContentType"];
            this.sessionDurationSeconds = _data["sessionDurationSeconds"];
            this.nymbleId = _data["nymbleId"];
            if (_data["extra"]) {
                this.extra = {} as any;
                for (let key in _data["extra"]) {
                    if (_data["extra"].hasOwnProperty(key))
                        (this.extra as any)![key] = _data["extra"][key];
                }
            }
        }
    }

    static fromJS(data: any): TrackAppEventDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new TrackAppEventDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["occurredOn"] = this.occurredOn ? this.occurredOn.toISOString() : undefined as any;
        data["sessionId"] = this.sessionId;
        data["pageName"] = this.pageName;
        data["resourceId"] = this.resourceId;
        data["resourceName"] = this.resourceName;
        data["resourceContentType"] = this.resourceContentType;
        data["sessionDurationSeconds"] = this.sessionDurationSeconds;
        data["nymbleId"] = this.nymbleId;
        if (this.extra) {
            data["extra"] = {};
            for (let key in this.extra) {
                if (this.extra.hasOwnProperty(key))
                    (data["extra"] as any)[key] = (this.extra as any)[key];
            }
        }
        return data;
    }
}

export interface ITrackAppEventDto2 {
    eventType?: string | undefined;
    occurredOn?: Date;
    sessionId?: string | undefined;
    pageName?: string | undefined;
    resourceId?: number | undefined;
    resourceName?: string | undefined;
    resourceContentType?: string | undefined;
    sessionDurationSeconds?: number | undefined;
    nymbleId?: string | undefined;
    extra?: { [key: string]: string; } | undefined;
}

export class PublicSitePatientConversationModel2 implements IPublicSitePatientConversationModel2 {
    state?: ConversationState2;
    lastReadOn?: Date | undefined;
    messages?: PublicSitePatientMessageModel2[] | undefined;

    constructor(data?: IPublicSitePatientConversationModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.lastReadOn = _data["lastReadOn"] ? new Date(_data["lastReadOn"].toString()) : undefined as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(PublicSitePatientMessageModel2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicSitePatientConversationModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSitePatientConversationModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["lastReadOn"] = this.lastReadOn ? this.lastReadOn.toISOString() : undefined as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPublicSitePatientConversationModel2 {
    state?: ConversationState2;
    lastReadOn?: Date | undefined;
    messages?: PublicSitePatientMessageModel2[] | undefined;
}

export enum ConversationState2 {
    Unknown = 0,
    Resolved = 1,
    Unresolved = 2,
}

export class PublicSitePatientMessageModel2 implements IPublicSitePatientMessageModel2 {
    id?: string;
    sentOn?: Date;
    senderType?: ChatSender2;
    senderName?: string | undefined;
    message?: string | undefined;

    constructor(data?: IPublicSitePatientMessageModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sentOn = _data["sentOn"] ? new Date(_data["sentOn"].toString()) : undefined as any;
            this.senderType = _data["senderType"];
            this.senderName = _data["senderName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PublicSitePatientMessageModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new PublicSitePatientMessageModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sentOn"] = this.sentOn ? this.sentOn.toISOString() : undefined as any;
        data["senderType"] = this.senderType;
        data["senderName"] = this.senderName;
        data["message"] = this.message;
        return data;
    }
}

export interface IPublicSitePatientMessageModel2 {
    id?: string;
    sentOn?: Date;
    senderType?: ChatSender2;
    senderName?: string | undefined;
    message?: string | undefined;
}

export enum ChatSender2 {
    Unknown = 0,
    Patient = 1,
    Agent = 2,
    System = 3,
}

export class UnreadMessagesResponse2 implements IUnreadMessagesResponse2 {
    unreadMessages?: number;

    constructor(data?: IUnreadMessagesResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadMessages = _data["unreadMessages"];
        }
    }

    static fromJS(data: any): UnreadMessagesResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new UnreadMessagesResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadMessages"] = this.unreadMessages;
        return data;
    }
}

export interface IUnreadMessagesResponse2 {
    unreadMessages?: number;
}

export class SendChatMessageRequest implements ISendChatMessageRequest {
    message?: string | undefined;

    constructor(data?: ISendChatMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendChatMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendChatMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface ISendChatMessageRequest {
    message?: string | undefined;
}

export class GetNymbleEnrollData implements IGetNymbleEnrollData {
    name?: string | undefined;
    customerId?: string | undefined;

    constructor(data?: IGetNymbleEnrollData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): GetNymbleEnrollData {
        data = typeof data === 'object' ? data : {};
        let result = new GetNymbleEnrollData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IGetNymbleEnrollData {
    name?: string | undefined;
    customerId?: string | undefined;
}

export class GetSystemPatientModel implements IGetSystemPatientModel {
    systemPatient?: SystemPatientSummaryModel | undefined;

    constructor(data?: IGetSystemPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemPatient = _data["systemPatient"] ? SystemPatientSummaryModel.fromJS(_data["systemPatient"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetSystemPatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemPatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemPatient"] = this.systemPatient ? this.systemPatient.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetSystemPatientModel {
    systemPatient?: SystemPatientSummaryModel | undefined;
}

export class SystemPatientSummaryModel implements ISystemPatientSummaryModel {
    patientId?: string;
    uniqueId?: string | undefined;

    constructor(data?: ISystemPatientSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): SystemPatientSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemPatientSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

export interface ISystemPatientSummaryModel {
    patientId?: string;
    uniqueId?: string | undefined;
}

export class UpdateStudyPspSystemPatientModel implements IUpdateStudyPspSystemPatientModel {
    patientId?: string | undefined;

    constructor(data?: IUpdateStudyPspSystemPatientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): UpdateStudyPspSystemPatientModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyPspSystemPatientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        return data;
    }
}

export interface IUpdateStudyPspSystemPatientModel {
    patientId?: string | undefined;
}

export class ParticipantsSummaryResult implements IParticipantsSummaryResult {
    statusCounts?: PatientStatusResult[] | undefined;

    constructor(data?: IParticipantsSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statusCounts"])) {
                this.statusCounts = [] as any;
                for (let item of _data["statusCounts"])
                    this.statusCounts!.push(PatientStatusResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantsSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantsSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusCounts)) {
            data["statusCounts"] = [];
            for (let item of this.statusCounts)
                data["statusCounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParticipantsSummaryResult {
    statusCounts?: PatientStatusResult[] | undefined;
}

export class PatientStatusResult implements IPatientStatusResult {
    patientStatus?: PatientStatus2;
    name?: string | undefined;
    count?: number;

    constructor(data?: IPatientStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientStatus = _data["patientStatus"];
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PatientStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientStatus"] = this.patientStatus;
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface IPatientStatusResult {
    patientStatus?: PatientStatus2;
    name?: string | undefined;
    count?: number;
}

export class PatientSummaryStatusResult implements IPatientSummaryStatusResult {
    patientId?: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: PatientStatus2;
    enrolledSubStatus?: string | undefined;

    constructor(data?: IPatientSummaryStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.uniqueId = _data["uniqueId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.enrolledSubStatus = _data["enrolledSubStatus"];
        }
    }

    static fromJS(data: any): PatientSummaryStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSummaryStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["uniqueId"] = this.uniqueId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["enrolledSubStatus"] = this.enrolledSubStatus;
        return data;
    }
}

export interface IPatientSummaryStatusResult {
    patientId?: string;
    uniqueId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: PatientStatus2;
    enrolledSubStatus?: string | undefined;
}

export class EnrollmentCountModel implements IEnrollmentCountModel {
    enrollments?: number;

    constructor(data?: IEnrollmentCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enrollments = _data["enrollments"];
        }
    }

    static fromJS(data: any): EnrollmentCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enrollments"] = this.enrollments;
        return data;
    }
}

export interface IEnrollmentCountModel {
    enrollments?: number;
}

export class QueueMetricsModel implements IQueueMetricsModel {
    averageWaitTime?: string | undefined;
    englishQueuedCallers?: number;
    frenchQueuedCallers?: number;
    englishAvailableAgents?: number;
    frenchAvailableAgents?: number;
    totalAvailableAgents?: number;

    constructor(data?: IQueueMetricsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageWaitTime = _data["averageWaitTime"];
            this.englishQueuedCallers = _data["englishQueuedCallers"];
            this.frenchQueuedCallers = _data["frenchQueuedCallers"];
            this.englishAvailableAgents = _data["englishAvailableAgents"];
            this.frenchAvailableAgents = _data["frenchAvailableAgents"];
            this.totalAvailableAgents = _data["totalAvailableAgents"];
        }
    }

    static fromJS(data: any): QueueMetricsModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueueMetricsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageWaitTime"] = this.averageWaitTime;
        data["englishQueuedCallers"] = this.englishQueuedCallers;
        data["frenchQueuedCallers"] = this.frenchQueuedCallers;
        data["englishAvailableAgents"] = this.englishAvailableAgents;
        data["frenchAvailableAgents"] = this.frenchAvailableAgents;
        data["totalAvailableAgents"] = this.totalAvailableAgents;
        return data;
    }
}

export interface IQueueMetricsModel {
    averageWaitTime?: string | undefined;
    englishQueuedCallers?: number;
    frenchQueuedCallers?: number;
    englishAvailableAgents?: number;
    frenchAvailableAgents?: number;
    totalAvailableAgents?: number;
}

export class AccountSummaryResult implements IAccountSummaryResult {
    accountId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IAccountSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): AccountSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IAccountSummaryResult {
    accountId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class PatientInteractionSummaryResult implements IPatientInteractionSummaryResult {
    interaction?: InteractionSummaryResult | undefined;
    patientInteractionId?: number;
    createdOn?: Date;
    patient?: PatientSummaryResult | undefined;
    account?: AccountSummaryResult | undefined;

    constructor(data?: IPatientInteractionSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interaction = _data["interaction"] ? InteractionSummaryResult.fromJS(_data["interaction"]) : undefined as any;
            this.patientInteractionId = _data["patientInteractionId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.patient = _data["patient"] ? PatientSummaryResult.fromJS(_data["patient"]) : undefined as any;
            this.account = _data["account"] ? AccountSummaryResult.fromJS(_data["account"]) : undefined as any;
        }
    }

    static fromJS(data: any): PatientInteractionSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInteractionSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interaction"] = this.interaction ? this.interaction.toJSON() : undefined as any;
        data["patientInteractionId"] = this.patientInteractionId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["patient"] = this.patient ? this.patient.toJSON() : undefined as any;
        data["account"] = this.account ? this.account.toJSON() : undefined as any;
        return data;
    }
}

export interface IPatientInteractionSummaryResult {
    interaction?: InteractionSummaryResult | undefined;
    patientInteractionId?: number;
    createdOn?: Date;
    patient?: PatientSummaryResult | undefined;
    account?: AccountSummaryResult | undefined;
}

export class InteractionSummaryResult implements IInteractionSummaryResult {
    interactionId?: number;
    name?: string | undefined;

    constructor(data?: IInteractionSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["interactionId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InteractionSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interactionId"] = this.interactionId;
        data["name"] = this.name;
        return data;
    }
}

export interface IInteractionSummaryResult {
    interactionId?: number;
    name?: string | undefined;
}

export class AsteriskSummaryModel implements IAsteriskSummaryModel {
    averageLengthOfCalls?: string;
    dailyInboundVideoCalls?: number;
    dailyInboundPhoneCalls?: number;
    abandonedCalls?: number;
    averageAgentInbound?: number;
    averageAgentOutbound?: number;

    constructor(data?: IAsteriskSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageLengthOfCalls = _data["averageLengthOfCalls"];
            this.dailyInboundVideoCalls = _data["dailyInboundVideoCalls"];
            this.dailyInboundPhoneCalls = _data["dailyInboundPhoneCalls"];
            this.abandonedCalls = _data["abandonedCalls"];
            this.averageAgentInbound = _data["averageAgentInbound"];
            this.averageAgentOutbound = _data["averageAgentOutbound"];
        }
    }

    static fromJS(data: any): AsteriskSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new AsteriskSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageLengthOfCalls"] = this.averageLengthOfCalls;
        data["dailyInboundVideoCalls"] = this.dailyInboundVideoCalls;
        data["dailyInboundPhoneCalls"] = this.dailyInboundPhoneCalls;
        data["abandonedCalls"] = this.abandonedCalls;
        data["averageAgentInbound"] = this.averageAgentInbound;
        data["averageAgentOutbound"] = this.averageAgentOutbound;
        return data;
    }
}

export interface IAsteriskSummaryModel {
    averageLengthOfCalls?: string;
    dailyInboundVideoCalls?: number;
    dailyInboundPhoneCalls?: number;
    abandonedCalls?: number;
    averageAgentInbound?: number;
    averageAgentOutbound?: number;
}

export class CreateAppointmentAndPaymentLinkResponse2 implements ICreateAppointmentAndPaymentLinkResponse2 {
    patientServicePurchaseId?: string;
    paymentAlternatives?: CreateAppointmentPaymentAlternativeResponse2[] | undefined;

    constructor(data?: ICreateAppointmentAndPaymentLinkResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientServicePurchaseId = _data["patientServicePurchaseId"];
            if (Array.isArray(_data["paymentAlternatives"])) {
                this.paymentAlternatives = [] as any;
                for (let item of _data["paymentAlternatives"])
                    this.paymentAlternatives!.push(CreateAppointmentPaymentAlternativeResponse2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAppointmentAndPaymentLinkResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentAndPaymentLinkResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientServicePurchaseId"] = this.patientServicePurchaseId;
        if (Array.isArray(this.paymentAlternatives)) {
            data["paymentAlternatives"] = [];
            for (let item of this.paymentAlternatives)
                data["paymentAlternatives"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateAppointmentAndPaymentLinkResponse2 {
    patientServicePurchaseId?: string;
    paymentAlternatives?: CreateAppointmentPaymentAlternativeResponse2[] | undefined;
}

export class CreateAppointmentPaymentAlternativeResponse2 implements ICreateAppointmentPaymentAlternativeResponse2 {
    paymentLink?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICreateAppointmentPaymentAlternativeResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentLink = _data["paymentLink"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateAppointmentPaymentAlternativeResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentPaymentAlternativeResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentLink"] = this.paymentLink;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateAppointmentPaymentAlternativeResponse2 {
    paymentLink?: string | undefined;
    name?: string | undefined;
}

export class AppointmentAndPaymentLinkRequest implements IAppointmentAndPaymentLinkRequest {
    patientLoginId?: string;
    productId?: string;

    constructor(data?: IAppointmentAndPaymentLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLoginId = _data["patientLoginId"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): AppointmentAndPaymentLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentAndPaymentLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientLoginId"] = this.patientLoginId;
        data["productId"] = this.productId;
        return data;
    }
}

export interface IAppointmentAndPaymentLinkRequest {
    patientLoginId?: string;
    productId?: string;
}

export class AppointmentPaymentFromTokenResponse implements IAppointmentPaymentFromTokenResponse {
    paymentLink?: string | undefined;

    constructor(data?: IAppointmentPaymentFromTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentLink = _data["paymentLink"];
        }
    }

    static fromJS(data: any): AppointmentPaymentFromTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentPaymentFromTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentLink"] = this.paymentLink;
        return data;
    }
}

export interface IAppointmentPaymentFromTokenResponse {
    paymentLink?: string | undefined;
}

export class AppointmentPurchasedConfirmRequest implements IAppointmentPurchasedConfirmRequest {
    patientLoginId?: string;
    productId?: string;
    patientServicePurchaseId?: string;

    constructor(data?: IAppointmentPurchasedConfirmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientLoginId = _data["patientLoginId"];
            this.productId = _data["productId"];
            this.patientServicePurchaseId = _data["patientServicePurchaseId"];
        }
    }

    static fromJS(data: any): AppointmentPurchasedConfirmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentPurchasedConfirmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientLoginId"] = this.patientLoginId;
        data["productId"] = this.productId;
        data["patientServicePurchaseId"] = this.patientServicePurchaseId;
        return data;
    }
}

export interface IAppointmentPurchasedConfirmRequest {
    patientLoginId?: string;
    productId?: string;
    patientServicePurchaseId?: string;
}

export class ProvinceState implements IProvinceState {
    provinceStateID?: number;
    code?: string | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;
    timeZone?: string | undefined;

    constructor(data?: IProvinceState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provinceStateID = _data["provinceStateID"];
            this.code = _data["code"];
            this.countryCode = _data["countryCode"];
            this.name = _data["name"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): ProvinceState {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provinceStateID"] = this.provinceStateID;
        data["code"] = this.code;
        data["countryCode"] = this.countryCode;
        data["name"] = this.name;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IProvinceState {
    provinceStateID?: number;
    code?: string | undefined;
    countryCode?: string | undefined;
    name?: string | undefined;
    timeZone?: string | undefined;
}

export class PharmacyModel implements IPharmacyModel {
    pharmacyID?: string;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified?: boolean;

    constructor(data?: IPharmacyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pharmacyID = _data["pharmacyID"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.provinceState = _data["provinceState"];
            this.postalZipCode = _data["postalZipCode"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
            this.faxNumber = _data["faxNumber"];
            this.email = _data["email"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): PharmacyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PharmacyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pharmacyID"] = this.pharmacyID;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["provinceState"] = this.provinceState;
        data["postalZipCode"] = this.postalZipCode;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        data["faxNumber"] = this.faxNumber;
        data["email"] = this.email;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface IPharmacyModel {
    pharmacyID?: string;
    name?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified?: boolean;
}

export class GetPharmaciesRequest implements IGetPharmaciesRequest {
    studyId?: string;
    name?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;

    constructor(data?: IGetPharmaciesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.name = _data["name"];
            this.province = _data["province"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): GetPharmaciesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPharmaciesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["name"] = this.name;
        data["province"] = this.province;
        data["city"] = this.city;
        return data;
    }
}

export interface IGetPharmaciesRequest {
    studyId?: string;
    name?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
}

export class PhysicianModel implements IPhysicianModel {
    physicianID?: string;
    internalReferenceId?: string | undefined;
    externalReferenceId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    specialtyGroup?: string | undefined;
    specialtyType?: string | undefined;
    address?: string | undefined;
    apartment?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified?: boolean;

    constructor(data?: IPhysicianModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.physicianID = _data["physicianID"];
            this.internalReferenceId = _data["internalReferenceId"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.specialtyGroup = _data["specialtyGroup"];
            this.specialtyType = _data["specialtyType"];
            this.address = _data["address"];
            this.apartment = _data["apartment"];
            this.city = _data["city"];
            this.provinceState = _data["provinceState"];
            this.postalZipCode = _data["postalZipCode"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
            this.faxNumber = _data["faxNumber"];
            this.email = _data["email"];
            this.isVerified = _data["isVerified"];
        }
    }

    static fromJS(data: any): PhysicianModel {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicianModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["physicianID"] = this.physicianID;
        data["internalReferenceId"] = this.internalReferenceId;
        data["externalReferenceId"] = this.externalReferenceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["specialtyGroup"] = this.specialtyGroup;
        data["specialtyType"] = this.specialtyType;
        data["address"] = this.address;
        data["apartment"] = this.apartment;
        data["city"] = this.city;
        data["provinceState"] = this.provinceState;
        data["postalZipCode"] = this.postalZipCode;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        data["faxNumber"] = this.faxNumber;
        data["email"] = this.email;
        data["isVerified"] = this.isVerified;
        return data;
    }
}

export interface IPhysicianModel {
    physicianID?: string;
    internalReferenceId?: string | undefined;
    externalReferenceId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organization?: string | undefined;
    specialtyGroup?: string | undefined;
    specialtyType?: string | undefined;
    address?: string | undefined;
    apartment?: string | undefined;
    city?: string | undefined;
    provinceState?: string | undefined;
    postalZipCode?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    email?: string | undefined;
    isVerified?: boolean;
}

export class GetPhysicianRequest implements IGetPhysicianRequest {
    studyId?: string;
    country?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IGetPhysicianRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.country = _data["country"];
            this.province = _data["province"];
            this.city = _data["city"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): GetPhysicianRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPhysicianRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IGetPhysicianRequest {
    studyId?: string;
    country?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class InteractionRenderModel2 implements IInteractionRenderModel2 {
    heartBeatSend?: boolean;
    heartBeatEndpoint?: string | undefined;
    interactionType?: InteractionType2;
    callbackToken?: string | undefined;
    name?: string | undefined;
    languageCode?: string | undefined;
    questions?: InteractionQuestion2[] | undefined;
    groups?: InteractionQuestionGroup2[] | undefined;
    interactionNote?: InteractionNoteModel2 | undefined;
    rules?: { [key: string]: InteractionRulesGroup2; } | undefined;
    executionOutcomeNotifications?: ExecutionOutcomeNotification2[] | undefined;

    constructor(data?: IInteractionRenderModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heartBeatSend = _data["heartBeatSend"];
            this.heartBeatEndpoint = _data["heartBeatEndpoint"];
            this.interactionType = _data["interactionType"];
            this.callbackToken = _data["callbackToken"];
            this.name = _data["name"];
            this.languageCode = _data["languageCode"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(InteractionQuestion2.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(InteractionQuestionGroup2.fromJS(item));
            }
            this.interactionNote = _data["interactionNote"] ? InteractionNoteModel2.fromJS(_data["interactionNote"]) : undefined as any;
            if (_data["rules"]) {
                this.rules = {} as any;
                for (let key in _data["rules"]) {
                    if (_data["rules"].hasOwnProperty(key))
                        (this.rules as any)![key] = _data["rules"][key] ? InteractionRulesGroup2.fromJS(_data["rules"][key]) : new InteractionRulesGroup2();
                }
            }
            if (Array.isArray(_data["executionOutcomeNotifications"])) {
                this.executionOutcomeNotifications = [] as any;
                for (let item of _data["executionOutcomeNotifications"])
                    this.executionOutcomeNotifications!.push(ExecutionOutcomeNotification2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionRenderModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRenderModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heartBeatSend"] = this.heartBeatSend;
        data["heartBeatEndpoint"] = this.heartBeatEndpoint;
        data["interactionType"] = this.interactionType;
        data["callbackToken"] = this.callbackToken;
        data["name"] = this.name;
        data["languageCode"] = this.languageCode;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        data["interactionNote"] = this.interactionNote ? this.interactionNote.toJSON() : undefined as any;
        if (this.rules) {
            data["rules"] = {};
            for (let key in this.rules) {
                if (this.rules.hasOwnProperty(key))
                    (data["rules"] as any)[key] = this.rules[key] ? this.rules[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.executionOutcomeNotifications)) {
            data["executionOutcomeNotifications"] = [];
            for (let item of this.executionOutcomeNotifications)
                data["executionOutcomeNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInteractionRenderModel2 {
    heartBeatSend?: boolean;
    heartBeatEndpoint?: string | undefined;
    interactionType?: InteractionType2;
    callbackToken?: string | undefined;
    name?: string | undefined;
    languageCode?: string | undefined;
    questions?: InteractionQuestion2[] | undefined;
    groups?: InteractionQuestionGroup2[] | undefined;
    interactionNote?: InteractionNoteModel2 | undefined;
    rules?: { [key: string]: InteractionRulesGroup2; } | undefined;
    executionOutcomeNotifications?: ExecutionOutcomeNotification2[] | undefined;
}

export enum InteractionType2 {
    Registration = 1,
    System = 2,
    Standard = 3,
    Signed = 4,
    EmailParticipant = 5,
    FaxPhysician = 6,
    FaxAttachment = 7,
}

export class InteractionQuestion2 implements IInteractionQuestion2 {
    answers?: QuestionAnswerModel2[] | undefined;
    interactionQuestionId?: number;
    uniqueCode?: string | undefined;
    isRepeatable?: boolean;
    items?: InteractionQuestionItem2[] | undefined;

    constructor(data?: IInteractionQuestion2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(QuestionAnswerModel2.fromJS(item));
            }
            this.interactionQuestionId = _data["interactionQuestionId"];
            this.uniqueCode = _data["uniqueCode"];
            this.isRepeatable = _data["isRepeatable"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InteractionQuestionItem2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionQuestion2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestion2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["interactionQuestionId"] = this.interactionQuestionId;
        data["uniqueCode"] = this.uniqueCode;
        data["isRepeatable"] = this.isRepeatable;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInteractionQuestion2 {
    answers?: QuestionAnswerModel2[] | undefined;
    interactionQuestionId?: number;
    uniqueCode?: string | undefined;
    isRepeatable?: boolean;
    items?: InteractionQuestionItem2[] | undefined;
}

export class QuestionAnswerModel2 implements IQuestionAnswerModel2 {
    answerValues?: QuestionAnswerValue2[] | undefined;

    constructor(data?: IQuestionAnswerModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answerValues"])) {
                this.answerValues = [] as any;
                for (let item of _data["answerValues"])
                    this.answerValues!.push(QuestionAnswerValue2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionAnswerModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answerValues)) {
            data["answerValues"] = [];
            for (let item of this.answerValues)
                data["answerValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionAnswerModel2 {
    answerValues?: QuestionAnswerValue2[] | undefined;
}

export class QuestionAnswerValue2 implements IQuestionAnswerValue2 {
    subCode?: string | undefined;
    value?: string | undefined;

    constructor(data?: IQuestionAnswerValue2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subCode = _data["subCode"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuestionAnswerValue2 {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswerValue2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subCode"] = this.subCode;
        data["value"] = this.value;
        return data;
    }
}

export interface IQuestionAnswerValue2 {
    subCode?: string | undefined;
    value?: string | undefined;
}

export class InteractionQuestionItem2 implements IInteractionQuestionItem2 {
    questionId?: string;
    subCode?: string | undefined;
    position?: number;
    questionType?: QuestionType2;
    required?: boolean;
    readOnly?: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    questionOptions?: QuestionOption2[] | undefined;
    extendedOptions?: ExtendedOptionsObjectMigration2 | undefined;
    renderData?: string | undefined;

    constructor(data?: IInteractionQuestionItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.subCode = _data["subCode"];
            this.position = _data["position"];
            this.questionType = _data["questionType"];
            this.required = _data["required"];
            this.readOnly = _data["readOnly"];
            this.label = _data["label"];
            this.instruction = _data["instruction"];
            this.validationMessage = _data["validationMessage"];
            if (Array.isArray(_data["questionOptions"])) {
                this.questionOptions = [] as any;
                for (let item of _data["questionOptions"])
                    this.questionOptions!.push(QuestionOption2.fromJS(item));
            }
            this.extendedOptions = _data["extendedOptions"] ? ExtendedOptionsObjectMigration2.fromJS(_data["extendedOptions"]) : undefined as any;
            this.renderData = _data["renderData"];
        }
    }

    static fromJS(data: any): InteractionQuestionItem2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestionItem2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["subCode"] = this.subCode;
        data["position"] = this.position;
        data["questionType"] = this.questionType;
        data["required"] = this.required;
        data["readOnly"] = this.readOnly;
        data["label"] = this.label;
        data["instruction"] = this.instruction;
        data["validationMessage"] = this.validationMessage;
        if (Array.isArray(this.questionOptions)) {
            data["questionOptions"] = [];
            for (let item of this.questionOptions)
                data["questionOptions"].push(item ? item.toJSON() : undefined as any);
        }
        data["extendedOptions"] = this.extendedOptions ? this.extendedOptions.toJSON() : undefined as any;
        data["renderData"] = this.renderData;
        return data;
    }
}

export interface IInteractionQuestionItem2 {
    questionId?: string;
    subCode?: string | undefined;
    position?: number;
    questionType?: QuestionType2;
    required?: boolean;
    readOnly?: boolean;
    label?: string | undefined;
    instruction?: string | undefined;
    validationMessage?: string | undefined;
    questionOptions?: QuestionOption2[] | undefined;
    extendedOptions?: ExtendedOptionsObjectMigration2 | undefined;
    renderData?: string | undefined;
}

export enum QuestionType2 {
    Instruction = 0,
    Identifier = 1,
    Text = 2,
    Number = 3,
    Date = 4,
    Time = 5,
    SingleChoice = 6,
    MultipleChoice = 7,
    Matrix = 8,
    MultiLineText = 9,
    InteractionNote = 10,
    Attachment = 11,
    Score = 12,
    Checkbox = 13,
    InteractionSummary = 14,
    Name = 20,
    Language = 21,
    Email = 22,
    MailingAddress = 23,
    PhoneInformation = 24,
    Height = 25,
    Weight = 26,
    Gender = 27,
    DateOfBirth = 28,
    ContactConsent = 29,
    Physician = 30,
    Guardian = 31,
    EnrollmentDate = 32,
    PatientStatus = 33,
    Frequency = 34,
    DropDown = 35,
    Avatar = 36,
    Initials = 37,
    CareMember = 38,
    Signature = 39,
    ActigraphMinuteData = 40,
    EMA = 41,
    AdverseEffectEvent = 42,
    ConcomitantMedicationDetails = 43,
    PhysicianListPhysician = 44,
    SelectDocument = 45,
    SelectAttachment = 46,
    Hidden = 47,
    PatientEmail = 48,
    PatientPhone = 49,
    MedicalHistoryDetails = 53,
    NovoNordiskToolsAndConsent = 54,
    ConcomitantMedicationDetailsShort = 55,
    BodyMassIndex = 56,
    AdverseEventCCGlow = 57,
    AdverseEventLink = 58,
    Pharmacy = 1001,
    ObesityModules = 1002,
    LabWork = 1003,
    Medications = 1004,
    Prescriptions = 1005,
    AomReview = 1006,
    AomReviewMedication = 1007,
    WaistCircumference = 1008,
    SleepApneaReferral = 1009,
    UpdatePatientStatus = 1010,
    Webinar = 1011,
    WebinarAttendance = 1012,
    WebinarEmail = 1013,
}

export class QuestionOption2 implements IQuestionOption2 {
    code?: string | undefined;
    label?: string | undefined;
    score?: number;

    constructor(data?: IQuestionOption2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): QuestionOption2 {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOption2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["score"] = this.score;
        return data;
    }
}

export interface IQuestionOption2 {
    code?: string | undefined;
    label?: string | undefined;
    score?: number;
}

export class ExtendedOptionsObjectMigration2 implements IExtendedOptionsObjectMigration2 {
    optionGroups?: OptionGroupMigration2[] | undefined;
    extendedQuestionOptions?: ExtendedQuestionOptionMigration2[] | undefined;

    constructor(data?: IExtendedOptionsObjectMigration2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["optionGroups"])) {
                this.optionGroups = [] as any;
                for (let item of _data["optionGroups"])
                    this.optionGroups!.push(OptionGroupMigration2.fromJS(item));
            }
            if (Array.isArray(_data["extendedQuestionOptions"])) {
                this.extendedQuestionOptions = [] as any;
                for (let item of _data["extendedQuestionOptions"])
                    this.extendedQuestionOptions!.push(ExtendedQuestionOptionMigration2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtendedOptionsObjectMigration2 {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedOptionsObjectMigration2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.optionGroups)) {
            data["optionGroups"] = [];
            for (let item of this.optionGroups)
                data["optionGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.extendedQuestionOptions)) {
            data["extendedQuestionOptions"] = [];
            for (let item of this.extendedQuestionOptions)
                data["extendedQuestionOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExtendedOptionsObjectMigration2 {
    optionGroups?: OptionGroupMigration2[] | undefined;
    extendedQuestionOptions?: ExtendedQuestionOptionMigration2[] | undefined;
}

export class OptionGroupMigration2 implements IOptionGroupMigration2 {
    uniqueCode?: string | undefined;
    labels?: LabelTranslation2[] | undefined;
    options?: QuestionOptionMigration2[] | undefined;
    value?: string | undefined;
    required?: boolean;
    validationMessages?: LabelTranslation2[] | undefined;
    validationMessage?: string | undefined;
    label?: string | undefined;

    constructor(data?: IOptionGroupMigration2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueCode = _data["uniqueCode"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelTranslation2.fromJS(item));
            }
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(QuestionOptionMigration2.fromJS(item));
            }
            this.value = _data["value"];
            this.required = _data["required"];
            if (Array.isArray(_data["validationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["validationMessages"])
                    this.validationMessages!.push(LabelTranslation2.fromJS(item));
            }
            this.validationMessage = _data["validationMessage"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): OptionGroupMigration2 {
        data = typeof data === 'object' ? data : {};
        let result = new OptionGroupMigration2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueCode"] = this.uniqueCode;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        data["value"] = this.value;
        data["required"] = this.required;
        if (Array.isArray(this.validationMessages)) {
            data["validationMessages"] = [];
            for (let item of this.validationMessages)
                data["validationMessages"].push(item ? item.toJSON() : undefined as any);
        }
        data["validationMessage"] = this.validationMessage;
        data["label"] = this.label;
        return data;
    }
}

export interface IOptionGroupMigration2 {
    uniqueCode?: string | undefined;
    labels?: LabelTranslation2[] | undefined;
    options?: QuestionOptionMigration2[] | undefined;
    value?: string | undefined;
    required?: boolean;
    validationMessages?: LabelTranslation2[] | undefined;
    validationMessage?: string | undefined;
    label?: string | undefined;
}

export class LabelTranslation2 implements ILabelTranslation2 {
    language?: string | undefined;
    languageCode?: string | undefined;
    value?: string | undefined;
    isDefault?: boolean;

    constructor(data?: ILabelTranslation2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.languageCode = _data["languageCode"];
            this.value = _data["value"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): LabelTranslation2 {
        data = typeof data === 'object' ? data : {};
        let result = new LabelTranslation2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["languageCode"] = this.languageCode;
        data["value"] = this.value;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface ILabelTranslation2 {
    language?: string | undefined;
    languageCode?: string | undefined;
    value?: string | undefined;
    isDefault?: boolean;
}

export class QuestionOptionMigration2 implements IQuestionOptionMigration2 {
    code?: string | undefined;
    labels?: LabelTranslation2[] | undefined;
    label?: string | undefined;
    score?: number;

    constructor(data?: IQuestionOptionMigration2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelTranslation2.fromJS(item));
            }
            this.label = _data["label"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): QuestionOptionMigration2 {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOptionMigration2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item ? item.toJSON() : undefined as any);
        }
        data["label"] = this.label;
        data["score"] = this.score;
        return data;
    }
}

export interface IQuestionOptionMigration2 {
    code?: string | undefined;
    labels?: LabelTranslation2[] | undefined;
    label?: string | undefined;
    score?: number;
}

export class ExtendedQuestionOptionMigration2 implements IExtendedQuestionOptionMigration2 {
    label?: string | undefined;
    code?: string | undefined;
    labels?: LabelTranslation2[] | undefined;
    score?: number;
    scoreOptions?: Score2[] | undefined;

    constructor(data?: IExtendedQuestionOptionMigration2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.code = _data["code"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelTranslation2.fromJS(item));
            }
            this.score = _data["score"];
            if (Array.isArray(_data["scoreOptions"])) {
                this.scoreOptions = [] as any;
                for (let item of _data["scoreOptions"])
                    this.scoreOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): ExtendedQuestionOptionMigration2 {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedQuestionOptionMigration2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["code"] = this.code;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item ? item.toJSON() : undefined as any);
        }
        data["score"] = this.score;
        if (Array.isArray(this.scoreOptions)) {
            data["scoreOptions"] = [];
            for (let item of this.scoreOptions)
                data["scoreOptions"].push(item);
        }
        return data;
    }
}

export interface IExtendedQuestionOptionMigration2 {
    label?: string | undefined;
    code?: string | undefined;
    labels?: LabelTranslation2[] | undefined;
    score?: number;
    scoreOptions?: Score2[] | undefined;
}

export enum Score2 {
    Ignore = 0,
    Include = 1,
    Reverse = 2,
}

export class InteractionQuestionGroup2 implements IInteractionQuestionGroup2 {
    groupId?: number;
    label?: string | undefined;
    questionIds?: number[] | undefined;

    constructor(data?: IInteractionQuestionGroup2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.label = _data["label"];
            if (Array.isArray(_data["questionIds"])) {
                this.questionIds = [] as any;
                for (let item of _data["questionIds"])
                    this.questionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InteractionQuestionGroup2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionQuestionGroup2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["label"] = this.label;
        if (Array.isArray(this.questionIds)) {
            data["questionIds"] = [];
            for (let item of this.questionIds)
                data["questionIds"].push(item);
        }
        return data;
    }
}

export interface IInteractionQuestionGroup2 {
    groupId?: number;
    label?: string | undefined;
    questionIds?: number[] | undefined;
}

export class InteractionNoteModel2 implements IInteractionNoteModel2 {
    noteType?: InteractionNoteType2;
    notes?: string | undefined;

    constructor(data?: IInteractionNoteModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noteType = _data["noteType"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): InteractionNoteModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionNoteModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noteType"] = this.noteType;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IInteractionNoteModel2 {
    noteType?: InteractionNoteType2;
    notes?: string | undefined;
}

export enum InteractionNoteType2 {
    Optional = 1,
    Required = 2,
    Hidden = 3,
    HiddenForPatients = 4,
}

export class InteractionRulesGroup2 implements IInteractionRulesGroup2 {
    rules?: InteractionRule2[] | undefined;
    comparisor?: InteractionRuleComparisor2 | undefined;
    groups?: InteractionRulesGroup2[] | undefined;

    constructor(data?: IInteractionRulesGroup2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(InteractionRule2.fromJS(item));
            }
            this.comparisor = _data["comparisor"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(InteractionRulesGroup2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InteractionRulesGroup2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRulesGroup2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        data["comparisor"] = this.comparisor;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInteractionRulesGroup2 {
    rules?: InteractionRule2[] | undefined;
    comparisor?: InteractionRuleComparisor2 | undefined;
    groups?: InteractionRulesGroup2[] | undefined;
}

export class InteractionRule2 implements IInteractionRule2 {
    ruleId?: string | undefined;
    dependOnQuestionId?: number;
    operator?: InteractionRuleOperator2;
    evaluatedValue?: string | undefined;
    evaluationSubCode?: string | undefined;

    constructor(data?: IInteractionRule2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleId = _data["ruleId"];
            this.dependOnQuestionId = _data["dependOnQuestionId"];
            this.operator = _data["operator"];
            this.evaluatedValue = _data["evaluatedValue"];
            this.evaluationSubCode = _data["evaluationSubCode"];
        }
    }

    static fromJS(data: any): InteractionRule2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionRule2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleId"] = this.ruleId;
        data["dependOnQuestionId"] = this.dependOnQuestionId;
        data["operator"] = this.operator;
        data["evaluatedValue"] = this.evaluatedValue;
        data["evaluationSubCode"] = this.evaluationSubCode;
        return data;
    }
}

export interface IInteractionRule2 {
    ruleId?: string | undefined;
    dependOnQuestionId?: number;
    operator?: InteractionRuleOperator2;
    evaluatedValue?: string | undefined;
    evaluationSubCode?: string | undefined;
}

export enum InteractionRuleOperator2 {
    IsBlank = 1,
    IsNotBlank = 2,
    StartsWith = 3,
    EndsWith = 4,
    Contains = 5,
    Equals = 6,
    GreaterThan = 7,
    LessThan = 8,
    DoesNotContain = 9,
    DoesNotEqual = 10,
}

export enum InteractionRuleComparisor2 {
    And = 0,
    Or = 1,
}

export class ExecutionOutcomeNotification2 implements IExecutionOutcomeNotification2 {
    type?: ExecutionOutcomeNotificationType2;
    title?: string | undefined;
    description?: string | undefined;

    constructor(data?: IExecutionOutcomeNotification2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExecutionOutcomeNotification2 {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionOutcomeNotification2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IExecutionOutcomeNotification2 {
    type?: ExecutionOutcomeNotificationType2;
    title?: string | undefined;
    description?: string | undefined;
}

export enum ExecutionOutcomeNotificationType2 {
    Info = 0,
    Alert = 1,
    Warning = 2,
    Error = 3,
}

export class PostEnrollmentInteractionResponse2 implements IPostEnrollmentInteractionResponse2 {
    status?: PostEnrollmentInteractionStatus2;
    patientIdentifier?: string | undefined;
    errorType?: string | undefined;
    errorDescription?: string | undefined;
    redirectToUrl?: string | undefined;
    isRegistration?: boolean | undefined;

    constructor(data?: IPostEnrollmentInteractionResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.patientIdentifier = _data["patientIdentifier"];
            this.errorType = _data["errorType"];
            this.errorDescription = _data["errorDescription"];
            this.redirectToUrl = _data["redirectToUrl"];
            this.isRegistration = _data["isRegistration"];
        }
    }

    static fromJS(data: any): PostEnrollmentInteractionResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new PostEnrollmentInteractionResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["patientIdentifier"] = this.patientIdentifier;
        data["errorType"] = this.errorType;
        data["errorDescription"] = this.errorDescription;
        data["redirectToUrl"] = this.redirectToUrl;
        data["isRegistration"] = this.isRegistration;
        return data;
    }
}

export interface IPostEnrollmentInteractionResponse2 {
    status?: PostEnrollmentInteractionStatus2;
    patientIdentifier?: string | undefined;
    errorType?: string | undefined;
    errorDescription?: string | undefined;
    redirectToUrl?: string | undefined;
    isRegistration?: boolean | undefined;
}

export enum PostEnrollmentInteractionStatus2 {
    Ok = 0,
    PaymentFail = 1,
    PaymentSuccess = 2,
    PatientFailed = 3,
    RouteToPayment = 4,
    RouteToScheduler = 5,
    PatientSuccess = 6,
}

export class PostGenericInteractionPublicRequest2 implements IPostGenericInteractionPublicRequest2 {
    requestKey?: string;
    interactionResponse?: InteractionResponseModel2 | undefined;

    constructor(data?: IPostGenericInteractionPublicRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestKey = _data["requestKey"];
            this.interactionResponse = _data["interactionResponse"] ? InteractionResponseModel2.fromJS(_data["interactionResponse"]) : undefined as any;
        }
    }

    static fromJS(data: any): PostGenericInteractionPublicRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new PostGenericInteractionPublicRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestKey"] = this.requestKey;
        data["interactionResponse"] = this.interactionResponse ? this.interactionResponse.toJSON() : undefined as any;
        return data;
    }
}

export interface IPostGenericInteractionPublicRequest2 {
    requestKey?: string;
    interactionResponse?: InteractionResponseModel2 | undefined;
}

export class InteractionResponseModel2 implements IInteractionResponseModel2 {
    ipAddress?: string | undefined;
    saveAsDraft?: boolean;
    callBackToken?: string | undefined;
    responses?: InteractionResponseQuestion2[] | undefined;
    notes?: string | undefined;

    constructor(data?: IInteractionResponseModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.callBackToken = _data["callBackToken"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(InteractionResponseQuestion2.fromJS(item));
            }
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): InteractionResponseModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionResponseModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["saveAsDraft"] = this.saveAsDraft;
        data["callBackToken"] = this.callBackToken;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item ? item.toJSON() : undefined as any);
        }
        data["notes"] = this.notes;
        return data;
    }
}

export interface IInteractionResponseModel2 {
    ipAddress?: string | undefined;
    saveAsDraft?: boolean;
    callBackToken?: string | undefined;
    responses?: InteractionResponseQuestion2[] | undefined;
    notes?: string | undefined;
}

export class InteractionResponseQuestion2 implements IInteractionResponseQuestion2 {
    answers?: QuestionAnswerModel2[] | undefined;
    interactionQuestionId?: number;

    constructor(data?: IInteractionResponseQuestion2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(QuestionAnswerModel2.fromJS(item));
            }
            this.interactionQuestionId = _data["interactionQuestionId"];
        }
    }

    static fromJS(data: any): InteractionResponseQuestion2 {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionResponseQuestion2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        data["interactionQuestionId"] = this.interactionQuestionId;
        return data;
    }
}

export interface IInteractionResponseQuestion2 {
    answers?: QuestionAnswerModel2[] | undefined;
    interactionQuestionId?: number;
}

export class PostEnrollmentInteractionRequest2 implements IPostEnrollmentInteractionRequest2 {
    interactionResponse?: InteractionResponseModel2 | undefined;
    enrollmentPaymentInformation?: EnrollmentPaymentInformation2 | undefined;

    constructor(data?: IPostEnrollmentInteractionRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionResponse = _data["interactionResponse"] ? InteractionResponseModel2.fromJS(_data["interactionResponse"]) : undefined as any;
            this.enrollmentPaymentInformation = _data["enrollmentPaymentInformation"] ? EnrollmentPaymentInformation2.fromJS(_data["enrollmentPaymentInformation"]) : undefined as any;
        }
    }

    static fromJS(data: any): PostEnrollmentInteractionRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new PostEnrollmentInteractionRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interactionResponse"] = this.interactionResponse ? this.interactionResponse.toJSON() : undefined as any;
        data["enrollmentPaymentInformation"] = this.enrollmentPaymentInformation ? this.enrollmentPaymentInformation.toJSON() : undefined as any;
        return data;
    }
}

export interface IPostEnrollmentInteractionRequest2 {
    interactionResponse?: InteractionResponseModel2 | undefined;
    enrollmentPaymentInformation?: EnrollmentPaymentInformation2 | undefined;
}

export class EnrollmentPaymentInformation2 implements IEnrollmentPaymentInformation2 {
    cardNumber?: string | undefined;
    cvv?: string | undefined;
    expiration?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IEnrollmentPaymentInformation2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"];
            this.cvv = _data["cvv"];
            this.expiration = _data["expiration"];
            this.streetNumber = _data["streetNumber"];
            this.streetName = _data["streetName"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): EnrollmentPaymentInformation2 {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollmentPaymentInformation2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber;
        data["cvv"] = this.cvv;
        data["expiration"] = this.expiration;
        data["streetNumber"] = this.streetNumber;
        data["streetName"] = this.streetName;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IEnrollmentPaymentInformation2 {
    cardNumber?: string | undefined;
    cvv?: string | undefined;
    expiration?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    postalCode?: string | undefined;
}

export class InteractionModel implements IInteractionModel {
    interactionId?: number;
    siteId?: string;
    studyId?: string;
    categoryId?: string | undefined;
    name?: string | undefined;
    type?: InteractionType2;
    securityType?: InteractionSecurityType;
    scoreType?: ScoreType;
    noteType?: InteractionNoteType2;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    autoScheduleLength?: number | undefined;
    autoScheduleInterval?: IntervalOptions | undefined;
    tabPosition?: number | undefined;
    tabName?: string | undefined;
    variablePrefix?: string | undefined;
    rescore?: boolean;
    requireInternalSignature?: boolean;
    isPriority?: boolean;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date;
    faxNumberId?: string | undefined;

    constructor(data?: IInteractionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interactionId = _data["interactionId"];
            this.siteId = _data["siteId"];
            this.studyId = _data["studyId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.securityType = _data["securityType"];
            this.scoreType = _data["scoreType"];
            this.noteType = _data["noteType"];
            this.minAge = _data["minAge"];
            this.maxAge = _data["maxAge"];
            this.autoScheduleLength = _data["autoScheduleLength"];
            this.autoScheduleInterval = _data["autoScheduleInterval"];
            this.tabPosition = _data["tabPosition"];
            this.tabName = _data["tabName"];
            this.variablePrefix = _data["variablePrefix"];
            this.rescore = _data["rescore"];
            this.requireInternalSignature = _data["requireInternalSignature"];
            this.isPriority = _data["isPriority"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : undefined as any;
            this.faxNumberId = _data["faxNumberId"];
        }
    }

    static fromJS(data: any): InteractionModel {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interactionId"] = this.interactionId;
        data["siteId"] = this.siteId;
        data["studyId"] = this.studyId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["securityType"] = this.securityType;
        data["scoreType"] = this.scoreType;
        data["noteType"] = this.noteType;
        data["minAge"] = this.minAge;
        data["maxAge"] = this.maxAge;
        data["autoScheduleLength"] = this.autoScheduleLength;
        data["autoScheduleInterval"] = this.autoScheduleInterval;
        data["tabPosition"] = this.tabPosition;
        data["tabName"] = this.tabName;
        data["variablePrefix"] = this.variablePrefix;
        data["rescore"] = this.rescore;
        data["requireInternalSignature"] = this.requireInternalSignature;
        data["isPriority"] = this.isPriority;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : undefined as any;
        data["faxNumberId"] = this.faxNumberId;
        return data;
    }
}

export interface IInteractionModel {
    interactionId?: number;
    siteId?: string;
    studyId?: string;
    categoryId?: string | undefined;
    name?: string | undefined;
    type?: InteractionType2;
    securityType?: InteractionSecurityType;
    scoreType?: ScoreType;
    noteType?: InteractionNoteType2;
    minAge?: number | undefined;
    maxAge?: number | undefined;
    autoScheduleLength?: number | undefined;
    autoScheduleInterval?: IntervalOptions | undefined;
    tabPosition?: number | undefined;
    tabName?: string | undefined;
    variablePrefix?: string | undefined;
    rescore?: boolean;
    requireInternalSignature?: boolean;
    isPriority?: boolean;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdOn?: Date;
    modifiedBy?: string | undefined;
    modifiedOn?: Date;
    faxNumberId?: string | undefined;
}

export enum InteractionSecurityType {
    Private = 1,
    Shared = 2,
    Public = 3,
}

export enum ScoreType {
    NotScored = 0,
    Scored = 1,
}

export enum IntervalOptions {
    Day = 0,
    Week = 1,
    Month = 2,
}

export class AccountDto implements IAccountDto {
    name?: string | undefined;
    email?: string | undefined;
    accountId?: string | undefined;
    agentId?: string | undefined;
    isVerified?: boolean;
    culture?: string;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.accountId = _data["accountId"];
            this.agentId = _data["agentId"];
            this.isVerified = _data["isVerified"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["accountId"] = this.accountId;
        data["agentId"] = this.agentId;
        data["isVerified"] = this.isVerified;
        data["culture"] = this.culture;
        return data;
    }
}

export interface IAccountDto {
    name?: string | undefined;
    email?: string | undefined;
    accountId?: string | undefined;
    agentId?: string | undefined;
    isVerified?: boolean;
    culture?: string;
}

export class AccountCultureResponseDto implements IAccountCultureResponseDto {
    cultureId?: string;
    name?: string;

    constructor(data?: IAccountCultureResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureId = _data["cultureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AccountCultureResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCultureResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureId"] = this.cultureId;
        data["name"] = this.name;
        return data;
    }
}

export interface IAccountCultureResponseDto {
    cultureId?: string;
    name?: string;
}

export class AccountCultureSetRequest implements IAccountCultureSetRequest {
    accountId?: string;
    cultureId?: string;

    constructor(data?: IAccountCultureSetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.cultureId = _data["cultureId"];
        }
    }

    static fromJS(data: any): AccountCultureSetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCultureSetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["cultureId"] = this.cultureId;
        return data;
    }
}

export interface IAccountCultureSetRequest {
    accountId?: string;
    cultureId?: string;
}

export class AdminRegisterResponseModel implements IAdminRegisterResponseModel {
    success?: boolean;

    constructor(data?: IAdminRegisterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AdminRegisterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminRegisterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IAdminRegisterResponseModel {
    success?: boolean;
}

export class AdminRegisterRequestModel implements IAdminRegisterRequestModel {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IAdminRegisterRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): AdminRegisterRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminRegisterRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IAdminRegisterRequestModel {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    ipAddress?: string | undefined;
}

export class CurrentUserRole implements ICurrentUserRole {
    isAdmin?: boolean;

    constructor(data?: ICurrentUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): CurrentUserRole {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface ICurrentUserRole {
    isAdmin?: boolean;
}

export class BaseAgentDto implements IBaseAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles?: AgentFileServiceModel[];
    name!: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress?: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus!: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;

    constructor(data?: IBaseAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.personalEmail = _data["personalEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.bankTransitNumber = _data["bankTransitNumber"];
            this.branchTransitNumber = _data["branchTransitNumber"];
            this.accountTransitNumber = _data["accountTransitNumber"];
            if (Array.isArray(_data["agentFiles"])) {
                this.agentFiles = [] as any;
                for (let item of _data["agentFiles"])
                    this.agentFiles!.push(AgentFileServiceModel.fromJS(item));
            }
            this.name = _data["name"];
            this.personalAddress = _data["personalAddress"] ? AgentAddressDto.fromJS(_data["personalAddress"]) : undefined as any;
            this.billingEntityName = _data["billingEntityName"];
            this.billingAddress = _data["billingAddress"] ? AgentAddressDto.fromJS(_data["billingAddress"]) : undefined as any;
            this.billingSamePersonalAddress = _data["billingSamePersonalAddress"];
            this.salesTaxIdentifier = _data["salesTaxIdentifier"];
            this.salesTaxRate = _data["salesTaxRate"];
            this.hourRate = _data["hourRate"];
            if (Array.isArray(_data["licencedProvinces"])) {
                this.licencedProvinces = [] as any;
                for (let item of _data["licencedProvinces"])
                    this.licencedProvinces!.push(AgentLicenceProvinceDto.fromJS(item));
            }
            this.liabilityInsuranceProvider = _data["liabilityInsuranceProvider"];
            this.liabilityInsuranceExpirationDate = _data["liabilityInsuranceExpirationDate"] ? new Date(_data["liabilityInsuranceExpirationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.scheduleNotes = _data["scheduleNotes"];
            this.professionalDesignation = _data["professionalDesignation"];
            this.accountEmail = _data["accountEmail"];
            this.startingOn = _data["startingOn"] ? new Date(_data["startingOn"].toString()) : undefined as any;
            this.agentStatus = _data["agentStatus"];
            if (Array.isArray(_data["agentAdminNotes"])) {
                this.agentAdminNotes = [] as any;
                for (let item of _data["agentAdminNotes"])
                    this.agentAdminNotes!.push(AgentAdminNoteDto.fromJS(item));
            }
            this.agentDevice = _data["agentDevice"] ? AgentDtoDeviceSummary.fromJS(_data["agentDevice"]) : undefined as any;
        }
    }

    static fromJS(data: any): BaseAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["personalEmail"] = this.personalEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["bankTransitNumber"] = this.bankTransitNumber;
        data["branchTransitNumber"] = this.branchTransitNumber;
        data["accountTransitNumber"] = this.accountTransitNumber;
        if (Array.isArray(this.agentFiles)) {
            data["agentFiles"] = [];
            for (let item of this.agentFiles)
                data["agentFiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["personalAddress"] = this.personalAddress ? this.personalAddress.toJSON() : undefined as any;
        data["billingEntityName"] = this.billingEntityName;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["billingSamePersonalAddress"] = this.billingSamePersonalAddress;
        data["salesTaxIdentifier"] = this.salesTaxIdentifier;
        data["salesTaxRate"] = this.salesTaxRate;
        data["hourRate"] = this.hourRate;
        if (Array.isArray(this.licencedProvinces)) {
            data["licencedProvinces"] = [];
            for (let item of this.licencedProvinces)
                data["licencedProvinces"].push(item ? item.toJSON() : undefined as any);
        }
        data["liabilityInsuranceProvider"] = this.liabilityInsuranceProvider;
        data["liabilityInsuranceExpirationDate"] = this.liabilityInsuranceExpirationDate ? this.liabilityInsuranceExpirationDate.toISOString() : undefined as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["scheduleNotes"] = this.scheduleNotes;
        data["professionalDesignation"] = this.professionalDesignation;
        data["accountEmail"] = this.accountEmail;
        data["startingOn"] = this.startingOn ? this.startingOn.toISOString() : undefined as any;
        data["agentStatus"] = this.agentStatus;
        if (Array.isArray(this.agentAdminNotes)) {
            data["agentAdminNotes"] = [];
            for (let item of this.agentAdminNotes)
                data["agentAdminNotes"].push(item ? item.toJSON() : undefined as any);
        }
        data["agentDevice"] = this.agentDevice ? this.agentDevice.toJSON() : undefined as any;
        return data;
    }
}

export interface IBaseAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles?: AgentFileServiceModel[];
    name: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress?: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;
}

export class SimpleAgentDto extends BaseAgentDto implements ISimpleAgentDto {

    constructor(data?: ISimpleAgentDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SimpleAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleAgentDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleAgentDto extends IBaseAgentDto {
}

export class AgentFileServiceModel implements IAgentFileServiceModel {
    fileName?: string | undefined;
    type?: AgentFileType;
    blobId?: string;

    constructor(data?: IAgentFileServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.type = _data["type"];
            this.blobId = _data["blobId"];
        }
    }

    static fromJS(data: any): AgentFileServiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentFileServiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["type"] = this.type;
        data["blobId"] = this.blobId;
        return data;
    }
}

export interface IAgentFileServiceModel {
    fileName?: string | undefined;
    type?: AgentFileType;
    blobId?: string;
}

export enum AgentFileType {
    Insurance = 1,
    ProfilePicture = 2,
    Signature = 3,
    Resume = 4,
    Interview = 5,
    References = 6,
    ContractorsAgreement = 7,
    VoidCheque = 8,
}

export class AgentAddressDto implements IAgentAddressDto {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceStateID?: number | undefined;

    constructor(data?: IAgentAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceStateID = _data["provinceStateID"];
        }
    }

    static fromJS(data: any): AgentAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceStateID"] = this.provinceStateID;
        return data;
    }
}

export interface IAgentAddressDto {
    address?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceStateID?: number | undefined;
}

export class AgentLicenceProvinceDto implements IAgentLicenceProvinceDto {
    stateProvinceId?: number;
    licenceIdentifier?: string | undefined;
    healthInsuranceBillingNumber?: string | undefined;

    constructor(data?: IAgentLicenceProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateProvinceId = _data["stateProvinceId"];
            this.licenceIdentifier = _data["licenceIdentifier"];
            this.healthInsuranceBillingNumber = _data["healthInsuranceBillingNumber"];
        }
    }

    static fromJS(data: any): AgentLicenceProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentLicenceProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateProvinceId"] = this.stateProvinceId;
        data["licenceIdentifier"] = this.licenceIdentifier;
        data["healthInsuranceBillingNumber"] = this.healthInsuranceBillingNumber;
        return data;
    }
}

export interface IAgentLicenceProvinceDto {
    stateProvinceId?: number;
    licenceIdentifier?: string | undefined;
    healthInsuranceBillingNumber?: string | undefined;
}

export enum Languages {
    English = 0,
    French = 1,
    Portuguese = 2,
    Mandarin = 3,
    Cantonese = 4,
    Punjabi = 5,
    Tagalog = 6,
    Spanish = 7,
    Arabic = 8,
    Italian = 9,
    German = 10,
}

export enum AgentStatus {
    Onboarding = 0,
    Active = 1,
    Inactive = 2,
}

export class AgentAdminNoteDto implements IAgentAdminNoteDto {
    agentAdminNoteId?: string;
    subject?: string | undefined;
    body?: string | undefined;
    reviewedOn?: Date | undefined;
    createdOn?: Date | undefined;
    agentId?: string;
    agentName?: string | undefined;
    accountAuthorId?: string;

    constructor(data?: IAgentAdminNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentAdminNoteId = _data["agentAdminNoteId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.reviewedOn = _data["reviewedOn"] ? new Date(_data["reviewedOn"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.accountAuthorId = _data["accountAuthorId"];
        }
    }

    static fromJS(data: any): AgentAdminNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAdminNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentAdminNoteId"] = this.agentAdminNoteId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["reviewedOn"] = this.reviewedOn ? this.reviewedOn.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["accountAuthorId"] = this.accountAuthorId;
        return data;
    }
}

export interface IAgentAdminNoteDto {
    agentAdminNoteId?: string;
    subject?: string | undefined;
    body?: string | undefined;
    reviewedOn?: Date | undefined;
    createdOn?: Date | undefined;
    agentId?: string;
    agentName?: string | undefined;
    accountAuthorId?: string;
}

export class AgentDtoDeviceSummary implements IAgentDtoDeviceSummary {
    deviceId?: string | undefined;
    hasPendingDevices?: boolean;
    deviceInfo?: AgentDeviceInfo | undefined;
    agentDeviceModelType?: string | undefined;
    agentDeviceOperatingSystem?: string | undefined;
    deviceChecks?: DeviceCheck[] | undefined;

    constructor(data?: IAgentDtoDeviceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.hasPendingDevices = _data["hasPendingDevices"];
            this.deviceInfo = _data["deviceInfo"] ? AgentDeviceInfo.fromJS(_data["deviceInfo"]) : undefined as any;
            this.agentDeviceModelType = _data["agentDeviceModelType"];
            this.agentDeviceOperatingSystem = _data["agentDeviceOperatingSystem"];
            if (Array.isArray(_data["deviceChecks"])) {
                this.deviceChecks = [] as any;
                for (let item of _data["deviceChecks"])
                    this.deviceChecks!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentDtoDeviceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDtoDeviceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["hasPendingDevices"] = this.hasPendingDevices;
        data["deviceInfo"] = this.deviceInfo ? this.deviceInfo.toJSON() : undefined as any;
        data["agentDeviceModelType"] = this.agentDeviceModelType;
        data["agentDeviceOperatingSystem"] = this.agentDeviceOperatingSystem;
        if (Array.isArray(this.deviceChecks)) {
            data["deviceChecks"] = [];
            for (let item of this.deviceChecks)
                data["deviceChecks"].push(item);
        }
        return data;
    }
}

export interface IAgentDtoDeviceSummary {
    deviceId?: string | undefined;
    hasPendingDevices?: boolean;
    deviceInfo?: AgentDeviceInfo | undefined;
    agentDeviceModelType?: string | undefined;
    agentDeviceOperatingSystem?: string | undefined;
    deviceChecks?: DeviceCheck[] | undefined;
}

export class AgentDeviceInfo implements IAgentDeviceInfo {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;
    deviceIdentifier?: string | undefined;
    deviceModelType?: string | undefined;
    deviceOperatingSystem?: string | undefined;

    constructor(data?: IAgentDeviceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelType = _data["modelType"];
            this.operatingSystem = _data["operatingSystem"];
            this.deviceIdentifier = _data["deviceIdentifier"];
            this.deviceModelType = _data["deviceModelType"];
            this.deviceOperatingSystem = _data["deviceOperatingSystem"];
        }
    }

    static fromJS(data: any): AgentDeviceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDeviceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelType"] = this.modelType;
        data["operatingSystem"] = this.operatingSystem;
        data["deviceIdentifier"] = this.deviceIdentifier;
        data["deviceModelType"] = this.deviceModelType;
        data["deviceOperatingSystem"] = this.deviceOperatingSystem;
        return data;
    }
}

export interface IAgentDeviceInfo {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;
    deviceIdentifier?: string | undefined;
    deviceModelType?: string | undefined;
    deviceOperatingSystem?: string | undefined;
}

export enum DeviceCheck {
    MeetsRequirements = 0,
    OpenVpnInstalled = 1,
    AsteriskClientInstalled = 2,
    MsOfficeInstalled = 3,
}

export enum AgentRole {
    Admin = 0,
    Dietitian = 1,
    MD = 2,
}

export class FullAgentDto implements IFullAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles?: AgentFileServiceModel[];
    name!: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress?: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus!: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;
    agentRole!: AgentRole;
    agentNotes?: AgentNoteDto[] | undefined;
    hasUnreviewedAgentAdminNotes?: boolean | undefined;
    availableForCareTeam?: boolean | undefined;

    constructor(data?: IFullAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.personalEmail = _data["personalEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.bankTransitNumber = _data["bankTransitNumber"];
            this.branchTransitNumber = _data["branchTransitNumber"];
            this.accountTransitNumber = _data["accountTransitNumber"];
            if (Array.isArray(_data["agentFiles"])) {
                this.agentFiles = [] as any;
                for (let item of _data["agentFiles"])
                    this.agentFiles!.push(AgentFileServiceModel.fromJS(item));
            }
            this.name = _data["name"];
            this.personalAddress = _data["personalAddress"] ? AgentAddressDto.fromJS(_data["personalAddress"]) : undefined as any;
            this.billingEntityName = _data["billingEntityName"];
            this.billingAddress = _data["billingAddress"] ? AgentAddressDto.fromJS(_data["billingAddress"]) : undefined as any;
            this.billingSamePersonalAddress = _data["billingSamePersonalAddress"];
            this.salesTaxIdentifier = _data["salesTaxIdentifier"];
            this.salesTaxRate = _data["salesTaxRate"];
            this.hourRate = _data["hourRate"];
            if (Array.isArray(_data["licencedProvinces"])) {
                this.licencedProvinces = [] as any;
                for (let item of _data["licencedProvinces"])
                    this.licencedProvinces!.push(AgentLicenceProvinceDto.fromJS(item));
            }
            this.liabilityInsuranceProvider = _data["liabilityInsuranceProvider"];
            this.liabilityInsuranceExpirationDate = _data["liabilityInsuranceExpirationDate"] ? new Date(_data["liabilityInsuranceExpirationDate"].toString()) : undefined as any;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.scheduleNotes = _data["scheduleNotes"];
            this.professionalDesignation = _data["professionalDesignation"];
            this.accountEmail = _data["accountEmail"];
            this.startingOn = _data["startingOn"] ? new Date(_data["startingOn"].toString()) : undefined as any;
            this.agentStatus = _data["agentStatus"];
            if (Array.isArray(_data["agentAdminNotes"])) {
                this.agentAdminNotes = [] as any;
                for (let item of _data["agentAdminNotes"])
                    this.agentAdminNotes!.push(AgentAdminNoteDto.fromJS(item));
            }
            this.agentDevice = _data["agentDevice"] ? AgentDtoDeviceSummary.fromJS(_data["agentDevice"]) : undefined as any;
            this.agentRole = _data["agentRole"];
            if (Array.isArray(_data["agentNotes"])) {
                this.agentNotes = [] as any;
                for (let item of _data["agentNotes"])
                    this.agentNotes!.push(AgentNoteDto.fromJS(item));
            }
            this.hasUnreviewedAgentAdminNotes = _data["hasUnreviewedAgentAdminNotes"];
            this.availableForCareTeam = _data["availableForCareTeam"];
        }
    }

    static fromJS(data: any): FullAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["personalEmail"] = this.personalEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["bankTransitNumber"] = this.bankTransitNumber;
        data["branchTransitNumber"] = this.branchTransitNumber;
        data["accountTransitNumber"] = this.accountTransitNumber;
        if (Array.isArray(this.agentFiles)) {
            data["agentFiles"] = [];
            for (let item of this.agentFiles)
                data["agentFiles"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["personalAddress"] = this.personalAddress ? this.personalAddress.toJSON() : undefined as any;
        data["billingEntityName"] = this.billingEntityName;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["billingSamePersonalAddress"] = this.billingSamePersonalAddress;
        data["salesTaxIdentifier"] = this.salesTaxIdentifier;
        data["salesTaxRate"] = this.salesTaxRate;
        data["hourRate"] = this.hourRate;
        if (Array.isArray(this.licencedProvinces)) {
            data["licencedProvinces"] = [];
            for (let item of this.licencedProvinces)
                data["licencedProvinces"].push(item ? item.toJSON() : undefined as any);
        }
        data["liabilityInsuranceProvider"] = this.liabilityInsuranceProvider;
        data["liabilityInsuranceExpirationDate"] = this.liabilityInsuranceExpirationDate ? this.liabilityInsuranceExpirationDate.toISOString() : undefined as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["scheduleNotes"] = this.scheduleNotes;
        data["professionalDesignation"] = this.professionalDesignation;
        data["accountEmail"] = this.accountEmail;
        data["startingOn"] = this.startingOn ? this.startingOn.toISOString() : undefined as any;
        data["agentStatus"] = this.agentStatus;
        if (Array.isArray(this.agentAdminNotes)) {
            data["agentAdminNotes"] = [];
            for (let item of this.agentAdminNotes)
                data["agentAdminNotes"].push(item ? item.toJSON() : undefined as any);
        }
        data["agentDevice"] = this.agentDevice ? this.agentDevice.toJSON() : undefined as any;
        data["agentRole"] = this.agentRole;
        if (Array.isArray(this.agentNotes)) {
            data["agentNotes"] = [];
            for (let item of this.agentNotes)
                data["agentNotes"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasUnreviewedAgentAdminNotes"] = this.hasUnreviewedAgentAdminNotes;
        data["availableForCareTeam"] = this.availableForCareTeam;
        return data;
    }
}

export interface IFullAgentDto {
    agentId?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    branchTransitNumber?: string | undefined;
    accountTransitNumber?: string | undefined;
    agentFiles?: AgentFileServiceModel[];
    name: string;
    personalAddress?: AgentAddressDto | undefined;
    billingEntityName?: string | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress?: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    licencedProvinces?: AgentLicenceProvinceDto[] | undefined;
    liabilityInsuranceProvider?: string | undefined;
    liabilityInsuranceExpirationDate?: Date | undefined;
    languages?: Languages[] | undefined;
    scheduleNotes?: string | undefined;
    professionalDesignation?: string | undefined;
    accountEmail?: string | undefined;
    startingOn?: Date | undefined;
    agentStatus: AgentStatus;
    agentAdminNotes?: AgentAdminNoteDto[] | undefined;
    agentDevice?: AgentDtoDeviceSummary | undefined;
    agentRole: AgentRole;
    agentNotes?: AgentNoteDto[] | undefined;
    hasUnreviewedAgentAdminNotes?: boolean | undefined;
    availableForCareTeam?: boolean | undefined;
}

export class AgentNoteDto implements IAgentNoteDto {
    agentNoteId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    agentId?: string;
    authorName?: string;
    authorAccountId?: string;
    createdOn?: Date | undefined;

    constructor(data?: IAgentNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentNoteId = _data["agentNoteId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.agentId = _data["agentId"];
            this.authorName = _data["authorName"];
            this.authorAccountId = _data["authorAccountId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AgentNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentNoteId"] = this.agentNoteId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["agentId"] = this.agentId;
        data["authorName"] = this.authorName;
        data["authorAccountId"] = this.authorAccountId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IAgentNoteDto {
    agentNoteId?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    agentId?: string;
    authorName?: string;
    authorAccountId?: string;
    createdOn?: Date | undefined;
}

export class PaginatedResponseOfSummaryAgentDto implements IPaginatedResponseOfSummaryAgentDto {
    results?: SummaryAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfSummaryAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SummaryAgentDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfSummaryAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfSummaryAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfSummaryAgentDto {
    results?: SummaryAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class SummaryAgentDto implements ISummaryAgentDto {
    agentId?: string;
    name?: string;
    agentRole?: AgentRole | undefined;

    constructor(data?: ISummaryAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.name = _data["name"];
            this.agentRole = _data["agentRole"];
        }
    }

    static fromJS(data: any): SummaryAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["name"] = this.name;
        data["agentRole"] = this.agentRole;
        return data;
    }
}

export interface ISummaryAgentDto {
    agentId?: string;
    name?: string;
    agentRole?: AgentRole | undefined;
}

export class PaginatedResponseOfFullAgentDto implements IPaginatedResponseOfFullAgentDto {
    results?: FullAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfFullAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FullAgentDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfFullAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfFullAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfFullAgentDto {
    results?: FullAgentDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class GetListRequest implements IGetListRequest {

    constructor(data?: IGetListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetListRequest {
}

export class PaginatedResponseOfAgentNoteDto implements IPaginatedResponseOfAgentNoteDto {
    results?: AgentNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfAgentNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgentNoteDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAgentNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAgentNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfAgentNoteDto {
    results?: AgentNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class PaginatedResponseOfAgentAdminNoteDto implements IPaginatedResponseOfAgentAdminNoteDto {
    results?: AgentAdminNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfAgentAdminNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgentAdminNoteDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAgentAdminNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAgentAdminNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfAgentAdminNoteDto {
    results?: AgentAdminNoteDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class DoReviewAgentAdminNoteModelRequest implements IDoReviewAgentAdminNoteModelRequest {
    agentAdminNoteId?: string;

    constructor(data?: IDoReviewAgentAdminNoteModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentAdminNoteId = _data["agentAdminNoteId"];
        }
    }

    static fromJS(data: any): DoReviewAgentAdminNoteModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoReviewAgentAdminNoteModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentAdminNoteId"] = this.agentAdminNoteId;
        return data;
    }
}

export interface IDoReviewAgentAdminNoteModelRequest {
    agentAdminNoteId?: string;
}

export class DoSetActiveDeviceRequest implements IDoSetActiveDeviceRequest {
    agentId?: string;
    deviceId?: string | undefined;
    deviceDefinition?: DoSetActiveDeviceRequestDeviceDefinition | undefined;

    constructor(data?: IDoSetActiveDeviceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.deviceId = _data["deviceId"];
            this.deviceDefinition = _data["deviceDefinition"] ? DoSetActiveDeviceRequestDeviceDefinition.fromJS(_data["deviceDefinition"]) : undefined as any;
        }
    }

    static fromJS(data: any): DoSetActiveDeviceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSetActiveDeviceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["deviceId"] = this.deviceId;
        data["deviceDefinition"] = this.deviceDefinition ? this.deviceDefinition.toJSON() : undefined as any;
        return data;
    }
}

export interface IDoSetActiveDeviceRequest {
    agentId?: string;
    deviceId?: string | undefined;
    deviceDefinition?: DoSetActiveDeviceRequestDeviceDefinition | undefined;
}

export class DoSetActiveDeviceRequestDeviceDefinition implements IDoSetActiveDeviceRequestDeviceDefinition {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;

    constructor(data?: IDoSetActiveDeviceRequestDeviceDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelType = _data["modelType"];
            this.operatingSystem = _data["operatingSystem"];
        }
    }

    static fromJS(data: any): DoSetActiveDeviceRequestDeviceDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new DoSetActiveDeviceRequestDeviceDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelType"] = this.modelType;
        data["operatingSystem"] = this.operatingSystem;
        return data;
    }
}

export interface IDoSetActiveDeviceRequestDeviceDefinition {
    modelType?: string | undefined;
    operatingSystem?: string | undefined;
}

export class PaginatedResponseOfDeviceDto implements IPaginatedResponseOfDeviceDto {
    results?: DeviceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DeviceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfDeviceDto {
    results?: DeviceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class DeviceDto implements IDeviceDto {
    deviceId?: string | undefined;
    identifier?: string;
    modelType?: string;
    modelYear?: string;
    serialNumber?: string | undefined;
    operatingSystem?: string | undefined;
    purchaseDate?: Date;
    deviceStatus?: DeviceStatus;

    constructor(data?: IDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.identifier = _data["identifier"];
            this.modelType = _data["modelType"];
            this.modelYear = _data["modelYear"];
            this.serialNumber = _data["serialNumber"];
            this.operatingSystem = _data["operatingSystem"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : undefined as any;
            this.deviceStatus = _data["deviceStatus"];
        }
    }

    static fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["identifier"] = this.identifier;
        data["modelType"] = this.modelType;
        data["modelYear"] = this.modelYear;
        data["serialNumber"] = this.serialNumber;
        data["operatingSystem"] = this.operatingSystem;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : undefined as any;
        data["deviceStatus"] = this.deviceStatus;
        return data;
    }
}

export interface IDeviceDto {
    deviceId?: string | undefined;
    identifier?: string;
    modelType?: string;
    modelYear?: string;
    serialNumber?: string | undefined;
    operatingSystem?: string | undefined;
    purchaseDate?: Date;
    deviceStatus?: DeviceStatus;
}

export enum DeviceStatus {
    Available = 1,
    Busy = 2,
    Disabled = 3,
}

export class AgentDeviceCheckDto implements IAgentDeviceCheckDto {
    deviceChecks?: DeviceCheck[] | undefined;
    agentId?: string;
    openVpnAccountName?: string | undefined;
    asteriskIdentifier?: string | undefined;

    constructor(data?: IAgentDeviceCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deviceChecks"])) {
                this.deviceChecks = [] as any;
                for (let item of _data["deviceChecks"])
                    this.deviceChecks!.push(item);
            }
            this.agentId = _data["agentId"];
            this.openVpnAccountName = _data["openVpnAccountName"];
            this.asteriskIdentifier = _data["asteriskIdentifier"];
        }
    }

    static fromJS(data: any): AgentDeviceCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentDeviceCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deviceChecks)) {
            data["deviceChecks"] = [];
            for (let item of this.deviceChecks)
                data["deviceChecks"].push(item);
        }
        data["agentId"] = this.agentId;
        data["openVpnAccountName"] = this.openVpnAccountName;
        data["asteriskIdentifier"] = this.asteriskIdentifier;
        return data;
    }
}

export interface IAgentDeviceCheckDto {
    deviceChecks?: DeviceCheck[] | undefined;
    agentId?: string;
    openVpnAccountName?: string | undefined;
    asteriskIdentifier?: string | undefined;
}

export class AgentRegisterResponseModel implements IAgentRegisterResponseModel {
    accountId?: string;
    success?: boolean;

    constructor(data?: IAgentRegisterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AgentRegisterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRegisterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["success"] = this.success;
        return data;
    }
}

export interface IAgentRegisterResponseModel {
    accountId?: string;
    success?: boolean;
}

export class AgentRegisterRequestModel implements IAgentRegisterRequestModel {
    email?: string;
    firstName?: string;
    lastName?: string;
    ipAddress?: string | undefined;
    agentId?: string;

    constructor(data?: IAgentRegisterRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.ipAddress = _data["ipAddress"];
            this.agentId = _data["agentId"];
        }
    }

    static fromJS(data: any): AgentRegisterRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRegisterRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ipAddress"] = this.ipAddress;
        data["agentId"] = this.agentId;
        return data;
    }
}

export interface IAgentRegisterRequestModel {
    email?: string;
    firstName?: string;
    lastName?: string;
    ipAddress?: string | undefined;
    agentId?: string;
}

export class DashboardResponseModel implements IDashboardResponseModel {
    activeAgents?: number;
    onboardingAgents?: number;
    totalAgents?: number;
    activePhysicianAgents?: number;
    activeDietitianAgents?: number;
    activeBilingualAgents?: number;
    unassignedEquipment?: number;
    pendingEquipment?: number;
    pendingAdminInvoices?: number;
    physicianInvoicesDueForCreation?: number;
    disputedPhysicianInvoices?: number;
    approvedPhysicianInvoices?: number;
    notesForReview?: number;
    trainingSupportRequests?: number;

    constructor(data?: IDashboardResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeAgents = _data["activeAgents"];
            this.onboardingAgents = _data["onboardingAgents"];
            this.totalAgents = _data["totalAgents"];
            this.activePhysicianAgents = _data["activePhysicianAgents"];
            this.activeDietitianAgents = _data["activeDietitianAgents"];
            this.activeBilingualAgents = _data["activeBilingualAgents"];
            this.unassignedEquipment = _data["unassignedEquipment"];
            this.pendingEquipment = _data["pendingEquipment"];
            this.pendingAdminInvoices = _data["pendingAdminInvoices"];
            this.physicianInvoicesDueForCreation = _data["physicianInvoicesDueForCreation"];
            this.disputedPhysicianInvoices = _data["disputedPhysicianInvoices"];
            this.approvedPhysicianInvoices = _data["approvedPhysicianInvoices"];
            this.notesForReview = _data["notesForReview"];
            this.trainingSupportRequests = _data["trainingSupportRequests"];
        }
    }

    static fromJS(data: any): DashboardResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeAgents"] = this.activeAgents;
        data["onboardingAgents"] = this.onboardingAgents;
        data["totalAgents"] = this.totalAgents;
        data["activePhysicianAgents"] = this.activePhysicianAgents;
        data["activeDietitianAgents"] = this.activeDietitianAgents;
        data["activeBilingualAgents"] = this.activeBilingualAgents;
        data["unassignedEquipment"] = this.unassignedEquipment;
        data["pendingEquipment"] = this.pendingEquipment;
        data["pendingAdminInvoices"] = this.pendingAdminInvoices;
        data["physicianInvoicesDueForCreation"] = this.physicianInvoicesDueForCreation;
        data["disputedPhysicianInvoices"] = this.disputedPhysicianInvoices;
        data["approvedPhysicianInvoices"] = this.approvedPhysicianInvoices;
        data["notesForReview"] = this.notesForReview;
        data["trainingSupportRequests"] = this.trainingSupportRequests;
        return data;
    }
}

export interface IDashboardResponseModel {
    activeAgents?: number;
    onboardingAgents?: number;
    totalAgents?: number;
    activePhysicianAgents?: number;
    activeDietitianAgents?: number;
    activeBilingualAgents?: number;
    unassignedEquipment?: number;
    pendingEquipment?: number;
    pendingAdminInvoices?: number;
    physicianInvoicesDueForCreation?: number;
    disputedPhysicianInvoices?: number;
    approvedPhysicianInvoices?: number;
    notesForReview?: number;
    trainingSupportRequests?: number;
}

export class DeviceAgentDto extends DeviceDto implements IDeviceAgentDto {
    pendingAgentName?: string | undefined;

    constructor(data?: IDeviceAgentDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pendingAgentName = _data["pendingAgentName"];
        }
    }

    static override fromJS(data: any): DeviceAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAgentDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingAgentName"] = this.pendingAgentName;
        super.toJSON(data);
        return data;
    }
}

export interface IDeviceAgentDto extends IDeviceDto {
    pendingAgentName?: string | undefined;
}

export class PaginatedResponseOfInvoicingStatusDto implements IPaginatedResponseOfInvoicingStatusDto {
    results?: InvoicingStatusDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfInvoicingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InvoicingStatusDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfInvoicingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfInvoicingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfInvoicingStatusDto {
    results?: InvoicingStatusDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class InvoicingStatusDto implements IInvoicingStatusDto {
    agentId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    periods?: InvoicingStatusPeriodDto[] | undefined;

    constructor(data?: IInvoicingStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.name = _data["name"];
            this.email = _data["email"];
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(InvoicingStatusPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicingStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["name"] = this.name;
        data["email"] = this.email;
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoicingStatusDto {
    agentId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    periods?: InvoicingStatusPeriodDto[] | undefined;
}

export class InvoicingStatusPeriodDto implements IInvoicingStatusPeriodDto {
    period?: Date | undefined;
    invoices?: InvoicingStatusInvoiceDto[] | undefined;

    constructor(data?: IInvoicingStatusPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? new Date(_data["period"].toString()) : undefined as any;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoicingStatusInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoicingStatusPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingStatusPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toISOString() : undefined as any;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoicingStatusPeriodDto {
    period?: Date | undefined;
    invoices?: InvoicingStatusInvoiceDto[] | undefined;
}

export class InvoicingStatusInvoiceDto implements IInvoicingStatusInvoiceDto {
    invoiceId?: string | undefined;
    invoiceFlow?: InvoiceFlow;
    invoiceStatus?: InvoiceStatus;
    number?: number;
    latestDispute?: string;
    invoiceDate?: Date;

    constructor(data?: IInvoicingStatusInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceFlow = _data["invoiceFlow"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.number = _data["number"];
            this.latestDispute = _data["latestDispute"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InvoicingStatusInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingStatusInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceFlow"] = this.invoiceFlow;
        data["invoiceStatus"] = this.invoiceStatus;
        data["number"] = this.number;
        data["latestDispute"] = this.latestDispute;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IInvoicingStatusInvoiceDto {
    invoiceId?: string | undefined;
    invoiceFlow?: InvoiceFlow;
    invoiceStatus?: InvoiceStatus;
    number?: number;
    latestDispute?: string;
    invoiceDate?: Date;
}

export enum InvoiceFlow {
    AgentApproval = 0,
    AdminApproval = 1,
    AutoApproval = 2,
}

export enum InvoiceStatus {
    Draft = 0,
    InReview = 1,
    Disputed = 2,
    ApprovedByAgent = 3,
    ApprovedByAdmin = 4,
    Completed = 5,
}

export class PaginatedResponseOfInvoiceDto implements IPaginatedResponseOfInvoiceDto {
    results?: InvoiceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(InvoiceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfInvoiceDto {
    results?: InvoiceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    invoice?: InvoiceBaseDto;
    extendedData?: InvoiceExtendedDto | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["invoice"] ? InvoiceBaseDto.fromJS(_data["invoice"]) : undefined as any;
            this.extendedData = _data["extendedData"] ? InvoiceExtendedDto.fromJS(_data["extendedData"]) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : undefined as any;
        data["extendedData"] = this.extendedData ? this.extendedData.toJSON() : undefined as any;
        return data;
    }
}

export interface IInvoiceDto {
    invoice?: InvoiceBaseDto;
    extendedData?: InvoiceExtendedDto | undefined;
}

export class InvoiceBaseDto implements IInvoiceBaseDto {
    invoiceId?: string;
    invoiceStatus?: InvoiceStatus;
    invoiceNumber?: number;
    invoiceDate?: Date;
    invoiceFlow?: InvoiceFlow;
    agent?: AgentInvoiceDto;
    servicePeriodFrom?: Date;
    servicePeriodTo?: Date;
    latestDispute?: string | undefined;

    constructor(data?: IInvoiceBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.invoiceStatus = _data["invoiceStatus"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceFlow = _data["invoiceFlow"];
            this.agent = _data["agent"] ? AgentInvoiceDto.fromJS(_data["agent"]) : undefined as any;
            this.servicePeriodFrom = _data["servicePeriodFrom"] ? new Date(_data["servicePeriodFrom"].toString()) : undefined as any;
            this.servicePeriodTo = _data["servicePeriodTo"] ? new Date(_data["servicePeriodTo"].toString()) : undefined as any;
            this.latestDispute = _data["latestDispute"];
        }
    }

    static fromJS(data: any): InvoiceBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["invoiceStatus"] = this.invoiceStatus;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceFlow"] = this.invoiceFlow;
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["servicePeriodFrom"] = this.servicePeriodFrom ? this.servicePeriodFrom.toISOString() : undefined as any;
        data["servicePeriodTo"] = this.servicePeriodTo ? this.servicePeriodTo.toISOString() : undefined as any;
        data["latestDispute"] = this.latestDispute;
        return data;
    }
}

export interface IInvoiceBaseDto {
    invoiceId?: string;
    invoiceStatus?: InvoiceStatus;
    invoiceNumber?: number;
    invoiceDate?: Date;
    invoiceFlow?: InvoiceFlow;
    agent?: AgentInvoiceDto;
    servicePeriodFrom?: Date;
    servicePeriodTo?: Date;
    latestDispute?: string | undefined;
}

export class AgentInvoiceDto implements IAgentInvoiceDto {
    agentId?: string;
    billingEntityName?: string | undefined;
    accountEmail?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    personalAddress?: AgentAddressDto | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress?: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    name?: string | undefined;

    constructor(data?: IAgentInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.billingEntityName = _data["billingEntityName"];
            this.accountEmail = _data["accountEmail"];
            this.personalEmail = _data["personalEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.personalAddress = _data["personalAddress"] ? AgentAddressDto.fromJS(_data["personalAddress"]) : undefined as any;
            this.billingAddress = _data["billingAddress"] ? AgentAddressDto.fromJS(_data["billingAddress"]) : undefined as any;
            this.billingSamePersonalAddress = _data["billingSamePersonalAddress"];
            this.salesTaxIdentifier = _data["salesTaxIdentifier"];
            this.salesTaxRate = _data["salesTaxRate"];
            this.hourRate = _data["hourRate"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AgentInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["billingEntityName"] = this.billingEntityName;
        data["accountEmail"] = this.accountEmail;
        data["personalEmail"] = this.personalEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["personalAddress"] = this.personalAddress ? this.personalAddress.toJSON() : undefined as any;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : undefined as any;
        data["billingSamePersonalAddress"] = this.billingSamePersonalAddress;
        data["salesTaxIdentifier"] = this.salesTaxIdentifier;
        data["salesTaxRate"] = this.salesTaxRate;
        data["hourRate"] = this.hourRate;
        data["name"] = this.name;
        return data;
    }
}

export interface IAgentInvoiceDto {
    agentId?: string;
    billingEntityName?: string | undefined;
    accountEmail?: string | undefined;
    personalEmail?: string | undefined;
    phoneNumber?: string | undefined;
    personalAddress?: AgentAddressDto | undefined;
    billingAddress?: AgentAddressDto | undefined;
    billingSamePersonalAddress?: boolean;
    salesTaxIdentifier?: string | undefined;
    salesTaxRate?: number | undefined;
    hourRate?: number | undefined;
    name?: string | undefined;
}

export class InvoiceExtendedDto implements IInvoiceExtendedDto {
    serviceDescription?: string;
    invoiceItems?: InvoiceItemDto[];
    disputes?: InvoiceDisputeDto[];

    constructor(data?: IInvoiceExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDescription = _data["serviceDescription"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            if (Array.isArray(_data["disputes"])) {
                this.disputes = [] as any;
                for (let item of _data["disputes"])
                    this.disputes!.push(InvoiceDisputeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDescription"] = this.serviceDescription;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.disputes)) {
            data["disputes"] = [];
            for (let item of this.disputes)
                data["disputes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceExtendedDto {
    serviceDescription?: string;
    invoiceItems?: InvoiceItemDto[];
    disputes?: InvoiceDisputeDto[];
}

export class InvoiceItemDto implements IInvoiceItemDto {
    invoiceItemId?: string;
    date?: Date;
    minutes?: number;
    notes?: string | undefined;

    constructor(data?: IInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceItemId = _data["invoiceItemId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.minutes = _data["minutes"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): InvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceItemId"] = this.invoiceItemId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["minutes"] = this.minutes;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IInvoiceItemDto {
    invoiceItemId?: string;
    date?: Date;
    minutes?: number;
    notes?: string | undefined;
}

export class InvoiceDisputeDto implements IInvoiceDisputeDto {
    disputedOn?: Date;
    comment?: string;

    constructor(data?: IInvoiceDisputeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disputedOn = _data["disputedOn"] ? new Date(_data["disputedOn"].toString()) : undefined as any;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): InvoiceDisputeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDisputeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disputedOn"] = this.disputedOn ? this.disputedOn.toISOString() : undefined as any;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IInvoiceDisputeDto {
    disputedOn?: Date;
    comment?: string;
}

export class DoDisputeRequest implements IDoDisputeRequest {
    invoiceId?: string;
    comment?: string;

    constructor(data?: IDoDisputeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): DoDisputeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoDisputeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IDoDisputeRequest {
    invoiceId?: string;
    comment?: string;
}

export class CreateInvoiceRequest implements ICreateInvoiceRequest {
    invoiceFlow?: InvoiceFlow;
    agentId?: string | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    servicePeriodFrom?: Date;
    servicePeriodTo?: Date;

    constructor(data?: ICreateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceFlow = _data["invoiceFlow"];
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            this.servicePeriodFrom = _data["servicePeriodFrom"] ? new Date(_data["servicePeriodFrom"].toString()) : undefined as any;
            this.servicePeriodTo = _data["servicePeriodTo"] ? new Date(_data["servicePeriodTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceFlow"] = this.invoiceFlow;
        data["agentId"] = this.agentId;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["servicePeriodFrom"] = this.servicePeriodFrom ? this.servicePeriodFrom.toISOString() : undefined as any;
        data["servicePeriodTo"] = this.servicePeriodTo ? this.servicePeriodTo.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateInvoiceRequest {
    invoiceFlow?: InvoiceFlow;
    agentId?: string | undefined;
    invoiceItems?: InvoiceItemDto[] | undefined;
    servicePeriodFrom?: Date;
    servicePeriodTo?: Date;
}

export class UpdateInvoiceRequest implements IUpdateInvoiceRequest {
    invoiceId?: string;
    invoiceItems?: InvoiceItemDto[];
    servicePeriodFrom?: Date;
    servicePeriodTo?: Date;

    constructor(data?: IUpdateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemDto.fromJS(item));
            }
            this.servicePeriodFrom = _data["servicePeriodFrom"] ? new Date(_data["servicePeriodFrom"].toString()) : undefined as any;
            this.servicePeriodTo = _data["servicePeriodTo"] ? new Date(_data["servicePeriodTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        data["servicePeriodFrom"] = this.servicePeriodFrom ? this.servicePeriodFrom.toISOString() : undefined as any;
        data["servicePeriodTo"] = this.servicePeriodTo ? this.servicePeriodTo.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateInvoiceRequest {
    invoiceId?: string;
    invoiceItems?: InvoiceItemDto[];
    servicePeriodFrom?: Date;
    servicePeriodTo?: Date;
}

export class AccountVerifyRequest implements IAccountVerifyRequest {
    email?: string;
    token?: string;
    password?: string;

    constructor(data?: IAccountVerifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AccountVerifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountVerifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["password"] = this.password;
        return data;
    }
}

export interface IAccountVerifyRequest {
    email?: string;
    token?: string;
    password?: string;
}

export class DoForgotPasswordStartModel implements IDoForgotPasswordStartModel {
    email?: string;

    constructor(data?: IDoForgotPasswordStartModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): DoForgotPasswordStartModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoForgotPasswordStartModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IDoForgotPasswordStartModel {
    email?: string;
}

export class DoCompleteForgotPasswordRequest implements IDoCompleteForgotPasswordRequest {
    email?: string;
    token?: string;
    password?: string;

    constructor(data?: IDoCompleteForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): DoCompleteForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoCompleteForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["password"] = this.password;
        return data;
    }
}

export interface IDoCompleteForgotPasswordRequest {
    email?: string;
    token?: string;
    password?: string;
}

export class AccountAuthenticateModelResponse implements IAccountAuthenticateModelResponse {
    success?: boolean;
    displayName?: string | undefined;
    culture?: string;

    constructor(data?: IAccountAuthenticateModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.displayName = _data["displayName"];
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): AccountAuthenticateModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAuthenticateModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["displayName"] = this.displayName;
        data["culture"] = this.culture;
        return data;
    }
}

export interface IAccountAuthenticateModelResponse {
    success?: boolean;
    displayName?: string | undefined;
    culture?: string;
}

export class AccountAuthenticateModel implements IAccountAuthenticateModel {
    username?: string;
    password?: string;

    constructor(data?: IAccountAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AccountAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IAccountAuthenticateModel {
    username?: string;
    password?: string;
}

export class MWMSettings implements IMWMSettings {
    emailTemplateSettings?: EmailTemplateSettings;
    accountsEmail?: EmailSettings;
    fileUploadSettings?: FileUploadSettings;
    referralFaxSettings?: ReferralFaxSettings;

    constructor(data?: IMWMSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplateSettings = _data["emailTemplateSettings"] ? EmailTemplateSettings.fromJS(_data["emailTemplateSettings"]) : undefined as any;
            this.accountsEmail = _data["accountsEmail"] ? EmailSettings.fromJS(_data["accountsEmail"]) : undefined as any;
            this.fileUploadSettings = _data["fileUploadSettings"] ? FileUploadSettings.fromJS(_data["fileUploadSettings"]) : undefined as any;
            this.referralFaxSettings = _data["referralFaxSettings"] ? ReferralFaxSettings.fromJS(_data["referralFaxSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): MWMSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MWMSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailTemplateSettings"] = this.emailTemplateSettings ? this.emailTemplateSettings.toJSON() : undefined as any;
        data["accountsEmail"] = this.accountsEmail ? this.accountsEmail.toJSON() : undefined as any;
        data["fileUploadSettings"] = this.fileUploadSettings ? this.fileUploadSettings.toJSON() : undefined as any;
        data["referralFaxSettings"] = this.referralFaxSettings ? this.referralFaxSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IMWMSettings {
    emailTemplateSettings?: EmailTemplateSettings;
    accountsEmail?: EmailSettings;
    fileUploadSettings?: FileUploadSettings;
    referralFaxSettings?: ReferralFaxSettings;
}

export class EmailTemplateSettings implements IEmailTemplateSettings {
    forgotPassword?: string | undefined;
    verifyAccountPath?: string | undefined;
    agentInvoicePath?: string | undefined;
    adminInvoicePath?: string | undefined;
    paymentProcessingRecipient?: string | undefined;

    constructor(data?: IEmailTemplateSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forgotPassword = _data["forgotPassword"];
            this.verifyAccountPath = _data["verifyAccountPath"];
            this.agentInvoicePath = _data["agentInvoicePath"];
            this.adminInvoicePath = _data["adminInvoicePath"];
            this.paymentProcessingRecipient = _data["paymentProcessingRecipient"];
        }
    }

    static fromJS(data: any): EmailTemplateSettings {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forgotPassword"] = this.forgotPassword;
        data["verifyAccountPath"] = this.verifyAccountPath;
        data["agentInvoicePath"] = this.agentInvoicePath;
        data["adminInvoicePath"] = this.adminInvoicePath;
        data["paymentProcessingRecipient"] = this.paymentProcessingRecipient;
        return data;
    }
}

export interface IEmailTemplateSettings {
    forgotPassword?: string | undefined;
    verifyAccountPath?: string | undefined;
    agentInvoicePath?: string | undefined;
    adminInvoicePath?: string | undefined;
    paymentProcessingRecipient?: string | undefined;
}

export class EmailSettings implements IEmailSettings {
    applicationName?: string | undefined;
    defaultFromEmail?: string | undefined;
    password?: string | undefined;
    emailServer?: string | undefined;
    port?: number;
    useSSL?: boolean;
    useAuthentication?: boolean;
    customFromEmail?: string | undefined;
    customFromPassword?: string | undefined;
    faxFromEmail?: string | undefined;
    faxToEmailDomain?: string | undefined;
    faxEmailPassword?: string | undefined;
    adverseEventRecipient?: string | undefined;

    constructor(data?: IEmailSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.defaultFromEmail = _data["defaultFromEmail"];
            this.password = _data["password"];
            this.emailServer = _data["emailServer"];
            this.port = _data["port"];
            this.useSSL = _data["useSSL"];
            this.useAuthentication = _data["useAuthentication"];
            this.customFromEmail = _data["customFromEmail"];
            this.customFromPassword = _data["customFromPassword"];
            this.faxFromEmail = _data["faxFromEmail"];
            this.faxToEmailDomain = _data["faxToEmailDomain"];
            this.faxEmailPassword = _data["faxEmailPassword"];
            this.adverseEventRecipient = _data["adverseEventRecipient"];
        }
    }

    static fromJS(data: any): EmailSettings {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["defaultFromEmail"] = this.defaultFromEmail;
        data["password"] = this.password;
        data["emailServer"] = this.emailServer;
        data["port"] = this.port;
        data["useSSL"] = this.useSSL;
        data["useAuthentication"] = this.useAuthentication;
        data["customFromEmail"] = this.customFromEmail;
        data["customFromPassword"] = this.customFromPassword;
        data["faxFromEmail"] = this.faxFromEmail;
        data["faxToEmailDomain"] = this.faxToEmailDomain;
        data["faxEmailPassword"] = this.faxEmailPassword;
        data["adverseEventRecipient"] = this.adverseEventRecipient;
        return data;
    }
}

export interface IEmailSettings {
    applicationName?: string | undefined;
    defaultFromEmail?: string | undefined;
    password?: string | undefined;
    emailServer?: string | undefined;
    port?: number;
    useSSL?: boolean;
    useAuthentication?: boolean;
    customFromEmail?: string | undefined;
    customFromPassword?: string | undefined;
    faxFromEmail?: string | undefined;
    faxToEmailDomain?: string | undefined;
    faxEmailPassword?: string | undefined;
    adverseEventRecipient?: string | undefined;
}

export class FileUploadSettings implements IFileUploadSettings {
    maxSize?: number;

    constructor(data?: IFileUploadSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxSize = _data["maxSize"];
        }
    }

    static fromJS(data: any): FileUploadSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxSize"] = this.maxSize;
        return data;
    }
}

export interface IFileUploadSettings {
    maxSize?: number;
}

export class ReferralFaxSettings implements IReferralFaxSettings {
    sleepApneaFaxNumber?: string;

    constructor(data?: IReferralFaxSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sleepApneaFaxNumber = _data["sleepApneaFaxNumber"];
        }
    }

    static fromJS(data: any): ReferralFaxSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralFaxSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sleepApneaFaxNumber"] = this.sleepApneaFaxNumber;
        return data;
    }
}

export interface IReferralFaxSettings {
    sleepApneaFaxNumber?: string;
}

export class MWMPublicSettings implements IMWMPublicSettings {
    fileUploadSettings?: FileUploadSettings;

    constructor(data?: IMWMPublicSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUploadSettings = _data["fileUploadSettings"] ? FileUploadSettings.fromJS(_data["fileUploadSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): MWMPublicSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MWMPublicSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUploadSettings"] = this.fileUploadSettings ? this.fileUploadSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IMWMPublicSettings {
    fileUploadSettings?: FileUploadSettings;
}

export enum ResourceType {
    Documentation = 1,
    Resource = 2,
}

export class DoSortTasksRequest implements IDoSortTasksRequest {
    taskIds?: string[];

    constructor(data?: IDoSortTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["taskIds"])
                    this.taskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DoSortTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSortTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["taskIds"] = [];
            for (let item of this.taskIds)
                data["taskIds"].push(item);
        }
        return data;
    }
}

export interface IDoSortTasksRequest {
    taskIds?: string[];
}

export class DoSortModulesRequest implements IDoSortModulesRequest {
    moduleIds?: string[];

    constructor(data?: IDoSortModulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["moduleIds"])) {
                this.moduleIds = [] as any;
                for (let item of _data["moduleIds"])
                    this.moduleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DoSortModulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSortModulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleIds)) {
            data["moduleIds"] = [];
            for (let item of this.moduleIds)
                data["moduleIds"].push(item);
        }
        return data;
    }
}

export interface IDoSortModulesRequest {
    moduleIds?: string[];
}

export class DoSortTopicsRequest implements IDoSortTopicsRequest {
    topicIds?: string[];

    constructor(data?: IDoSortTopicsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["topicIds"])) {
                this.topicIds = [] as any;
                for (let item of _data["topicIds"])
                    this.topicIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DoSortTopicsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DoSortTopicsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.topicIds)) {
            data["topicIds"] = [];
            for (let item of this.topicIds)
                data["topicIds"].push(item);
        }
        return data;
    }
}

export interface IDoSortTopicsRequest {
    topicIds?: string[];
}

export abstract class HelpRequestBaseDto implements IHelpRequestBaseDto {
    helpRequestId?: string;
    agentId?: string;
    subject?: string | undefined;
    notes?: string | undefined;
    completedOn?: Date | undefined;
    createdOn?: Date | undefined;

    constructor(data?: IHelpRequestBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.helpRequestId = _data["helpRequestId"];
            this.agentId = _data["agentId"];
            this.subject = _data["subject"];
            this.notes = _data["notes"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HelpRequestBaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HelpRequestBaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["helpRequestId"] = this.helpRequestId;
        data["agentId"] = this.agentId;
        data["subject"] = this.subject;
        data["notes"] = this.notes;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IHelpRequestBaseDto {
    helpRequestId?: string;
    agentId?: string;
    subject?: string | undefined;
    notes?: string | undefined;
    completedOn?: Date | undefined;
    createdOn?: Date | undefined;
}

export class HelpRequestDto extends HelpRequestBaseDto implements IHelpRequestDto {

    constructor(data?: IHelpRequestDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HelpRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpRequestDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHelpRequestDto extends IHelpRequestBaseDto {
}

export class SaveModuleRequest implements ISaveModuleRequest {
    moduleId?: string;
    name?: string;
    description?: string;
    moduleType?: ModuleType;
    role?: AgentRole;

    constructor(data?: ISaveModuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.moduleType = _data["moduleType"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): SaveModuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveModuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["moduleType"] = this.moduleType;
        data["role"] = this.role;
        return data;
    }
}

export interface ISaveModuleRequest {
    moduleId?: string;
    name?: string;
    description?: string;
    moduleType?: ModuleType;
    role?: AgentRole;
}

export enum ModuleType {
    Regular = 1,
    ContinuingEducation = 2,
}

export class SaveTopicRequest implements ISaveTopicRequest {
    topicId?: string;
    moduleId?: string;
    name?: string;
    description?: string;

    constructor(data?: ISaveTopicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.moduleId = _data["moduleId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SaveTopicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTopicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["moduleId"] = this.moduleId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ISaveTopicRequest {
    topicId?: string;
    moduleId?: string;
    name?: string;
    description?: string;
}

export enum TaskType {
    Video = 1,
    Article = 2,
    Assignment = 3,
    Quiz = 4,
}

export class AgentCompleteTaskRequest implements IAgentCompleteTaskRequest {
    agentId?: string;
    taskId?: string;
    completionType?: AgentTaskCompletionType;

    constructor(data?: IAgentCompleteTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.taskId = _data["taskId"];
            this.completionType = _data["completionType"];
        }
    }

    static fromJS(data: any): AgentCompleteTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCompleteTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["taskId"] = this.taskId;
        data["completionType"] = this.completionType;
        return data;
    }
}

export interface IAgentCompleteTaskRequest {
    agentId?: string;
    taskId?: string;
    completionType?: AgentTaskCompletionType;
}

export enum AgentTaskCompletionType {
    Regular = 1,
    Manual = 2,
}

export class PaginatedResponseOfResourceDto implements IPaginatedResponseOfResourceDto {
    results?: ResourceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ResourceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfResourceDto {
    results?: ResourceDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ResourceDto implements IResourceDto {
    resourceId?: string;
    name?: string | undefined;
    description?: string | undefined;
    fileName?: string | undefined;
    blobId?: string | undefined;
    resourceType?: ResourceType;
    externalLink?: string | undefined;

    constructor(data?: IResourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.fileName = _data["fileName"];
            this.blobId = _data["blobId"];
            this.resourceType = _data["resourceType"];
            this.externalLink = _data["externalLink"];
        }
    }

    static fromJS(data: any): ResourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["fileName"] = this.fileName;
        data["blobId"] = this.blobId;
        data["resourceType"] = this.resourceType;
        data["externalLink"] = this.externalLink;
        return data;
    }
}

export interface IResourceDto {
    resourceId?: string;
    name?: string | undefined;
    description?: string | undefined;
    fileName?: string | undefined;
    blobId?: string | undefined;
    resourceType?: ResourceType;
    externalLink?: string | undefined;
}

export class PaginatedResponseOfHelpRequestSummaryDto implements IPaginatedResponseOfHelpRequestSummaryDto {
    results?: HelpRequestSummaryDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfHelpRequestSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(HelpRequestSummaryDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfHelpRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfHelpRequestSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfHelpRequestSummaryDto {
    results?: HelpRequestSummaryDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class HelpRequestSummaryDto extends HelpRequestBaseDto implements IHelpRequestSummaryDto {
    agentIdentifier?: string | undefined;
    agentName?: string | undefined;
    agentEmail?: string | undefined;
    agentRole?: AgentRole | undefined;

    constructor(data?: IHelpRequestSummaryDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentIdentifier = _data["agentIdentifier"];
            this.agentName = _data["agentName"];
            this.agentEmail = _data["agentEmail"];
            this.agentRole = _data["agentRole"];
        }
    }

    static override fromJS(data: any): HelpRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new HelpRequestSummaryDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentIdentifier"] = this.agentIdentifier;
        data["agentName"] = this.agentName;
        data["agentEmail"] = this.agentEmail;
        data["agentRole"] = this.agentRole;
        super.toJSON(data);
        return data;
    }
}

export interface IHelpRequestSummaryDto extends IHelpRequestBaseDto {
    agentIdentifier?: string | undefined;
    agentName?: string | undefined;
    agentEmail?: string | undefined;
    agentRole?: AgentRole | undefined;
}

export class AgentTaskCompletionStatusSummary implements IAgentTaskCompletionStatusSummary {
    agentId?: string;
    agentTaskCompletionStatusSummaryModules?: AgentTaskCompletionStatusSummaryModule[];
    totalTasks?: number;
    completedTasks?: number;

    constructor(data?: IAgentTaskCompletionStatusSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            if (Array.isArray(_data["agentTaskCompletionStatusSummaryModules"])) {
                this.agentTaskCompletionStatusSummaryModules = [] as any;
                for (let item of _data["agentTaskCompletionStatusSummaryModules"])
                    this.agentTaskCompletionStatusSummaryModules!.push(AgentTaskCompletionStatusSummaryModule.fromJS(item));
            }
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        if (Array.isArray(this.agentTaskCompletionStatusSummaryModules)) {
            data["agentTaskCompletionStatusSummaryModules"] = [];
            for (let item of this.agentTaskCompletionStatusSummaryModules)
                data["agentTaskCompletionStatusSummaryModules"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummary {
    agentId?: string;
    agentTaskCompletionStatusSummaryModules?: AgentTaskCompletionStatusSummaryModule[];
    totalTasks?: number;
    completedTasks?: number;
}

export class AgentTaskCompletionStatusSummaryModule implements IAgentTaskCompletionStatusSummaryModule {
    moduleId?: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTopics?: AgentTaskCompletionStatusSummaryTopic[];
    completionRate?: number;
    totalTasks?: number;
    completedTasks?: number;

    constructor(data?: IAgentTaskCompletionStatusSummaryModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.name = _data["name"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            if (Array.isArray(_data["agentTaskCompletionStatusSummaryTopics"])) {
                this.agentTaskCompletionStatusSummaryTopics = [] as any;
                for (let item of _data["agentTaskCompletionStatusSummaryTopics"])
                    this.agentTaskCompletionStatusSummaryTopics!.push(AgentTaskCompletionStatusSummaryTopic.fromJS(item));
            }
            this.completionRate = _data["completionRate"];
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummaryModule {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummaryModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["name"] = this.name;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        if (Array.isArray(this.agentTaskCompletionStatusSummaryTopics)) {
            data["agentTaskCompletionStatusSummaryTopics"] = [];
            for (let item of this.agentTaskCompletionStatusSummaryTopics)
                data["agentTaskCompletionStatusSummaryTopics"].push(item ? item.toJSON() : undefined as any);
        }
        data["completionRate"] = this.completionRate;
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummaryModule {
    moduleId?: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTopics?: AgentTaskCompletionStatusSummaryTopic[];
    completionRate?: number;
    totalTasks?: number;
    completedTasks?: number;
}

export class AgentTaskCompletionStatusSummaryTopic implements IAgentTaskCompletionStatusSummaryTopic {
    topicId?: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTasks?: AgentTaskCompletionStatusSummaryTask[];
    completionRate?: number;
    totalTasks?: number;
    completedTasks?: number;

    constructor(data?: IAgentTaskCompletionStatusSummaryTopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.name = _data["name"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            if (Array.isArray(_data["agentTaskCompletionStatusSummaryTasks"])) {
                this.agentTaskCompletionStatusSummaryTasks = [] as any;
                for (let item of _data["agentTaskCompletionStatusSummaryTasks"])
                    this.agentTaskCompletionStatusSummaryTasks!.push(AgentTaskCompletionStatusSummaryTask.fromJS(item));
            }
            this.completionRate = _data["completionRate"];
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummaryTopic {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummaryTopic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["name"] = this.name;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        if (Array.isArray(this.agentTaskCompletionStatusSummaryTasks)) {
            data["agentTaskCompletionStatusSummaryTasks"] = [];
            for (let item of this.agentTaskCompletionStatusSummaryTasks)
                data["agentTaskCompletionStatusSummaryTasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["completionRate"] = this.completionRate;
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummaryTopic {
    topicId?: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    agentTaskCompletionStatusSummaryTasks?: AgentTaskCompletionStatusSummaryTask[];
    completionRate?: number;
    totalTasks?: number;
    completedTasks?: number;
}

export class AgentTaskCompletionStatusSummaryTask implements IAgentTaskCompletionStatusSummaryTask {
    taskId?: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    completionRate?: number;

    constructor(data?: IAgentTaskCompletionStatusSummaryTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.name = _data["name"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            this.completionRate = _data["completionRate"];
        }
    }

    static fromJS(data: any): AgentTaskCompletionStatusSummaryTask {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskCompletionStatusSummaryTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["name"] = this.name;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        data["completionRate"] = this.completionRate;
        return data;
    }
}

export interface IAgentTaskCompletionStatusSummaryTask {
    taskId?: string;
    name?: string | undefined;
    completedOn?: Date | undefined;
    completionRate?: number;
}

export class PaginatedResponseOfReadModuleDto implements IPaginatedResponseOfReadModuleDto {
    results?: ReadModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfReadModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReadModuleDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfReadModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfReadModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfReadModuleDto {
    results?: ReadModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ReadModuleDto implements IReadModuleDto {
    moduleId?: string;
    role?: AgentRole | undefined;
    name?: string | undefined;
    description?: string | undefined;
    moduleType?: ModuleType;
    order?: number;
    deletedOn?: Date | undefined;

    constructor(data?: IReadModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.role = _data["role"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.moduleType = _data["moduleType"];
            this.order = _data["order"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ReadModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["role"] = this.role;
        data["name"] = this.name;
        data["description"] = this.description;
        data["moduleType"] = this.moduleType;
        data["order"] = this.order;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IReadModuleDto {
    moduleId?: string;
    role?: AgentRole | undefined;
    name?: string | undefined;
    description?: string | undefined;
    moduleType?: ModuleType;
    order?: number;
    deletedOn?: Date | undefined;
}

export class PaginatedResponseOfReadTopicDto implements IPaginatedResponseOfReadTopicDto {
    results?: ReadTopicDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfReadTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReadTopicDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfReadTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfReadTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfReadTopicDto {
    results?: ReadTopicDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ReadTopicDto implements IReadTopicDto {
    topicId?: string;
    moduleId?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number;
    deletedOn?: Date | undefined;

    constructor(data?: IReadTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.moduleId = _data["moduleId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ReadTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["moduleId"] = this.moduleId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["order"] = this.order;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IReadTopicDto {
    topicId?: string;
    moduleId?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number;
    deletedOn?: Date | undefined;
}

export class PaginatedResponseOfReadTaskDto implements IPaginatedResponseOfReadTaskDto {
    results?: ReadTaskDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfReadTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ReadTaskDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfReadTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfReadTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfReadTaskDto {
    results?: ReadTaskDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class ReadTaskDto implements IReadTaskDto {
    topicId?: string;
    taskId?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number;
    taskType?: TaskType;
    blobId?: string | undefined;
    content?: string | undefined;
    externalUrl?: string | undefined;
    deletedOn?: Date | undefined;
    isEmbedded?: boolean;

    constructor(data?: IReadTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.taskId = _data["taskId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.taskType = _data["taskType"];
            this.blobId = _data["blobId"];
            this.content = _data["content"];
            this.externalUrl = _data["externalUrl"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : undefined as any;
            this.isEmbedded = _data["isEmbedded"];
        }
    }

    static fromJS(data: any): ReadTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReadTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["taskId"] = this.taskId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["order"] = this.order;
        data["taskType"] = this.taskType;
        data["blobId"] = this.blobId;
        data["content"] = this.content;
        data["externalUrl"] = this.externalUrl;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : undefined as any;
        data["isEmbedded"] = this.isEmbedded;
        return data;
    }
}

export interface IReadTaskDto {
    topicId?: string;
    taskId?: string;
    name?: string | undefined;
    description?: string | undefined;
    order?: number;
    taskType?: TaskType;
    blobId?: string | undefined;
    content?: string | undefined;
    externalUrl?: string | undefined;
    deletedOn?: Date | undefined;
    isEmbedded?: boolean;
}

export class AgentTaskViewCompleteDto implements IAgentTaskViewCompleteDto {
    tasksStatus?: TasksStatusDto | undefined;
    taskBasic?: AgentTaskViewDto | undefined;
    taskExtra?: AgentTaskViewExtraDto | undefined;

    constructor(data?: IAgentTaskViewCompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tasksStatus = _data["tasksStatus"] ? TasksStatusDto.fromJS(_data["tasksStatus"]) : undefined as any;
            this.taskBasic = _data["taskBasic"] ? AgentTaskViewDto.fromJS(_data["taskBasic"]) : undefined as any;
            this.taskExtra = _data["taskExtra"] ? AgentTaskViewExtraDto.fromJS(_data["taskExtra"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgentTaskViewCompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskViewCompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tasksStatus"] = this.tasksStatus ? this.tasksStatus.toJSON() : undefined as any;
        data["taskBasic"] = this.taskBasic ? this.taskBasic.toJSON() : undefined as any;
        data["taskExtra"] = this.taskExtra ? this.taskExtra.toJSON() : undefined as any;
        return data;
    }
}

export interface IAgentTaskViewCompleteDto {
    tasksStatus?: TasksStatusDto | undefined;
    taskBasic?: AgentTaskViewDto | undefined;
    taskExtra?: AgentTaskViewExtraDto | undefined;
}

export class TasksStatusDto implements ITasksStatusDto {
    totalTasks?: number;
    completedTasks?: number;

    constructor(data?: ITasksStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
        }
    }

    static fromJS(data: any): TasksStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TasksStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        return data;
    }
}

export interface ITasksStatusDto {
    totalTasks?: number;
    completedTasks?: number;
}

export class AgentTaskViewDto implements IAgentTaskViewDto {
    taskId?: string;
    name?: string | undefined;
    description?: string | undefined;
    taskType?: TaskType;
    order?: number;
    completed?: boolean;

    constructor(data?: IAgentTaskViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.taskType = _data["taskType"];
            this.order = _data["order"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): AgentTaskViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["taskType"] = this.taskType;
        data["order"] = this.order;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IAgentTaskViewDto {
    taskId?: string;
    name?: string | undefined;
    description?: string | undefined;
    taskType?: TaskType;
    order?: number;
    completed?: boolean;
}

export class AgentTaskViewExtraDto implements IAgentTaskViewExtraDto {
    blobId?: string | undefined;
    externalUrl?: string | undefined;
    moduleName?: string | undefined;
    topicName?: string | undefined;
    isEmbedded?: boolean;

    constructor(data?: IAgentTaskViewExtraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobId = _data["blobId"];
            this.externalUrl = _data["externalUrl"];
            this.moduleName = _data["moduleName"];
            this.topicName = _data["topicName"];
            this.isEmbedded = _data["isEmbedded"];
        }
    }

    static fromJS(data: any): AgentTaskViewExtraDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTaskViewExtraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobId"] = this.blobId;
        data["externalUrl"] = this.externalUrl;
        data["moduleName"] = this.moduleName;
        data["topicName"] = this.topicName;
        data["isEmbedded"] = this.isEmbedded;
        return data;
    }
}

export interface IAgentTaskViewExtraDto {
    blobId?: string | undefined;
    externalUrl?: string | undefined;
    moduleName?: string | undefined;
    topicName?: string | undefined;
    isEmbedded?: boolean;
}

export class PaginatedResponseOfAgentModuleDto implements IPaginatedResponseOfAgentModuleDto {
    results?: AgentModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;

    constructor(data?: IPaginatedResponseOfAgentModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(AgentModuleDto.fromJS(item));
            }
            this.total = _data["total"];
            this.taken = _data["taken"];
            this.skipped = _data["skipped"];
        }
    }

    static fromJS(data: any): PaginatedResponseOfAgentModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResponseOfAgentModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["taken"] = this.taken;
        data["skipped"] = this.skipped;
        return data;
    }
}

export interface IPaginatedResponseOfAgentModuleDto {
    results?: AgentModuleDto[] | undefined;
    total?: number | undefined;
    taken?: number | undefined;
    skipped?: number | undefined;
}

export class AgentModuleDto implements IAgentModuleDto {
    module?: AgentModuleViewDto | undefined;
    tasksStatus?: TasksStatusDto | undefined;
    moduleStatus?: AgentModuleCompletionStatusDto | undefined;

    constructor(data?: IAgentModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] ? AgentModuleViewDto.fromJS(_data["module"]) : undefined as any;
            this.tasksStatus = _data["tasksStatus"] ? TasksStatusDto.fromJS(_data["tasksStatus"]) : undefined as any;
            this.moduleStatus = _data["moduleStatus"] ? AgentModuleCompletionStatusDto.fromJS(_data["moduleStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): AgentModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        data["tasksStatus"] = this.tasksStatus ? this.tasksStatus.toJSON() : undefined as any;
        data["moduleStatus"] = this.moduleStatus ? this.moduleStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IAgentModuleDto {
    module?: AgentModuleViewDto | undefined;
    tasksStatus?: TasksStatusDto | undefined;
    moduleStatus?: AgentModuleCompletionStatusDto | undefined;
}

export class AgentModuleViewDto implements IAgentModuleViewDto {
    moduleId?: string;
    moduleName?: string | undefined;
    moduleDescription?: string | undefined;
    moduleType?: ModuleType | undefined;
    agentModuleTopics?: AgentTopicViewDto[] | undefined;

    constructor(data?: IAgentModuleViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.moduleDescription = _data["moduleDescription"];
            this.moduleType = _data["moduleType"];
            if (Array.isArray(_data["agentModuleTopics"])) {
                this.agentModuleTopics = [] as any;
                for (let item of _data["agentModuleTopics"])
                    this.agentModuleTopics!.push(AgentTopicViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentModuleViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModuleViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["moduleDescription"] = this.moduleDescription;
        data["moduleType"] = this.moduleType;
        if (Array.isArray(this.agentModuleTopics)) {
            data["agentModuleTopics"] = [];
            for (let item of this.agentModuleTopics)
                data["agentModuleTopics"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAgentModuleViewDto {
    moduleId?: string;
    moduleName?: string | undefined;
    moduleDescription?: string | undefined;
    moduleType?: ModuleType | undefined;
    agentModuleTopics?: AgentTopicViewDto[] | undefined;
}

export class AgentTopicViewDto implements IAgentTopicViewDto {
    topicId?: string;
    topicName?: string | undefined;
    topicDescription?: string | undefined;
    tasks?: AgentTaskViewDto[] | undefined;
    completed?: boolean;

    constructor(data?: IAgentTopicViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"];
            this.topicName = _data["topicName"];
            this.topicDescription = _data["topicDescription"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(AgentTaskViewDto.fromJS(item));
            }
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): AgentTopicViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentTopicViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["topicName"] = this.topicName;
        data["topicDescription"] = this.topicDescription;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["completed"] = this.completed;
        return data;
    }
}

export interface IAgentTopicViewDto {
    topicId?: string;
    topicName?: string | undefined;
    topicDescription?: string | undefined;
    tasks?: AgentTaskViewDto[] | undefined;
    completed?: boolean;
}

export class AgentModuleCompletionStatusDto implements IAgentModuleCompletionStatusDto {
    completed?: boolean;
    completedOn?: Date | undefined;

    constructor(data?: IAgentModuleCompletionStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completed = _data["completed"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AgentModuleCompletionStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModuleCompletionStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IAgentModuleCompletionStatusDto {
    completed?: boolean;
    completedOn?: Date | undefined;
}

export class CompletePhoneWrapUpModel implements ICompletePhoneWrapUpModel {
    patientId?: string | undefined;
    studyId?: string;

    constructor(data?: ICompletePhoneWrapUpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.studyId = _data["studyId"];
        }
    }

    static fromJS(data: any): CompletePhoneWrapUpModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePhoneWrapUpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["studyId"] = this.studyId;
        return data;
    }
}

export interface ICompletePhoneWrapUpModel {
    patientId?: string | undefined;
    studyId?: string;
}

export class PhoneWrapUpPendingResult implements IPhoneWrapUpPendingResult {
    phoneCallRecordId?: string;
    createdOn?: Date;
    phoneStartedOn?: Date;
    phoneNumber?: string | undefined;

    constructor(data?: IPhoneWrapUpPendingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneCallRecordId = _data["phoneCallRecordId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.phoneStartedOn = _data["phoneStartedOn"] ? new Date(_data["phoneStartedOn"].toString()) : undefined as any;
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): PhoneWrapUpPendingResult {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneWrapUpPendingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneCallRecordId"] = this.phoneCallRecordId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["phoneStartedOn"] = this.phoneStartedOn ? this.phoneStartedOn.toISOString() : undefined as any;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IPhoneWrapUpPendingResult {
    phoneCallRecordId?: string;
    createdOn?: Date;
    phoneStartedOn?: Date;
    phoneNumber?: string | undefined;
}

export class UserContextResult implements IUserContextResult {
    id?: string;
    isAdmin?: boolean;
    isInternalAdmin?: boolean;
    status?: UserStatusResult | undefined;

    constructor(data?: IUserContextResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAdmin = _data["isAdmin"];
            this.isInternalAdmin = _data["isInternalAdmin"];
            this.status = _data["status"] ? UserStatusResult.fromJS(_data["status"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserContextResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserContextResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAdmin"] = this.isAdmin;
        data["isInternalAdmin"] = this.isInternalAdmin;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserContextResult {
    id?: string;
    isAdmin?: boolean;
    isInternalAdmin?: boolean;
    status?: UserStatusResult | undefined;
}

export class UserStatusResult implements IUserStatusResult {
    id?: string;
    statusId?: string;
    expiresOn?: Date | undefined;

    constructor(data?: IUserStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusId = _data["statusId"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserStatusResult {
    id?: string;
    statusId?: string;
    expiresOn?: Date | undefined;
}

export class SetUserIsEnabledModel implements ISetUserIsEnabledModel {
    isEnabled?: boolean;

    constructor(data?: ISetUserIsEnabledModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): SetUserIsEnabledModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserIsEnabledModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface ISetUserIsEnabledModel {
    isEnabled?: boolean;
}

export class SetUserStatusModel implements ISetUserStatusModel {
    statusId?: string;

    constructor(data?: ISetUserStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): SetUserStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ISetUserStatusModel {
    statusId?: string;
}

export class ExtendExpirationModel implements IExtendExpirationModel {
    minutes?: number;

    constructor(data?: IExtendExpirationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): ExtendExpirationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendExpirationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface IExtendExpirationModel {
    minutes?: number;
}

export class UserStatusHistoryResult extends UserStatusResult implements IUserStatusHistoryResult {
    createdOn?: Date;
    supersededByUserStatusId?: string | undefined;

    constructor(data?: IUserStatusHistoryResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.supersededByUserStatusId = _data["supersededByUserStatusId"];
        }
    }

    static override fromJS(data: any): UserStatusHistoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusHistoryResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["supersededByUserStatusId"] = this.supersededByUserStatusId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserStatusHistoryResult extends IUserStatusResult {
    createdOn?: Date;
    supersededByUserStatusId?: string | undefined;
}

export class SetUserRolesModel implements ISetUserRolesModel {
    userId?: string;
    roleIds?: string[] | undefined;

    constructor(data?: ISetUserRolesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetUserRolesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserRolesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface ISetUserRolesModel {
    userId?: string;
    roleIds?: string[] | undefined;
}

export class TaskItemResult implements ITaskItemResult {
    id?: string;
    studyId?: string;
    userId?: string | undefined;
    isArchived?: boolean;
    label?: string | undefined;
    source?: TaskSourceResult | undefined;

    constructor(data?: ITaskItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.userId = _data["userId"];
            this.isArchived = _data["isArchived"];
            this.label = _data["label"];
            this.source = _data["source"] ? TaskSourceResult.fromJS(_data["source"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaskItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["userId"] = this.userId;
        data["isArchived"] = this.isArchived;
        data["label"] = this.label;
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaskItemResult {
    id?: string;
    studyId?: string;
    userId?: string | undefined;
    isArchived?: boolean;
    label?: string | undefined;
    source?: TaskSourceResult | undefined;
}

export class CallbackTaskResult extends TaskItemResult implements ICallbackTaskResult {
    studyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    languageCode?: string | undefined;
    callAttemptCount?: number;
    startDate?: Date;
    endDate?: Date;
    callbackType?: CallType;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;
    handlingUserId?: string | undefined;
    completedUserId?: string | undefined;
    activeStateId?: string;
    patientID?: string;
    uniqueId?: string | undefined;
    isHcpCall?: boolean;
    isAsap?: boolean;
    serviceRating?: number | undefined;
    confidenceRating?: number | undefined;
    recommendationRating?: number | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented?: boolean;
    isComplete?: boolean;
    patientJoinedVideoCallOn?: Date | undefined;
    stateLastUpdateOn?: Date;
    durationOptionLabel?: string | undefined;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;

    constructor(data?: ICallbackTaskResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyName = _data["studyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.languageCode = _data["languageCode"];
            this.callAttemptCount = _data["callAttemptCount"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.callbackType = _data["callbackType"];
            this.onlineMeetingId = _data["onlineMeetingId"];
            this.onlineMeetingJoinWebUrl = _data["onlineMeetingJoinWebUrl"];
            this.handlingUserId = _data["handlingUserId"];
            this.completedUserId = _data["completedUserId"];
            this.activeStateId = _data["activeStateId"];
            this.patientID = _data["patientID"];
            this.uniqueId = _data["uniqueId"];
            this.isHcpCall = _data["isHcpCall"];
            this.isAsap = _data["isAsap"];
            this.serviceRating = _data["serviceRating"];
            this.confidenceRating = _data["confidenceRating"];
            this.recommendationRating = _data["recommendationRating"];
            this.timeZone = _data["timeZone"];
            this.isVoicemailConsented = _data["isVoicemailConsented"];
            this.isComplete = _data["isComplete"];
            this.patientJoinedVideoCallOn = _data["patientJoinedVideoCallOn"] ? new Date(_data["patientJoinedVideoCallOn"].toString()) : undefined as any;
            this.stateLastUpdateOn = _data["stateLastUpdateOn"] ? new Date(_data["stateLastUpdateOn"].toString()) : undefined as any;
            this.durationOptionLabel = _data["durationOptionLabel"];
            this.interactionTypeOption = _data["interactionTypeOption"] ? StudyCallDurationOptionResult.fromJS(_data["interactionTypeOption"]) : undefined as any;
        }
    }

    static override fromJS(data: any): CallbackTaskResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackTaskResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyName"] = this.studyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["language"] = this.language;
        data["languageCode"] = this.languageCode;
        data["callAttemptCount"] = this.callAttemptCount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["callbackType"] = this.callbackType;
        data["onlineMeetingId"] = this.onlineMeetingId;
        data["onlineMeetingJoinWebUrl"] = this.onlineMeetingJoinWebUrl;
        data["handlingUserId"] = this.handlingUserId;
        data["completedUserId"] = this.completedUserId;
        data["activeStateId"] = this.activeStateId;
        data["patientID"] = this.patientID;
        data["uniqueId"] = this.uniqueId;
        data["isHcpCall"] = this.isHcpCall;
        data["isAsap"] = this.isAsap;
        data["serviceRating"] = this.serviceRating;
        data["confidenceRating"] = this.confidenceRating;
        data["recommendationRating"] = this.recommendationRating;
        data["timeZone"] = this.timeZone;
        data["isVoicemailConsented"] = this.isVoicemailConsented;
        data["isComplete"] = this.isComplete;
        data["patientJoinedVideoCallOn"] = this.patientJoinedVideoCallOn ? this.patientJoinedVideoCallOn.toISOString() : undefined as any;
        data["stateLastUpdateOn"] = this.stateLastUpdateOn ? this.stateLastUpdateOn.toISOString() : undefined as any;
        data["durationOptionLabel"] = this.durationOptionLabel;
        data["interactionTypeOption"] = this.interactionTypeOption ? this.interactionTypeOption.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface ICallbackTaskResult extends ITaskItemResult {
    studyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    languageCode?: string | undefined;
    callAttemptCount?: number;
    startDate?: Date;
    endDate?: Date;
    callbackType?: CallType;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;
    handlingUserId?: string | undefined;
    completedUserId?: string | undefined;
    activeStateId?: string;
    patientID?: string;
    uniqueId?: string | undefined;
    isHcpCall?: boolean;
    isAsap?: boolean;
    serviceRating?: number | undefined;
    confidenceRating?: number | undefined;
    recommendationRating?: number | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented?: boolean;
    isComplete?: boolean;
    patientJoinedVideoCallOn?: Date | undefined;
    stateLastUpdateOn?: Date;
    durationOptionLabel?: string | undefined;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;
}

export class StudyCallDurationOptionResult implements IStudyCallDurationOptionResult {
    id?: string;
    studyId?: string;
    callType?: CallType | undefined;
    name?: string | undefined;
    displayOrder?: number;
    durationMinutes?: number;
    schedulesPatientCallTask?: boolean;
    identifier?: string | undefined;

    constructor(data?: IStudyCallDurationOptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.callType = _data["callType"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
            this.durationMinutes = _data["durationMinutes"];
            this.schedulesPatientCallTask = _data["schedulesPatientCallTask"];
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): StudyCallDurationOptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyCallDurationOptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["callType"] = this.callType;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        data["durationMinutes"] = this.durationMinutes;
        data["schedulesPatientCallTask"] = this.schedulesPatientCallTask;
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IStudyCallDurationOptionResult {
    id?: string;
    studyId?: string;
    callType?: CallType | undefined;
    name?: string | undefined;
    displayOrder?: number;
    durationMinutes?: number;
    schedulesPatientCallTask?: boolean;
    identifier?: string | undefined;
}

export class TaskSourceResult implements ITaskSourceResult {
    sourceType?: SourceType;

    constructor(data?: ITaskSourceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): TaskSourceResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSourceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface ITaskSourceResult {
    sourceType?: SourceType;
}

export enum SourceType {
    Other = 0,
    Microsite = 1,
}

export class UpdateTaskStateModel implements IUpdateTaskStateModel {
    note?: string | undefined;
    sendSatisfactionSurvey?: boolean;

    constructor(data?: IUpdateTaskStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.sendSatisfactionSurvey = _data["sendSatisfactionSurvey"];
        }
    }

    static fromJS(data: any): UpdateTaskStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["sendSatisfactionSurvey"] = this.sendSatisfactionSurvey;
        return data;
    }
}

export interface IUpdateTaskStateModel {
    note?: string | undefined;
    sendSatisfactionSurvey?: boolean;
}

export class CreateCallbackAttemptModel extends UpdateTaskStateModel implements ICreateCallbackAttemptModel {

    constructor(data?: ICreateCallbackAttemptModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateCallbackAttemptModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallbackAttemptModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCallbackAttemptModel extends IUpdateTaskStateModel {
}

export class TaskStateResult implements ITaskStateResult {
    id?: string;
    username?: string | undefined;
    createdOn?: Date;
    note?: string | undefined;
    isArchived?: boolean;
    isCallAttempt?: boolean;
    isUserHandle?: boolean;
    isComplete?: boolean;

    constructor(data?: ITaskStateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.note = _data["note"];
            this.isArchived = _data["isArchived"];
            this.isCallAttempt = _data["isCallAttempt"];
            this.isUserHandle = _data["isUserHandle"];
            this.isComplete = _data["isComplete"];
        }
    }

    static fromJS(data: any): TaskStateResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["note"] = this.note;
        data["isArchived"] = this.isArchived;
        data["isCallAttempt"] = this.isCallAttempt;
        data["isUserHandle"] = this.isUserHandle;
        data["isComplete"] = this.isComplete;
        return data;
    }
}

export interface ITaskStateResult {
    id?: string;
    username?: string | undefined;
    createdOn?: Date;
    note?: string | undefined;
    isArchived?: boolean;
    isCallAttempt?: boolean;
    isUserHandle?: boolean;
    isComplete?: boolean;
}

export class ValueTupleOfStringAndBoolean implements IValueTupleOfStringAndBoolean {

    constructor(data?: IValueTupleOfStringAndBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueTupleOfStringAndBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfStringAndBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IValueTupleOfStringAndBoolean {
}

export class CallRatingModel implements ICallRatingModel {
    serviceRating?: number;
    confidenceRating?: number;
    recommendationRating?: number;

    constructor(data?: ICallRatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceRating = _data["serviceRating"];
            this.confidenceRating = _data["confidenceRating"];
            this.recommendationRating = _data["recommendationRating"];
        }
    }

    static fromJS(data: any): CallRatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallRatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceRating"] = this.serviceRating;
        data["confidenceRating"] = this.confidenceRating;
        data["recommendationRating"] = this.recommendationRating;
        return data;
    }
}

export interface ICallRatingModel {
    serviceRating?: number;
    confidenceRating?: number;
    recommendationRating?: number;
}

export class HandleTaskModel implements IHandleTaskModel {
    originalTaskItemId?: string;

    constructor(data?: IHandleTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalTaskItemId = _data["originalTaskItemId"];
        }
    }

    static fromJS(data: any): HandleTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new HandleTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalTaskItemId"] = this.originalTaskItemId;
        return data;
    }
}

export interface IHandleTaskModel {
    originalTaskItemId?: string;
}

export class CreateCallbackTaskModel implements ICreateCallbackTaskModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    timeZone?: string | undefined;
    isVoicemailConsented?: boolean;
    callbackType?: CallType;
    studyId?: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;
    isAsap?: boolean;

    constructor(data?: ICreateCallbackTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.language = _data["language"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
            this.isVoicemailConsented = _data["isVoicemailConsented"];
            this.callbackType = _data["callbackType"];
            this.studyId = _data["studyId"];
            this.label = _data["label"];
            if (Array.isArray(_data["reminderIntervalsInMinutes"])) {
                this.reminderIntervalsInMinutes = [] as any;
                for (let item of _data["reminderIntervalsInMinutes"])
                    this.reminderIntervalsInMinutes!.push(item);
            }
            this.isAsap = _data["isAsap"];
        }
    }

    static fromJS(data: any): CreateCallbackTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallbackTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["language"] = this.language;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["timeZone"] = this.timeZone;
        data["isVoicemailConsented"] = this.isVoicemailConsented;
        data["callbackType"] = this.callbackType;
        data["studyId"] = this.studyId;
        data["label"] = this.label;
        if (Array.isArray(this.reminderIntervalsInMinutes)) {
            data["reminderIntervalsInMinutes"] = [];
            for (let item of this.reminderIntervalsInMinutes)
                data["reminderIntervalsInMinutes"].push(item);
        }
        data["isAsap"] = this.isAsap;
        return data;
    }
}

export interface ICreateCallbackTaskModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    timeZone?: string | undefined;
    isVoicemailConsented?: boolean;
    callbackType?: CallType;
    studyId?: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;
    isAsap?: boolean;
}

export class AgentCreateCallbackTaskModel extends CreateCallbackTaskModel implements IAgentCreateCallbackTaskModel {
    agentId?: string | undefined;
    patientId?: string | undefined;
    uniqueId?: string | undefined;

    constructor(data?: IAgentCreateCallbackTaskModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentId = _data["agentId"];
            this.patientId = _data["patientId"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static override fromJS(data: any): AgentCreateCallbackTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCreateCallbackTaskModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["patientId"] = this.patientId;
        data["uniqueId"] = this.uniqueId;
        super.toJSON(data);
        return data;
    }
}

export interface IAgentCreateCallbackTaskModel extends ICreateCallbackTaskModel {
    agentId?: string | undefined;
    patientId?: string | undefined;
    uniqueId?: string | undefined;
}

export class CreateHcpCallResponse implements ICreateHcpCallResponse {
    outcome?: AppointmentOutcome;
    call?: CallbackTaskResult | undefined;

    constructor(data?: ICreateHcpCallResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outcome = _data["outcome"];
            this.call = _data["call"] ? CallbackTaskResult.fromJS(_data["call"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateHcpCallResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHcpCallResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outcome"] = this.outcome;
        data["call"] = this.call ? this.call.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateHcpCallResponse {
    outcome?: AppointmentOutcome;
    call?: CallbackTaskResult | undefined;
}

export enum AppointmentOutcome {
    Success = 1,
    TimeNoLongerAvailable = 2,
    Error = 3,
}

export class AgentCreateHcpCallbackTaskModel implements IAgentCreateHcpCallbackTaskModel {
    appointmentid?: string;
    agentId?: string;
    patientId?: string | undefined;
    uniqueId?: string | undefined;
    callDurationOptionId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented?: boolean;
    callbackType?: CallType;
    studyId?: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;

    constructor(data?: IAgentCreateHcpCallbackTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentid = _data["appointmentid"];
            this.agentId = _data["agentId"];
            this.patientId = _data["patientId"];
            this.uniqueId = _data["uniqueId"];
            this.callDurationOptionId = _data["callDurationOptionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.language = _data["language"];
            this.timeZone = _data["timeZone"];
            this.isVoicemailConsented = _data["isVoicemailConsented"];
            this.callbackType = _data["callbackType"];
            this.studyId = _data["studyId"];
            this.label = _data["label"];
            if (Array.isArray(_data["reminderIntervalsInMinutes"])) {
                this.reminderIntervalsInMinutes = [] as any;
                for (let item of _data["reminderIntervalsInMinutes"])
                    this.reminderIntervalsInMinutes!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentCreateHcpCallbackTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCreateHcpCallbackTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentid"] = this.appointmentid;
        data["agentId"] = this.agentId;
        data["patientId"] = this.patientId;
        data["uniqueId"] = this.uniqueId;
        data["callDurationOptionId"] = this.callDurationOptionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["language"] = this.language;
        data["timeZone"] = this.timeZone;
        data["isVoicemailConsented"] = this.isVoicemailConsented;
        data["callbackType"] = this.callbackType;
        data["studyId"] = this.studyId;
        data["label"] = this.label;
        if (Array.isArray(this.reminderIntervalsInMinutes)) {
            data["reminderIntervalsInMinutes"] = [];
            for (let item of this.reminderIntervalsInMinutes)
                data["reminderIntervalsInMinutes"].push(item);
        }
        return data;
    }
}

export interface IAgentCreateHcpCallbackTaskModel {
    appointmentid?: string;
    agentId?: string;
    patientId?: string | undefined;
    uniqueId?: string | undefined;
    callDurationOptionId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    language?: string | undefined;
    timeZone?: string | undefined;
    isVoicemailConsented?: boolean;
    callbackType?: CallType;
    studyId?: string;
    label?: string | undefined;
    reminderIntervalsInMinutes?: number[] | undefined;
}

export class CallAttemptConfigurationResult implements ICallAttemptConfigurationResult {
    callAttemptsBeforeArchive?: number;
    id?: string;
    name?: string | undefined;
    studyId?: string;
    callType?: CallType;
    agentType?: AgentType;
    rescheduleCallIntervalMinutes?: number;

    constructor(data?: ICallAttemptConfigurationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callAttemptsBeforeArchive = _data["callAttemptsBeforeArchive"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.studyId = _data["studyId"];
            this.callType = _data["callType"];
            this.agentType = _data["agentType"];
            this.rescheduleCallIntervalMinutes = _data["rescheduleCallIntervalMinutes"];
        }
    }

    static fromJS(data: any): CallAttemptConfigurationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallAttemptConfigurationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callAttemptsBeforeArchive"] = this.callAttemptsBeforeArchive;
        data["id"] = this.id;
        data["name"] = this.name;
        data["studyId"] = this.studyId;
        data["callType"] = this.callType;
        data["agentType"] = this.agentType;
        data["rescheduleCallIntervalMinutes"] = this.rescheduleCallIntervalMinutes;
        return data;
    }
}

export interface ICallAttemptConfigurationResult {
    callAttemptsBeforeArchive?: number;
    id?: string;
    name?: string | undefined;
    studyId?: string;
    callType?: CallType;
    agentType?: AgentType;
    rescheduleCallIntervalMinutes?: number;
}

export enum AgentType {
    HCP = 0,
    General = 1,
}

export class StudyResult implements IStudyResult {
    id?: string;
    lumediStudyId?: string | undefined;
    name?: string;
    primaryColor?: string;

    constructor(data?: IStudyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lumediStudyId = _data["lumediStudyId"];
            this.name = _data["name"];
            this.primaryColor = _data["primaryColor"];
        }
    }

    static fromJS(data: any): StudyResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lumediStudyId"] = this.lumediStudyId;
        data["name"] = this.name;
        data["primaryColor"] = this.primaryColor;
        return data;
    }
}

export interface IStudyResult {
    id?: string;
    lumediStudyId?: string | undefined;
    name?: string;
    primaryColor?: string;
}

export class UpdateStudyUserModel implements IUpdateStudyUserModel {
    isEnabled?: boolean;
    cultures?: string[] | undefined;
    mappings?: StudyUserMappingsModel[] | undefined;
    designations?: UpdateDesignationModel[] | undefined;

    constructor(data?: IUpdateStudyUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(item);
            }
            if (Array.isArray(_data["mappings"])) {
                this.mappings = [] as any;
                for (let item of _data["mappings"])
                    this.mappings!.push(StudyUserMappingsModel.fromJS(item));
            }
            if (Array.isArray(_data["designations"])) {
                this.designations = [] as any;
                for (let item of _data["designations"])
                    this.designations!.push(UpdateDesignationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateStudyUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item);
        }
        if (Array.isArray(this.mappings)) {
            data["mappings"] = [];
            for (let item of this.mappings)
                data["mappings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.designations)) {
            data["designations"] = [];
            for (let item of this.designations)
                data["designations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateStudyUserModel {
    isEnabled?: boolean;
    cultures?: string[] | undefined;
    mappings?: StudyUserMappingsModel[] | undefined;
    designations?: UpdateDesignationModel[] | undefined;
}

export class StudyUserMappingsModel implements IStudyUserMappingsModel {
    studyId?: string;
    isHcp?: boolean;
    isActive?: boolean;

    constructor(data?: IStudyUserMappingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.isHcp = _data["isHcp"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): StudyUserMappingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserMappingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["isHcp"] = this.isHcp;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IStudyUserMappingsModel {
    studyId?: string;
    isHcp?: boolean;
    isActive?: boolean;
}

export class UpdateDesignationModel implements IUpdateDesignationModel {
    cultureCode?: string | undefined;
    value?: string | undefined;

    constructor(data?: IUpdateDesignationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateDesignationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDesignationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateDesignationModel {
    cultureCode?: string | undefined;
    value?: string | undefined;
}

export class StudyEmailConfigurationResult implements IStudyEmailConfigurationResult {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;

    constructor(data?: IStudyEmailConfigurationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callRatingEmailTemplateId = _data["callRatingEmailTemplateId"];
            this.callRatingEmailSenderId = _data["callRatingEmailSenderId"];
            this.videoAppointmentConfirmationEmailTemplateId = _data["videoAppointmentConfirmationEmailTemplateId"];
            this.phoneAppointmentConfirmationEmailTemplateId = _data["phoneAppointmentConfirmationEmailTemplateId"];
            this.videoAppointmentReminderEmailTemplateId = _data["videoAppointmentReminderEmailTemplateId"];
            this.phoneAppointmentReminderEmailTemplateId = _data["phoneAppointmentReminderEmailTemplateId"];
            this.appointmentConfirmationEmailSenderId = _data["appointmentConfirmationEmailSenderId"];
            this.appointmentReminderEmailSenderId = _data["appointmentReminderEmailSenderId"];
        }
    }

    static fromJS(data: any): StudyEmailConfigurationResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyEmailConfigurationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callRatingEmailTemplateId"] = this.callRatingEmailTemplateId;
        data["callRatingEmailSenderId"] = this.callRatingEmailSenderId;
        data["videoAppointmentConfirmationEmailTemplateId"] = this.videoAppointmentConfirmationEmailTemplateId;
        data["phoneAppointmentConfirmationEmailTemplateId"] = this.phoneAppointmentConfirmationEmailTemplateId;
        data["videoAppointmentReminderEmailTemplateId"] = this.videoAppointmentReminderEmailTemplateId;
        data["phoneAppointmentReminderEmailTemplateId"] = this.phoneAppointmentReminderEmailTemplateId;
        data["appointmentConfirmationEmailSenderId"] = this.appointmentConfirmationEmailSenderId;
        data["appointmentReminderEmailSenderId"] = this.appointmentReminderEmailSenderId;
        return data;
    }
}

export interface IStudyEmailConfigurationResult {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;
}

export class UpdateStudyEmailConfigurationModel implements IUpdateStudyEmailConfigurationModel {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;

    constructor(data?: IUpdateStudyEmailConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callRatingEmailTemplateId = _data["callRatingEmailTemplateId"];
            this.callRatingEmailSenderId = _data["callRatingEmailSenderId"];
            this.videoAppointmentConfirmationEmailTemplateId = _data["videoAppointmentConfirmationEmailTemplateId"];
            this.phoneAppointmentConfirmationEmailTemplateId = _data["phoneAppointmentConfirmationEmailTemplateId"];
            this.videoAppointmentReminderEmailTemplateId = _data["videoAppointmentReminderEmailTemplateId"];
            this.phoneAppointmentReminderEmailTemplateId = _data["phoneAppointmentReminderEmailTemplateId"];
            this.appointmentConfirmationEmailSenderId = _data["appointmentConfirmationEmailSenderId"];
            this.appointmentReminderEmailSenderId = _data["appointmentReminderEmailSenderId"];
        }
    }

    static fromJS(data: any): UpdateStudyEmailConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyEmailConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callRatingEmailTemplateId"] = this.callRatingEmailTemplateId;
        data["callRatingEmailSenderId"] = this.callRatingEmailSenderId;
        data["videoAppointmentConfirmationEmailTemplateId"] = this.videoAppointmentConfirmationEmailTemplateId;
        data["phoneAppointmentConfirmationEmailTemplateId"] = this.phoneAppointmentConfirmationEmailTemplateId;
        data["videoAppointmentReminderEmailTemplateId"] = this.videoAppointmentReminderEmailTemplateId;
        data["phoneAppointmentReminderEmailTemplateId"] = this.phoneAppointmentReminderEmailTemplateId;
        data["appointmentConfirmationEmailSenderId"] = this.appointmentConfirmationEmailSenderId;
        data["appointmentReminderEmailSenderId"] = this.appointmentReminderEmailSenderId;
        return data;
    }
}

export interface IUpdateStudyEmailConfigurationModel {
    callRatingEmailTemplateId?: string | undefined;
    callRatingEmailSenderId?: string | undefined;
    videoAppointmentConfirmationEmailTemplateId?: string | undefined;
    phoneAppointmentConfirmationEmailTemplateId?: string | undefined;
    videoAppointmentReminderEmailTemplateId?: string | undefined;
    phoneAppointmentReminderEmailTemplateId?: string | undefined;
    appointmentConfirmationEmailSenderId?: string | undefined;
    appointmentReminderEmailSenderId?: string | undefined;
}

export class RootStatusResult implements IRootStatusResult {
    id?: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order?: number;
    subStatuses?: StatusResult[] | undefined;
    duration?: string | undefined;

    constructor(data?: IRootStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.culture = _data["culture"] ? StatusCultureResult.fromJS(_data["culture"]) : undefined as any;
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
            this.order = _data["order"];
            if (Array.isArray(_data["subStatuses"])) {
                this.subStatuses = [] as any;
                for (let item of _data["subStatuses"])
                    this.subStatuses!.push(StatusResult.fromJS(item));
            }
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): RootStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new RootStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["culture"] = this.culture ? this.culture.toJSON() : undefined as any;
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        data["order"] = this.order;
        if (Array.isArray(this.subStatuses)) {
            data["subStatuses"] = [];
            for (let item of this.subStatuses)
                data["subStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        data["duration"] = this.duration;
        return data;
    }
}

export interface IRootStatusResult {
    id?: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order?: number;
    subStatuses?: StatusResult[] | undefined;
    duration?: string | undefined;
}

export class StatusCultureResult implements IStatusCultureResult {
    name?: string | undefined;
    isDefault?: boolean;
    cultureCode?: string | undefined;

    constructor(data?: IStatusCultureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): StatusCultureResult {
        data = typeof data === 'object' ? data : {};
        let result = new StatusCultureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IStatusCultureResult {
    name?: string | undefined;
    isDefault?: boolean;
    cultureCode?: string | undefined;
}

export class StatusResult implements IStatusResult {
    id?: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order?: number;
    duration?: string | undefined;

    constructor(data?: IStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.culture = _data["culture"] ? StatusCultureResult.fromJS(_data["culture"]) : undefined as any;
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
            this.order = _data["order"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): StatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new StatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["culture"] = this.culture ? this.culture.toJSON() : undefined as any;
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        data["order"] = this.order;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IStatusResult {
    id?: string;
    culture?: StatusCultureResult | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    order?: number;
    duration?: string | undefined;
}

export class NewStatusViewModel implements INewStatusViewModel {
    name?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;

    constructor(data?: INewStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
        }
    }

    static fromJS(data: any): NewStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        return data;
    }
}

export interface INewStatusViewModel {
    name?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
}

export class UpdateStatusViewModel implements IUpdateStatusViewModel {
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;

    constructor(data?: IUpdateStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
        }
    }

    static fromJS(data: any): UpdateStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        return data;
    }
}

export interface IUpdateStatusViewModel {
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
}

export class UpdateDurationStatusViewModel extends UpdateStatusViewModel implements IUpdateDurationStatusViewModel {
    duration?: string;

    constructor(data?: IUpdateDurationStatusViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duration = _data["duration"];
        }
    }

    static override fromJS(data: any): UpdateDurationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDurationStatusViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateDurationStatusViewModel extends IUpdateStatusViewModel {
    duration?: string;
}

export class NewDurationStatusViewModel extends NewStatusViewModel implements INewDurationStatusViewModel {
    duration?: string;

    constructor(data?: INewDurationStatusViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duration = _data["duration"];
        }
    }

    static override fromJS(data: any): NewDurationStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewDurationStatusViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        super.toJSON(data);
        return data;
    }
}

export interface INewDurationStatusViewModel extends INewStatusViewModel {
    duration?: string;
}

export class UpdateStatusCultureViewModel implements IUpdateStatusCultureViewModel {
    name?: string | undefined;

    constructor(data?: IUpdateStatusCultureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateStatusCultureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusCultureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateStatusCultureViewModel {
    name?: string | undefined;
}

export class RoleResult implements IRoleResult {
    id?: string;
    name?: string | undefined;

    constructor(data?: IRoleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleResult {
        data = typeof data === 'object' ? data : {};
        let result = new RoleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleResult {
    id?: string;
    name?: string | undefined;
}

export class CallbackRoleResult extends RoleResult implements ICallbackRoleResult {
    studyId?: string;
    permissions?: PermissionResult[];

    constructor(data?: ICallbackRoleResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.studyId = _data["studyId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CallbackRoleResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackRoleResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICallbackRoleResult extends IRoleResult {
    studyId?: string;
    permissions?: PermissionResult[];
}

export class PermissionResult implements IPermissionResult {
    name?: string | undefined;
    id?: string;
    permissionType?: PermissionType;

    constructor(data?: IPermissionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.permissionType = _data["permissionType"];
        }
    }

    static fromJS(data: any): PermissionResult {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["permissionType"] = this.permissionType;
        return data;
    }
}

export interface IPermissionResult {
    name?: string | undefined;
    id?: string;
    permissionType?: PermissionType;
}

export enum PermissionType {
    ScheduleCall = 0,
    ScheduleHCPCall = 1,
    TakeOutboundVideoCall = 2,
    TakeOutboundPhoneCall = 3,
    TakeIncomingVideoCall = 4,
    EditCall = 5,
    ManageEmail = 6,
    SubmitSupportRequest = 7,
    ManageUsers = 8,
    ManageProgramClosures = 9,
}

export class CreateRoleModel implements ICreateRoleModel {
    name?: string | undefined;
    studyId?: string;
    permissions?: PermissionResult[] | undefined;

    constructor(data?: ICreateRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.studyId = _data["studyId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["studyId"] = this.studyId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateRoleModel {
    name?: string | undefined;
    studyId?: string;
    permissions?: PermissionResult[] | undefined;
}

export class UpdateRoleModel implements IUpdateRoleModel {
    name?: string | undefined;
    permissions?: PermissionResult[] | undefined;

    constructor(data?: IUpdateRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateRoleModel {
    name?: string | undefined;
    permissions?: PermissionResult[] | undefined;
}

export class GetSoftphoneUserResponse implements IGetSoftphoneUserResponse {
    profileUserID?: string;
    profileName?: string | undefined;
    profilePicture?: string | undefined;
    wssServer?: string | undefined;
    webSocketPort?: string | undefined;
    serverPath?: string | undefined;
    sipDomain?: string | undefined;
    sipUsername?: string | undefined;
    sipPassword?: string | undefined;

    constructor(data?: IGetSoftphoneUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileUserID = _data["profileUserID"];
            this.profileName = _data["profileName"];
            this.profilePicture = _data["profilePicture"];
            this.wssServer = _data["wssServer"];
            this.webSocketPort = _data["webSocketPort"];
            this.serverPath = _data["serverPath"];
            this.sipDomain = _data["sipDomain"];
            this.sipUsername = _data["sipUsername"];
            this.sipPassword = _data["sipPassword"];
        }
    }

    static fromJS(data: any): GetSoftphoneUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSoftphoneUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileUserID"] = this.profileUserID;
        data["profileName"] = this.profileName;
        data["profilePicture"] = this.profilePicture;
        data["wssServer"] = this.wssServer;
        data["webSocketPort"] = this.webSocketPort;
        data["serverPath"] = this.serverPath;
        data["sipDomain"] = this.sipDomain;
        data["sipUsername"] = this.sipUsername;
        data["sipPassword"] = this.sipPassword;
        return data;
    }
}

export interface IGetSoftphoneUserResponse {
    profileUserID?: string;
    profileName?: string | undefined;
    profilePicture?: string | undefined;
    wssServer?: string | undefined;
    webSocketPort?: string | undefined;
    serverPath?: string | undefined;
    sipDomain?: string | undefined;
    sipUsername?: string | undefined;
    sipPassword?: string | undefined;
}

export class SearchedPatient implements ISearchedPatient {
    patientID?: string;
    status?: PatientStatus2;
    uniqueID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    preferredLanguage?: string | undefined;
    preferredLanguageCode?: string | undefined;
    isVoicemailConsented?: boolean;
    preferredTimeToCall?: string | undefined;

    constructor(data?: ISearchedPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.status = _data["status"];
            this.uniqueID = _data["uniqueID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.preferredLanguage = _data["preferredLanguage"];
            this.preferredLanguageCode = _data["preferredLanguageCode"];
            this.isVoicemailConsented = _data["isVoicemailConsented"];
            this.preferredTimeToCall = _data["preferredTimeToCall"];
        }
    }

    static fromJS(data: any): SearchedPatient {
        data = typeof data === 'object' ? data : {};
        let result = new SearchedPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["status"] = this.status;
        data["uniqueID"] = this.uniqueID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["preferredLanguage"] = this.preferredLanguage;
        data["preferredLanguageCode"] = this.preferredLanguageCode;
        data["isVoicemailConsented"] = this.isVoicemailConsented;
        data["preferredTimeToCall"] = this.preferredTimeToCall;
        return data;
    }
}

export interface ISearchedPatient {
    patientID?: string;
    status?: PatientStatus2;
    uniqueID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    preferredLanguage?: string | undefined;
    preferredLanguageCode?: string | undefined;
    isVoicemailConsented?: boolean;
    preferredTimeToCall?: string | undefined;
}

export class IsPatientUnsubscribedModel implements IIsPatientUnsubscribedModel {
    isUnsubscribed?: boolean;

    constructor(data?: IIsPatientUnsubscribedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUnsubscribed = _data["isUnsubscribed"];
        }
    }

    static fromJS(data: any): IsPatientUnsubscribedModel {
        data = typeof data === 'object' ? data : {};
        let result = new IsPatientUnsubscribedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUnsubscribed"] = this.isUnsubscribed;
        return data;
    }
}

export interface IIsPatientUnsubscribedModel {
    isUnsubscribed?: boolean;
}

export class ValidateFollowUpModel implements IValidateFollowUpModel {
    patientFollowUpId?: string;

    constructor(data?: IValidateFollowUpModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientFollowUpId = _data["patientFollowUpId"];
        }
    }

    static fromJS(data: any): ValidateFollowUpModel {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateFollowUpModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientFollowUpId"] = this.patientFollowUpId;
        return data;
    }
}

export interface IValidateFollowUpModel {
    patientFollowUpId?: string;
}

export class SaxendaAnswerModel implements ISaxendaAnswerModel {
    takingSaxenda?: string | undefined;
    saxendaDose?: string | undefined;

    constructor(data?: ISaxendaAnswerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.takingSaxenda = _data["takingSaxenda"];
            this.saxendaDose = _data["saxendaDose"];
        }
    }

    static fromJS(data: any): SaxendaAnswerModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaxendaAnswerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["takingSaxenda"] = this.takingSaxenda;
        data["saxendaDose"] = this.saxendaDose;
        return data;
    }
}

export interface ISaxendaAnswerModel {
    takingSaxenda?: string | undefined;
    saxendaDose?: string | undefined;
}

export class StudyFollowUpScheduleResult implements IStudyFollowUpScheduleResult {
    id?: string;
    studyId?: string;
    followUpType?: FollowUpType;
    name?: string | undefined;

    constructor(data?: IStudyFollowUpScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.followUpType = _data["followUpType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StudyFollowUpScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyFollowUpScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["followUpType"] = this.followUpType;
        data["name"] = this.name;
        return data;
    }
}

export interface IStudyFollowUpScheduleResult {
    id?: string;
    studyId?: string;
    followUpType?: FollowUpType;
    name?: string | undefined;
}

export enum FollowUpType {
    Email = 0,
    PhoneCall = 1,
    VideoCall = 2,
}

export class StudyFollowUpCallScheduleResult extends StudyFollowUpScheduleResult implements IStudyFollowUpCallScheduleResult {
    scheduleTicks?: number;
    callLengthTicks?: number;
    callScheduleDays?: number;
    callLengthMinutes?: number;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;

    constructor(data?: IStudyFollowUpCallScheduleResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.scheduleTicks = _data["scheduleTicks"];
            this.callLengthTicks = _data["callLengthTicks"];
            this.callScheduleDays = _data["callScheduleDays"];
            this.callLengthMinutes = _data["callLengthMinutes"];
            this.interactionTypeOption = _data["interactionTypeOption"] ? StudyCallDurationOptionResult.fromJS(_data["interactionTypeOption"]) : undefined as any;
        }
    }

    static override fromJS(data: any): StudyFollowUpCallScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyFollowUpCallScheduleResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleTicks"] = this.scheduleTicks;
        data["callLengthTicks"] = this.callLengthTicks;
        data["callScheduleDays"] = this.callScheduleDays;
        data["callLengthMinutes"] = this.callLengthMinutes;
        data["interactionTypeOption"] = this.interactionTypeOption ? this.interactionTypeOption.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IStudyFollowUpCallScheduleResult extends IStudyFollowUpScheduleResult {
    scheduleTicks?: number;
    callLengthTicks?: number;
    callScheduleDays?: number;
    callLengthMinutes?: number;
    interactionTypeOption?: StudyCallDurationOptionResult | undefined;
}

export class CallScheduleModel implements ICallScheduleModel {
    name?: string | undefined;
    callIntervalDays?: number;
    callDurationMinutes?: number;
    interactionTypeOptionId?: string;

    constructor(data?: ICallScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.callIntervalDays = _data["callIntervalDays"];
            this.callDurationMinutes = _data["callDurationMinutes"];
            this.interactionTypeOptionId = _data["interactionTypeOptionId"];
        }
    }

    static fromJS(data: any): CallScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["callIntervalDays"] = this.callIntervalDays;
        data["callDurationMinutes"] = this.callDurationMinutes;
        data["interactionTypeOptionId"] = this.interactionTypeOptionId;
        return data;
    }
}

export interface ICallScheduleModel {
    name?: string | undefined;
    callIntervalDays?: number;
    callDurationMinutes?: number;
    interactionTypeOptionId?: string;
}

export class StudyFollowUpEmailScheduleResult extends StudyFollowUpScheduleResult implements IStudyFollowUpEmailScheduleResult {
    surveyTitle?: string | undefined;
    sendTickInterval?: number;
    sendIntervalMinutes?: number;
    surveyUrl?: string | undefined;
    lumediInteractionId?: number;
    expiryTicks?: number | undefined;
    emailTemplateId?: string;
    emailTemplateName?: string | undefined;
    emailSenderId?: string;
    emailSenderName?: string | undefined;

    constructor(data?: IStudyFollowUpEmailScheduleResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyTitle = _data["surveyTitle"];
            this.sendTickInterval = _data["sendTickInterval"];
            this.sendIntervalMinutes = _data["sendIntervalMinutes"];
            this.surveyUrl = _data["surveyUrl"];
            this.lumediInteractionId = _data["lumediInteractionId"];
            this.expiryTicks = _data["expiryTicks"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.emailTemplateName = _data["emailTemplateName"];
            this.emailSenderId = _data["emailSenderId"];
            this.emailSenderName = _data["emailSenderName"];
        }
    }

    static override fromJS(data: any): StudyFollowUpEmailScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyFollowUpEmailScheduleResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTitle"] = this.surveyTitle;
        data["sendTickInterval"] = this.sendTickInterval;
        data["sendIntervalMinutes"] = this.sendIntervalMinutes;
        data["surveyUrl"] = this.surveyUrl;
        data["lumediInteractionId"] = this.lumediInteractionId;
        data["expiryTicks"] = this.expiryTicks;
        data["emailTemplateId"] = this.emailTemplateId;
        data["emailTemplateName"] = this.emailTemplateName;
        data["emailSenderId"] = this.emailSenderId;
        data["emailSenderName"] = this.emailSenderName;
        super.toJSON(data);
        return data;
    }
}

export interface IStudyFollowUpEmailScheduleResult extends IStudyFollowUpScheduleResult {
    surveyTitle?: string | undefined;
    sendTickInterval?: number;
    sendIntervalMinutes?: number;
    surveyUrl?: string | undefined;
    lumediInteractionId?: number;
    expiryTicks?: number | undefined;
    emailTemplateId?: string;
    emailTemplateName?: string | undefined;
    emailSenderId?: string;
    emailSenderName?: string | undefined;
}

export class EmailScheduleModel implements IEmailScheduleModel {
    title?: string | undefined;
    name?: string | undefined;
    sendIntervalMinutes?: number;
    surveyUrl?: string | undefined;
    lumediInteractionId?: number;
    emailTemplateId?: string;
    emailSenderId?: string;

    constructor(data?: IEmailScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.name = _data["name"];
            this.sendIntervalMinutes = _data["sendIntervalMinutes"];
            this.surveyUrl = _data["surveyUrl"];
            this.lumediInteractionId = _data["lumediInteractionId"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.emailSenderId = _data["emailSenderId"];
        }
    }

    static fromJS(data: any): EmailScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["name"] = this.name;
        data["sendIntervalMinutes"] = this.sendIntervalMinutes;
        data["surveyUrl"] = this.surveyUrl;
        data["lumediInteractionId"] = this.lumediInteractionId;
        data["emailTemplateId"] = this.emailTemplateId;
        data["emailSenderId"] = this.emailSenderId;
        return data;
    }
}

export interface IEmailScheduleModel {
    title?: string | undefined;
    name?: string | undefined;
    sendIntervalMinutes?: number;
    surveyUrl?: string | undefined;
    lumediInteractionId?: number;
    emailTemplateId?: string;
    emailSenderId?: string;
}

export class MissedAppointmentEmailFollowupModel implements IMissedAppointmentEmailFollowupModel {
    name?: string | undefined;
    studyId?: string;
    callType?: CallType;
    agentType?: AgentType;
    emailSenderId?: string;
    emailTemplateId?: string;
    sendInterval?: number;

    constructor(data?: IMissedAppointmentEmailFollowupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.studyId = _data["studyId"];
            this.callType = _data["callType"];
            this.agentType = _data["agentType"];
            this.emailSenderId = _data["emailSenderId"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.sendInterval = _data["sendInterval"];
        }
    }

    static fromJS(data: any): MissedAppointmentEmailFollowupModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissedAppointmentEmailFollowupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["studyId"] = this.studyId;
        data["callType"] = this.callType;
        data["agentType"] = this.agentType;
        data["emailSenderId"] = this.emailSenderId;
        data["emailTemplateId"] = this.emailTemplateId;
        data["sendInterval"] = this.sendInterval;
        return data;
    }
}

export interface IMissedAppointmentEmailFollowupModel {
    name?: string | undefined;
    studyId?: string;
    callType?: CallType;
    agentType?: AgentType;
    emailSenderId?: string;
    emailTemplateId?: string;
    sendInterval?: number;
}

export class MissedAppointmentEmailScheduleResult implements IMissedAppointmentEmailScheduleResult {
    id?: string;
    name?: string | undefined;
    studyId?: string;
    callType?: CallType;
    agentType?: AgentType;
    callAttemptsBeforeArchive?: number;
    emailTemplateId?: string;
    emailTemplateName?: string | undefined;
    emailSenderId?: string;
    emailSenderAddress?: string | undefined;
    emailFollowUpIntervalMinutes?: number;

    constructor(data?: IMissedAppointmentEmailScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.studyId = _data["studyId"];
            this.callType = _data["callType"];
            this.agentType = _data["agentType"];
            this.callAttemptsBeforeArchive = _data["callAttemptsBeforeArchive"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.emailTemplateName = _data["emailTemplateName"];
            this.emailSenderId = _data["emailSenderId"];
            this.emailSenderAddress = _data["emailSenderAddress"];
            this.emailFollowUpIntervalMinutes = _data["emailFollowUpIntervalMinutes"];
        }
    }

    static fromJS(data: any): MissedAppointmentEmailScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new MissedAppointmentEmailScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["studyId"] = this.studyId;
        data["callType"] = this.callType;
        data["agentType"] = this.agentType;
        data["callAttemptsBeforeArchive"] = this.callAttemptsBeforeArchive;
        data["emailTemplateId"] = this.emailTemplateId;
        data["emailTemplateName"] = this.emailTemplateName;
        data["emailSenderId"] = this.emailSenderId;
        data["emailSenderAddress"] = this.emailSenderAddress;
        data["emailFollowUpIntervalMinutes"] = this.emailFollowUpIntervalMinutes;
        return data;
    }
}

export interface IMissedAppointmentEmailScheduleResult {
    id?: string;
    name?: string | undefined;
    studyId?: string;
    callType?: CallType;
    agentType?: AgentType;
    callAttemptsBeforeArchive?: number;
    emailTemplateId?: string;
    emailTemplateName?: string | undefined;
    emailSenderId?: string;
    emailSenderAddress?: string | undefined;
    emailFollowUpIntervalMinutes?: number;
}

export class MissedAppointmentCallConfigurationModel implements IMissedAppointmentCallConfigurationModel {
    name?: string | undefined;
    callType?: CallType;
    agentType?: AgentType;
    callAttemptsBeforeArchive?: number;
    rescheduleIntervalMinutes?: number;

    constructor(data?: IMissedAppointmentCallConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.callType = _data["callType"];
            this.agentType = _data["agentType"];
            this.callAttemptsBeforeArchive = _data["callAttemptsBeforeArchive"];
            this.rescheduleIntervalMinutes = _data["rescheduleIntervalMinutes"];
        }
    }

    static fromJS(data: any): MissedAppointmentCallConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissedAppointmentCallConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["callType"] = this.callType;
        data["agentType"] = this.agentType;
        data["callAttemptsBeforeArchive"] = this.callAttemptsBeforeArchive;
        data["rescheduleIntervalMinutes"] = this.rescheduleIntervalMinutes;
        return data;
    }
}

export interface IMissedAppointmentCallConfigurationModel {
    name?: string | undefined;
    callType?: CallType;
    agentType?: AgentType;
    callAttemptsBeforeArchive?: number;
    rescheduleIntervalMinutes?: number;
}

export class QueueMetricsModel2 implements IQueueMetricsModel2 {
    averageWaitTime?: string | undefined;
    englishQueuedCallers?: number;
    englishAvailableAgents?: number;
    frenchQueuedCallers?: number;
    frenchAvailableAgents?: number;
    totalAvailableAgents?: number;

    constructor(data?: IQueueMetricsModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageWaitTime = _data["averageWaitTime"];
            this.englishQueuedCallers = _data["englishQueuedCallers"];
            this.englishAvailableAgents = _data["englishAvailableAgents"];
            this.frenchQueuedCallers = _data["frenchQueuedCallers"];
            this.frenchAvailableAgents = _data["frenchAvailableAgents"];
            this.totalAvailableAgents = _data["totalAvailableAgents"];
        }
    }

    static fromJS(data: any): QueueMetricsModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new QueueMetricsModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageWaitTime"] = this.averageWaitTime;
        data["englishQueuedCallers"] = this.englishQueuedCallers;
        data["englishAvailableAgents"] = this.englishAvailableAgents;
        data["frenchQueuedCallers"] = this.frenchQueuedCallers;
        data["frenchAvailableAgents"] = this.frenchAvailableAgents;
        data["totalAvailableAgents"] = this.totalAvailableAgents;
        return data;
    }
}

export interface IQueueMetricsModel2 {
    averageWaitTime?: string | undefined;
    englishQueuedCallers?: number;
    englishAvailableAgents?: number;
    frenchQueuedCallers?: number;
    frenchAvailableAgents?: number;
    totalAvailableAgents?: number;
}

export class CallMetricsModel implements ICallMetricsModel {
    dailyInboundVideoCallsCount?: number;
    averageInboundVideoCallsPerAgent?: number;
    averageOutboundVideoCallsPerAgent?: number;

    constructor(data?: ICallMetricsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dailyInboundVideoCallsCount = _data["dailyInboundVideoCallsCount"];
            this.averageInboundVideoCallsPerAgent = _data["averageInboundVideoCallsPerAgent"];
            this.averageOutboundVideoCallsPerAgent = _data["averageOutboundVideoCallsPerAgent"];
        }
    }

    static fromJS(data: any): CallMetricsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CallMetricsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dailyInboundVideoCallsCount"] = this.dailyInboundVideoCallsCount;
        data["averageInboundVideoCallsPerAgent"] = this.averageInboundVideoCallsPerAgent;
        data["averageOutboundVideoCallsPerAgent"] = this.averageOutboundVideoCallsPerAgent;
        return data;
    }
}

export interface ICallMetricsModel {
    dailyInboundVideoCallsCount?: number;
    averageInboundVideoCallsPerAgent?: number;
    averageOutboundVideoCallsPerAgent?: number;
}

export class MessageThreadSummaryResult implements IMessageThreadSummaryResult {
    messageId?: string;
    toUserId?: string;
    fromUserId?: string;
    subject?: string | undefined;
    completedOn?: Date | undefined;
    lastMessageCommentCreatedOn?: Date;
    lastMessageComment?: string | undefined;
    isUnread?: boolean;

    constructor(data?: IMessageThreadSummaryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.toUserId = _data["toUserId"];
            this.fromUserId = _data["fromUserId"];
            this.subject = _data["subject"];
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            this.lastMessageCommentCreatedOn = _data["lastMessageCommentCreatedOn"] ? new Date(_data["lastMessageCommentCreatedOn"].toString()) : undefined as any;
            this.lastMessageComment = _data["lastMessageComment"];
            this.isUnread = _data["isUnread"];
        }
    }

    static fromJS(data: any): MessageThreadSummaryResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageThreadSummaryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["toUserId"] = this.toUserId;
        data["fromUserId"] = this.fromUserId;
        data["subject"] = this.subject;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        data["lastMessageCommentCreatedOn"] = this.lastMessageCommentCreatedOn ? this.lastMessageCommentCreatedOn.toISOString() : undefined as any;
        data["lastMessageComment"] = this.lastMessageComment;
        data["isUnread"] = this.isUnread;
        return data;
    }
}

export interface IMessageThreadSummaryResult {
    messageId?: string;
    toUserId?: string;
    fromUserId?: string;
    subject?: string | undefined;
    completedOn?: Date | undefined;
    lastMessageCommentCreatedOn?: Date;
    lastMessageComment?: string | undefined;
    isUnread?: boolean;
}

export class MessageThreadResult implements IMessageThreadResult {
    messageThreadId?: string;
    createdOn?: Date;
    completedOn?: Date | undefined;
    sendingUserId?: string;
    recipientUserId?: string;
    subject?: string | undefined;
    comments?: MessageThreadCommentResult[] | undefined;

    constructor(data?: IMessageThreadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageThreadId = _data["messageThreadId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : undefined as any;
            this.sendingUserId = _data["sendingUserId"];
            this.recipientUserId = _data["recipientUserId"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(MessageThreadCommentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageThreadResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageThreadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageThreadId"] = this.messageThreadId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : undefined as any;
        data["sendingUserId"] = this.sendingUserId;
        data["recipientUserId"] = this.recipientUserId;
        data["subject"] = this.subject;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMessageThreadResult {
    messageThreadId?: string;
    createdOn?: Date;
    completedOn?: Date | undefined;
    sendingUserId?: string;
    recipientUserId?: string;
    subject?: string | undefined;
    comments?: MessageThreadCommentResult[] | undefined;
}

export class MessageThreadCommentResult implements IMessageThreadCommentResult {
    messageThreadId?: string;
    messageThreadCommentId?: string;
    createdOn?: Date;
    value?: string | undefined;
    commentingUserId?: string;

    constructor(data?: IMessageThreadCommentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageThreadId = _data["messageThreadId"];
            this.messageThreadCommentId = _data["messageThreadCommentId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.value = _data["value"];
            this.commentingUserId = _data["commentingUserId"];
        }
    }

    static fromJS(data: any): MessageThreadCommentResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageThreadCommentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageThreadId"] = this.messageThreadId;
        data["messageThreadCommentId"] = this.messageThreadCommentId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["value"] = this.value;
        data["commentingUserId"] = this.commentingUserId;
        return data;
    }
}

export interface IMessageThreadCommentResult {
    messageThreadId?: string;
    messageThreadCommentId?: string;
    createdOn?: Date;
    value?: string | undefined;
    commentingUserId?: string;
}

export class CreateMessageThreadRequestModel implements ICreateMessageThreadRequestModel {
    subject!: string;
    toUserId?: string;
    initialComment!: string;

    constructor(data?: ICreateMessageThreadRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.toUserId = _data["toUserId"];
            this.initialComment = _data["initialComment"];
        }
    }

    static fromJS(data: any): CreateMessageThreadRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageThreadRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["toUserId"] = this.toUserId;
        data["initialComment"] = this.initialComment;
        return data;
    }
}

export interface ICreateMessageThreadRequestModel {
    subject: string;
    toUserId?: string;
    initialComment: string;
}

export class CreateCommentForMessageThreadRequestModel implements ICreateCommentForMessageThreadRequestModel {
    messageThreadId?: string;
    comment!: string;
    complete?: boolean;

    constructor(data?: ICreateCommentForMessageThreadRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageThreadId = _data["messageThreadId"];
            this.comment = _data["comment"];
            this.complete = _data["complete"];
        }
    }

    static fromJS(data: any): CreateCommentForMessageThreadRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentForMessageThreadRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageThreadId"] = this.messageThreadId;
        data["comment"] = this.comment;
        data["complete"] = this.complete;
        return data;
    }
}

export interface ICreateCommentForMessageThreadRequestModel {
    messageThreadId?: string;
    comment: string;
    complete?: boolean;
}

export class InitialStateEmailResult implements IInitialStateEmailResult {
    infoEmails?: EmailResult[] | undefined;
    faxReceipts?: EmailResult[] | undefined;

    constructor(data?: IInitialStateEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["infoEmails"])) {
                this.infoEmails = [] as any;
                for (let item of _data["infoEmails"])
                    this.infoEmails!.push(EmailResult.fromJS(item));
            }
            if (Array.isArray(_data["faxReceipts"])) {
                this.faxReceipts = [] as any;
                for (let item of _data["faxReceipts"])
                    this.faxReceipts!.push(EmailResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InitialStateEmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new InitialStateEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.infoEmails)) {
            data["infoEmails"] = [];
            for (let item of this.infoEmails)
                data["infoEmails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.faxReceipts)) {
            data["faxReceipts"] = [];
            for (let item of this.faxReceipts)
                data["faxReceipts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInitialStateEmailResult {
    infoEmails?: EmailResult[] | undefined;
    faxReceipts?: EmailResult[] | undefined;
}

export class EmailResult implements IEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    toAll?: string | undefined;
    processed?: boolean;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    htmlBody?: string | undefined;
    date?: Date;
    attachments?: EmailAttachmentResult[] | undefined;

    constructor(data?: IEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.to = _data["to"];
            this.toAll = _data["toAll"];
            this.processed = _data["processed"];
            this.from = _data["from"];
            this.subject = _data["subject"];
            this.textBody = _data["textBody"];
            this.htmlBody = _data["htmlBody"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["to"] = this.to;
        data["toAll"] = this.toAll;
        data["processed"] = this.processed;
        data["from"] = this.from;
        data["subject"] = this.subject;
        data["textBody"] = this.textBody;
        data["htmlBody"] = this.htmlBody;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    toAll?: string | undefined;
    processed?: boolean;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    htmlBody?: string | undefined;
    date?: Date;
    attachments?: EmailAttachmentResult[] | undefined;
}

export class EmailAttachmentResult implements IEmailAttachmentResult {
    fileName?: string | undefined;

    constructor(data?: IEmailAttachmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): EmailAttachmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IEmailAttachmentResult {
    fileName?: string | undefined;
}

export class AdministrativeDataResult implements IAdministrativeDataResult {
    userContext?: UserContextResult | undefined;
    cultures?: CultureResult[] | undefined;
    userStudies?: StudyResult[] | undefined;
    statuses?: RootStatusResult[] | undefined;
    agents?: UserResult[] | undefined;
    phoneQueues?: AsteriskQueueResult[] | undefined;
    permissions?: PermissionResult[] | undefined;
    roles?: CallbackRoleResult[] | undefined;

    constructor(data?: IAdministrativeDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userContext = _data["userContext"] ? UserContextResult.fromJS(_data["userContext"]) : undefined as any;
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(CultureResult.fromJS(item));
            }
            if (Array.isArray(_data["userStudies"])) {
                this.userStudies = [] as any;
                for (let item of _data["userStudies"])
                    this.userStudies!.push(StudyResult.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(RootStatusResult.fromJS(item));
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(UserResult.fromJS(item));
            }
            if (Array.isArray(_data["phoneQueues"])) {
                this.phoneQueues = [] as any;
                for (let item of _data["phoneQueues"])
                    this.phoneQueues!.push(AsteriskQueueResult.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionResult.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(CallbackRoleResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdministrativeDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrativeDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userContext"] = this.userContext ? this.userContext.toJSON() : undefined as any;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userStudies)) {
            data["userStudies"] = [];
            for (let item of this.userStudies)
                data["userStudies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phoneQueues)) {
            data["phoneQueues"] = [];
            for (let item of this.phoneQueues)
                data["phoneQueues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdministrativeDataResult {
    userContext?: UserContextResult | undefined;
    cultures?: CultureResult[] | undefined;
    userStudies?: StudyResult[] | undefined;
    statuses?: RootStatusResult[] | undefined;
    agents?: UserResult[] | undefined;
    phoneQueues?: AsteriskQueueResult[] | undefined;
    permissions?: PermissionResult[] | undefined;
    roles?: CallbackRoleResult[] | undefined;
}

export class CultureResult implements ICultureResult {
    code?: string;

    constructor(data?: ICultureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CultureResult {
        data = typeof data === 'object' ? data : {};
        let result = new CultureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface ICultureResult {
    code?: string;
}

export class UserResult implements IUserResult {
    id?: string;
    name?: string | undefined;
    fullName?: string | undefined;
    asteriskUsername?: string | undefined;
    isEnabled?: boolean;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    asteriskExtensionNumber?: string | undefined;
    cultures?: CultureResult[];
    status?: UserStatusResult | undefined;
    studies?: StudyUserRoleResult[];
    assignedQueues?: string[];
    temporaryAssignedQueues?: string[];
    designations?: DesignationResult[];
    agentStatus?: AgentStatus | undefined;

    constructor(data?: IUserResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.asteriskUsername = _data["asteriskUsername"];
            this.isEnabled = _data["isEnabled"];
            if (Array.isArray(_data["agentProvinces"])) {
                this.agentProvinces = [] as any;
                for (let item of _data["agentProvinces"])
                    this.agentProvinces!.push(ProvinceScheduleSummary.fromJS(item));
            }
            this.agentRole = _data["agentRole"];
            this.asteriskExtensionNumber = _data["asteriskExtensionNumber"];
            if (Array.isArray(_data["cultures"])) {
                this.cultures = [] as any;
                for (let item of _data["cultures"])
                    this.cultures!.push(CultureResult.fromJS(item));
            }
            this.status = _data["status"] ? UserStatusResult.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["studies"])) {
                this.studies = [] as any;
                for (let item of _data["studies"])
                    this.studies!.push(StudyUserRoleResult.fromJS(item));
            }
            if (Array.isArray(_data["assignedQueues"])) {
                this.assignedQueues = [] as any;
                for (let item of _data["assignedQueues"])
                    this.assignedQueues!.push(item);
            }
            if (Array.isArray(_data["temporaryAssignedQueues"])) {
                this.temporaryAssignedQueues = [] as any;
                for (let item of _data["temporaryAssignedQueues"])
                    this.temporaryAssignedQueues!.push(item);
            }
            if (Array.isArray(_data["designations"])) {
                this.designations = [] as any;
                for (let item of _data["designations"])
                    this.designations!.push(DesignationResult.fromJS(item));
            }
            this.agentStatus = _data["agentStatus"];
        }
    }

    static fromJS(data: any): UserResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["asteriskUsername"] = this.asteriskUsername;
        data["isEnabled"] = this.isEnabled;
        if (Array.isArray(this.agentProvinces)) {
            data["agentProvinces"] = [];
            for (let item of this.agentProvinces)
                data["agentProvinces"].push(item ? item.toJSON() : undefined as any);
        }
        data["agentRole"] = this.agentRole;
        data["asteriskExtensionNumber"] = this.asteriskExtensionNumber;
        if (Array.isArray(this.cultures)) {
            data["cultures"] = [];
            for (let item of this.cultures)
                data["cultures"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.studies)) {
            data["studies"] = [];
            for (let item of this.studies)
                data["studies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assignedQueues)) {
            data["assignedQueues"] = [];
            for (let item of this.assignedQueues)
                data["assignedQueues"].push(item);
        }
        if (Array.isArray(this.temporaryAssignedQueues)) {
            data["temporaryAssignedQueues"] = [];
            for (let item of this.temporaryAssignedQueues)
                data["temporaryAssignedQueues"].push(item);
        }
        if (Array.isArray(this.designations)) {
            data["designations"] = [];
            for (let item of this.designations)
                data["designations"].push(item ? item.toJSON() : undefined as any);
        }
        data["agentStatus"] = this.agentStatus;
        return data;
    }
}

export interface IUserResult {
    id?: string;
    name?: string | undefined;
    fullName?: string | undefined;
    asteriskUsername?: string | undefined;
    isEnabled?: boolean;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    asteriskExtensionNumber?: string | undefined;
    cultures?: CultureResult[];
    status?: UserStatusResult | undefined;
    studies?: StudyUserRoleResult[];
    assignedQueues?: string[];
    temporaryAssignedQueues?: string[];
    designations?: DesignationResult[];
    agentStatus?: AgentStatus | undefined;
}

export class ProvinceScheduleSummary implements IProvinceScheduleSummary {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IProvinceScheduleSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProvinceScheduleSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceScheduleSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IProvinceScheduleSummary {
    code?: string | undefined;
    name?: string | undefined;
}

export class StudyUserRoleResult implements IStudyUserRoleResult {
    studyUserId?: string;
    studyId?: string;
    studyName?: string | undefined;
    studyColor?: string | undefined;
    isHcp?: boolean;
    roleIds?: string[];

    constructor(data?: IStudyUserRoleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyUserId = _data["studyUserId"];
            this.studyId = _data["studyId"];
            this.studyName = _data["studyName"];
            this.studyColor = _data["studyColor"];
            this.isHcp = _data["isHcp"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): StudyUserRoleResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserRoleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyUserId"] = this.studyUserId;
        data["studyId"] = this.studyId;
        data["studyName"] = this.studyName;
        data["studyColor"] = this.studyColor;
        data["isHcp"] = this.isHcp;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IStudyUserRoleResult {
    studyUserId?: string;
    studyId?: string;
    studyName?: string | undefined;
    studyColor?: string | undefined;
    isHcp?: boolean;
    roleIds?: string[];
}

export class DesignationResult implements IDesignationResult {
    cultureCode?: string;
    value?: string | undefined;

    constructor(data?: IDesignationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DesignationResult {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["value"] = this.value;
        return data;
    }
}

export interface IDesignationResult {
    cultureCode?: string;
    value?: string | undefined;
}

export class AsteriskQueueResult implements IAsteriskQueueResult {
    id?: string;
    queueName?: string;
    disabled?: boolean;
    displayName?: string | undefined;
    studyId?: string | undefined;
    cultureCode?: string | undefined;

    constructor(data?: IAsteriskQueueResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.queueName = _data["queueName"];
            this.disabled = _data["disabled"];
            this.displayName = _data["displayName"];
            this.studyId = _data["studyId"];
            this.cultureCode = _data["cultureCode"];
        }
    }

    static fromJS(data: any): AsteriskQueueResult {
        data = typeof data === 'object' ? data : {};
        let result = new AsteriskQueueResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["queueName"] = this.queueName;
        data["disabled"] = this.disabled;
        data["displayName"] = this.displayName;
        data["studyId"] = this.studyId;
        data["cultureCode"] = this.cultureCode;
        return data;
    }
}

export interface IAsteriskQueueResult {
    id?: string;
    queueName?: string;
    disabled?: boolean;
    displayName?: string | undefined;
    studyId?: string | undefined;
    cultureCode?: string | undefined;
}

export class TaskDataResult implements ITaskDataResult {
    activeTasks?: CallbackTaskResult[] | undefined;
    activeVideos?: IncomingVideoResult[] | undefined;
    inProgressVideos?: InProgressVideoCallResult[] | undefined;
    channelSnapshot?: ChannelsStateSnapshot | undefined;
    queueSnapshot?: QueueSummariesSnapshot | undefined;
    pendingWrapUps?: PhoneWrapUpPendingResult[] | undefined;

    constructor(data?: ITaskDataResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activeTasks"])) {
                this.activeTasks = [] as any;
                for (let item of _data["activeTasks"])
                    this.activeTasks!.push(CallbackTaskResult.fromJS(item));
            }
            if (Array.isArray(_data["activeVideos"])) {
                this.activeVideos = [] as any;
                for (let item of _data["activeVideos"])
                    this.activeVideos!.push(IncomingVideoResult.fromJS(item));
            }
            if (Array.isArray(_data["inProgressVideos"])) {
                this.inProgressVideos = [] as any;
                for (let item of _data["inProgressVideos"])
                    this.inProgressVideos!.push(InProgressVideoCallResult.fromJS(item));
            }
            this.channelSnapshot = _data["channelSnapshot"] ? ChannelsStateSnapshot.fromJS(_data["channelSnapshot"]) : undefined as any;
            this.queueSnapshot = _data["queueSnapshot"] ? QueueSummariesSnapshot.fromJS(_data["queueSnapshot"]) : undefined as any;
            if (Array.isArray(_data["pendingWrapUps"])) {
                this.pendingWrapUps = [] as any;
                for (let item of _data["pendingWrapUps"])
                    this.pendingWrapUps!.push(PhoneWrapUpPendingResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskDataResult {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDataResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activeTasks)) {
            data["activeTasks"] = [];
            for (let item of this.activeTasks)
                data["activeTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activeVideos)) {
            data["activeVideos"] = [];
            for (let item of this.activeVideos)
                data["activeVideos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.inProgressVideos)) {
            data["inProgressVideos"] = [];
            for (let item of this.inProgressVideos)
                data["inProgressVideos"].push(item ? item.toJSON() : undefined as any);
        }
        data["channelSnapshot"] = this.channelSnapshot ? this.channelSnapshot.toJSON() : undefined as any;
        data["queueSnapshot"] = this.queueSnapshot ? this.queueSnapshot.toJSON() : undefined as any;
        if (Array.isArray(this.pendingWrapUps)) {
            data["pendingWrapUps"] = [];
            for (let item of this.pendingWrapUps)
                data["pendingWrapUps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskDataResult {
    activeTasks?: CallbackTaskResult[] | undefined;
    activeVideos?: IncomingVideoResult[] | undefined;
    inProgressVideos?: InProgressVideoCallResult[] | undefined;
    channelSnapshot?: ChannelsStateSnapshot | undefined;
    queueSnapshot?: QueueSummariesSnapshot | undefined;
    pendingWrapUps?: PhoneWrapUpPendingResult[] | undefined;
}

export class IncomingVideoResult implements IIncomingVideoResult {
    id?: string;
    studyId?: string;
    createdOn?: Date;
    isArchived?: boolean;
    language?: string | undefined;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;

    constructor(data?: IIncomingVideoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.isArchived = _data["isArchived"];
            this.language = _data["language"];
            this.onlineMeetingId = _data["onlineMeetingId"];
            this.onlineMeetingJoinWebUrl = _data["onlineMeetingJoinWebUrl"];
        }
    }

    static fromJS(data: any): IncomingVideoResult {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingVideoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["isArchived"] = this.isArchived;
        data["language"] = this.language;
        data["onlineMeetingId"] = this.onlineMeetingId;
        data["onlineMeetingJoinWebUrl"] = this.onlineMeetingJoinWebUrl;
        return data;
    }
}

export interface IIncomingVideoResult {
    id?: string;
    studyId?: string;
    createdOn?: Date;
    isArchived?: boolean;
    language?: string | undefined;
    onlineMeetingId?: string | undefined;
    onlineMeetingJoinWebUrl?: string | undefined;
}

export class InProgressVideoCallResult implements IInProgressVideoCallResult {
    incomingVideoCallId?: string;
    studyId?: string;
    users?: UserVideoJoinResult[] | undefined;

    constructor(data?: IInProgressVideoCallResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingVideoCallId = _data["incomingVideoCallId"];
            this.studyId = _data["studyId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserVideoJoinResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InProgressVideoCallResult {
        data = typeof data === 'object' ? data : {};
        let result = new InProgressVideoCallResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomingVideoCallId"] = this.incomingVideoCallId;
        data["studyId"] = this.studyId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInProgressVideoCallResult {
    incomingVideoCallId?: string;
    studyId?: string;
    users?: UserVideoJoinResult[] | undefined;
}

export class UserVideoJoinResult implements IUserVideoJoinResult {
    userId?: string;
    createdOn?: Date;

    constructor(data?: IUserVideoJoinResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserVideoJoinResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserVideoJoinResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserVideoJoinResult {
    userId?: string;
    createdOn?: Date;
}

export class ChannelsStateSnapshot implements IChannelsStateSnapshot {
    users?: { [key: string]: UserSnapshot; };
    callers?: { [key: string]: CallerSnapshot; };

    constructor(data?: IChannelsStateSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["users"]) {
                this.users = {} as any;
                for (let key in _data["users"]) {
                    if (_data["users"].hasOwnProperty(key))
                        (this.users as any)![key] = _data["users"][key] ? UserSnapshot.fromJS(_data["users"][key]) : new UserSnapshot();
                }
            }
            if (_data["callers"]) {
                this.callers = {} as any;
                for (let key in _data["callers"]) {
                    if (_data["callers"].hasOwnProperty(key))
                        (this.callers as any)![key] = _data["callers"][key] ? CallerSnapshot.fromJS(_data["callers"][key]) : new CallerSnapshot();
                }
            }
        }
    }

    static fromJS(data: any): ChannelsStateSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelsStateSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.users) {
            data["users"] = {};
            for (let key in this.users) {
                if (this.users.hasOwnProperty(key))
                    (data["users"] as any)[key] = this.users[key] ? this.users[key].toJSON() : undefined as any;
            }
        }
        if (this.callers) {
            data["callers"] = {};
            for (let key in this.callers) {
                if (this.callers.hasOwnProperty(key))
                    (data["callers"] as any)[key] = this.callers[key] ? this.callers[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IChannelsStateSnapshot {
    users?: { [key: string]: UserSnapshot; };
    callers?: { [key: string]: CallerSnapshot; };
}

export class ChannelSnapshot implements IChannelSnapshot {
    status?: ChannelStatus;
    startedOn?: Date;
    snapshotCreated?: Date;
    channel?: string | undefined;
    uniqueId?: string | undefined;
    linkedId?: string | undefined;

    constructor(data?: IChannelSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : undefined as any;
            this.snapshotCreated = _data["snapshotCreated"] ? new Date(_data["snapshotCreated"].toString()) : undefined as any;
            this.channel = _data["channel"];
            this.uniqueId = _data["uniqueId"];
            this.linkedId = _data["linkedId"];
        }
    }

    static fromJS(data: any): ChannelSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : undefined as any;
        data["snapshotCreated"] = this.snapshotCreated ? this.snapshotCreated.toISOString() : undefined as any;
        data["channel"] = this.channel;
        data["uniqueId"] = this.uniqueId;
        data["linkedId"] = this.linkedId;
        return data;
    }
}

export interface IChannelSnapshot {
    status?: ChannelStatus;
    startedOn?: Date;
    snapshotCreated?: Date;
    channel?: string | undefined;
    uniqueId?: string | undefined;
    linkedId?: string | undefined;
}

export class UserSnapshot extends ChannelSnapshot implements IUserSnapshot {
    userId?: string;
    isDialedOutbound?: boolean;
    dialedNumber?: string | undefined;

    constructor(data?: IUserSnapshot) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.isDialedOutbound = _data["isDialedOutbound"];
            this.dialedNumber = _data["dialedNumber"];
        }
    }

    static override fromJS(data: any): UserSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new UserSnapshot();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isDialedOutbound"] = this.isDialedOutbound;
        data["dialedNumber"] = this.dialedNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IUserSnapshot extends IChannelSnapshot {
    userId?: string;
    isDialedOutbound?: boolean;
    dialedNumber?: string | undefined;
}

export enum ChannelStatus {
    DownAvailable = 0,
    DownReserved = 1,
    OffHook = 2,
    Dialed = 3,
    LineRining = 4,
    RemoteRinging = 5,
    Up = 6,
    Busy = 7,
}

export class CallerSnapshot extends ChannelSnapshot implements ICallerSnapshot {
    callerIdName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: ICallerSnapshot) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.callerIdName = _data["callerIdName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static override fromJS(data: any): CallerSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new CallerSnapshot();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callerIdName"] = this.callerIdName;
        data["phoneNumber"] = this.phoneNumber;
        super.toJSON(data);
        return data;
    }
}

export interface ICallerSnapshot extends IChannelSnapshot {
    callerIdName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class QueueSummariesSnapshot implements IQueueSummariesSnapshot {
    queues?: { [key: string]: QueueSnapshot; };
    userQueues?: { [key: string]: string[]; };

    constructor(data?: IQueueSummariesSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["queues"]) {
                this.queues = {} as any;
                for (let key in _data["queues"]) {
                    if (_data["queues"].hasOwnProperty(key))
                        (this.queues as any)![key] = _data["queues"][key] ? QueueSnapshot.fromJS(_data["queues"][key]) : new QueueSnapshot();
                }
            }
            if (_data["userQueues"]) {
                this.userQueues = {} as any;
                for (let key in _data["userQueues"]) {
                    if (_data["userQueues"].hasOwnProperty(key))
                        (this.userQueues as any)![key] = _data["userQueues"][key] !== undefined ? _data["userQueues"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): QueueSummariesSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new QueueSummariesSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.queues) {
            data["queues"] = {};
            for (let key in this.queues) {
                if (this.queues.hasOwnProperty(key))
                    (data["queues"] as any)[key] = this.queues[key] ? this.queues[key].toJSON() : undefined as any;
            }
        }
        if (this.userQueues) {
            data["userQueues"] = {};
            for (let key in this.userQueues) {
                if (this.userQueues.hasOwnProperty(key))
                    (data["userQueues"] as any)[key] = (this.userQueues as any)[key];
            }
        }
        return data;
    }
}

export interface IQueueSummariesSnapshot {
    queues?: { [key: string]: QueueSnapshot; };
    userQueues?: { [key: string]: string[]; };
}

export class QueueSnapshot implements IQueueSnapshot {
    name?: string | undefined;
    holdTime?: string;
    callers?: QueuedCallerSnapshot[];

    constructor(data?: IQueueSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.holdTime = _data["holdTime"];
            if (Array.isArray(_data["callers"])) {
                this.callers = [] as any;
                for (let item of _data["callers"])
                    this.callers!.push(QueuedCallerSnapshot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueueSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new QueueSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["holdTime"] = this.holdTime;
        if (Array.isArray(this.callers)) {
            data["callers"] = [];
            for (let item of this.callers)
                data["callers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQueueSnapshot {
    name?: string | undefined;
    holdTime?: string;
    callers?: QueuedCallerSnapshot[];
}

export class QueuedCallerSnapshot implements IQueuedCallerSnapshot {
    uniqueId?: string | undefined;
    position?: number;
    queuedOn?: Date;

    constructor(data?: IQueuedCallerSnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.position = _data["position"];
            this.queuedOn = _data["queuedOn"] ? new Date(_data["queuedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): QueuedCallerSnapshot {
        data = typeof data === 'object' ? data : {};
        let result = new QueuedCallerSnapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["position"] = this.position;
        data["queuedOn"] = this.queuedOn ? this.queuedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IQueuedCallerSnapshot {
    uniqueId?: string | undefined;
    position?: number;
    queuedOn?: Date;
}

export class IncomingVideoStateResult implements IIncomingVideoStateResult {
    id?: string;
    username?: string | undefined;
    createdOn?: Date;
    note?: string | undefined;
    isArchived?: boolean;

    constructor(data?: IIncomingVideoStateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.note = _data["note"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): IncomingVideoStateResult {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingVideoStateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["note"] = this.note;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IIncomingVideoStateResult {
    id?: string;
    username?: string | undefined;
    createdOn?: Date;
    note?: string | undefined;
    isArchived?: boolean;
}

export class CompleteIncomingVideoModel implements ICompleteIncomingVideoModel {
    incomingVideoId?: string;
    studyId?: string;
    sendSatisfactionSurvey?: boolean;
    patientId?: string;

    constructor(data?: ICompleteIncomingVideoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomingVideoId = _data["incomingVideoId"];
            this.studyId = _data["studyId"];
            this.sendSatisfactionSurvey = _data["sendSatisfactionSurvey"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): CompleteIncomingVideoModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteIncomingVideoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomingVideoId"] = this.incomingVideoId;
        data["studyId"] = this.studyId;
        data["sendSatisfactionSurvey"] = this.sendSatisfactionSurvey;
        data["patientId"] = this.patientId;
        return data;
    }
}

export interface ICompleteIncomingVideoModel {
    incomingVideoId?: string;
    studyId?: string;
    sendSatisfactionSurvey?: boolean;
    patientId?: string;
}

export class UpdateIncomingVideoStateModel implements IUpdateIncomingVideoStateModel {
    note?: string | undefined;

    constructor(data?: IUpdateIncomingVideoStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateIncomingVideoStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncomingVideoStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateIncomingVideoStateModel {
    note?: string | undefined;
}

export class EmailTemplateResult implements IEmailTemplateResult {
    id?: string;
    name?: string | undefined;
    emailContents?: EmailContentResult[];
    studyId?: string;
    usedForCallRating?: boolean;
    usedForPhoneConfirmation?: boolean;
    usedForVideoConfirmation?: boolean;
    usedForPhoneReminder?: boolean;
    usedForVideoReminder?: boolean;

    constructor(data?: IEmailTemplateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["emailContents"])) {
                this.emailContents = [] as any;
                for (let item of _data["emailContents"])
                    this.emailContents!.push(EmailContentResult.fromJS(item));
            }
            this.studyId = _data["studyId"];
            this.usedForCallRating = _data["usedForCallRating"];
            this.usedForPhoneConfirmation = _data["usedForPhoneConfirmation"];
            this.usedForVideoConfirmation = _data["usedForVideoConfirmation"];
            this.usedForPhoneReminder = _data["usedForPhoneReminder"];
            this.usedForVideoReminder = _data["usedForVideoReminder"];
        }
    }

    static fromJS(data: any): EmailTemplateResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.emailContents)) {
            data["emailContents"] = [];
            for (let item of this.emailContents)
                data["emailContents"].push(item ? item.toJSON() : undefined as any);
        }
        data["studyId"] = this.studyId;
        data["usedForCallRating"] = this.usedForCallRating;
        data["usedForPhoneConfirmation"] = this.usedForPhoneConfirmation;
        data["usedForVideoConfirmation"] = this.usedForVideoConfirmation;
        data["usedForPhoneReminder"] = this.usedForPhoneReminder;
        data["usedForVideoReminder"] = this.usedForVideoReminder;
        return data;
    }
}

export interface IEmailTemplateResult {
    id?: string;
    name?: string | undefined;
    emailContents?: EmailContentResult[];
    studyId?: string;
    usedForCallRating?: boolean;
    usedForPhoneConfirmation?: boolean;
    usedForVideoConfirmation?: boolean;
    usedForPhoneReminder?: boolean;
    usedForVideoReminder?: boolean;
}

export class EmailContentResult implements IEmailContentResult {
    id?: string;
    emailTemplateId?: string;
    cultureCode?: string;
    subject?: string | undefined;
    body?: string | undefined;
    isDefault?: boolean;
    attachments?: EmailAttachmentResult2[] | undefined;

    constructor(data?: IEmailContentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailTemplateId = _data["emailTemplateId"];
            this.cultureCode = _data["cultureCode"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentResult2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmailContentResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailContentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailTemplateId"] = this.emailTemplateId;
        data["cultureCode"] = this.cultureCode;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEmailContentResult {
    id?: string;
    emailTemplateId?: string;
    cultureCode?: string;
    subject?: string | undefined;
    body?: string | undefined;
    isDefault?: boolean;
    attachments?: EmailAttachmentResult2[] | undefined;
}

export class EmailAttachmentResult2 implements IEmailAttachmentResult2 {
    id?: string;
    fileName?: string | undefined;

    constructor(data?: IEmailAttachmentResult2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): EmailAttachmentResult2 {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAttachmentResult2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IEmailAttachmentResult2 {
    id?: string;
    fileName?: string | undefined;
}

export class CreateEmailTemplateModel implements ICreateEmailTemplateModel {
    name!: string;

    constructor(data?: ICreateEmailTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateEmailTemplateModel {
    name: string;
}

export class UpdateEmailTemplateModel implements IUpdateEmailTemplateModel {
    name!: string;

    constructor(data?: IUpdateEmailTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateEmailTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateEmailTemplateModel {
    name: string;
}

export class CreateEmailContentModel implements ICreateEmailContentModel {
    cultureCode?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: ICreateEmailContentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): CreateEmailContentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailContentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface ICreateEmailContentModel {
    cultureCode?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class SentEmailResult implements ISentEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    htmlBody?: string | undefined;
    date?: Date;
    attachments?: EmailAttachmentResult[] | undefined;

    constructor(data?: ISentEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.to = _data["to"];
            this.from = _data["from"];
            this.subject = _data["subject"];
            this.textBody = _data["textBody"];
            this.htmlBody = _data["htmlBody"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(EmailAttachmentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SentEmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new SentEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["to"] = this.to;
        data["from"] = this.from;
        data["subject"] = this.subject;
        data["textBody"] = this.textBody;
        data["htmlBody"] = this.htmlBody;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISentEmailResult {
    messageId?: string | undefined;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    textBody?: string | undefined;
    htmlBody?: string | undefined;
    date?: Date;
    attachments?: EmailAttachmentResult[] | undefined;
}

export class ProcessEmailModel implements IProcessEmailModel {
    emailAddress?: string | undefined;
    messageID?: string | undefined;

    constructor(data?: IProcessEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.messageID = _data["messageID"];
        }
    }

    static fromJS(data: any): ProcessEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["messageID"] = this.messageID;
        return data;
    }
}

export interface IProcessEmailModel {
    emailAddress?: string | undefined;
    messageID?: string | undefined;
}

export class EmailSenderServiceResult implements IEmailSenderServiceResult {
    emailSenderId?: string;
    emailAddress?: string | undefined;

    constructor(data?: IEmailSenderServiceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailSenderId = _data["emailSenderId"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): EmailSenderServiceResult {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSenderServiceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailSenderId"] = this.emailSenderId;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IEmailSenderServiceResult {
    emailSenderId?: string;
    emailAddress?: string | undefined;
}

export class SurveyUIModel implements ISurveyUIModel {
    id?: string | undefined;
    studyId?: string;
    language?: string | undefined;

    constructor(data?: ISurveyUIModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studyId = _data["studyId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): SurveyUIModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyUIModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studyId"] = this.studyId;
        data["language"] = this.language;
        return data;
    }
}

export interface ISurveyUIModel {
    id?: string | undefined;
    studyId?: string;
    language?: string | undefined;
}

export class UserScheduleResult implements IUserScheduleResult {
    id?: string;
    userId?: string;
    userName?: string | undefined;
    startOn?: Date;
    endOn?: Date;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    languages?: string[] | undefined;
    studies?: ScheduleStudyAssociationResult[];
    isLocked?: boolean;

    constructor(data?: IUserScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
            if (Array.isArray(_data["agentProvinces"])) {
                this.agentProvinces = [] as any;
                for (let item of _data["agentProvinces"])
                    this.agentProvinces!.push(ProvinceScheduleSummary.fromJS(item));
            }
            this.agentRole = _data["agentRole"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["studies"])) {
                this.studies = [] as any;
                for (let item of _data["studies"])
                    this.studies!.push(ScheduleStudyAssociationResult.fromJS(item));
            }
            this.isLocked = _data["isLocked"];
        }
    }

    static fromJS(data: any): UserScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        if (Array.isArray(this.agentProvinces)) {
            data["agentProvinces"] = [];
            for (let item of this.agentProvinces)
                data["agentProvinces"].push(item ? item.toJSON() : undefined as any);
        }
        data["agentRole"] = this.agentRole;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        if (Array.isArray(this.studies)) {
            data["studies"] = [];
            for (let item of this.studies)
                data["studies"].push(item ? item.toJSON() : undefined as any);
        }
        data["isLocked"] = this.isLocked;
        return data;
    }
}

export interface IUserScheduleResult {
    id?: string;
    userId?: string;
    userName?: string | undefined;
    startOn?: Date;
    endOn?: Date;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
    languages?: string[] | undefined;
    studies?: ScheduleStudyAssociationResult[];
    isLocked?: boolean;
}

export class ScheduleStudyAssociationResult implements IScheduleStudyAssociationResult {
    studyId?: string;
    studyName?: string | undefined;
    studyPrimaryColor?: string | undefined;
    shiftSupervisor?: boolean;

    constructor(data?: IScheduleStudyAssociationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.studyName = _data["studyName"];
            this.studyPrimaryColor = _data["studyPrimaryColor"];
            this.shiftSupervisor = _data["shiftSupervisor"];
        }
    }

    static fromJS(data: any): ScheduleStudyAssociationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStudyAssociationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["studyName"] = this.studyName;
        data["studyPrimaryColor"] = this.studyPrimaryColor;
        data["shiftSupervisor"] = this.shiftSupervisor;
        return data;
    }
}

export interface IScheduleStudyAssociationResult {
    studyId?: string;
    studyName?: string | undefined;
    studyPrimaryColor?: string | undefined;
    shiftSupervisor?: boolean;
}

export class CreateStudyUserScheduleModel implements ICreateStudyUserScheduleModel {
    userId?: string;
    startOn?: Date;
    endOn?: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;

    constructor(data?: ICreateStudyUserScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
            this.notes = _data["notes"];
            if (Array.isArray(_data["studyAssociations"])) {
                this.studyAssociations = [] as any;
                for (let item of _data["studyAssociations"])
                    this.studyAssociations!.push(ScheduleStudyAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["breaks"])) {
                this.breaks = [] as any;
                for (let item of _data["breaks"])
                    this.breaks!.push(StudyUserScheduleBreakModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateStudyUserScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyUserScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        data["notes"] = this.notes;
        if (Array.isArray(this.studyAssociations)) {
            data["studyAssociations"] = [];
            for (let item of this.studyAssociations)
                data["studyAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.breaks)) {
            data["breaks"] = [];
            for (let item of this.breaks)
                data["breaks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateStudyUserScheduleModel {
    userId?: string;
    startOn?: Date;
    endOn?: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;
}

export class ScheduleStudyAssociationModel implements IScheduleStudyAssociationModel {
    shiftSupervisor?: boolean;
    studyId?: string;

    constructor(data?: IScheduleStudyAssociationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftSupervisor = _data["shiftSupervisor"];
            this.studyId = _data["studyId"];
        }
    }

    static fromJS(data: any): ScheduleStudyAssociationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStudyAssociationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftSupervisor"] = this.shiftSupervisor;
        data["studyId"] = this.studyId;
        return data;
    }
}

export interface IScheduleStudyAssociationModel {
    shiftSupervisor?: boolean;
    studyId?: string;
}

export class StudyUserScheduleBreakModel implements IStudyUserScheduleBreakModel {
    breakId?: string | undefined;
    startOn?: Date;
    duration?: number;
    deleted?: boolean;

    constructor(data?: IStudyUserScheduleBreakModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakId = _data["breakId"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): StudyUserScheduleBreakModel {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserScheduleBreakModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breakId"] = this.breakId;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IStudyUserScheduleBreakModel {
    breakId?: string | undefined;
    startOn?: Date;
    duration?: number;
    deleted?: boolean;
}

export class UpdateUserScheduleRequestModel implements IUpdateUserScheduleRequestModel {
    studyUserScheduleId?: string;
    startOn?: Date;
    endOn?: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;

    constructor(data?: IUpdateUserScheduleRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyUserScheduleId = _data["studyUserScheduleId"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
            this.notes = _data["notes"];
            if (Array.isArray(_data["studyAssociations"])) {
                this.studyAssociations = [] as any;
                for (let item of _data["studyAssociations"])
                    this.studyAssociations!.push(ScheduleStudyAssociationModel.fromJS(item));
            }
            if (Array.isArray(_data["breaks"])) {
                this.breaks = [] as any;
                for (let item of _data["breaks"])
                    this.breaks!.push(StudyUserScheduleBreakModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateUserScheduleRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserScheduleRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyUserScheduleId"] = this.studyUserScheduleId;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        data["notes"] = this.notes;
        if (Array.isArray(this.studyAssociations)) {
            data["studyAssociations"] = [];
            for (let item of this.studyAssociations)
                data["studyAssociations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.breaks)) {
            data["breaks"] = [];
            for (let item of this.breaks)
                data["breaks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateUserScheduleRequestModel {
    studyUserScheduleId?: string;
    startOn?: Date;
    endOn?: Date;
    notes?: string | undefined;
    studyAssociations?: ScheduleStudyAssociationModel[] | undefined;
    breaks?: StudyUserScheduleBreakModel[] | undefined;
}

export class ScheduleOpeningResult2 implements IScheduleOpeningResult2 {
    userId?: string;
    start?: Date;
    end?: Date;

    constructor(data?: IScheduleOpeningResult2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleOpeningResult2 {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleOpeningResult2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }
}

export interface IScheduleOpeningResult2 {
    userId?: string;
    start?: Date;
    end?: Date;
}

export class StudyUserHoursResult implements IStudyUserHoursResult {
    userId?: string;
    userName?: string | undefined;
    hours?: number | undefined;
    adjustedHours?: number | undefined;
    studies?: ScheduleStudyReference[] | undefined;

    constructor(data?: IStudyUserHoursResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.hours = _data["hours"];
            this.adjustedHours = _data["adjustedHours"];
            if (Array.isArray(_data["studies"])) {
                this.studies = [] as any;
                for (let item of _data["studies"])
                    this.studies!.push(ScheduleStudyReference.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudyUserHoursResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudyUserHoursResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["hours"] = this.hours;
        data["adjustedHours"] = this.adjustedHours;
        if (Array.isArray(this.studies)) {
            data["studies"] = [];
            for (let item of this.studies)
                data["studies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStudyUserHoursResult {
    userId?: string;
    userName?: string | undefined;
    hours?: number | undefined;
    adjustedHours?: number | undefined;
    studies?: ScheduleStudyReference[] | undefined;
}

export class ScheduleStudyReference implements IScheduleStudyReference {
    studyId?: string;
    studyName?: string | undefined;
    role?: string | undefined;

    constructor(data?: IScheduleStudyReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.studyName = _data["studyName"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ScheduleStudyReference {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleStudyReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["studyName"] = this.studyName;
        data["role"] = this.role;
        return data;
    }
}

export interface IScheduleStudyReference {
    studyId?: string;
    studyName?: string | undefined;
    role?: string | undefined;
}

export class DuplicateScheduleViewModel implements IDuplicateScheduleViewModel {
    sourceStart?: Date;
    sourceEnd?: Date;
    target?: Date;

    constructor(data?: IDuplicateScheduleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceStart = _data["sourceStart"] ? new Date(_data["sourceStart"].toString()) : undefined as any;
            this.sourceEnd = _data["sourceEnd"] ? new Date(_data["sourceEnd"].toString()) : undefined as any;
            this.target = _data["target"] ? new Date(_data["target"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DuplicateScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceStart"] = this.sourceStart ? this.sourceStart.toISOString() : undefined as any;
        data["sourceEnd"] = this.sourceEnd ? this.sourceEnd.toISOString() : undefined as any;
        data["target"] = this.target ? this.target.toISOString() : undefined as any;
        return data;
    }
}

export interface IDuplicateScheduleViewModel {
    sourceStart?: Date;
    sourceEnd?: Date;
    target?: Date;
}

export class PostScheduleViewModel implements IPostScheduleViewModel {
    schedulePostedDate?: Date;

    constructor(data?: IPostScheduleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schedulePostedDate = _data["schedulePostedDate"] ? new Date(_data["schedulePostedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PostScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schedulePostedDate"] = this.schedulePostedDate ? this.schedulePostedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPostScheduleViewModel {
    schedulePostedDate?: Date;
}

export class GridScheduleViewModel implements IGridScheduleViewModel {
    agentId?: string;
    agentName?: string | undefined;
    languages?: string[] | undefined;
    scheduleDetails?: ScheduleDetail[] | undefined;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;

    constructor(data?: IGridScheduleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["scheduleDetails"])) {
                this.scheduleDetails = [] as any;
                for (let item of _data["scheduleDetails"])
                    this.scheduleDetails!.push(ScheduleDetail.fromJS(item));
            }
            if (Array.isArray(_data["agentProvinces"])) {
                this.agentProvinces = [] as any;
                for (let item of _data["agentProvinces"])
                    this.agentProvinces!.push(ProvinceScheduleSummary.fromJS(item));
            }
            this.agentRole = _data["agentRole"];
        }
    }

    static fromJS(data: any): GridScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GridScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        if (Array.isArray(this.scheduleDetails)) {
            data["scheduleDetails"] = [];
            for (let item of this.scheduleDetails)
                data["scheduleDetails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.agentProvinces)) {
            data["agentProvinces"] = [];
            for (let item of this.agentProvinces)
                data["agentProvinces"].push(item ? item.toJSON() : undefined as any);
        }
        data["agentRole"] = this.agentRole;
        return data;
    }
}

export interface IGridScheduleViewModel {
    agentId?: string;
    agentName?: string | undefined;
    languages?: string[] | undefined;
    scheduleDetails?: ScheduleDetail[] | undefined;
    agentProvinces?: ProvinceScheduleSummary[] | undefined;
    agentRole?: AgentRole | undefined;
}

export class ScheduleDetail implements IScheduleDetail {
    shiftId?: string;
    shiftStudies?: ShiftStudy[] | undefined;
    startOn?: Date;
    endOn?: Date;
    isLocked?: boolean;
    breaks?: BreakResult[] | undefined;
    notes?: string | undefined;

    constructor(data?: IScheduleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            if (Array.isArray(_data["shiftStudies"])) {
                this.shiftStudies = [] as any;
                for (let item of _data["shiftStudies"])
                    this.shiftStudies!.push(ShiftStudy.fromJS(item));
            }
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
            this.isLocked = _data["isLocked"];
            if (Array.isArray(_data["breaks"])) {
                this.breaks = [] as any;
                for (let item of _data["breaks"])
                    this.breaks!.push(BreakResult.fromJS(item));
            }
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ScheduleDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        if (Array.isArray(this.shiftStudies)) {
            data["shiftStudies"] = [];
            for (let item of this.shiftStudies)
                data["shiftStudies"].push(item ? item.toJSON() : undefined as any);
        }
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        data["isLocked"] = this.isLocked;
        if (Array.isArray(this.breaks)) {
            data["breaks"] = [];
            for (let item of this.breaks)
                data["breaks"].push(item ? item.toJSON() : undefined as any);
        }
        data["notes"] = this.notes;
        return data;
    }
}

export interface IScheduleDetail {
    shiftId?: string;
    shiftStudies?: ShiftStudy[] | undefined;
    startOn?: Date;
    endOn?: Date;
    isLocked?: boolean;
    breaks?: BreakResult[] | undefined;
    notes?: string | undefined;
}

export class ShiftStudy implements IShiftStudy {
    studyId?: string;
    shiftSupervisor?: boolean;

    constructor(data?: IShiftStudy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.shiftSupervisor = _data["shiftSupervisor"];
        }
    }

    static fromJS(data: any): ShiftStudy {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftStudy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["shiftSupervisor"] = this.shiftSupervisor;
        return data;
    }
}

export interface IShiftStudy {
    studyId?: string;
    shiftSupervisor?: boolean;
}

export class BreakResult implements IBreakResult {
    breakId?: string;
    startOn?: Date;
    duration?: number;

    constructor(data?: IBreakResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakId = _data["breakId"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): BreakResult {
        data = typeof data === 'object' ? data : {};
        let result = new BreakResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breakId"] = this.breakId;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IBreakResult {
    breakId?: string;
    startOn?: Date;
    duration?: number;
}

export class AvailabilityResult implements IAvailabilityResult {
    id?: string;
    userId?: string | undefined;
    userName?: string | undefined;
    start?: Date;
    end?: Date;

    constructor(data?: IAvailabilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AvailabilityResult {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }
}

export interface IAvailabilityResult {
    id?: string;
    userId?: string | undefined;
    userName?: string | undefined;
    start?: Date;
    end?: Date;
}

export class AvailabilityViewModel implements IAvailabilityViewModel {
    id?: string | undefined;
    userId?: string;
    start?: Date;
    end?: Date;

    constructor(data?: IAvailabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AvailabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }
}

export interface IAvailabilityViewModel {
    id?: string | undefined;
    userId?: string;
    start?: Date;
    end?: Date;
}

export class DuplicateAvailabilityViewModel implements IDuplicateAvailabilityViewModel {
    sourceStart?: Date;
    sourceEnd?: Date;
    target?: Date;

    constructor(data?: IDuplicateAvailabilityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceStart = _data["sourceStart"] ? new Date(_data["sourceStart"].toString()) : undefined as any;
            this.sourceEnd = _data["sourceEnd"] ? new Date(_data["sourceEnd"].toString()) : undefined as any;
            this.target = _data["target"] ? new Date(_data["target"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DuplicateAvailabilityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateAvailabilityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceStart"] = this.sourceStart ? this.sourceStart.toISOString() : undefined as any;
        data["sourceEnd"] = this.sourceEnd ? this.sourceEnd.toISOString() : undefined as any;
        data["target"] = this.target ? this.target.toISOString() : undefined as any;
        return data;
    }
}

export interface IDuplicateAvailabilityViewModel {
    sourceStart?: Date;
    sourceEnd?: Date;
    target?: Date;
}

export class CallHistoryResult implements ICallHistoryResult {
    uniqueId?: string | undefined;
    callStartDate?: Date;
    callEndDate?: Date | undefined;
    callDirection?: CallDirection;
    callerId?: string | undefined;
    callType?: CallType;
    userId?: string | undefined;
    studyId?: string;
    cdrs?: CallEntryResult[];

    constructor(data?: ICallHistoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.callStartDate = _data["callStartDate"] ? new Date(_data["callStartDate"].toString()) : undefined as any;
            this.callEndDate = _data["callEndDate"] ? new Date(_data["callEndDate"].toString()) : undefined as any;
            this.callDirection = _data["callDirection"];
            this.callerId = _data["callerId"];
            this.callType = _data["callType"];
            this.userId = _data["userId"];
            this.studyId = _data["studyId"];
            if (Array.isArray(_data["cdrs"])) {
                this.cdrs = [] as any;
                for (let item of _data["cdrs"])
                    this.cdrs!.push(CallEntryResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CallHistoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallHistoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["callStartDate"] = this.callStartDate ? this.callStartDate.toISOString() : undefined as any;
        data["callEndDate"] = this.callEndDate ? this.callEndDate.toISOString() : undefined as any;
        data["callDirection"] = this.callDirection;
        data["callerId"] = this.callerId;
        data["callType"] = this.callType;
        data["userId"] = this.userId;
        data["studyId"] = this.studyId;
        if (Array.isArray(this.cdrs)) {
            data["cdrs"] = [];
            for (let item of this.cdrs)
                data["cdrs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICallHistoryResult {
    uniqueId?: string | undefined;
    callStartDate?: Date;
    callEndDate?: Date | undefined;
    callDirection?: CallDirection;
    callerId?: string | undefined;
    callType?: CallType;
    userId?: string | undefined;
    studyId?: string;
    cdrs?: CallEntryResult[];
}

export enum CallDirection {
    Inbound = 0,
    Outbound = 1,
}

export class CallEntryResult implements ICallEntryResult {
    callDate?: Date | undefined;
    dContext?: string | undefined;
    src?: string | undefined;
    userId?: string | undefined;
    destinationUserId?: string | undefined;
    duration?: number | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    answeredOn?: Date | undefined;
    linkedId?: string | undefined;
    clid?: string | undefined;
    studyId?: string | undefined;

    constructor(data?: ICallEntryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callDate = _data["callDate"] ? new Date(_data["callDate"].toString()) : undefined as any;
            this.dContext = _data["dContext"];
            this.src = _data["src"];
            this.userId = _data["userId"];
            this.destinationUserId = _data["destinationUserId"];
            this.duration = _data["duration"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.answeredOn = _data["answeredOn"] ? new Date(_data["answeredOn"].toString()) : undefined as any;
            this.linkedId = _data["linkedId"];
            this.clid = _data["clid"];
            this.studyId = _data["studyId"];
        }
    }

    static fromJS(data: any): CallEntryResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallEntryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callDate"] = this.callDate ? this.callDate.toISOString() : undefined as any;
        data["dContext"] = this.dContext;
        data["src"] = this.src;
        data["userId"] = this.userId;
        data["destinationUserId"] = this.destinationUserId;
        data["duration"] = this.duration;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        data["answeredOn"] = this.answeredOn ? this.answeredOn.toISOString() : undefined as any;
        data["linkedId"] = this.linkedId;
        data["clid"] = this.clid;
        data["studyId"] = this.studyId;
        return data;
    }
}

export interface ICallEntryResult {
    callDate?: Date | undefined;
    dContext?: string | undefined;
    src?: string | undefined;
    userId?: string | undefined;
    destinationUserId?: string | undefined;
    duration?: number | undefined;
    start?: Date | undefined;
    end?: Date | undefined;
    answeredOn?: Date | undefined;
    linkedId?: string | undefined;
    clid?: string | undefined;
    studyId?: string | undefined;
}

export class UserQueuesResult implements IUserQueuesResult {
    userId?: string;
    queueIds?: string[];

    constructor(data?: IUserQueuesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["queueIds"])) {
                this.queueIds = [] as any;
                for (let item of _data["queueIds"])
                    this.queueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserQueuesResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserQueuesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.queueIds)) {
            data["queueIds"] = [];
            for (let item of this.queueIds)
                data["queueIds"].push(item);
        }
        return data;
    }
}

export interface IUserQueuesResult {
    userId?: string;
    queueIds?: string[];
}

export class SetUserQueuesModel implements ISetUserQueuesModel {
    asteriskUsername?: string | undefined;
    queueIds?: string[] | undefined;

    constructor(data?: ISetUserQueuesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asteriskUsername = _data["asteriskUsername"];
            if (Array.isArray(_data["queueIds"])) {
                this.queueIds = [] as any;
                for (let item of _data["queueIds"])
                    this.queueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetUserQueuesModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserQueuesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asteriskUsername"] = this.asteriskUsername;
        if (Array.isArray(this.queueIds)) {
            data["queueIds"] = [];
            for (let item of this.queueIds)
                data["queueIds"].push(item);
        }
        return data;
    }
}

export interface ISetUserQueuesModel {
    asteriskUsername?: string | undefined;
    queueIds?: string[] | undefined;
}

export class JoinTempQueueModel implements IJoinTempQueueModel {
    queueName?: string | undefined;

    constructor(data?: IJoinTempQueueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["queueName"];
        }
    }

    static fromJS(data: any): JoinTempQueueModel {
        data = typeof data === 'object' ? data : {};
        let result = new JoinTempQueueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueName"] = this.queueName;
        return data;
    }
}

export interface IJoinTempQueueModel {
    queueName?: string | undefined;
}

export class AppointmentResult implements IAppointmentResult {
    id?: string;
    createdOn?: Date;
    studyId?: string | undefined;
    userId?: string;
    createdByUserId?: string | undefined;
    userFullName?: string | undefined;
    appointmentType?: AppointmentType;
    pendingExpiresOn?: Date | undefined;
    startOn?: Date;
    endOn?: Date;
    callbackTaskId?: string | undefined;
    task?: CallbackTaskResult | undefined;
    notes?: string | undefined;
    durationOption?: StudyCallDurationOptionResult | undefined;

    constructor(data?: IAppointmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.studyId = _data["studyId"];
            this.userId = _data["userId"];
            this.createdByUserId = _data["createdByUserId"];
            this.userFullName = _data["userFullName"];
            this.appointmentType = _data["appointmentType"];
            this.pendingExpiresOn = _data["pendingExpiresOn"] ? new Date(_data["pendingExpiresOn"].toString()) : undefined as any;
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
            this.callbackTaskId = _data["callbackTaskId"];
            this.task = _data["task"] ? CallbackTaskResult.fromJS(_data["task"]) : undefined as any;
            this.notes = _data["notes"];
            this.durationOption = _data["durationOption"] ? StudyCallDurationOptionResult.fromJS(_data["durationOption"]) : undefined as any;
        }
    }

    static fromJS(data: any): AppointmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["studyId"] = this.studyId;
        data["userId"] = this.userId;
        data["createdByUserId"] = this.createdByUserId;
        data["userFullName"] = this.userFullName;
        data["appointmentType"] = this.appointmentType;
        data["pendingExpiresOn"] = this.pendingExpiresOn ? this.pendingExpiresOn.toISOString() : undefined as any;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        data["callbackTaskId"] = this.callbackTaskId;
        data["task"] = this.task ? this.task.toJSON() : undefined as any;
        data["notes"] = this.notes;
        data["durationOption"] = this.durationOption ? this.durationOption.toJSON() : undefined as any;
        return data;
    }
}

export interface IAppointmentResult {
    id?: string;
    createdOn?: Date;
    studyId?: string | undefined;
    userId?: string;
    createdByUserId?: string | undefined;
    userFullName?: string | undefined;
    appointmentType?: AppointmentType;
    pendingExpiresOn?: Date | undefined;
    startOn?: Date;
    endOn?: Date;
    callbackTaskId?: string | undefined;
    task?: CallbackTaskResult | undefined;
    notes?: string | undefined;
    durationOption?: StudyCallDurationOptionResult | undefined;
}

export enum AppointmentType {
    Other = 0,
    Break = 1,
    ManualBreak = 2,
    Call = 3,
    Pending = 4,
}

export class PendingAppointmentCreatedModel implements IPendingAppointmentCreatedModel {
    appointmentId?: string;

    constructor(data?: IPendingAppointmentCreatedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
        }
    }

    static fromJS(data: any): PendingAppointmentCreatedModel {
        data = typeof data === 'object' ? data : {};
        let result = new PendingAppointmentCreatedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        return data;
    }
}

export interface IPendingAppointmentCreatedModel {
    appointmentId?: string;
}

export class CreatePendingAppointmentModel implements ICreatePendingAppointmentModel {
    userId?: string;
    startOn?: Date;
    endOn?: Date;

    constructor(data?: ICreatePendingAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePendingAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePendingAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreatePendingAppointmentModel {
    userId?: string;
    startOn?: Date;
    endOn?: Date;
}

export class UpdateAppointmentTimeModel implements IUpdateAppointmentTimeModel {
    startOn?: Date;
    endOn?: Date;
    appointmentId?: string;

    constructor(data?: IUpdateAppointmentTimeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
            this.appointmentId = _data["appointmentId"];
        }
    }

    static fromJS(data: any): UpdateAppointmentTimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentTimeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        data["appointmentId"] = this.appointmentId;
        return data;
    }
}

export interface IUpdateAppointmentTimeModel {
    startOn?: Date;
    endOn?: Date;
    appointmentId?: string;
}

export class UpdateAppointmentModel implements IUpdateAppointmentModel {
    startOn?: Date;
    endOn?: Date;
    appointmentId?: string;
    label?: string | undefined;

    constructor(data?: IUpdateAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startOn = _data["startOn"] ? new Date(_data["startOn"].toString()) : undefined as any;
            this.endOn = _data["endOn"] ? new Date(_data["endOn"].toString()) : undefined as any;
            this.appointmentId = _data["appointmentId"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): UpdateAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startOn"] = this.startOn ? this.startOn.toISOString() : undefined as any;
        data["endOn"] = this.endOn ? this.endOn.toISOString() : undefined as any;
        data["appointmentId"] = this.appointmentId;
        data["label"] = this.label;
        return data;
    }
}

export interface IUpdateAppointmentModel {
    startOn?: Date;
    endOn?: Date;
    appointmentId?: string;
    label?: string | undefined;
}

export class FinalizeHcpBreakAppointmentModel implements IFinalizeHcpBreakAppointmentModel {
    appointmentId?: string;
    interactionTypeDurationOptionId?: string;
    studyId?: string;
    notes?: string | undefined;

    constructor(data?: IFinalizeHcpBreakAppointmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.interactionTypeDurationOptionId = _data["interactionTypeDurationOptionId"];
            this.studyId = _data["studyId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): FinalizeHcpBreakAppointmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinalizeHcpBreakAppointmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["interactionTypeDurationOptionId"] = this.interactionTypeDurationOptionId;
        data["studyId"] = this.studyId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IFinalizeHcpBreakAppointmentModel {
    appointmentId?: string;
    interactionTypeDurationOptionId?: string;
    studyId?: string;
    notes?: string | undefined;
}

export class CreateCallbackViewModel implements ICreateCallbackViewModel {
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientEmail?: string | undefined;
    patientPhoneNumber?: string | undefined;
    hasPatientConsentedVoicemail?: boolean | undefined;
    patientLanguageCode?: LanguageCode;
    startDateTime?: Date | undefined;
    patientSelectedTimeZone?: string | undefined;
    callbackType?: CallType;
    studyId?: string;
    isCallbackAsap?: boolean | undefined;

    constructor(data?: ICreateCallbackViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientEmail = _data["patientEmail"];
            this.patientPhoneNumber = _data["patientPhoneNumber"];
            this.hasPatientConsentedVoicemail = _data["hasPatientConsentedVoicemail"];
            this.patientLanguageCode = _data["patientLanguageCode"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : undefined as any;
            this.patientSelectedTimeZone = _data["patientSelectedTimeZone"];
            this.callbackType = _data["callbackType"];
            this.studyId = _data["studyId"];
            this.isCallbackAsap = _data["isCallbackAsap"];
        }
    }

    static fromJS(data: any): CreateCallbackViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCallbackViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientEmail"] = this.patientEmail;
        data["patientPhoneNumber"] = this.patientPhoneNumber;
        data["hasPatientConsentedVoicemail"] = this.hasPatientConsentedVoicemail;
        data["patientLanguageCode"] = this.patientLanguageCode;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["patientSelectedTimeZone"] = this.patientSelectedTimeZone;
        data["callbackType"] = this.callbackType;
        data["studyId"] = this.studyId;
        data["isCallbackAsap"] = this.isCallbackAsap;
        return data;
    }
}

export interface ICreateCallbackViewModel {
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientEmail?: string | undefined;
    patientPhoneNumber?: string | undefined;
    hasPatientConsentedVoicemail?: boolean | undefined;
    patientLanguageCode?: LanguageCode;
    startDateTime?: Date | undefined;
    patientSelectedTimeZone?: string | undefined;
    callbackType?: CallType;
    studyId?: string;
    isCallbackAsap?: boolean | undefined;
}

export enum LanguageCode {
    English = 0,
    French = 1,
}

export class ProgramAppointmentAvailabilityReponse implements IProgramAppointmentAvailabilityReponse {
    calculatedFor?: Date;
    openingTime?: Date;
    closedTime?: Date;
    closures?: ProgramClosureConfiguration[] | undefined;
    appointments?: AvailableAppointmentResult[] | undefined;

    constructor(data?: IProgramAppointmentAvailabilityReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculatedFor = _data["calculatedFor"] ? new Date(_data["calculatedFor"].toString()) : undefined as any;
            this.openingTime = _data["openingTime"] ? new Date(_data["openingTime"].toString()) : undefined as any;
            this.closedTime = _data["closedTime"] ? new Date(_data["closedTime"].toString()) : undefined as any;
            if (Array.isArray(_data["closures"])) {
                this.closures = [] as any;
                for (let item of _data["closures"])
                    this.closures!.push(ProgramClosureConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(AvailableAppointmentResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProgramAppointmentAvailabilityReponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramAppointmentAvailabilityReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculatedFor"] = this.calculatedFor ? this.calculatedFor.toISOString() : undefined as any;
        data["openingTime"] = this.openingTime ? this.openingTime.toISOString() : undefined as any;
        data["closedTime"] = this.closedTime ? this.closedTime.toISOString() : undefined as any;
        if (Array.isArray(this.closures)) {
            data["closures"] = [];
            for (let item of this.closures)
                data["closures"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProgramAppointmentAvailabilityReponse {
    calculatedFor?: Date;
    openingTime?: Date;
    closedTime?: Date;
    closures?: ProgramClosureConfiguration[] | undefined;
    appointments?: AvailableAppointmentResult[] | undefined;
}

export class ProgramClosureConfiguration implements IProgramClosureConfiguration {
    from?: Date;
    to?: Date;
    messageEn?: string;
    messageFr?: string;

    constructor(data?: IProgramClosureConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.messageEn = _data["messageEn"];
            this.messageFr = _data["messageFr"];
        }
    }

    static fromJS(data: any): ProgramClosureConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramClosureConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["messageEn"] = this.messageEn;
        data["messageFr"] = this.messageFr;
        return data;
    }
}

export interface IProgramClosureConfiguration {
    from?: Date;
    to?: Date;
    messageEn?: string;
    messageFr?: string;
}

export class AvailableAppointmentResult implements IAvailableAppointmentResult {
    label?: string | undefined;
    startOn?: string | undefined;
    group?: string | undefined;
    startDate?: Date;

    constructor(data?: IAvailableAppointmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.startOn = _data["startOn"];
            this.group = _data["group"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AvailableAppointmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableAppointmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["startOn"] = this.startOn;
        data["group"] = this.group;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAvailableAppointmentResult {
    label?: string | undefined;
    startOn?: string | undefined;
    group?: string | undefined;
    startDate?: Date;
}

export class AvailableTimezoneResult implements IAvailableTimezoneResult {
    label?: string | undefined;
    timezone?: string | undefined;

    constructor(data?: IAvailableTimezoneResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): AvailableTimezoneResult {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableTimezoneResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IAvailableTimezoneResult {
    label?: string | undefined;
    timezone?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}